


'use strict';

var litui = (function(){
    function LituiAPI(){
        this.$$version = "v2.0.4";
        
        if(this.$$version.indexOf('.x') > -1 || this.$$version.indexOf('-dev') > -1)
            console.warn("You are using development (DEV) version of LITUI, which could be untested or unstable. Version in use: " + this.$$version);
    };
    
    return new LituiAPI();
})();'use strict';

(function(){
    litui.$$const = {
        'ANGULAR_MODULE': 'app',
        'ANGULAR_VIEWBASE': '/',
        'LTUI_ANGULAR_MODULE': 'ltui',
        'LTUI_ANGULAR_VIEWBASE': 'ltui/',
        'RESOURCE_PATH': 'resource/'
    };
})();'use strict';

/** 
 * @namespace litui.base
 */
(function(){
    /**
     * <b>LT: (special service) <code>litui.$$registry</code></b><br /><br />
     * 
     * Registry is LT service which handles registration of LT Concepts. LT 
     * Concept is either Class or Singleton.<br /><br />
     * 
     * Registry is the fundamental LT concept. It provides methods for handling 
     * Concept registration, creation of LT namespace modules, special 
     * annotation parsing etc...<br /><br />
     * 
     * Concept can be registered by calling:
     * <code>litui.$$register(c:Function|Object)</code><br /><br />
     * 
     * <b>NOTE: registering two concepts with the same signature 
     * (module name and class/singleton name) will result in override of the 
     * previous (latest will override previously registered Concept).</b>
     * 
     * @class
     * @memberOf litui.base
     */
    LituiRegistry.__CLASS__ = { name: 'Registry', module: ''};
    function LituiRegistry(ns){
        this.exposed = {};
        this.ns = ns || litui;
    }
    
    /**
     * Registers LT Concept. It uses Concept's annotation to register it into 
     * appropriate module in <code>lt</code> facade.
     * 
     * @param {Function|Object} C Either JS constructor function (Class) or 
     * Object (Singleton).
     */
    LituiRegistry.prototype.register = function(C){        
        var concept = null;
        var meta = null;
        
        if(C.__SINGLETON__ !== undefined){
            concept = new C();                                
            meta = this.parseAnnotation(C.__SINGLETON__);
        }
        else if(C.__CLASS__ !== undefined){
            concept = C;
            meta = this.parseAnnotation(C.__CLASS__);
        }
        else{
            concept = C;
        }
        
        this.addToModule(concept, meta);
        this.expose(concept, meta);
    };
    
    /**
     * Parses annotation and returns meta info.
     * 
     * @param {type} ann
     * @returns {Object} object containing meta info { module:String, name:String, angular:boolean }
     */
    LituiRegistry.prototype.parseAnnotation = function(ann){
        var meta = {
            module: null,
            name: null,
            angular: true
        };
        
        if(!(typeof ann === "string") && ann.name !== undefined){
            meta.name = ann.name;
            meta.module = ann.module;
            meta.angular = ann.angular === false? false : true;
        }
        else{
            meta.name = ann;
        }
        return meta;
    };
    
    /**
     * Adds concept to the module, as defined in meta info.
     * 
     * @param {Function|Object} concept
     * @param {Object} meta
     */
    LituiRegistry.prototype.addToModule = function(concept, meta){
        var mname = (meta === null)? null : meta.module || null;
        var module = this.createModule(mname, this.ns);
        
        if(meta === null){
            module[concept.prototype.constructor.name] = concept;
        }
        else{
            module[meta.name] = concept;
        }
    };
    
    /**
     * Creates new module in lt facade, if it doesn't exist yet.
     * 
     * @param {String} moduleName
     * @param {Object} moduleContext
     * @returns {Object} module context
     */
    LituiRegistry.prototype.createModule = function(moduleName, moduleContext){
        if(moduleName === null || moduleName === undefined || moduleName.length === 0)
            return moduleContext;
        
        // create submodule tree
        var delimI = moduleName.indexOf('.');
        if(delimI > -1){
            var mnameCurr = moduleName.substring(0, delimI);
            var mnameTree = moduleName.substring(delimI + 1);
            // prepare new module context
            if(moduleContext[mnameCurr] === undefined){
                moduleContext[mnameCurr] = {};
            }
            return this.createModule(mnameTree, moduleContext[mnameCurr]);
        }
        
        // prepare new module
        if(moduleContext[moduleName] === undefined){
            moduleContext[moduleName] = {};
        }
        return moduleContext[moduleName];
    };
    
    /**
     * Exposes concept to 3rd party framework.
     * 
     * @param {Function|Object} c
     * @param {Object} meta
     */
    LituiRegistry.prototype.expose = function(c, meta){
        if(meta === null || meta === undefined) return;
        
        if(meta.angular){
            if(this.exposed.angular === undefined){
                this.exposed.angular = {};
            }
            
            this.exposed.angular[meta.name] = c;
        }
        
    };
    
    LituiRegistry.prototype.getBySignature = function(signature){
        var keys = signature.split('.');
        var lastNode = null;
        for(var i = 0; i < keys.length; i++){
            var k = keys[i];
            var node = (i === 0)? litui[k] : lastNode[k];
            if(litui.utils.isDefined(node) && i < keys.length - 1){
                lastNode = node;
            }
            else
                return node;
        }
    };
    
    
//    litui.namespaceFactory.createRegistry(litui, LituiRegistry);
    
    // expose as "private" prop
    litui.$$registry = new LituiRegistry();
    litui.$$register = function $$register(c){
        litui.$$registry.register(c);
    };
    litui.$$get = function $$register(signature){
        return litui.$$registry.getBySignature(signature);
    };
    litui.$$register(LituiRegistry);
})();'use strict';

(function () {
    LituiLogger.__SINGLETON__ = {name: 'logger', module: ''};

    /**
     * <b>LT: <code>litui.logger</code> (singleton)</b><br />
     * Wrapps console with own definition of log levels. Default logging level 
     * is set to NONE.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiLogger(owner, level) {
        /**
         * Represents enum for log level
         * TODO: move this to LituiLogger as static
         */
        this.Levels = {
            NONE: 'NONE',
            ALL: 'ALL',
            ERROR: 'ERROR'
        };
        this.currentLevel = level || this.Levels.NONE;
        this.owner = owner || 'litui';
    }

    /**
     * Wrapps console.log.
     */
    LituiLogger.prototype.log = function () {
        if (this.level() === this.Levels.NONE)
            return;

        console.log.apply(console, this.$$prefix(arguments));
    };

    /**
     * Wrapps console.info.
     */
    LituiLogger.prototype.info = function () {
        if (this.level() === this.Levels.NONE)
            return;

        console.info.apply(console, this.$$prefix(arguments));
    };

    /**
     * Wrapps console.debug.
     */
    LituiLogger.prototype.debug = function () {
        if (this.level() === this.Levels.NONE)
            return;

        console.debug.apply(console, this.$$prefix(arguments));
    };

    /**
     * Wrapps console.warn.
     */
    LituiLogger.prototype.warn = function () {
        console.warn.apply(console, this.$$prefix(arguments));
    };

    /**
     * Outputs TODO's as console.warn.
     * NOTE: it disregards log level alltogether.
     */
    LituiLogger.prototype.todo = function (text) {
        console.warn.apply(console, ["TODO (not yet implemented): " + text]);
    };

    /**
     * Wrapps console.error. Log level: ERROR
     */
    LituiLogger.prototype.error = function () {
        if (this.level() === this.Levels.NONE)
            return;
        if (this.level() !== this.Levels.ERROR && this.level() !== this.Levels.ALL)
            return;

        console.error.apply(console, this.$$prefix(arguments));
    };

    /**
     * Sets/gets current log level.
     * 
     * @param {String} level
     * @returns {String}
     */
    LituiLogger.prototype.level = function (level) {
        if (level !== undefined) {
            this.currentLevel = level;
            this.debug("Log level changed: ", this.currentLevel);
        }
        return this.currentLevel;
    };

    /**
     * Formats current time (HH:mm:ss).
     * 
     * @returns {String}
     */
    LituiLogger.prototype.$$time = function () {
        return moment().format("HH:mm:ss");
    };

    /**
     * Prefixes logger output.
     * 
     * @param {Array} args First argument gets altered if its type is String 
     * (appends LT prefix).
     * @returns {Array} an array of provided arguments with altered first argument.
     */
    LituiLogger.prototype.$$prefix = function (args) {
        // TODO: this needs to be tested cross browser 
        // - doesn't work on firefox (TypeError: access to strict mode caller function is censored)
//        var caller = (arguments.callee.caller && arguments.callee.caller !== null && arguments.callee.caller.length)? arguments.callee.caller.name : "lt";
        var caller = this.owner.toUpperCase();

        if (typeof args[0] === "string")
            args[0] = '.:[' + caller + ' - ' + this.$$time() + ']:. ' + args[0];
        return args;
    };
    
    LituiLogger.prototype.produce = function(owner, level){
        return new LituiLogger(owner, level);
    };
    
    LituiLogger.prototype.out = function(){
        console.log.apply(console, this.$$prefix(arguments));
    };

    litui.$$register(LituiLogger);
})();(function(){    
    LituiLang.__SINGLETON__ = { name: 'lang', module: ''};
    /**
     * <b>LT: <code>litui.lang</code> (singleton)</b><br />
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiLang(){
        
    }
    
    /**
     * Extends prototypes of A and B.
     * 
     * @param {Function} A Constructor function A.
     * @param {Function} B Constructor function B.
     * @returns {Function} new extended prototype of
     */
    LituiLang.prototype.extend = function (A, B) {
        
        // extend prototypes
        if (!(typeof A === "function" && typeof B === "function")) 
            throw "Exception when extending prototypes: One of the entities is not a function";
            
        // this kind of declaration offends "strict mode"
        function __() {
            this.constructor = A;
        }

        __.prototype = B.prototype;
        A.prototype = new __();
        return A;
    };
    
    LituiLang.prototype.implement = function (proto, protoInterface) {
        var missing = [];
        for(var fname in protoInterface.prototype){
            if(proto.prototype[fname] === undefined)
                missing.push(fname);
        }
        
        if(missing.length > 0)
            litui.logger.error(proto.name + " is missing implementation for " + protoInterface.name + "! Missing: " + missing.concat(","));
        return proto;
    };
    
    /**
     * Merges two objects. Comes handy in object inheritance. The properties 
     * from B override properties from A.<br />
     * Throws exception when any of the given parameters is not an object.
     * 
     * @throws {Exception} 
     * @param {Object} a
     * @param {Object} b
     * @returns {Object} object A.
     */
    LituiLang.prototype.merge = function (a, b) {
        // extend objects
        if (!(typeof a === "object" && typeof b === "object")) {
            console.error("Merge values", a, b);
            throw "Exception when merging: One of the entities is not an object";
        }
        
        for (var k in b) {
            if(b[k] === undefined) continue ;
            a[k] = b[k];
        }

        return a;
    };
    
    LituiLang.prototype.deepMerge = function (a, b) {
        if(b === null)
            return null;
        
        // extend objects
//        if (!(typeof a === "object" && typeof b === "object")) 
//            throw "Exception when merging: One of the entities is not an object";
        
        if((a === null || a === undefined))
            a = {};
        
        for (var k in b) {
            var propA = a[k];
            var propB = b[k];
            if(b[k] === undefined)
                continue;
            
            if (typeof propA === "object" && typeof propB === "object") {
                a[k] = this.deepMerge(propA, propB);
            }
            else
                a[k] = b[k];
        }
        return a;
    };
    
    /**
     * Merges two objects. It differs from <code>.merge(..)</code> in a way that 
     * it appends any new properties from object A to object B and it does not 
     * override any existing properties on B.<br />
     * Throws exception when any of the given parameters is not an object.
     * 
     * @throws {Exception} 
     * @param {Object} a
     * @param {Object} b
     * @returns {Object} object B.
     */
    LituiLang.prototype.mergeB = function (a, b) {
        // extend objects
        if (!(typeof a === "object" && typeof b === "object")) 
            throw "Exception when merging: One of the entities is not an object";
        
        for (var k in a) {
            if(b[k] === undefined && a[k] !== undefined){
                b[k] = a[k];
            }
            else if(litui.utils.isDefined(a[k]) && litui.utils.isSimpleObject(a[k])){
                this.mergeB(a[k], b[k]);
            }
        }

        return b;
    };
    
    /**
     * Copies the propeties from object A to new object.<br />
     * NOTE: this only performes one-level copy, meaning it does not performe 
     * "deep copy". Please look at the <code>litui.utils</code> for "deep copy".<br />
     * Throws exception when the given parameter is not an object.
     * 
     * @throws {Exception} 
     * @param {Object} a
     * @returns {Object} fresh object copy.
     */
    LituiLang.prototype.copy = function (a) {
        // extend objects
        if (!typeof a === "object") 
            throw "Exception when copying: Entities is not an object";
        var b = {};
        for (var k in a) {
            if(a[k] === undefined) continue ;
            b[k] = a[k];
        }

        return b;
    };
    
    LituiLang.prototype.copyArray = function (arr) {
        var arrCopy = [];
        for(var i = 0; i < arr.length; i++){
            if(typeof arr[i] === 'object')
                arrCopy.push(this.copy(arr[i]));
            else
                arrCopy.push(arr[i]);
        }
        return arrCopy;
    };
    
    LituiLang.prototype.deepCopy = function (a) {
        // extend objects
        if (!typeof a === "object") 
            throw "Exception when copying: Entities is not an object";
        var b = {};
        for (var k in a) {
            if(a[k] === undefined) continue ;
//            litui.logger.log("type of a", typeof a === "object");
            if(typeof a[k] === "object")
                b[k] = this.deepCopy(a[k]);
            else
                b[k] = a[k];
        }

        return b;
    };
    
    /**
     * Merges two arrays.
     * 
     * @param {Array} a
     * @param {Array} b
     * @returns {Array} new array of two given arrays.
     */
    LituiLang.prototype.mergeArr = function(a, b){
        var c = null;
        if(b === undefined){
            c = a;
        }
        else
            c = a.concat(b);
        var uniqueC = [];
        for(var i = 0; i < c.length; i++){
            if(uniqueC.indexOf(c[i]) === -1)
                uniqueC.push(c[i]);
        }
        return uniqueC;
    };
    
    /**
     * Ensures that property or an array of properties exist on the object. 
     * Throws exception if property is not found.
     * 
     * @throws {Exception}
     * @param {String|Array:String} pname Property name or an array of property names
     * @param {Object} obj
     */
    LituiLang.prototype.ensure = function(pname, obj){
        if(Object.prototype.toString.call(pname) === '[object Array]'){
            if (!typeof obj === "object") 
                throw "Exception: can not ensure properties; second argument is not a object but " + (typeof obj) + "!";
        
            for(var i = 0; i < pname.length; i++){
                if(!obj.hasOwnProperty(pname[i])){
                    throw "Exception when ensuring object property: '" + pname[i] + "' is mandatory property!";
                }
            }
        }
        else{
            if (!typeof obj === "object") 
                throw "Exception: can not ensure property '" + pname + "'; second argument is not a object but " + (typeof obj) + "!";
            if(!obj.hasOwnProperty(pname))
                throw "Exception when ensuring object property: '" + pname + "' is mandatory property!";
        }
    };
    
    LituiLang.prototype.prepareSettings = function(properties, context, setname){
        setname = litui.utils.isUndefined(setname)? 'settings' : setname;
        if(litui.utils.isUndefined(context[setname]))
            context[setname] = {};
        this.mergeB(properties, context[setname]);
    };
    
    litui.$$register(LituiLang);
})();(function () {
    LituiUtils.__SINGLETON__ = {name: 'utils', module: ''};
    /**
     * LT utility class, with useful utility functions.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiUtils() {

    }

    /**
     * Converts pixel (string, eg. '10px') to number (eg. 10).
     * 
     * @param {String} px
     * @returns {Number}
     */
    LituiUtils.prototype.pxToNum = function (px) {
        if (!px)
            return 0;
        var num = px.substring(0, px.length - 2);
        if (!num)
            return px;
        return Number(num);
    };

    /**
     * Converts number to pixel. (Adds px to the end of a string representing 
     * number of pixels).
     * 
     * @param {Number} num
     * @returns {String}
     */
    LituiUtils.prototype.numToPx = function (num) {
        return num + 'px';
    };

    /**
     * Gets index of object in array.
     * 
     * @param {Object} obj
     * @param {Array} arr
     * @returns {Number}
     */
    LituiUtils.prototype.getIndex = function (obj, arr) {
        return $.inArray(obj, arr);
    };

    /**
     * Trimms the given string.
     * 
     * @param {String} string Text to be trimmed.
     * @param {Number} max Limit string. Defaults to 7.
     * @param {String} trail Defaults to "..."
     * @returns {String}
     */
    LituiUtils.prototype.trimm = function (string, max, trail) {
        if (this.isUndefined(string))
            return "...";

        trail = trail === undefined ? "..." : trail;
        max = max === undefined ? 7 : max;

        if (string.length > max) {
            return string.substring(0, max) + trail;
        }
        return string;
    };

    /**
     * Clones an array of objects.
     * 
     * @param {Array<Object>} arr
     * @returns {Array<Objects>} copy of array of objects.
     */
    LituiUtils.prototype.cloneObjects = function (arr) {
        var newA = [];
        for (var i = 0; i < arr.length; i++) {
            newA.push(this.clone(arr[i]));
        }
        return newA;
    };

    /**
     * Truncates array.
     * 
     * @param {Array} arr
     */
    LituiUtils.prototype.truncate = function (arr) {
//        console.debug("Initial length %o", arr.length);
        var length = arr.length;
        arr.slice(0, length);
        if (arr.length <= length) {
            arr.splice(0, arr.length);
        }
//        console.debug("After remove length %o", arr.length);
    };

    /**
     * Makes given array an unique array. By default it keeps array reference, 
     * but by setting keepRef argument, we can break reference.
     * 
     * @param {Array} array
     * @param {Function} comparationFx
     * @param {boolean} keepRef (default undefined - TRUE).
     * @returns {undefined|Array} array will be returned when reference is not 
     * kept.
     */
    LituiUtils.prototype.uniqueArray = function (array, comparationFx, keepRef) {
        keepRef = this.isDefined(keepRef) ? keepRef : true;

        var unique = [];
        for (var i = 0; i < array.length; i++) {
            var item = array[i];

            var exists = false;
            for (var j = 0; j < unique.length; j++) {
                if (comparationFx(item, unique[j])) {
                    exists = true;
                    break;
                }
            }

            if (!exists && item > 0) {
                unique.push(item);
            }
        }

        if (keepRef) {
            this.truncate(array);
            for (var i = 0; i < unique.length; i++) {
                array.push(unique[i]);
            }
        } else {
            return unique;
        }
    };

    /**
     * Updates array and keeps the references of array items.
     * 
     * @param {Array} arr Old array
     * @param {Array} updateArr New array
     * @param {Function} condition
     * @param {Function} onUpdate On update callback
     */
    LituiUtils.prototype.updateArray = function (arr, updateArr, condition, onUpdate) {
        console.warn("DEPRECATION: Method litui.utils.updateArray(..) is deprecated, use litui.utils.arrayUpdate(..) instead");
        if (!this.isFunction(condition))
            throw "Condition must be function that either returns object or function! " + (typeof condition) + " given.";

        var _arr = [];

        for (var i = 0; i < arr.length; i++) {
            var a = arr[i];

            var cond = condition(a);

            var b = null;
            if (this.isFunction(cond)) {
                for (var j = 0; j < updateArr.length; j++) {
                    var bc = updateArr[j];

                    if (cond(a, bc)) {
                        b = bc;
                    }
                }
            } else
                b = this.findWhere(updateArr, cond);

            if (this.isUndefined(b))
                _arr.push(a);
            else
                _arr.push(b);
        }

        this.truncate(arr);
        for (var i = 0; i < _arr.length; i++) {
            arr.push(_arr[i]);

            if (this.isFunction(onUpdate))
                onUpdate(arr[i], i);
        }
    };

    /**
     * Checks if array or object is empty.
     * 
     * @param {Array|Object} item
     * @returns {boolean}
     */
    LituiUtils.prototype.isEmpty = function (item) {
        if (!this.isSet(item))
            return;
        
        if(this.isString(item))
            return item.length === 0;
        if (this.isArray(item)) {
            return item.length === 0;
        } else if (this.isObject(item)) {
            var i = 0;
            for (var k in item) {
                i++;
                break;
            }
            return i === 0;
        }
//        console.warn("isEmpty not supported for types other than Array or Object");
    };

    /**
     * Gets query parameter from URL.<br />
     * Adapted from: (GET) http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript,
     *               (SET) https://gist.github.com/excalq/2961415
     * 
     * @param {String} key Parameter name
     * @returns {UNKNOWN}
     */

    LituiUtils.prototype.stateParam = function (key, value) {
        var queryStr = window.location.search;
        var isHash = this.isDefined(window.location.hash);
        if (window.location.hash.indexOf('?') > -1) {
            queryStr = window.location.hash.substr(window.location.hash.indexOf('#/') + 2);
        }
        key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
        var results = regex.exec(queryStr);

        var param = results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, " "));

        if (arguments.length === 2) {
            var newQueryStr = queryStr;

            // remove from query string, when value is undefined and param 
            // value is defined
            // or update existing / append new
            if (this.isUndefined(value)) {
                if (this.isDefined(param)) {
                    var cleaned = queryStr.substring(1);
                    if (cleaned.indexOf('&') > -1) {
                        var a = cleaned.split('&');
                        this.deleteElement(a, a.indexOf(key + '=' + param));
                        newQueryStr = a.join('');
                    } else
                        newQueryStr = '';
                }
            } else {
                if (this.isUndefined(param)) {
                    var paramVal = key + '=' + value;
                    if (newQueryStr.length > 0) {
                        newQueryStr += '&' + paramVal;
                    } else {
                        newQueryStr = '?' + paramVal;
                    }
                } else if (key + '=' + param !== key + '=' + value) {
                    newQueryStr = this.strReplace(queryStr, key + '=' + param, key + '=' + value);
                }
            }
            var url = location.protocol + '//' + location.host + location.pathname + (isHash ? '#/' : '') + newQueryStr;

            if (litui.utils.nonNull(window.history.state) && window.history.state.url === url)
                return;
            window.history.pushState({
                url: url
            }, litui.dateTime.now().valueOf(), url);
        }

        if (param === undefined || param.length === 0)
            return undefined;

        return param;
    };

    /**
     * Removes given object from array.
     * 
     * @param {Array} arr
     * @param {Object} obj Object to be removed from array
     * @returns {Array} array without the given element
     */
    LituiUtils.prototype.without = function (arr, obj, useSplice) {
        litui.logger.warn("litui.utils.without(..) method is deprecated. Please use litui.utils.deleteElement, litui.utils.deleteElements, litui.utils.deleteItem or litui.utils.deleteItems methods!");

        var index = $.inArray(obj, arr);
        if (index !== -1) {
            if (useSplice === true)
                arr.splice(index, 1);
            else
                arr.slice(index, 1);
        }
        return arr;
    };

    /**
     * Checks if it's function.
     * 
     * @param {mixed} fx
     * @returns {boolean}
     */
    LituiUtils.prototype.isFunction = function (fx) {
        return typeof fx === 'function';
    };
    
    LituiUtils.prototype.notFunction = function (fx) {
        return typeof fx !== 'function';
    };

    /**
     * Checks if it's undefined.
     * 
     * @param {mixed} x
     * @returns {boolean}
     */
    LituiUtils.prototype.isUndefined = function (x) {
        return x === undefined;
    };

    /**
     * Checks if it's NOT undefined..
     * 
     * @param {mixed} x
     * @returns {boolean}
     */
    LituiUtils.prototype.isDefined = function (x) {
        return x !== undefined;
    };

    /**
     * Checks if it's an array.
     * 
     * @param {mixed} x
     * @returns {boolean}
     */
    LituiUtils.prototype.isArray = function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    };

    /**
     * Checks if it's an object.
     * 
     * @param {mixed} x
     * @returns {boolean}
     */
    LituiUtils.prototype.isObject = function (x) {
        return !this.isNull(x) && !this.isUndefined(x) && !this.isArray(x) && typeof x === 'object';
    };

    /**
     * Checks if it's a promise.
     * 
     * @param {mixed} p
     * @returns {boolean}
     */
    LituiUtils.prototype.isPromise = function (p) {
        if (this.isDefined(p) && this.isFunction(p.then)) {
            return true;
        }
        return false;
    };

    /**
     * Checks if it's a string.
     * 
     * @param {mixed} val
     * @returns {boolean}
     */
    LituiUtils.prototype.isString = function (val) {
        return typeof val === "string";
    };

    /**
     * Checks if it's a number.
     * 
     * @param {mixed} val
     * @returns {boolean}
     */
    LituiUtils.prototype.isNumber = function (val) {
//        return typeof val === "number";
        if (this.isNaN(Number(val)))
            return false;
        return true;
    };

    /**
     * Checks if it's boolean value.
     * 
     * @param {mixed} val
     * @returns {boolean}
     */
    LituiUtils.prototype.isBoolean = function (val) {
        if (this.isString(val) && (val === 'false' || val === 'true'))
            return true;
        return typeof val === 'boolean';
    };

    /**
     * Checks if it's NULL value.
     * 
     * @param {mixed} val
     * @returns {boolean}
     */
    LituiUtils.prototype.isNull = function (val) {
        return val === null;
    };

    LituiUtils.prototype.nonNull = function (val) {
        return val !== null;
    };

    /**
     * Clones an object.
     * 
     * @param {Object} obj
     * @returns {Object} copy of the original object.
     */
    LituiUtils.prototype.clone = function (obj) {
        return _.clone(obj);
    };

    /**
     * Callback function must return Promise.
     * 
     * @param {Array} arr
     * @param {Function} fx Callback function.
     */
    LituiUtils.prototype.eachAsync = function (arr, fx) {
        var i = 0;
        var recursive = function () {
            if (i < arr.length) {
                fx(arr[i], i).then(function () {
                    i++;
                    recursive();
                });
            }
        };

        recursive();
    };

    /**
     * Checks if value is set. Value must not be null, undefined or empty 
     * string.
     * 
     * @param {mixed} val
     * @returns {boolean}
     */
    LituiUtils.prototype.isSet = function (val) {
        if (this.isNull(val) || this.isUndefined(val) || (this.isString(val) && val.length === 0))
            return false;
        return true;
    };

    LituiUtils.prototype.notSet = function (val) {
        return !this.isSet(val);
    };

    /**
     * Returns random number.
     * 
     * @param {Number} min
     * @param {Number} max
     * @returns {Number}
     */
    LituiUtils.prototype.random = function (min, max, controlNumber) {
        var r = Math.floor((Math.random() * (max - min)) + min);

        // 1st recursion loop
        if (this.isUndefined(controlNumber)) {
            r = this.random(min, max, r);
        }

        if (r !== controlNumber)
            return r;
        return this.random(min, max, controlNumber);
    };

    /**
     * Returns random item in array of items.
     * 
     * @param {Array} arr
     * @returns {mixed}
     */
    LituiUtils.prototype.randomItem = function (arr) {
        if (!this.isArray(arr)) {
            throw "An array of objects must be provided";
        }
        return arr[this.random(0, arr.length)];
    };

    /**
     * Finds element in array by given condition. Wrapps Lodash findWhere 
     * method. If Lodash findWhere method does not exists, Lodash find method 
     * is used (Lodash v4.17.1 compatibility).
     * 
     * @param {Array<Object>} arr
     * @param {Function|Object} condition
     * @returns {Object}
     */
    LituiUtils.prototype.findWhere = function (arr, condition) {
        if(this.isFunction(_.findWhere))
            return _.findWhere(arr, condition);
        return _.find(arr, condition);
    };

    /**
     * Checks if property exists in given context.
     * 
     * @param {Object} context
     * @param {String} propName
     * @returns {boolean}
     */
    LituiUtils.prototype.isProp = function (context, propName) {
        return context.hasOwnProperty(propName);
    };

    /**
     * Tests if given coordinates are withing given bounding box.
     * 
     * @param {Number} x1
     * @param {Number} y1
     * @param {Number} w1
     * @param {Number} h1
     * @param {Number} x2
     * @param {Number} y2
     * @param {Number} w2
     * @param {Number} h2
     * @returns {Boolean}
     */
    LituiUtils.prototype.hitTest = function (x1, y1, w1, h1, x2, y2, w2, h2) {
        if (x1 + w1 > x2)
            if (x1 < x2 + w2)
                if (y1 + h1 > y2)
                    if (y1 < y2 + h2)
                        return true;
        return false;
    };

    /**
     * 
     * @param {String} str
     * @returns {Number}
     */
    LituiUtils.prototype.strToNum = function (str) {
        return str * 1;
    };

    /**
     * 
     * @param {Number} num
     * @returns {String}
     */
    LituiUtils.prototype.numToStr = function (num) {
        return num + '';
    };

    /**
     * Deep clones obj; if objects property is also an object it will be cloned.
     * 
     * Structured clone algorithm specs:
     * https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
     * 
     * @param {Object} obj
     * @returns {Object} the clone
     */
    LituiUtils.prototype.cloneDeep = function (obj) {
        var objHolder = {};
        for (var k in obj) {
            var prop = obj[k];
//            litui.logger.debug("JSON OBJ", prop, this.isJsonObject(prop));
            if (this.isJsonObject(prop)) {
                objHolder[k] = this.cloneDeep(prop);
            }
//            else if(this.isObject(prop)){
//                if(this.isFunction(prop.clone)){
//                    objHolder[k] = prop.clone();
//                }
//                else
//                    throw "Can't clone complex object. Complex object must implement own .clone(..) method.";
//            }
//            else if(this.isArray(prop)){
//                var arr = [];
//                for(var i = 0; i < prop.length; i++){
//                    arr.push(this.cloneDeep(prop[i]));
//                }
//                objHolder[k] = arr;
//            }
            else
                objHolder[k] = this.clone(prop);
        }
        return objHolder;
    };

    /**
     * Checks if given object is a simple (POJO, JSON) object.
     * 
     * @param {Object} x
     * @returns {Boolean}
     */
    LituiUtils.prototype.isJsonObject = function (x) {
        return this.isObject(x) && x.constructor.name.toLowerCase() === "object";
    };

    /**
     * Determines which items from hash map are missing according to the 
     * control items array based on the match condition
     * 
     * @param {Object} hashmap key-value
     * @param {Array} controlItems
     * @param {Function} matchCondition
     * @returns {Array}
     */
    LituiUtils.prototype.whichMissing = function (hashmap, controlItems, matchCondition) {
        if (this.countProperties(hashmap) === 0 || this.countElements(controlItems) === 0) {
            return [];
        }
        var missingQ = [];
        for (var k in hashmap) {
            var isMissing = true;
            for (var i = 0; i < controlItems.length; i++) {
                if (matchCondition(k, i, hashmap[k], controlItems[i], hashmap, controlItems)) {
                    isMissing = false;
                    break;
                }
            }

            if (isMissing)
                missingQ.push(hashmap[k]);
        }
        return missingQ;
    };

    /**
     * Deletes items from object according to the remove que. The remove que 
     * contains property names (hash map keys)
     * 
     * @param {Object} obj key-map
     * @param {Array} removeQ An array of hashmap keys.
     * @returns {undefined}
     */
    LituiUtils.prototype.deleteItems = function (obj, removeQ) {
        for (var i = 0; i < removeQ.length; i++) {
            delete obj[removeQ[i]];
        }
    };

    /**
     * Deletes property from object by the given property name.
     * 
     * @param {String} iname Property name.
     * @param {Object} obj Object from which property will be removed.
     * @returns {undefined}
     */
    LituiUtils.prototype.deleteItem = function (iname, obj) {
        delete obj[iname];
    };

    LituiUtils.prototype.deleteElements = function (arr, removeQ, removeCondition) {
        for (var i = 0; i < removeQ.length; i++) {
            var removeIndex = -1;
            for (var j = 0; j < arr.length; j++) {
                if (removeCondition(arr[j], removeQ[i], j, i)) {
                    removeIndex = j;
                    break;
                }
            }
            if (removeIndex > -1)
                this.deleteElement(arr, removeIndex);
        }
    };

    LituiUtils.prototype.deleteElement = function (arr, index, condition) {
        if(this.isUndefined(condition)){
            arr.splice(index, 1);
            return;
        }
        if(this.isFunction(condition)){
            for(var i = 0; i < arr.length; i++){
                var elt = arr[i];
                if(condition(i, elt, index)){
                    arr.splice(i, 1);
                    return;
                }
            }
        }
            
    };

    LituiUtils.prototype.removeQ = function (a, mapper) {
        var removeQ = [];
        if (this.isObject(a))
            for (var i = 0; i < a.length; i++) {
                if (litui.utils.isDefined(mapper) && litui.utils.isFunction(mapper))
                    removeQ.push(mapper(a[i], i));
                else
                    removeQ.push(a[i]);
            }
        else
            for (var k in a) {
                if (litui.utils.isDefined(mapper) && litui.utils.isFunction(mapper))
                    removeQ.push(mapper(a[k], k));
                else
                    removeQ.push(a[k]);
            }
        return removeQ;
    };

    /**
     * Counts properties on the given JSON (simple) object.<br /><br />
     * 
     * Throws exception if given parameter is not JSON (simple) object.
     * 
     * @throws {Exception} 
     * @param {Object} obj
     * @returns {Number}
     */
    LituiUtils.prototype.countProperties = function (obj) {
        if (this.isJsonObject(obj)) {
            var i = 0;
            for (var pname in obj) {
                i++;
            }
            return i;
        }
        throw "Can't count properties; not an object (obj=" + obj + ")";
    };

    /**
     * Counts characters in the given string.<br /><br />
     * 
     * Throws exception if given parameter is not String.
     * 
     * @throws {Exception}
     * @param {String} str
     * @returns {int}
     */
    LituiUtils.prototype.countChars = function (str) {
        if (this.isString(str))
            return str.length;
        throw "Can't count characters; not a string (str=" + str + ")";
    };

    /**
     * Counts elements of an array (wrapps arr.length).<br /><br />
     * 
     * Throws exception if given parameter is not an array.
     * 
     * @throws {Exception}
     * @param {Array} arr
     * @returns {int}
     */
    LituiUtils.prototype.countElements = function (arr) {
        if (this.isArray(arr))
            return arr.length;
        throw "Can't count elements; not an array (arr=" + arr + ")";
    };

    /**
     * Counts:<br />
     * a) properties if given parameter is an object<br />
     * b) characters if given parameter is a string<br />
     * c) elements if given parameter is an array<br /><br />
     * 
     * Throws exception if given parameter is not of type: Object, String or 
     * Array.
     * 
     * @throws {Exception}
     * @param {Object|String|Array} item
     * @returns {Number|int|Object.prototype.countProperties.i}
     */
    LituiUtils.prototype.count = function (item) {
        if (this.isJsonObject(item))
            return this.countProperties(item);
        if (this.isString(item))
            return this.countChars(item);
        if (this.isArray(item))
            return this.countElements(item);
        throw "Can't count; not a countable value; please provide JSON object, String or an Array; (item=" + item + ")";
    };

    /**
     * Checks if array contains certain element.<br /><br />
     * 
     * Throws exception if given parameter is not an Array.
     * 
     * @throws {Exception}
     * @param {Array} arr
     * @param {*} val
     * @returns {Boolean}
     */
    LituiUtils.prototype.contains = function (arr, val) {
        if (!this.isArray(arr))
            throw "Can't check if array contains value; provided structure is not an array (" + (typeof arr) + ")";

        return arr.indexOf(val) > -1;
    };

    /**
     * Encodes MD5 hash. It uses md5 lib under the hood.
     * 
     * @param {String} a
     * @returns {String} representing MD5 hash.
     */
    LituiUtils.prototype.encodeHash = function (a) {
        return md5(JSON.stringify(a));
    };

    /**
     * Calculates diff between two arrays and returns diff object, which contains:
     * <ul>
     *  <li>updateItems:Array - an array of items that already exist and should 
     *  be updated</li>
     *  <li>newItems:Array - an array of items that don't yet exist in the given 
     *  array</li>
     *  <li>obsoleteItems:Array - an array of items that should not exist in the 
     *  given array anymore</li>
     * </ul>
     * 
     * Simple example:
     * litui.utils.arrayDiff(['orange', 'apple', 'strawberry'],['cabbage', 'peach', 'strawberry', 'orange'],function(a,b){ return a === b});
     * 
     * @param {Array} arr1 "Old" array
     * @param {Array} arr2 "New" array
     * @param {Function} matchCriteria A function which return value is the 
     * condition by which items in the two arrays are matched (must return 
     * Boolean).
     * @returns {Object} array diff object.
     */
    LituiUtils.prototype.arrayDiff = function (arr1, arr2, matchCriteria) {
        if (!this.isArray(arr1) || !this.isArray(arr2))
            throw "Can't calculate array diff, one of the parameters is not an array!";
        if (!this.isFunction(matchCriteria))
            throw "Can't calculate array diff, match criteria must be a function returning Boolean!";
        var diffs = null;
        var obsolete = null;
        var fresh = null;
        for (var i = 0; i < arr1.length; i++) {
            var item1 = arr1[i];
            var hash1 = this.encodeHash(item1);

            var item2 = null;
            var hash2 = null;
            for (var j = 0; j < arr2.length; j++) {
                item2 = arr2[j];
                if (matchCriteria(item1, item2, i, j)) {
                    hash2 = this.encodeHash(item2);
                    break;
                }
                item2 = null;
            }
            // exists and differs
            if (!this.isNull(item2) && hash1 !== hash2) {
                if (this.isNull(diffs))
                    diffs = {};
                diffs[i] = item2;
            } else if (this.isNull(item2)) {
                if (this.isNull(obsolete))
                    obsolete = {};
                obsolete[i] = item1;
            }
        }

        for (var i = 0; i < arr2.length; i++) {
            var item2 = arr2[i];
            var exists = false;
            for (var j = 0; j < arr1.length; j++) {
                var item1 = arr1[j];
                if (matchCriteria(item1, item2, j, i)) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                if (this.isNull(fresh))
                    fresh = {};
                fresh[i] = item2;
            }
        }

        return {
            updateItems: diffs,
            newItems: fresh,
            obsoleteItems: obsolete
        };
    };

    /**
     * Returns the last item in hash map. Keys in hash map must be of numeric 
     * value (can be number typeof string, e.g. "1", "2"...).
     * 
     * @param {Object} obj Object representing hash map
     * @returns {*} last item of the hash map.
     */
    LituiUtils.prototype.getLastItem = function (obj) {
        var capture = null;
        for (var k in obj) {
            capture = obj[k];
        }
        return capture;
    };

    /**
     * Returns the last key of the hash map. Keys in hash map must be of numeric 
     * value (can be number typeof string, e.g. "1", "2"...).
     * 
     * @param {Object} obj
     * @returns {String|int}
     */
    LituiUtils.prototype.getLastKey = function (obj) {
        var capture = null;
        for (var k in obj) {
            capture = k;
        }
        return capture;
    };

    /**
     * Takes the numeric decimal value and cuts off any trailing zeros after 
     * the decimal point (delimiter).
     * 
     * @param {Number} value
     * @param {String} delimiter [default="."]
     * @returns {Number} number without trailing decimal zeros.
     */
    LituiUtils.prototype.cutTrailingDecimalZeros = function (value, delimiter) {
        if (this.isUndefined(delimiter))
            delimiter = ".";
        var str = litui.utils.numToStr(value);
        var delimIndex = str.indexOf(delimiter);
        str = litui.utils.numToStr(value);
        var lastindex = -1;
        for (var i = str.length - 1; i > delimIndex; i--) {
            var c = str[i];
            if (c === "0")
                lastindex = i;
            else
                break;
        }
        return litui.utils.strToNum(lastindex === -1 ? str : str.substring(0, lastindex));
    };

    LituiUtils.prototype.roundToHalf = function (val, whole) {
        var a = Math.floor(val);
        return Math.abs(a - val) > 0 ? a + (whole / 2) : val;
    };

    /**
     * Solution adapted from:
     * https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
     * 
     * @param {String} str
     * @returns {String}
     */
    LituiUtils.prototype.toCamelCase = function (str) {
        return str
                .replace(/\s(.)/g, function ($1) {
                    return $1.toUpperCase();
                })
                .replace(/\s/g, '')
                .replace(/^(.)/, function ($1) {
                    return $1.toLowerCase();
                });
    };

    /**
     * 
     * @param {String} str
     * @returns {String}
     */
    LituiUtils.prototype.toKebabCase = function (str) {
        return _.kebabCase(str);
    };

    LituiUtils.prototype.kebabToCamelCase = function (str) {
        return litui.utils.toCamelCase(litui.utils.strReplace(str, '-', ' '));
    };

    /**
     * 
     * @param {DOMElement} $component
     * @param {Object} bindingParams Key-value map
     */
    LituiUtils.prototype.applyBindingsToElement = function ($component, bindingParams) {
        for (var k in bindingParams) {
            var paramValue = bindingParams[k];
            var bindingAttrName = this.toKebabCase(k); // njami :D
            $component.attr(bindingAttrName, paramValue);
        }
    };

    /**
     * 
     * @param {Object} hashMap Object representing Hash map
     * @returns {Array}
     */
    LituiUtils.prototype.hashMapToArray = function (hashMap) {
        var arr = [];
        for (var k in hashMap) {
            var item = hashMap[k];
            arr.push(item);
        }
        return arr;
    };

    /**
     * 
     * @param {Array:Object} arr
     * @param {String} pname
     * @param {String} delim [optional]
     * @returns {String}
     */
    LituiUtils.prototype.arrayToString = function (arr, pname, delim) {
        delim = litui.utils.isUndefined(delim) ? ", " : delim + " ";
        var str = "";
        for (var i = 0; i < arr.length; i++) {
            str += ((i > 0) ? delim : "") + arr[i][pname];
        }
        return str;
    };

    /**
     * 
     * @param {Number} value
     * @returns {Number}
     */
    LituiUtils.prototype.valueToPercent = function (value) {
        return value / 100;
    };


    LituiUtils.prototype.isNumeric = function (value) {
        // if it's not NaN (Not A Number) => it's a number
        return !isNaN(value);
    };
    
    // TODO: this gets overriden!
    LituiUtils.prototype.equals = function (valueA, valueB) {
        return angular.equals(valueA, valueB)
    };

    LituiUtils.prototype.degToRad = function (deg) {
        return deg * Math.PI / 180;
    };

    LituiUtils.prototype.radToDeg = function (rad) {
        return rad * 180 / Math.PI;
    };

    LituiUtils.prototype.arrayUpdate = function (arr, updateArr, condition, onUpdate) {
        var diff = this.arrayDiff(arr, updateArr, condition);


        for (var k in diff.updateItems) {
            if (this.isObject(arr[this.strToNum(k)]) && this.isObject(diff.updateItems[k]))
                litui.lang.merge(arr[this.strToNum(k)], diff.updateItems[k]);
        }

        for (var k in diff.newItems) {
            arr.push(diff.newItems[k]);
        }

        for (var k in diff.obsoleteItems) {
            this.deleteElement(arr, this.strToNum(k));
        }
    };

    LituiUtils.prototype.strReplace = function (str, find, replace) {
        while (str.indexOf(find) > -1) {
            str = str.replace(find, replace);
        }
        return str;
    };

    LituiUtils.prototype.clearWhitespaces = function (val) {
        return val.replace(/\s/g, '');
    };

    LituiUtils.prototype.trimLeadingWhitespaces = function (str) {
        var index = -1;
        for (var i = 0; i < str.length; i++) {
            var ch = str[i];
            if (ch !== " ") {
                if (index === -1)
                    index = i;
                break;
            }
        }
        if (index.indexA > -1)
            return str.substring(index.indexA);
        return str;
    };

    LituiUtils.prototype.trimTrailingWhitespaces = function (str) {
        var index = -1;
        for (var i = str.length - 1; i > 0; i--) {
            var ch = str[i];
            if (ch !== " ") {
                if (index === -1)
                    index = i + 1;
                break;
            }
        }
        if (index > -1)
            return str.substring(0, index);
        return str;
    };

    LituiUtils.prototype.trimWhitespaces = function (str) {
        return this.trimTrailingWhitespaces(this.trimLeadingWhitespaces(str));
    };

    LituiUtils.prototype.ensureProperties = function (obj, declaration) {
        for (var i = 0; i < declaration.length; i++) {
            if (!obj.hasOwnProperty(declaration[i]))
                throw "Exception when ensuring object properties: property with name '" + declaration[i] + "' was not found in the object, but it was declared!"
        }
    };

    LituiUtils.prototype.arrayToHashmap = function (arr) {
        var hm = {};
        for (var i = 0; i < arr.length; i++) {
            hm[this.numToStr(i)] = arr[i];
        }
        return hm;
    };

    LituiUtils.prototype.sortBy = function (arr, callback) {
        if (this.isDefined(arr) && this.isDefined(callback) && this.isFunction(callback)) {
            return arr.sort(callback);
        }
    };

    /**
     * Checks if given value is NaN.
     * 
     * @param {mixed} arr
     * @returns {Boolean}
     
     */
    LituiUtils.prototype.isNaN = function (arr) {
        return _.isNaN(arr);
    };

    /**
     * Extracts item from object by given map.
     * 
     * @param {Object} obj
     * @param {string} keyMap Keymap: someObject.antoher.object.see.pattern.itemIwant
     * @returns {undefined}
     */
    LituiUtils.prototype.extractItem = function (obj, keyMap) {
        var item;
        if (keyMap.indexOf(".") > -1) {
            var val = keyMap.split(".");
            var elt;
            for (var i = 0; i < val.length; i++) {
                if (i === 0)
                    elt = obj[val[i]];
                else if(this.isDefined(elt))
                    elt = elt[val[i]];
            }
            item = elt;
        } else {
            item = obj[keyMap];
        }

        return item;
    };
    
    LituiUtils.prototype.updateItem = function (obj, keyMap, value) {
        if (keyMap.indexOf(".") > -1) {
            var val = keyMap.split(".");
            var item;
            for (var i = 0; i < val.length - 1; i++) {                
                if (i === 0){
                    item = obj[val[i]];
                    if(litui.utils.isUndefined(item)){
                        item = {};
                        obj[val[i]] = item;
                    }
                }
                else if(this.isDefined(item))
                    item = item[val[i]];
            }
//            if(this.isUndefined(item)){
//                item = {};
//                for (var i = 0; i < val.length - 1; i++) {
//                    item[val[i]] = {};
//                }
//            }
            
            item[val[val.length - 1]] = value;
            
        } else {
             obj[keyMap] = value;
        }
        return obj;
    };

    /**
     * @description Capitalizes first letter of the string.
     * @param {String} selectedGroups selected groups item
     * @returns {boolean, Array[Group]}
     */
    LituiUtils.prototype.capitalizeFirstLetter = function (string) {
        if (typeof string === "string")
            return string.charAt(0).toUpperCase() + string.slice(1);
        return string;
    };

    LituiUtils.prototype.containsDuplicate = function (valArr) {
        var values = [];
        for (var i = 0; i < valArr.length; i++) {
            var val = valArr[i];
            // found duplicate, exit
            if (values.indexOf(val) > -1) {
                return true;
            }
            values.push(val);
        }
        return false;
    };

    LituiUtils.prototype.getKeyByValue = function (obj, val) {
        for (var k in obj) {
            var objval = obj[k];
            if (objval === val)
                return k;
        }
    };

    LituiUtils.prototype.keysToArray = function (obj) {
        var arr = [];
        for (var k in obj) {
            arr.push(k);
        }
        return arr;
    };

    LituiUtils.prototype.toBoolean = function (value) {
        return value === "true" || value > 0;
    };

    /**
     *  Post parameter data to specific url
     *  
     * @param {string} path
     * @param {obj} params params: object with attr (filter: filterString, header: headerString, ...)
     * @param {boolean} newWindow: open new window
     * @param {string} method: rest method 
     * @param {string} enctype: header encryption type
     * @returns {undefined} some data from server
     */
    LituiUtils.prototype.postToURL = function (path, params, newWindow, method, enctype) {
        method = method || "post"; // Set method to post by default if not specified.
        enctype = enctype || "multipart/form-data";

        // The rest of this code assumes you are not using a library.
        // It can be made less wordy if you use one.
        var form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);
        form.setAttribute("enctype", enctype);

        if (newWindow)
            form.target = "_blank";

        for (var key in params) {
            if (params.hasOwnProperty(key)) {
                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", key);
                hiddenField.setAttribute("value", params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
    };

    /**
     * Finds an item in given object or array by specified condition.
     * 
     * @param {Object|Array} obj Object or array to be looked up
     * @param {Object} condition Key-value pairs defining condition (e.g. { id: 4 } - will find an item with id property set to 4
     */
    LituiUtils.prototype.findIn = function (obj, condition) {
        var foundArr = []; // array of objects matched by condition
        for (var key in condition) {
            var val = condition[key]; // condition value

            // check for key in Object
            if (obj instanceof Object && obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] === val) {
                // insert unique (when equals -1)
                if ($.inArray(obj, foundArr) === -1) {
                    foundArr.push(obj);
                }
            }
            // check for key in Array
            else if (obj instanceof Array) {
                for (var i = 0; i < obj.length; i++) {
                    if (obj[i][key] === val && $.inArray(obj[i], foundArr) === -1) {
                        foundArr.push(obj[i]);
                    }
                }
            }
        }

        // if array legnth is 0, return undefined
        if (foundArr.length === 0)
            return undefined;
        else if (foundArr.length === 1)
            return foundArr[0];
        return foundArr;
    };

    /**
     * Checks if array has an element picked by given condition.
     * 
     * @param {Array} arr
     * @param {Object} condition Object containing key => value pair which defines the condition. (E.g. { id: 4 }).
     * @returns {Boolean}
     */
    LituiUtils.prototype.containsWith = function (arr, condition) {

        for (var key in condition) {
            var val = condition[key]; // condition value
            //
            // check for condition in Object and arr is Array type
            if (arr instanceof Array && condition instanceof Object && condition.hasOwnProperty(key) && condition[key] !== undefined) {
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i] instanceof Object && arr[i].hasOwnProperty(key) && arr[i][key] === val) {
                        return true;
                    } else if (arr[i] === val) {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    LituiUtils.prototype.gotoURL = function (path) {
        window.location.assign(path);
    };

    LituiUtils.prototype.calc = function (calcExpression, pivotValue) {
        var expressionStart = calcExpression.indexOf("calc(") + 5;
        var expression = this.clearWhitespaces(calcExpression.substring(expressionStart, calcExpression.length - 1));

        var delim = ["%", "p", "x"];
        var operators = ["+", "-", "/", "*"];
        var calculus = "";
        var actor = "";
        for (var i = 0; i < expression.length; i++) {
            var ch = expression[i];
            var write = false;

            if (delim.indexOf(ch) === -1 && operators.indexOf(ch) === -1 && this.isNumeric(ch)) {
                actor += ch;
            } else {
                if (ch === "%") {
                    actor = this.calcRelative(actor, pivotValue);
                    write = false;
                } else if (operators.indexOf(ch) > -1) {
                    actor += ch;
                    write = true;
                } else {
                    write = false;
                }

            }

            if (write || i === expression.length - 1) {
                calculus += actor;
                actor = "";
            }
        }
        var res = eval(calculus);
//        lt.logger.debug("Expression %o, Parent %o, calculus %o, result %o", calcExpression, parentValue, calculus, res);
        return res;
    };

    LituiUtils.prototype.calcRelative = function (value, pivotValue) {
        value = this.strToNum(value) / 100;
        return pivotValue * value;
    };

    LituiUtils.prototype.calcDimension = function (value, privotValue) {
        var h = this.numToStr(value);
        if (h.indexOf('calc') > -1) {
            return this.strToNum(this.calc(h, privotValue));
        } else if (h.indexOf('%') > -1) {
            var perc = this.strToNum(h.substring(0, h.indexOf('%'))) / 100;
            return this.strToNum(privotValue * perc);
        }
        return this.strToNum(h);
    };

    LituiUtils.prototype.existsIn = function (arr, element, condition) {
        for (var i = 0; i < arr.length; i++) {
            var item = arr[i];
            if (this.isFunction(condition) && condition(item, element)) {
                return true;
            } else if (this.isString(condition) && item[condition] === element[condition]) {
                return true;
            } else if (arr.indexOf(element) > -1)
                return true;
        }
        return false;
    };

    LituiUtils.prototype.notExistsIn = function (arr, element, condition) {
        return !this.existsIn(arr, element, condition);
    };

    /**
     * Tests wether object contains cyclic references.
     * 
     * @param {Object} obj
     * @returns {Boolean}
     */
    LituiUtils.prototype.isObjectCyclic = function (obj) {
        return this.detectCyclicReference(obj, []);
    };

    /**
     * Detects cyclic object reference within the object. If cyclic reference is 
     * detected return TRUE.
     * 
     * @param {Object} obj
     * @param {Array:Object} seenObjects Keep track of already tested object.
     * @returns {Boolean}
     */
    LituiUtils.prototype.detectCyclicReference = function (obj, seenObjects) {
        if (obj && typeof obj === 'object') {
            if (seenObjects.indexOf(obj) !== -1) {
                return true;
            }
            seenObjects.push(obj);
            for (var key in obj) {
                if (this.isDefined(obj[key]) && this.detectCyclicReference(obj[key], seenObjects)) {
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * Serializes object safe from cyclic object references.
     * 
     * SOLUTION ADAPTED:
     * https://stackoverflow.com/a/14962496
     * 
     * @param {Object} object
     * @param {Object} settings { skipFunction:Boolean(false), flat:Boolean(false), skipCyclingReference:Boolean(false) }
     * @returns {String}
     */
    LituiUtils.prototype.serializeObject = function (object, settings) {
        if (this.isUndefined(settings))
            settings = {};
        litui.lang.mergeB({
            skipFunction: false,
            flat: false,
            skipCyclingReference: false
        }, settings);

        var simpleObject = {};
        for (var k in object) {
            var val = object[k];
//            console.log(object);
            if (this.isUndefined(val)) {
                simpleObject[k] = val;
                continue;
            }
            if (typeof (object[k]) === 'object' && settings.flat) {
                continue;
            }
            if (typeof (object[k]) === 'object' && !settings.skipCyclingReference && this.isObjectCyclic(object[k])) {
                if (this.isDefined(val.constructor))
                    val = "[" + val.constructor.name + "]";
                else
                    val = "[Object]";
            }
            if (typeof (object[k]) === 'function' && settings.skipFunction) {
                continue;
            }
            if (typeof (object[k]) === 'function') {
                val = "[Function]";
            }
            simpleObject[k] = val;
        }
        return JSON.stringify(simpleObject); // returns cleaned up JSON
    };

    LituiUtils.prototype.serializeArray = function (arr, settings) {
        var serArr = [];
        for (var i = 0; i < arr.length; i++) {
            var value = arr[i];
            if (litui.isObject(value))
                serArr[i] = this.serializeObject(value, settings);
            else
                serArr[i] = this.toString(value);
        }
        return JSON.stringify(serArr);
    };

    LituiUtils.prototype.findWhereIn = function (arrA, arrB, condition) {
        var found = [];
        for (var i = 0; i < arrA.length; i++) {
            var itemA = 0;
            for (var j = 0; j < arrB.length; j++) {
                var itemB = arrB[j];

                if (condition(itemA, itemB))
                    found.push(itemA);
            }
        }
        return found;
    };

    /**
     * Solution adapted from:
     * https://stackoverflow.com/questions/12505598/get-next-key-value-pair-in-an-object
     * 
     * @param {type} obj
     * @param {type} key
     * @returns {Boolean}
     */
    LituiUtils.prototype.getNextItem = function (obj, key) {
        var keys = Object.keys(obj);
        lt.logger.log("Are keys in correct order????", keys);
        var i = keys.indexOf(key);
        return i !== -1 && keys[i + 1] && obj[keys[i + 1]];
    };

    LituiUtils.prototype.getNextKey = function (obj, key) {
        var keys = Object.keys(obj);
        var i = keys.indexOf(key);
        lt.logger.log("Get next key:", keys, i, keys[i]);
        return i !== -1 && keys[i + 1];
    };

    LituiUtils.prototype.getFirstItem = function (obj) {
        for (var k in obj) {
            return obj[k];
        }
    };

    LituiUtils.prototype.getFirstKey = function (obj) {
        for (var k in obj) {
            return k;
        }
    };

    /**
     * Defaults the given value to specified default value. Default happens when 
     * provided value is not set (reffer to .isSet(..) method).
     * 
     * NOTE: DO NOT USE THIS TO DEFAULT OBJECTS, AS REFERENCE WILL BE BROKEN!!!
     * 
     * @param {*} val
     * @param {*} defaultVal
     * @returns {*}
     */
    LituiUtils.prototype.defaultTo = function (val, defaultVal) {
        if (this.isUndefined(val) || this.isNull(val) || (this.isString(val) && val.length === 0))
            return defaultVal;
        return val;
    };

    LituiUtils.prototype.indexOf = function (arr, item) {
        var index = -1;
        for (var i = 0; i < arr.length; i++) {
            var mo = arr[i];
            if (this.equals(item, mo)) {
                index = i;
                break;
            }
        }
        return index;
    };

    /**
     * Two objects are equal when all of their public properties are equal.
     * 
     * @param {mixed} a
     * @param {mixed} b
     * @returns {Boolean}
     */
    LituiUtils.prototype.equals = function (a, b) {
        // compare objects
        if (this.isObject(a) && this.isObject(b)) {
//            if((this.isEmpty(a) && !this.isEmpty(b)) ||
//                !this.isEmpty(a) && this.isEmpty(b))
//                return false;
            
            for (var propName in a) {
                if (this.isPropertyPrivate(propName)) {
                    continue;
                }

                var propA = a[propName];

                // do they have the same properties?
                if (!b.hasOwnProperty(propName))
                    return false;
                for (var k in b) {
                    if (!a.hasOwnProperty(k) && !this.isPropertyPrivate(k))
                        return false;
                }

                var propB = b[propName];

                // check for object orr array
                if ((this.isObject(propA) && this.isObject(propB)) ||
                        (this.isArray(propA) && this.isArray(propB))) {
                    if (!this.equals(propA, propB))
                        return false;
                } else if (propA !== propB)
                    return false;
            }
            return true;
        }
        // compare arrays
        else if (this.isArray(a) && this.isArray(b)) {
            for (var i = 0; i < a.length; i++) {
                var itemA = a[i];
                var itemB = b[i];

                if (!this.equals(itemA, itemB))
                    return false;
            }
            return a.length === b.length;
        }

        // compare primitive types
        if (a !== b) {
            return false;
        }
        return true;
    };

    LituiUtils.prototype.isPropertyPrivate = function (propName) {
        return propName.substr(0, 2) === "$$" || propName.substr(0, 2) === "__";
    };

    LituiUtils.prototype.toString = function (val, settings) {
        if (this.isObject(val)) {
            return this.serializeObject(val, settings);
        } else if (this.isArray(val))
            return this.serializeArr(val, settings);
        return val + "";
    };

    LituiUtils.prototype.toUpperCase = function (val) {
        if (litui.utils.isString(val))
            return val.toUpperCase();
        return val;
    };

    LituiUtils.prototype.toLowerCase = function (val) {
        if (litui.utils.isString(val))
            return val.toLowerCase();
        return val;
    };

    LituiUtils.prototype.objectUpdate = function (origin, fresh) {
        var pdiff = this.propertyDiff(origin, fresh);

        // update
        for (var i = 0; i < pdiff.updateItems.length; i++) {
            var pname = pdiff.updateItems[i];
            var originProp = origin[pname];

            if (this.isObject(originProp) && !this.isObjectCyclic(originProp))
                this.objectUpdate(originProp, fresh[pname]);
            else
                origin[pname] = fresh[pname];
        }

        // remove
        for (var i = 0; i < pdiff.obsoleteItems.length; i++) {
            var pname = pdiff.obsoleteItems[i];
            this.deleteItem(pname, origin);
        }

        // add
        for (var i = 0; i < pdiff.newItems.length; i++) {
            var pname = pdiff.newItems[i];
            origin[pname] = fresh[pname];
        }
        return origin;
    };

    LituiUtils.prototype.propertyDiff = function (a, b) {
        var diff = {
            updateItems: [],
            newItems: [],
            obsoleteItems: []
        };
        for (var pname in a) {
            if (!b.hasOwnProperty(pname)) {
                diff.obsoleteItems.push(pname);
                continue;
            }
            if (b.hasOwnProperty(pname) && a[pname] !== b[pname]) {
                diff.updateItems.push(pname);
                continue;
            }
        }
        for (var pname in b) {
            if (!a.hasOwnProperty(pname)) {
                diff.newItems.push(pname);
                continue;
            }
        }
        return diff;
    };

    /**
     * Parses value from string and converts it into given type.
     * Supported types:
     * String, Text, Number, Long, Integer, Double, Float, Boolean, Date,
     * Time, DateTime. Note that these are descriptive types not native to JS.
     * The Text type, for example, will be converted to String, while Long, 
     * Integer, Double and Float types will be converted to Number. For Date,
     * Time and DateTime Moment is used but with different formatting, although 
     * formatting can be changed afterwards.
     * 
     * @param {String} value
     * @param {String} type
     * @returns {Number|String|Boolean}
     */
    LituiUtils.prototype.parseValueFromStr = function (value, type) {
        switch (type.toUpperCase()) {
            case 'STRING':
            case 'TEXT':
                return value + "";
            case 'NUMBER':
            case 'LONG':
            case 'INTEGER':
            case 'DOUBLE':
            case 'FLOAT':
                return this.strToNum(value);
            case 'BOOLEAN':
                return this.toBoolean(value);
            case 'TIME':
                return litui.dateTime.fromFormat(value, 'TIME');
            case 'DATE':
                return litui.dateTime.fromFormat(value, 'DATE');
            case 'DATETIME':
                return litui.dateTime.fromFormat(value, 'DATETIME');
        }
    };

    LituiUtils.prototype.toDataURL = function (src) {
        return litui.request.blobToBase64(src);
    };

    LituiUtils.prototype.imageToBase64 = function (src) {
        var d = litui.async.defer();
        this.toDataURL(src).then(function (encodedStr) {
            var img = new Image();
            img.src = encodedStr;
            img.onload = function () {
                d.resolve(img);
            };
            img.onerror = function (err) {
                d.reject(err);
            };
        }).catch(function (err) {
            d.reject(err);
        });
        return d.promise;
    };

    LituiUtils.prototype.migrateElementsToArr = function (elts, arrA, arrB, iteration) {
        for (var i = 0; i < elts.length; i++) {
            var elt = elts[i];
            arrA.push(elt);
            this.deleteElement(arrB, arrB.indexOf(elt));

            if (this.isFunction(iteration(elt)))
                iteration();

        }
        return [];
    };
    
    LituiUtils.prototype.isSimpleObject = function(a){
        return this.isObject(a) && !this.isObjectCyclic(a);
    };
    
    LituiUtils.prototype.isInteger = function(value){
        return this.isNumber(2) && Number.isInteger(value);
    };
    
    LituiUtils.prototype.notEmpty = function(value){
        return !this.isEmpty(value);
    };
    
    LituiUtils.prototype.regexForFormat = function(format){
        switch(format){
            case 'image':
                return /.jpg|.jpeg|.png|.svg$/i; 
            case 'txt':
            default:
                return /.txt$/i;
        }
    };
    
    /**
     * 
     @src https://stackoverflow.com/questions/14880229/how-to-replace-a-substring-between-two-indices
     */
    LituiUtils.prototype.replaceBetween = function(start, end, what) {
        return this.substring(0, start) + what + this.substring(end);
    };
    
    LituiUtils.prototype.stringifyValue = function(value, type) {
        switch(type){
            case 'ENUM_KEY':
                var str = "";
                if(litui.utils.isObject(value)){
                    litui.utils.foreach(value, function(pname, pvalue){
                        str += pname +  ",";
                    });
                    str = str.substr(0, str.length - 1);
                }
                else if(litui.utils.isArray(value)){
                    litui.utils.foreach(value, function(i, pvalue){
                        str += pvalue +  ",";
                        litui.logger.log("Well?=?", pvalue);
                    });
                    str = str.substr(0, str.length - 2);
                }
                else
                    str = ",";
                    litui.logger.log("Ojoj...", value);
                
                return str;
        }
    };
    
    LituiUtils.prototype.foreach = function (obj, cb) {
        try {
            if (this.isObject(obj))
                for (var k in obj) {
                    cb(k, obj[k]);
                }
            else if (this.isArray(obj))
                for (var i = 0; i < obj.length; i++) {
                    cb(i, obj[i]);
                }
        } catch (ex) {
            console.error("Exception in foreach", ex);
        }
    };
    
    LituiUtils.prototype.getKeys = function (hashMap) {
        var arr = [];
        for (var k in hashMap) {
            arr.push(k);
        }
        return arr;
    };
    
    LituiUtils.prototype.generateUuid = function(parts){
        if(this.notSet(parts)){
            parts = 6;
        }
        
        var stringArr = [];
        for(var i = 0; i< parts; i++){
            // tslint:disable-next-line:no-bitwise
            var S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            stringArr.push(S4);
        }
        return stringArr.join('-');
    };
    

    litui.$$register(LituiUtils);
})();
'use strict';

(function(){
    LituiNamespaceFactory.__SINGLETON__ = { name: 'namespaceFactory', module: ''};
    function LituiNamespaceFactory(){
        
    }
    
    LituiNamespaceFactory.prototype.produce = function(name, version, Registry){
        // dynamic object name: https://stackoverflow.com/questions/12826154/can-i-create-dynamic-object-names-in-javascript
        var constrFx = new Function("return function " + litui.utils.capitalizeFirstLetter(name) + "(){}");
        var Ns = constrFx();
        var ns = new Ns();
        ns.$$version = version || "N/A";
        this.createRegistry(ns, Registry);
        this.createLogger(ns, name);
        return ns;
    };
    
    LituiNamespaceFactory.prototype.createRegistry = function(ns, Registry){
        ns.$$registry = new Registry(ns);
        ns.$$register = function $$register(c){
            ns.$$registry.register(c);
        };
        return ns;
    };
    
    LituiNamespaceFactory.prototype.createLogger = function(ns, name){
        ns.logger = litui.logger.produce(name);
    };
    
    litui.$$register(LituiNamespaceFactory);
})();'use strict';
(function () {
    LituiConfig.__SINGLETON__ = {name: 'config', module: ''};

    function LituiConfig() {
        this.settings = {
            timezone: 'Europe/Ljubljana',
            weather: {
                units: 'metric'
            },
            currencySymbol: '€',
            weightUnitType: 'kg'
        };
    }
    
    LituiConfig.prototype.set = function(settings){
        this.settings = litui.lang.deepMerge(this.settings, settings);
    };
    
    LituiConfig.prototype.get = function(pname){
        return this.settings[pname];
    };
    
    litui.$$register(LituiConfig);
})();
(function(){
    LituiSubscribe.__CLASS__ = { name: 'Subscribe', module: ''};
    /**
     * Constructs Subscribe object. It appends two methods to the context, for 
     * registering/unregistering events; ON and OFF. The Subscribe instance can 
     * be referenced from the context $$subscribe property.
     * 
     * @class

     * @param {Object} context
     * MyClass becomes the context of the subscription.
     * @param {Array<String>} eventsDeclaration A declaration list of event IDs.
     * @example 
function MyClass(){
    new Subscribe(this, ['EVENT_1', 'EVENT_2']);
}
     */
    function LituiSubscribe(context, eventsDeclaration){
        var self = this;
        
        if(litui.utils.isUndefined(context)){
            throw "Context is needed for subscription!";
        }
        
        this.context = context;
        this.subscriptions = {};
        
        /**
         * Registers callback for specific event.
         * 
         * @param {String} name Event name.
         * @param {Function} callback Event subscription callback.
         * @returns {Function} callback reference (can be used for deregistering 
         * specific event callback).
         */
        context.on = function(name, callback){
            if(arguments.length === 0)
                throw "ON method must have at least one (1) argument. 0 given.";
            
            if(!litui.utils.isFunction(callback))
                throw "Second argument must be a function, when registering new event listener (first argument is event name)!";
            return self.registerEvent(name, callback);
        };
        
        /**
         * Method dedicated for triggering event subscription.
         * 
         * The number of arguments is optional, but at least ONE argument must 
         * be provided. This argument is the event name for which subscriptions 
         * are being triggered.
         * 
         * Provided arguments, without the first (event name) argument, are then 
         * applied to the triggered callback.
         * 
         * @throws {Exception} 
         * @param {String} name Event name
         */
        context.trigger = function(){
            if(arguments.length === 0)
                throw "ON method must have at least one (1) argument. 0 given.";
            self.execEvent.apply(self, arguments);
        };
        
        /**
         * Method dedicated for deregistering event subscriptions. There are a 
         * few ways one can deregister subscription:
         * <ol>
         *  <li>By defined event reference: 
         *      var cb = ltSubscribe.on('FOO', function(){ });
         *      ltSubscribe.off(cb);
         *  </li>
         *  <li>By defined event reference for specific event namespace: 
         *      var cb = ltSubscribe.on('FOO', function(){ });
         *      ltSubscribe.off('FOO', cb);
         *      
         *      NOTE: this method works faster than the one above, because it 
         *      doesn't have to auto-discover the event callback in event 
         *      namespaces. If you are sure on what callback you are 
         *      deregistering, use this method. If not, use the one above.
         *  </li>
         *  <li>By an array of event names:
         *      ltSubscribe.on('FOO', function(){ }); // FOO subscription 1
         *      ltSubscribe.on('FOO', function(){ }); // FOO subscription 2
         *      ltSubscribe.on('BOO', function(){ }); // BOO subscription 1
         *      ltSubscribe.on('BOO', function(){ }); // BOO subscription 2
         *      ltSubscribe.on('GOO', function(){ }); // GOO subscription 1
         *      ltSubscribe.on('GOO', function(){ }); // GOO subscription 2
         *      
         *      ltSubscribe.off(['FOO', 'BOO', 'GOO']);
         *      
         *      NOTE: this deregisters any subscriptions for given event 
         *      namespaces
         *  </li>
         *  <li>By event name:
         *      ltSubscribe.on('FOO', function(){ }); // FOO subscription 1
         *      ltSubscribe.on('FOO', function(){ }); // FOO subscription 2
         *      
         *      ltSubscribe.off('FOO');
         *      
         *      NOTE: this deregisters any subscriptions for given event 
         *      namespace
         *  </li>
         * </ol>
         * 
         * 
         * @returns {undefined}
         */
        context.off = function(){
            if(arguments.length === 0){
                self.subscriptions = {};
            }
            else if(arguments.length === 1){
                // auto-discover which callback to remove
                if(litui.utils.isFunction(arguments[0])){
                    for(var k in self.subscriptions){
                        if(self.deregisterEventSubscriber(self.subscriptions[k], arguments[0], k))
                            break;
                    }
                }
                // remove subscriptions by event name (will remove all 
                // subscribers of the particular events)
                else if(litui.utils.isArray(arguments[0])){
                    for(var i = 0; i < arguments[0].length; i++){
                        self.subscriptions[arguments[0][i]] = [];
                    }
                } 
                else
                    self.subscriptions[arguments[0]] = [];
            }
            // remove specific callback from specific event
            else if(arguments.length === 2 && litui.utils.isDefined(self.subscriptions[arguments[0]])){
                self.deregisterEventSubscriber(self.subscriptions[arguments[0]], arguments[1], arguments[0]);
            }
        };
        
        // declare events, if their names are provided
        if(litui.utils.isArray(eventsDeclaration)){
            for(var i = 0; i < eventsDeclaration.length; i++){
                var event = eventsDeclaration[i];
                if(litui.utils.isUndefined(this.subscriptions[event])){
                    this.subscriptions[event] = [];
                }
                context.on[event] = event;
            }
        }
        if(litui.utils.isFunction(this.context.subscribe)){
            this.context.subscribe();
        }
        context.$$subscribe = this;
    }
    
    LituiSubscribe.prototype.deregisterEventSubscriber = function(eventNamespace, cb, eventName){
        var cbIndex = undefined;
        for(var i = 0; i < eventNamespace.length; i++){
            if(eventNamespace[i] === cb){
                
                eventNamespace[i] = undefined;
                cbIndex = i;
                break;
            }
        }
        
        eventNamespace.splice(cbIndex, 1);
        
        if(this.subscriptions[eventName].length === 0){
            litui.utils.deleteItem(eventName, this.subscriptions);
        }
        
        return litui.utils.isDefined(cbIndex);
    };
    
    /**
     * Registers callback for event ID.
     * 
     * @param {String} eventId
     * @param {Function} callback
     */
    LituiSubscribe.prototype.registerEvent = function(eventId, callback){        
        if(litui.utils.isArray(eventId)){
            var arr = [];
            for(var i = 0; i < eventId.length; i++){
                arr.push(this.$$register(eventId[i], callback));
            }
            return arr;
        }
        return this.$$register(eventId, callback);
    };
    
    LituiSubscribe.prototype.$$register = function(eventId, callback){
        if(litui.utils.isUndefined(this.subscriptions[eventId])){
            this.subscriptions[eventId] = [callback];
        }
        else
            this.subscriptions[eventId].push(callback);
        return callback;
    };
    
    
    /**
     * Executes given event ID with provided arguments.<br /></br>
     * 
     * NOTE: because of GIT revert in the past, this function will need to be 
     * fixed to correctly work with promise chain.
     * 
     * @param {String} eventId
     * @param {*} args Anything that needs to be injected into event callback.
     * @returns {Promise}
     */
    LituiSubscribe.prototype.execEvent = function(){
        var eventId = arguments[0];
        
        if(litui.utils.isUndefined(this.subscriptions[eventId])){
//            console.warn("Event %o doesn't exist for context %o", arguments[0], this.context.constructor.name);
            return;
        }
        
        var args = [];
        for(var i = 1; i < arguments.length; i++){
            args.push(arguments[i]);
        }
        
        if(litui.utils.isArray(eventId)){
            for(var i = 0; i < eventId.length; i++){
                this.$$exec(eventId[i], args);
            }
        }
        else{
            this.$$exec(eventId, args);
        }
    };
    
    LituiSubscribe.prototype.$$exec = function(eventId, args){
        for(var i = 0; i < this.subscriptions[eventId].length; i++){
            this.subscriptions[eventId][i].apply(this.context, args);
        }
    };
    
    /**
     * Declares (reserves) an event on the given context. Will display console 
     * warning if event ID already exists for given context.
     * 
     * @param {String} eventId
     * @param {Object} context
     */
    LituiSubscribe.declareEvent = function(eventId, context){
        if(litui.utils.isUndefined(context.__ltSubscribe.subscriptions[eventId])){
            context.__ltSubscribe.subscriptions[eventId] = [];
        }
        else
            console.warn("Event " + eventId + " already exist for " + context);
    };
    
    /**
     * Declares a list of events. Reffer to Subscribe.declareEvent(..).
     * 
     * @param {String} eventIds
     * @param {Object} context
     */
    LituiSubscribe.declareEvents = function(eventIds, context){
        for(var i = 0; i < eventIds.length; i++){
            LituiSubscribe.declareEvent(eventIds[i], context);
        }
    };
    
    litui.$$register(LituiSubscribe);
})();'use strict';

(function () {
    LituiTranslator.__SINGLETON__ = {name: 'translator', module: ''};
    
    /**
     * <b>LT: <code>litui.translator</code><b>(SINGLETON)</b></b><br />
     * 
     * Represents LT translation provider. It exposes a method 
     * <code>.translate(..)</code> which delegates the execution of the 
     * specific translation to the provider.<br /><br />
     * 
     * It is needed for LT applications to support multi-language, especially 
     * for integration between LTUI and litui.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiTranslator() {
        this.$$provider = {
            translate: function(str, params){
                if(litui.utils.isObject(params))
                    for(var k in params){
                        str = str.replace('{{' + k + '}}', params[k]);
                    }
                return str;
            }
        };
    }
    
    /**
     * Sets translation provider.
     * 
     * @param {Object} provider Object representing translation provider.
     */
    LituiTranslator.prototype.setProvider = function(provider){
        litui.logger.debug(litui.utils.isNull(this.$$provider)? "Translator provider set" : "Translator provider changed");
        this.$$provider = provider;
    };
    
    /**
     * Unsets translation provider.
     */
    LituiTranslator.prototype.unsetProvider = function(){
        this.$$provider = null;
    };
    
    /**
     * Delegates the translation execution to the provider.
     * 
     * @param {String} translationKey The key (langstring) of the translation
     * @param {Object} params [optional] Additional parameters to be used with 
     * the translation.
     * @returns {String} translated string.
     */
    LituiTranslator.prototype.translate = function(translationKey, params){
        if(litui.utils.isUndefined(translationKey)){
            return translationKey;
        }
        if(litui.utils.isUndefined(params))
            return this.$$provider.translate(translationKey);
        return this.$$provider.translate(translationKey, params);
    };
    
    litui.$$register(LituiTranslator);
})();'use strict';

(function (translator) {
    LituiNotify.__SINGLETON__ = {name: 'notify', module: ''};
    
    /**
     * <b>LT: <code>litui.notify</code><b>(SINGLETON)</b></b><br />
     * 
     * Represents LT notification provider. It wrapps multiple methods usually 
     * used by notify components (success, info, error, warn).<br /><br /> 
     * The goal is to be able to use 3rd party UI components so LTUI does not 
     * need to provide its own and system-wide notification component can be 
     * used. On the other side, however, LTUI could provide its own notification 
     * component, if needed (using the same mechanism).<br /><br />
     * It's fully compatible with <b>TMS Notification component</b>.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiNotify() {
        this.$$provider = {
            success: function(settings){
                litui.logger.info(settings.message);
            },
            info: function(settings){
                litui.logger.info(settings.message);
            },
            warn: function(){},
            error: function(){},
            remove: function(){}
        };
    }
    
    /**
     * Sets the notification provider.
     * 
     * @param {Object} provider Object representing notification provider.
     */
    LituiNotify.prototype.setProvider = function(provider){
        this.$$provider = provider;
        litui.logger.debug("Notify provider changed");
    };
    
    /**
     * Unsets notification provider.<br />
     * NOTE: it does not call any deregistration methods on the provider (e.g. 
     * destroy, unregister...).
     * 
     * @returns {undefined}
     */
    LituiNotify.prototype.unsetProvider = function(){
        this.$$provider = null;
    };
    
    /**
     * Intended to notify the success message.
     * 
     * @param {Object} settings Notification settings.
     * @returns {*} whatever notification provider's appropriate notification 
     * method returns.
     */
    LituiNotify.prototype.success = function(title, message, ttl, icon, data, onRemoveCallback){
        return this.$$notify('success', title, message, ttl, icon, data, onRemoveCallback);
    };
    
    /**
     * Intended to notify the info message.
     * 
     * @param {Object} settings Notification settings.
     * @returns {*} whatever notification provider's appropriate notification 
     * method returns.
     */
    LituiNotify.prototype.info = function(title, message, ttl, icon, data, onRemoveCallback){
        return this.$$notify('info', title, message, ttl, icon, data, onRemoveCallback);
    };
    
    /**
     * Intended to notify the error message.
     * 
     * @param {Object} settings Notification settings.
     * @returns {*} whatever notification provider's appropriate notification 
     * method returns.
     */
    LituiNotify.prototype.error = function(title, message, ttl, icon, data, onRemoveCallback){
        return this.$$notify('error', title, message, ttl, icon, data, onRemoveCallback);
    };
    
    /**
     * Intended to notify the warning message.
     * 
     * @param {Object} settings Notification settings.
     * @returns {*} whatever notification provider's appropriate notification 
     * method returns.
     */
    LituiNotify.prototype.warning = function(title, message, ttl, icon, data, onRemoveCallback){
        return this.$$notify('warning', title, message, ttl, icon, data, onRemoveCallback);
    };
    
    LituiNotify.prototype.remove = function(notification){
        return this.$$provider.remove(notification);
    };
    
    /**
     * Special notification method which delegates the notification 
     * execution to the notification provider.<br />
     * Throws exception when notification provider is not set.
     * 
     * @throws {Exception} 
     * @param {Object} settings Notification settings.
     * @returns {*} whatever notification provider's appropriate notification 
     * method returns.
     */
    LituiNotify.prototype.$$notify = function(type, title, message, ttl, icon, data, onRemoveCallback){
        var self = this;
        if(!litui.utils.isSet(this.$$provider))
            throw "Notification provider is not set!";
        var settings = null;
        if(litui.utils.isObject(title)){
            settings = title;
            settings.title = translator.translate(settings.title);
            settings.message = translator.translate(settings.message);
        }
        else{
            settings = {
                title: translator.translate(title),
                message: translator.translate(message),
                ttl: ttl,
                icon: icon,
                data: data,
                onRemoveCallback: onRemoveCallback
            };
        }
        
        if(litui.utils.isUndefined(self.$$provider[type]))
            throw "Notification provider method '" + type + "' doesn't exist";
        
        return self.$$provider[type](settings);
    };
    

    litui.$$register(LituiNotify);
})(litui.translator);'use strict';
(function () {
    LituiAsync.__SINGLETON__ = {name: 'async', module: ''};

    /**
     * <b>LT: <code>litui.async (singleton)</code></b><br />
     * 
     * Serves as generic Q provider (wrapps Q). By default Q needs to provided at 
     * app startup. See setQ(..) method.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiAsync() {
        this.q = null;
        this.$$timeoutProvider = {
            set: function(callback, duration){
                return setTimeout(function(){
                    callback();
                }, duration);
            },
            unset: function(instance){
                clearTimeout(instance);
            }
        };
        this.$$intervalProvider = {
            set: function(callback, duration){
                return setInterval(callback, duration);
            },
            unset: function(instance){
                clearInterval(instance);
            }
        };
    }

    /**
     * Sets Q.
     * 
     * @param {Q} q An implementation of Q. Can be original Q or Angular $q.
     */
    LituiAsync.prototype.setQ = function (q) {
        this.q = q;

        litui.logger.debug('Q provider changed');
    };
    
    LituiAsync.prototype.setTimeoutProvider = function (timeoutProvider) {
        this.$$timeoutProvider = timeoutProvider;
    };
    
    LituiAsync.prototype.setIntervalProvider = function (intervalProvider) {
        this.$$intervalProvider = intervalProvider;
    };

    /**
     * Shorthand method for Promise.
     * 
     * @param {boolean} forcedResolution Forces Promise outcome. Defaults to 
     * FALSE which causes Promise to reject.
     * @returns {Promise}
     */
    LituiAsync.prototype.promise = function (forcedResolution) {
        var d = this.q.defer();
        if (litui.utils.isObject(forcedResolution)) {
            d.resolve(forcedResolution);
        } else if (forcedResolution === true || litui.utils.isUndefined(forcedResolution))
            d.resolve();
        else
            d.reject();
        return d.promise;
    };
    
    /**
     * Delays execution of the callback for the given time.
     * 
     * @param {Function} callback
     * @param {int} time In milliseconds
     * @returns {Promise} What the callback returns will be resolved in the 
     * Promise.
     */
    LituiAsync.prototype.delay = function (callback, time) {
        var d = this.defer();
        
        if(litui.utils.isFunction(arguments[0])){
            var cb = function __lituiAsyncDelayExec(){
                d.resolve(callback());
            };
            callback.__lituiTimeoutCallback = cb;
            callback.__lituiTimeout = this.$$timeoutProvider.set(cb, time);
        }
        else
            this.$$timeoutProvider.set(function(){
                d.resolve();
            }, arguments[0]);
        return d.promise;
    };
    
    
    // ------------------
    // --- Q WRAPPERS ---
    // ------------------
    /**
     * Shorthand method for Deffered.
     * 
     * @returns {Deffered}
     */
    LituiAsync.prototype.defer = function () {
        return this.q.defer();
    };
    
    /**
     * Shorthand method for Q "when" function.
     * 
     * @returns {Promise}
     */
    LituiAsync.prototype.when = function () {
        return this.q.when.apply(this.q, arguments);
    };
    
    /**
     * Shorthand method for Q "all" function.
     * 
     * @returns {Promise}
     */
    LituiAsync.prototype.all = function () {
        return this.q.all.apply(this.q, arguments);
    };
    
    LituiAsync.prototype.periodical = function (callback, interval) {
        return this.$$intervalProvider.set(callback, interval);
    };
    
    LituiAsync.prototype.unset = function (callback) {
        return this.$$intervalProvider.unset(callback);
    };
    
    LituiAsync.prototype.unsetDelay = function (callback) {
        return this.$$timeoutProvider.unset(callback);
    };
    
    LituiAsync.prototype.periodicalPromise = function (callback) {
        var self = this;
        return this.q.when(callback()).then(function(){
            return self.periodicalPromise(callback);
        });
    };
    
    LituiAsync.prototype.unsetPeriodicalPromise = function (d) {
        d.resolve();
    };

    litui.$$register(LituiAsync);
})();'use strict';

(function (async) {
    LituiPull.__CLASS__ = {name: 'Pull', module: ''};
    /**
     * <b>LT: <code>litui.Pull</code></b><br /><br /> 
     * Pull helper class. We can use shorthand ('static') method Pull.create() 
     * which instantiates Pull object, starts the auto pull, if set so, and 
     * returns instance.
     * 
     * @class
     * @memberOf litui.base
     * @param {Function} callback Callback function that returns Promise.
     * @param {Object} settings. Frequency setting is in minutes.
     * Object{
     *     frequency:Number,
     *     autoPull:boolean
     * }
     */
    function LituiPull(callback, settings) {
        this.settings = litui.lang.merge({
            frequency: 15, // secs
            autoPull: true,
            delayFirstPull: true,
            notify: false
        }, settings || {});

        this.canPull = true;
        this.isAutoPull = this.settings.autoPull;
        this.__timeoutHandler;
        this.res;
        this.callback = callback || function () {
            var d = async.defer();
            d.resolve();
            return d.promise;
        };
    }

    /**
     * Creates Pull instance and starts auto-pulling process.
     * 
     * @param {Function} callback Callback function that returns Promise.
     * @param {Object} settings. Frequency setting is in seconds.
     * Object{
     *     frequency:Number
     *     autoPull:boolean
     * }  
     * @returns {litui.base.LituiPull}
     */
    LituiPull.create = function (callback, settings) {
        var ap = new LituiPull(callback, settings);
        if (ap.settings.autoPull)
            ap.start();
        return ap;
    };

    /**
     * Starts the auto-pull.
     * 
     * @returns {Promise}
     */
    LituiPull.prototype.start = function () {
        var self = this;

        // arg must be function and return Promise
        if (!litui.utils.isFunction(this.callback)) {
            throw "Auto pull argument must be function!";
            return;
        }

        if(this.settings.delayFirstPull){
            return self.pull();
        }
        return this.execPull(async.defer()).then(function () {
            return self.pull();
        });
    };

    /**
     * Pulls data from server in recursive loop until pull is stoped by .stop() 
     * method.
     * 
     * @returns {Promise}
     */
    LituiPull.prototype.pull = function () {
        var _self = this;
        var d = async.defer();

        // will continue auto-pull
        if (this.isAutoPull) {
            clearTimeout(this.__timeoutHandler);
            this.__timeoutHandler = setTimeout(function () {
                _self.execPull(d);
            }, this.settings.frequency * 1000);
            return d.promise;
        }

        // will exit auto-pull
        return this.execPull(d, true);
    };

    /**
     * 
     * @param {Deferred} defer
     * @param {boolean} single
     * @returns {Promise}
     */
    LituiPull.prototype.execPull = function (defer, single) {
        var self = this;
        single = single === true ? single : false;

        // as this is may be async event, check again if pull was not stopped
        if (self.canPull) {
            // callback execution result
            var res = self.callback(defer);

            // check if callback returns Promise or not AND that auto pulling is on
            if (litui.utils.isDefined(res) && litui.utils.isFunction(res.then)) {

                return res.then(function (val) {
                    try {
                        if(self.settings.notify)
                            defer.notify(val);
                        else
                            defer.resolve(val);

                        if (!single && self.isAutoPull) {
                            //                            console.info("[TMS Pull] data auto-pulling...");
                            return self.pull();
                        }
                    } catch (ex) {
                        defer.reject();
                        litui.logger.error("LT Pull error", ex);
                        return null;
                    }
                }, function () {
                    defer.reject();
                });
            } else {
                defer.resolve();

                if (!single && self.isAutoPull) {
//                        console.info("[TMS Pull] data auto-pulling...");
                    return self.pull();
                }
            }
        } else
            defer.reject();
        return defer.promise;
    };

    /**
     * Stops the auto-pull.
     */
    LituiPull.prototype.stop = function () {
        this.canPull = false;
        clearTimeout(this.__timeoutHandler);
//            console.info("[TMS Pull] auto-pull stopped");
    };

    /**
     * Pulls data from server (refreshes data), outside auto-pull cycle.
     * 
     * @param {boolean} notifyUser Will display popup message (lituiNotification)
     * @returns {Promise}
     */
    LituiPull.prototype.refresh = function (notifyUser) {
//            console.info("[TMS Pull] data refreshed manually");
        return this.execPull(async.defer(), true).then(function () {
            // this is settable third party component... watch out the usage 
            // as no adapter exists
            if (notifyUser === true)
                litui.logger.warn("TODO: notification missing");
        }, function () {
            // this is settable third party component... watch out the usage 
            // as no adapter exists
            litui.logger.warn("TODO: notification missing");
        });
    };

    /**
     * Call this in controller to stop any timeouts etc...
     */
    LituiPull.prototype.destroy = function () {
        this.stop();
    };

    litui.$$register(LituiPull);
})(litui.async);'use strict';

// ## NEEDS REVISION OF METHODS AND CONCEPT ##
// - maybe impl. LituiREST for rest specific requests.. we need solution that will 
// support both angular dependent app and standalone app
// - callSrv method could also be used to open web socket connection and stream
// data over it
// - maybe singleton isn't the right approach... think of it as it needs to be 
// configured "per app"; we could have multiple linetrack apps in our webapp, 
// where it's not necessary for all of the apps to connect to the same server

(function (async) {
    LituiRequest.__SINGLETON__ = {name: 'request', module: ''};

    /**
     * @class
     * @memberOf litui.base
     */
    function LituiRequest() {
        this.registeredRequests = {};
        this.baseUrl = null;
        this.restBaseUrl = null;

        this.contentType = 'application/json';

        this.settings();
    }
    ;

    LituiRequest.prototype.factory = function (baseUrl, restBasePath) {
        var r = new LituiRequest();
        r.settings(baseUrl, restBasePath);
        return r;
    };


    // ---------------
    // --- METHODS ---
    // ---------------  
    /**
     * Sets up base URL and base REST URL.
     *      
     * @param {String} baseUrl
     * @param {String} restBasePath
     */
    LituiRequest.prototype.settings = function (baseUrl, restBasePath) {
        this.baseUrl = baseUrl || "";
        this.restBaseUrl = this.baseUrl + (restBasePath || 'rest/');
    };

    /**
     * AJAX request call.
     * 
     * @param {string} type Request type (GET | POST | PUT | DELETE)
     */
    LituiRequest.prototype.callSrv = function (type, fragment, pathParams, payload, isAsync) {
        // setup path when path parameters are set, otherwise it's fragment
        var path = pathParams !== undefined ? this.paramsToPath(fragment, pathParams) : fragment;

        var d = async.defer();
        var cleanPayload = this.cleanPayload(payload);
        $.ajax({
            type: type || "GET",
//           dataType: "json",
            contentType: this.contentType,
            url: path[0] === "/" ? path : this.restBaseUrl + path,
            data: JSON.stringify(cleanPayload),
            async: isAsync !== undefined ? isAsync : true
        }).then(function (response) {
            if ((litui.utils.isString(response) && response.length === 0) || litui.utils.isEmpty(response)) {
                response = undefined;
            }

            d.resolve(response);
        }, function (err) {
            console.error("Failed calling REST", type, fragment, pathParams, cleanPayload, isAsync, arguments);
//           litui.notify.error({
//               title: litui.translator.translate('litui.SERVER_ERROR.TITLE', {
//                   status: err.status,
//                   statusText: err.statusText,
//               }),
//               message: litui.translator.translate('litui.SERVER_ERROR.TEXT', {
//                   message: err.responseText
//               })
//           });
            d.reject();
        });

        return d.promise;
    };

    /**
     * Requests JSON file content from server without extension.
     * 
     * @param {String} URL Location of the JSON file.
     * @returns {Promise}
     */

    LituiRequest.prototype.JSON = function (url) {
        var self = this;
        var d = async.defer();
        $.ajax({
            url: url + '.json',
            method: 'GET',
            dataType: 'json'
        }).then(function (payload) {
            d.resolve(payload);
        }, function (err) {
            console.error("Failed loading JSON", url, err);
            d.reject();
        });

        return d.promise;
    };

    /**
     * Requests a JSON from resources without extension.
     * 
     * @param {String} JSON name.
     * @returns {Promise}
     */
    LituiRequest.prototype.getResource = function (url) {
        return this.JSON(litui.$$const.RESOURCE_PATH + url);
    };

    /**
     * Requests a JSON from resources without extension.
     * 
     * @param {String} JSON name.
     * @returns {Promise}
     */
    LituiRequest.prototype.getTemplate = function (url, mod) {
        var d = async.defer();
        $.ajax({
            type: 'GET',
            dataType: "html",
            url: this.baseUrl + (mod + '/' || "app/") + url + ".html"
        }).then(function (payload) {
            d.resolve(payload);
        }, function (err) {
            console.error('Failed loading template', url, err);
            d.reject();
        });
        return d.promise;

    };

    /**
     * Requests text file content from server.
     * 
     * @param {String} url Location of the text file.
     * @returns {Promise}
     */
    LituiRequest.prototype.getTxt = function (url) {
        var d = async.defer();
        $.ajax({
            type: 'GET',
            dataType: "text",
            url: this.baseUrl + url
        }).then(function (payload) {
            d.resolve(payload);
        }, function (err) {
            console.error('Failed loading txt', url, err);
            d.reject();
        });
        return d.promise;
    };


    // ------------------
    // --- REST CALLS ---
    // ------------------
    /**
     * GET service request method.
     * 
     * @example 
     request.GET('example-service/{id}', {
     id: 1
     }).done(function(payload){
     // do your stuff
     }).fail(function(){
     // sth went wrong...
     });
     * 
     * @param {string} fragment URL fragment of the service, relative to service root.
     * @param {Object} pathParams Path parameters
     * @returns {Promise}
     */
    LituiRequest.prototype.GET = function (fragment, pathParams) {
        return this.callSrv('GET', fragment, pathParams);
    };

    /**
     * POST service request method.
     * 
     * @example 
     request.POST('example-service', {
     type: "regular"
     }, {
     name: "John",
     lastName: "Smith"
     }).done(function(payload){
     // do your stuff
     }).fail(function(){
     // sth went wrong...
     });
     * 
     * @param {string} fragment URL fragment of the service, relative to service root.
     * @param {Object} payload Object containing data to be transfered to the server.
     * @param {Object} pathParams Path parameters
     * @returns {Promise}
     */
    LituiRequest.prototype.POST = function (fragment, payload, pathParams) {
        if (arguments.length === 3)
            return this.callSrv('POST', fragment, pathParams, payload);
        return this.callSrv('POST', arguments[0], undefined, arguments[1]);
    };

    /**
     * PUT service request method.
     * 
     * @example 
     request.PUT('user/{id}', {
     id: 1
     }, {
     name: "Johnathan",
     lastName: "Smith"
     }).done(function(payload){
     // do your stuff
     }).fail(function(){
     // sth went wrong...
     });
     * 
     * @param {string} fragment URL fragment of the service, relative to service root.
     * @param {Object} pathParams Path parameters
     * @param {Object} payload Object containing data to be transfered to the server.
     * @returns {Promise}
     */
    LituiRequest.prototype.PUT = function (fragment, payload, pathParams) {
        return this.callSrv('PUT', fragment, pathParams, payload);
    };

    /**
     * DELETE service request method.
     * 
     * @example 
     request.DELETE('user/{id}', {
     id: 1
     }, {
     reason: "There's no real reason"
     }).done(function(payload){
     // do your stuff
     }).fail(function(){
     // sth went wrong...
     });
     * 
     * @param {string} fragment URL fragment of the service, relative to service root.
     * @param {Object} pathParams Path parameters
     * @param {Object} payload Object containing data to be transfered to the server.
     * @returns {Promise}
     */
    LituiRequest.prototype.DELETE = function (fragment, pathParams, payload) {
        return this.callSrv('DELETE', fragment, pathParams, payload);
    };


    // ------------------------
    // --- HELPER FUNCTIONS ---
    // ------------------------    
    /**
     * Populates path with given parameter values. E.g. some/{random}/path with 
     * parameters { random: 123 } will be transformed into some/123/path. The 
     * name in the curly bracets is the name of the parameter and will be 
     * replaced by it's value.
     * 
     * @param {String} path
     * @param {Array<Object>} pathParams
     * @returns {String} path populated with parameter values.
     */
    LituiRequest.prototype.paramsToPath = function (path, pathParams) {
        for (var key in pathParams) {
            if (path.indexOf(key) > -1 && pathParams[key] !== undefined) {
                path = path.replace('{' + key + '}', pathParams[key]);
            }
        }

        return path;
    };

    LituiRequest.prototype.cleanPayload = function (dto) {
        if (litui.utils.isNull(dto) || litui.utils.isUndefined(dto))
            return undefined;

        if (litui.utils.isObject(dto)) {
            var res = {};
            for (var k in dto) {
                var item = dto[k];

                // variable/property name that begin with $$ and __ is considered as private
                if ((k.substring(0, 2) !== "$$" && k.substring(0, 2) !== "__") && !litui.utils.isFunction(item)) {
                    var val = item;

                    if (litui.utils.isObject(val) || litui.utils.isArray(val)) {
                        val = this.cleanPayload(val);
                    }
                    res[k] = val;
                }
            }
            return litui.utils.isEmpty(res) ? undefined : res;
        } else if (litui.utils.isArray(dto)) {
            var res = [];
            for (var i = 0; i < dto.length; i++) {
                res.push(this.cleanPayload(dto[i]));
            }

            return res;
        }
        return litui.utils.isObject(dto) && litui.utils.isEmpty(dto) ? undefined : dto;
    };

    /**
     * 
     * Adapted from: https://bytenota.com/javascript-convert-image-to-base64-string/
     * 
     * @param {String} src
     * @returns {Promise}
     */
    LituiRequest.prototype.blobToBase64 = function (src) {
        var d = async.defer();
        var xhttp = new XMLHttpRequest();

        xhttp.onload = function () {
            var fileReader = new FileReader();
            fileReader.onloadend = function () {
                if(xhttp.status === 200)
                    d.resolve(fileReader.result);
                else
                    d.reject(xhttp.statusText);
            };
            fileReader.onerror = function (err) {
                d.reject(err);
            };
            fileReader.readAsDataURL(xhttp.response);

        };

        xhttp.onerror = function (err) {
            d.reject(err);
        };

        xhttp.responseType = 'blob';
        xhttp.open('GET', src, true);
        xhttp.send();

        return d.promise;
    };
    
    LituiRequest.prototype.getImage = function(src){
        var d = async.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
            d.resolve(img);
        };
        img.onerror = function(err){
            d.reject(err);
        };
        return d.promise;
    };

    litui.$$register(LituiRequest);
})(litui.async);'use strict';

(function(notify){
    LituiException.__CLASS__ = { name: 'Exception', module: '' };
    
    /**
     * <b>LT: <code>litui.Exception</code></b><br />
     * 
     * @class
     * @memberOf litui.base
     * @throws {Exception}
     * @param {String} msg
     * @param {Object} ref [optional]
     * @param {String} method [optional]
     * @param {Exception} e [optional]
     */
    function LituiException(msg, ref, method, e){
//        this.$$print(msg, ref, e);
        this.$$throw(msg, ref, method, e);
    }
    
    /**
     * Prints exception to console (if appropriate log level is ensured).
     * 
     * @param {String} msg
     * @param {Object} ref [optional]
     * @param {Exception} e [optional]
     */
    LituiException.prototype.$$print = function(msg, ref, e){
        litui.logger.error(msg, ref, e);
    };
    
    /**
     * Throws desired exception.
     * 
     * @throws {Exception}
     * @param {String} msg
     * @param {Object} ref [optional]
     * @param {String} method [optional]
     * @param {Object} e [optional]
     * @returns {undefined}
     */
    LituiException.prototype.$$throw = function(msg, ref, method, e){
        var refname = litui.utils.isDefined(ref)? ref.constructor.name : "UNSPECIFIED_ORIGIN";
        notify.error({
            title: "litui.GENERAL_EXCEPTION.TITLE",
            message: "litui.GENERAL_EXCEPTION.MSG"
        });
        throw "An exception has occured in " + refname + "::" + method + ": " + msg;
    };
    
    litui.$$register(LituiException);
})(litui.notify);'use strict';

(function(_super){
    litui.lang.extend(LituiOverrideException, _super);
    
    LituiOverrideException.__CLASS__ = { name: 'OverrideException', module: '' };
    
    /**
     * <b>LT: <code>litui.OverrideException</code></b><br />
     * 
     * @class
     * @memberOf litui.base
     * @augments litui.base.LituiException
     * @throws {Exception}
     * @param {Object} ref [optional]
     */
    function LituiOverrideException(ref, method){
        _super.call(this, "Child class must override this method!", ref, method);
    }
    
    litui.$$register(LituiOverrideException);
})(litui.Exception);'use strict';

(function (Subscribe) {
    /**
     * <b>LT: (special service) <code>litui.$$appPool</code></b><br /><br />
     * 
     * Application registry is LT service which handles registration, 
     * deregistration and accessibility of the LT applications.<br /><br />
     * 
     * Application registry is the fundamental LT concept. It's accessed through 
     * lt namespace as the function of the lt namespace.
     * Applications can be accessed using LT namespace special function:<br />
     * <code>litui.$$getApp(appid:String|Number):LituiApp</code><br /><br />
     * Application registry is masked in LT namespace as 
     * <code>litui.$$appPool</code>.<br /><br />
     * 
     * LT application is application that is compatible with LT framework.<br /><br />
     * 
     * Every LT application must provide its own application ID; it must have 
     * <code>appid</code> property, which must be unique for each individual 
     * application instance. Application ID is defined when we create new 
     * instance of LituiApp (or its descendents).<br /><br />
     * 
     * It uses Subscribe to inform any listeners about new app being registered 
     * or unregistered.
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiAppRegistry() {
        this.instances = {};

        new Subscribe(this, [
            'REGISTERED',
            'UNREGISTERED'
        ]);
    }
    
    /**
     * Registers new LT application.<br /><br />
     * 
     * <b>Triggers:</b> 'REGISTERED' -> app:LituiApp
     * 
     * @param {type} app
     */
    LituiAppRegistry.prototype.register = function (app) {
        this.$$ensureAppid(app);
        this.$$ensureNonExistent(app);

        this.instances[app.appid] = app;
        this.trigger('REGISTERED', app);

        litui.logger.debug("LituiApp registered", app.appid, app);
    };
    
    /**
     * Unregisters LT application.<br /><br />
     * 
     * <b>Triggers:</b> 'UNREGISTERED' -> app:LituiApp
     * 
     * @param {type} app
     * @returns {undefined}
     */
    LituiAppRegistry.prototype.unregister = function (app) {
        this.$$ensureAppid(app);
        delete this.instances[app.appid];
        this.trigger('UNREGISTERED', app);
        litui.logger.debug("LituiApp unregistered", app);
    };
    
    /**
     * Gets the LT application by its application ID.
     * 
     * @param {String|Number} appid Application ID.
     * @returns {litui.app.LituiApp} or its descendents.
     */
    LituiAppRegistry.prototype.get = function (appid) {
        return this.instances[appid];
    };
    
    /**
     * Special method which ensures application ID exists for given application.<br />
     * Throws exception if application ID is not found.
     * 
     * @throws {Exception}
     * @param {litui.app.LituiApp} app LituiApp or its descendents.
     */
    LituiAppRegistry.prototype.$$ensureAppid = function (app) {
        if (litui.utils.isUndefined(app.appid))
            throw "Application ID not found; each LituiApp must have its own appid!";
    };
    
    /**
     * Special method which ensures application is unique for LT namespace.<br />
     * Throws exception if application with the same application ID already 
     * exists. 
     * 
     * @throws {Exception}
     * @param {litui.app.LituiApp} app LituiApp or its descendents.
     */
    LituiAppRegistry.prototype.$$ensureNonExistent = function (app) {
        if (litui.utils.isDefined(this.instances[app.appid]))
            throw "LituiApp with ID " + app.appid + " already exists!";
    };

    // expose to lt namespace
    litui.$$appPool = new LituiAppRegistry();
    litui.$$getApp = function (appid) {
        return litui.$$appPool.get(appid);
    };
})(litui.Subscribe);'use strict';

(function () {
    LituiLayoutMngr.__SINGLETON__ = {name: 'layoutMngr', module: ''};
    
    /**
     * <b>LITUI: <code>litui.layoutMngr</code><b>(SINGLETON)</b></b><br />
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiLayoutMngr() {
        this.$$provider = null;
        
        new litui.Subscribe(this, ['PROVIDER_SET']);
    }
    
    /**
     * Sets translation provider.
     * 
     * @param {Object} provider Object representing translation provider.
     */
    LituiLayoutMngr.prototype.setProvider = function(provider){
        this.$$provider = provider;
        this.trigger('PROVIDER_SET');
        litui.logger.debug("Layout manager provider changed");
    };
    
    /**
     * Unsets translation provider.
     */
    LituiLayoutMngr.prototype.unsetProvider = function(){
        this.$$provider = null;
    };
    
    LituiLayoutMngr.prototype.isProviderSet = function(){
        return litui.utils.isNull(this.$$provider);
    };
    
    LituiLayoutMngr.prototype.get = function(){
        litui.logger.warn("LITUI Layout manager provider .get() (litui.layoutMngr.get()) is deprecated. Use litui.layoutMngr.provide() instead");
        return this.provide();
    };
    
    LituiLayoutMngr.prototype.provide = function(){
        if(litui.utils.isUndefined(this.$$provider))
            throw "No layout provider set!";
        return this.$$provider;
    };
    
    litui.$$register(LituiLayoutMngr);
})();(function(){    
    LituiDateTime.__SINGLETON__ = { name: 'dateTime', module: ''};
    /**
     * <b>LITUI: <code>litui.dateTime</code> (singleton)</b><br />
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiDateTime(){
        
    }
    
    LituiDateTime.prototype.isLeapYear = function (year) {
        return year % 4 === 0;
    };

    LituiDateTime.prototype.getDaysByMonths = function (year) {
        return [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    };

    LituiDateTime.prototype.getDaysInMonth = function (month, year) {
        return this.getDaysByMonths(year)[month];
    };
    
    LituiDateTime.prototype.toDate = function (datetime) {
        return new Date(datetime.year(), datetime.month(), datetime.date(), datetime.hour(), datetime.minute(), datetime.second(), datetime.millisecond());
    };

    LituiDateTime.prototype.toDateTime = function (date, tz) {
        var m = this.now(tz);
        if(litui.utils.isDefined(tz))
            m.tz(tz);
        this.addDate(m, date);
        return m;
    };

    LituiDateTime.prototype.compare = function (a, b) { 
        return litui.utils.isSet(a) && litui.utils.isSet(b) && 
                this.isMoment(a) && this.isMoment(b) &&
                a.year() === b.year() && 
                a.month() === b.month() &&
                a.date() === b.date() && 
                a.hour() === b.hour() &&
                a.minute() === b.minute() &&
                a.second() === b.second()
                a.millisecond === b.millisecond() && 
                a.tz() === b.tz();
    };

    LituiDateTime.prototype.getTime = function (datetime) {
        var time = {
            hour: datetime.hours(),
            minute: datetime.minutes(),
            second: datetime.seconds(),
            millisecond: datetime.milliseconds(),
            offset: datetime.utcOffset()
        };
        return time;
    };

    LituiDateTime.prototype.addTime = function (date, time) {
        var datetime = moment(date).utc();
        datetime.hours(time.hour);
        datetime.minutes(time.minute);
        datetime.seconds(time.second);
        datetime.milliseconds(time.millisecond);
        datetime.utcOffset(time.offset);
        return datetime;
    };

    LituiDateTime.prototype.addDate = function (datetime, date) {
        if(litui.utils.isString(date))
            date = new Date(date);
        datetime.year(date.getFullYear());
        datetime.month(date.getMonth());
        datetime.date(date.getDate());
        return datetime;
    };

    LituiDateTime.prototype.format = function (datetime, format, tz) {
        var dt = this.datetime(datetime, tz);
        if(this.isInfinityMin(dt))
            return litui.translator.translate('LITUI.DATE_TIME.INFINITY_MIN');
        if(this.isInfinityMax(dt))
            return litui.translator.translate('LITUI.DATE_TIME.INFINITY_MAX');
        
        if(this.isDescriptiveFormat(format))
            format = this.getFormatFromDescriptive(format);
        return dt.format(format);
    };

    LituiDateTime.prototype.getFormatFromDescriptive = function (desc) {
        if(litui.utils.isUndefined(desc))
            return 'YYYY/MM/DD HH:mm:ss';
        switch(desc){
            case 'date':
                return litui.config.get('dateFormat');
            case 'date-short':
                return litui.config.get('dateShortFormat');
            case 'time':
                return litui.config.get('timeFormat');
            case 'time-short':
                return litui.config.get('timeShortFormat');
            case 'datetime':
                return litui.config.get('datetimeFormat');
            case 'datetime-short':
                return litui.config.get('datetimeShortFormat');
        }
    };

    LituiDateTime.prototype.isDescriptiveFormat = function (format) {
        return litui.utils.isUndefined(format) ||
            format === 'date' ||
            format === 'date-short' ||
            format === 'time' ||
            format === 'time-short' ||
            format === 'datetime' ||
            format === 'datetime-short';
    };

    LituiDateTime.prototype.formatAuto = function (datetime, datetimeType) {
        var format = '';
        var tz = litui.config.get('timezone');
        switch(datetimeType){
            case 'TIME':
                format = litui.config.get('timeFormat');
                break;
            case 'TIME_SHORT':
                format = litui.config.get('timeShortFormat');
                break;
            case 'DATE':
                format = litui.config.get('dateFormat');
                break;
            case 'DATE_SHORT':
                format = litui.config.get('dateShortFormat');
                break;
            case 'DATETIME':
                format = litui.config.get('datetimeFormat');
                break;
            case 'DATETIME_SHORT':
                format = litui.config.get('datetimeShortFormat');
                break;
        }            
        return this.format(datetime, format, tz);
    };

    LituiDateTime.prototype.setDatetime = function (datetimeA, datetimeB, tz) {
        if(litui.utils.nonNull(datetimeB)){
            this.setDate(datetimeA, datetimeB, tz);
            this.setTime(datetimeA, datetimeB, tz);
        }
        return datetimeA;
    };

    LituiDateTime.prototype.setDate = function (datetimeA, datetimeB, tz) {
        datetimeA.year(datetimeB.year());
        datetimeA.month(datetimeB.month());
        datetimeA.date(datetimeB.date());
        return datetimeA;
    };

    LituiDateTime.prototype.setTime = function (datetimeA, datetimeB, tz) {
        datetimeA.tz(datetimeB.tz());    
        datetimeA.hours(datetimeB.hours());
        datetimeA.minutes(datetimeB.minutes());
        datetimeA.seconds(datetimeB.seconds());
        datetimeA.milliseconds(datetimeB.milliseconds());
        return datetimeA;
    };

    LituiDateTime.prototype.now = function (tz, isUtcOffset) {        
        var dt = moment().tz(tz || litui.config.get('timezone'));
        var localDt = moment().tz(litui.config.get('timezone'));
        if(tz === 'UTC' && (!litui.utils.isSet(isUtcOffset) || isUtcOffset)){
            dt.add(localDt.utcOffset(), 'minutes');
        }
        return dt;
    };
    
    LituiDateTime.prototype.datetime = function (dt, tz) {
        var m = moment(dt);
        if(litui.utils.isString(dt) && litui.utils.isUndefined(tz)){
            return m;
        }
        return m.tz(tz || litui.config.get('timezone'));
    };
    
    LituiDateTime.prototype.getBaseSecond = function(ts){
        return ts - (ts % (1000));
    };
    
    LituiDateTime.prototype.isDate = function(obj){
        return Object.prototype.toString.call(obj) === '[object Date]';
    };
    
    LituiDateTime.prototype.fromFormat = function(formatted, datetimeType){
        var format = '';
        switch(datetimeType){
            case 'TIME':
                format = litui.config.get('timeFormat');
                break;
            case 'TIME_SHORT':
                format = litui.config.get('timeShortFormat');
                break;
            case 'DATE':
                format = litui.config.get('dateFormat');
                break;
            case 'DATE_SHORT':
                format = litui.config.get('dateShortFormat');
                break;
            case 'DATETIME':
                format = litui.config.get('datetimeFormat');
                break;
            case 'DATETIME_SHORT':
                format = litui.config.get('datetimeShortFormat');
                break;
        }  
        
        return moment(formatted, format);
    };
    
    LituiDateTime.prototype.setInfinityMin = function(datetime){
        if(litui.utils.isUndefined(datetime))
            datetime = this.now('UTC');
        else
            datetime.tz('UTC');
        datetime.year(1970).month(0).date(1).minute(0).hour(0).second(0).millisecond(0);
        return datetime;
    };
    
    LituiDateTime.prototype.setInfinityMax = function(datetime){
        if(litui.utils.isUndefined(datetime))
            datetime = this.now('UTC');
        else
            datetime.tz('UTC');
        datetime.year(9999).month(0).date(1).minute(0).hour(0).second(0).millisecond(0);
        return datetime;
    };
    
    LituiDateTime.prototype.setInfinityTimeMin = function(){
        return litui.dateTime.parseFromTimeString('00:00:00', 'UTC').millisecond(0);
    };
    
    LituiDateTime.prototype.setInfinityTimeMax = function(){
        return litui.dateTime.parseFromTimeString('23:59:00', 'UTC').millisecond(0);
    };
    
    LituiDateTime.prototype.isInfinityMin = function(datetime){
        if(litui.utils.isNull(datetime))
            return true;
        var min = this.setInfinityMin();
        return datetime.isBefore(min) || datetime.isSame(min);
    };
    
    LituiDateTime.prototype.isInfinityMax = function(datetime){
        if(litui.utils.isNull(datetime))
            return true;
        var max = this.setInfinityMax();
        return datetime.isAfter(max) || datetime.isSame(max);
    };
    
    LituiDateTime.prototype.isInfinityTimeMin = function(datetime){
        if(litui.utils.isNull(datetime))
            return true;
        return datetime.hour() <= 0 && datetime.minute() <= 0;
    };
    
    LituiDateTime.prototype.isInfinityTimeMax = function(datetime){
        if(litui.utils.isNull(datetime))
            return true;
        return datetime.hour() >= 23 && datetime.minute() >= 59;
    };
    
    LituiDateTime.prototype.setNow = function(datetime, tz){
        return this.updateDatetime(datetime, this.now(tz));
    };
    
    LituiDateTime.prototype.updateDatetime = function(datetimeA, datetimeB, tz){
        this.setDate(datetimeA, datetimeB);
        this.setTime(datetimeA, datetimeB, tz || 'UTC');
        return datetimeA;
        
//        return datetimeA.year(datetimeB.year()).month(datetimeB.month()).date(datetimeB.date()).minutes(datetimeB.minute()).hour(datetimeB.hour()).seconds(datetimeB.second()).millisecond(datetimeB.millisecond());
    };
    
    LituiDateTime.prototype.copy = function(datetime, tz){
        if(litui.utils.isUndefined(datetime))
            return this.now(tz);
        return this.setDatetime(this.now(tz), datetime, tz);
    };
    
    LituiDateTime.prototype.parseFromTimeString = function(str, tz){
        var temporal = str.split(':');
        var m = this.datetime(undefined, tz);
        m.hour(temporal[0])
                .minute(temporal[1])
                .second(temporal[2]);
        return m;
    };
    
    LituiDateTime.prototype.readable = function(dt){
        if(this.isInfinityMax(dt))
            return "Infinity max.";
        if(this.isInfinityMin(dt))
            return "Infinity min.";
        return dt.format('YYYY/MM/DD HH:mm:ss');
    };
    
    LituiDateTime.prototype.isMoment = function(dt){
        return litui.utils.isObject(dt) && dt._isAMomentObject;
    };
    
    LituiDateTime.prototype.resetTime = function(dt){
        return dt.hour(0).minute(0).second(0).millisecond(0);
    };
    
    LituiDateTime.prototype.addTimeZoneStr = function(str){
        return str + 'T00:00:00.000Z';
    };
    
    LituiDateTime.prototype.datesEquals = function(datetimeA, datetimeB){
        return datetimeA.year() === datetimeB.year() && datetimeA.month() === datetimeB.month() && datetimeA.date() === datetimeB.date();
    };
    
    LituiDateTime.prototype.isInPeriod = function(datetime, periodA, periodB){
        return this.isDateAfter(datetime, periodA) && this.isDateBefore(datetime, periodB);
    };
    
    LituiDateTime.prototype.isInTimePeriod = function(datetime, periodA, periodB){
        var pivot = datetime.hour() * 60 + datetime.minute();
        var a = periodA.hour() * 60 + periodA.minute();
        var b = periodB.hour() * 60 + periodB.minute();
        
        return pivot >= a && pivot <= b;
    };
    
    LituiDateTime.prototype.isDateAfter = function(datetimeA, datetimeB){
        var a = this.datetime(datetimeA.format('YYYY-MM-DD'));
        var b = this.datetime(datetimeB.format('YYYY-MM-DD'));
        return !a.isBefore(b);
//        return datetimeA.year() >= datetimeB.year() &&
//                datetimeA.dayOfYear() >= datetimeB.dayOfYear();
    };
    
    LituiDateTime.prototype.isDateBefore = function(datetimeA, datetimeB){
        var a = this.datetime(datetimeA.format('YYYY-MM-DD'));
        var b = this.datetime(datetimeB.format('YYYY-MM-DD'));
        return !a.isAfter(b);
//        return datetimeA.year() <= datetimeB.year() && 
//                datetimeA.dayOfYear() <= datetimeB.dayOfYear();
    };
    
    litui.$$register(LituiDateTime);
})();'use strict';

(function () {
    LituiXhrInterceptor.__CLASS__ = {'name': 'XhrInterceptor', module: ''};
    /**
     * Constructs new LituiXhrInterceptor object. Sets up XHR object for 
     * interception.
     * 
     * @constructor
     */
    function LituiXhrInterceptor(config) {
        this.config = config;
        this.lastServerActiveTime = null;
        this.isServerDown = false;
        this.isConnectionLost = false;
        this.notification = null;
        this.notifyTimer = null;

        // setup XHR object
        this.setupXhr();

        litui.logger.debug("Xhr Interceptor created and configured");
    }

    /**
     * 
     * @returns {LituiXhrInterceptor} instance
     */
    LituiXhrInterceptor.create = function (config) {
        return new LituiXhrInterceptor(config);
    };

    /**
     * Pings the server to check if it's online. While it's detected, that 
     * server is unreachable, method will not ping the server, unless force 
     * property is set to TRUE.
     * 
     * @param {Boolean} force To force server ping. Defaults to FALSE.
     * @returns {Promise}
     */
    LituiXhrInterceptor.prototype.pingServer = function (force, isManual) {
        force = litui.utils.isDefined(force) ? force : false;
        this.isManual = litui.utils.isDefined(isManual) ? isManual : false;

        // don't ping server more than once when server down
        if (this.isServerDown && !force)
            return;

        this.isServerDown = true;

//        var basePath = 'rest';
//        if (this.config.basePath)
//        basePath = this.config.basePath;
//        return litui.request.POST('user-account/is-loggedin');
        return litui.security.authorize();
//        return $.ajax({
//            url: basePath + '/user-account/is-loggedin',
//            method: 'POST'
//        });
    };

    /**
     * Checks if browser has net connection. This might not work correctly on 
     * every browser or in every case. Thats why we ping the server to get 
     * correct information.
     * [unreliable]
     * 
     * @returns {Boolean}
     */
    LituiXhrInterceptor.prototype.isConnectionAvailable = function () {
        return navigator.onLine;
    };

    /**
     * Handler for XHR readystatechange event. Intercepts responses from server. 
     * Response status 401 will logout user.
     * When response status is different than 200 (success), but not 0 
     * (undeterminable status), it will check server activity, in the next 
     * step interceptor will react accordingly.
     * 
     * @param {XMLHttpRequest} xhr
     */
    LituiXhrInterceptor.prototype.intercept = function (xhr) {
        // 4 = complete
        if (xhr.readyState === 4) {
            switch (xhr.status) {
                case 401:
                    this.status401();
                    break;
                case 200:
                    // success
                    if (this.isServerDown) {
                        this.statusConnReestablished();
                        this.isServerDown = false;
                        this.isConnectionLost = false;
                    }
                    break;
                default:
                    // status 0 can be cancelled request or general request error - undeterminable
                    if (xhr.status === 0) {
                        if (this.isServerDown) {
                            this.statusConnLost();
                        }
                    } else {
                        this.pingServer();
                    }
                    break;
            }
            this.isManual = false;
        }
    };

    /**
     * Handler method for status 401 (unauthorized access). It performs user 
     * logout.
     */
    LituiXhrInterceptor.prototype.status401 = function () {
        litui.sessionHandler.doLogout();
    };

    /**
     * Handler method for case when the client has lost connection with the 
     * server. It will notify user about this event.
     */
    LituiXhrInterceptor.prototype.statusConnLost = function () {
        var self = this;

        this.isConnectionLost = true;

        if (litui.utils.isNull(this.notification)) {
            litui.logger.error("Lost connection to server.");

            var notifyTitle = "LITUI.SERVER.COMM_LOST.TITLE";
            var context = {
                countdown: this.config.retryConnectionTimespan,
                onRetry: function () {
                    self.pingServer(true, true);
                }
            };
            this.notification = litui.notify.error({
                title: litui.translator.translate(notifyTitle),
                component: {
                    template: '<span litui-translate="\'LITUI.SERVER.COMM_LOST.DESC\'" litui-translate-values="data"></span> <a class="bold pointer" ng-click="data.onRetry($events)" litui-translate="\'LITUI.SERVER.COMM_LOST.TRY_LINK\'"></a>',
//                    template: 'Why not working?',
                    params: {
                        data: context
                    },
                    isDeep: true,
                    isDynamic: true
                },
                ttl: -1,
                onRemoveCallback: function () {
                    self.notification = null;
                }
            });


            // -------------------
            // --- TIMER EVENT ---
            // -------------------
            this.notifyTimer = litui.async.periodical(function () {
                context.countdown--;

                if (context.countdown < 0) {
                    context.countdown = self.config.retryConnectionTimespan;
                    self.pingServer(true);
                }
            }, 1000);
        }

        if (this.isManual) {
            litui.notify.error("LITUI.SERVER_COMM.REATTEMPT.TITLE", "LITUI.SERVER_COMM.REATTEMPT.NO_RESPONSE");
        }
    };

    /**
     * Handler method for case when the client has re-established connection 
     * with the server. Will hide connection lost notification and will notify
     * user about re-connection event.
     */
    LituiXhrInterceptor.prototype.statusConnReestablished = function () {
        if (!litui.utils.isNull(this.notification)) {
            // clear existing notification
            litui.notify.remove(this.notification);
            this.notification = null;
        }

        // show success notification - server was down
        if (this.isConnectionLost) {
            clearInterval(this.notifyTimer);
            litui.notify.success("LITUI.SERVER_COMM.REATTEMPT.TITLE", "LITUI.SERVER_COMM.REATTEMPT.SUCCESS");
        }
    };

    /**
     * Sets up XHR object by "extending" its prototype functions open and send 
     * and sets up callbacks for XHR object.
     * 
     * @returns {XMLHttpRequest} xhr object.
     */
    LituiXhrInterceptor.prototype.setupXhr = function () {
        var self = this;

        var XHR = XMLHttpRequest;
        var openFx = XHR.prototype.open;
        var sendFx = XHR.prototype.send;

        // override XHR open() method
        XHR.prototype.open = function (method, url, async, user, pass) {
            // default
            openFx.call(this, method, url, async, user, pass);
        };

        // override XHR send() method
        XHR.prototype.send = function (data) {
            self.setupXhrCallbacks(this);

            // default
            sendFx.call(this, data);
        };
    };

    /**
     * Sets up callbacks for XHR object by adding event listeners for XHR 
     * readystatechange and error events. Both of callbacks are defined in this 
     * class; intercept() and onError(). 
     * 
     * @param {XMLHttpRequest} xhr
     */
    LituiXhrInterceptor.prototype.setupXhrCallbacks = function (xhr) {
        var self = this;
        var onreadystatechange = xhr.onreadystatechange;

        xhr.addEventListener("readystatechange", function () {
            self.intercept(xhr);

            // default
            if (litui.utils.isFunction(onreadystatechange))
                onreadystatechange();
        }, false);

        xhr.addEventListener("error", function (e) {
            return self.onError(e, xhr);
        }, false);

    };

    /**
     * Handler for XHR error event. Will check for connection and server 
     * activity.
     * 
     * @param {XMLHttpProgressEvent} e
     * @param {XMLHttpRequest} xhr
     */
    LituiXhrInterceptor.prototype.onError = function (e, xhr) {
        // PING SEVER - next interception will catch its response
        this.pingServer();
    };

    litui.$$register(LituiXhrInterceptor);
})();'use strict';

(function () {
    LituiSessionHandler.__CLASS__ = { 'name': 'SessionHandler', 'module': ''};
    /*
     * Adapted from Nagoya project (2013-2014)
     */
    function LituiSessionHandler(securityProvider) {
        this.__keyLS = "cs_timer";
        this.__keyLogoutCmd = "logout_cmd";
        this.__keyLoginCmd = "login_cmd";
        this.__timeoutHandler;
        this.__recordObserverTimer;
        this.__lastProlongTime = 0;
        this.__prolongFrequency = 30; // sec - 30
        this.__mouseClick = false;
        this.__expireCheckTimeUnit = 60; // minimum unit (in sec) by which expire will be checked in timer event
        this.sessionTimespan = 240; // min
        this.expirationTime = 0; // sec
        this.checkCount = 0;
        this.lastActivity = 0;
        this.isActive = false;
        this.securityProvider = securityProvider;
    }

    LituiSessionHandler.prototype.start = function () {
//        litui.logger.info("Client session started!");
        var self = this;
        this.__prolongFrequency = this.__expireCheckTimeUnit / 2;

        // update session timeout as this is the latest
        this.expirationTime = this.predictExpire();
        localStorage.setItem(this.__keyLS, this.expirationTime);

//        // subscribe to logout command
        $.jStorage.subscribe(this.__keyLogoutCmd, function (channel, rememberLocation) {
            litui.logger.debug("[client session] logout command triggered", rememberLocation);
            self.redirect(rememberLocation);
        });
//        
//        // start observer timer
        self.handleExpiration();
//
//        // register life detection
        this.detectLife();
        this.isActive = true;
        
        litui.logger.debug("Client session started");
    };

    LituiSessionHandler.prototype.detectLife = function () {
        var self = this;

        // mouse detection
        // mouse move
        $(document).mousemove(function () {
            // mouse down has already done checking for expiration and prolonged it
            if (self.__mouseClick) {
                self.__mouseClick = false;
                return;
            }
            self.prolongExpiration();
        });

        // mouse click
        $(document).mousedown(function () {
            self.prolongExpiration();
        });
        $(document).mouseup(function () {
            self.__mouseClick = true;
        });

        // mouse wheel
//        $(document).mousewheel(this.prolongExpiration);

        // keyboard detection
    };

    LituiSessionHandler.prototype.prolongExpiration = function () {
        this.lastActivity = moment().unix();

        if (this.canProlong()) {
//            litui.logger.debug("Session prolonged");

            this.expirationTime = this.predictExpire();
            localStorage.setItem(this.__keyLS, this.expirationTime);


            this.__lastProlongTime = moment().unix();

            this.checkCount = 0;
        }
    };

    LituiSessionHandler.prototype.handleExpiration = function () {
        var self = this;

        this.expirationTime = parseInt(localStorage.getItem(this.__keyLS));
        var expireCheckTime = this.__expireCheckTimeUnit * 1000;

        this.timeLeft = this.expirationTime - moment().unix();
//        litui.logger.info("Session will expire in %o min at %o if no user activity will prolong it. Current time %o", this.timeLeft/60, moment().add(this.timeLeft, 'second').format("HH:mm:ss"), moment().format("HH:mm:ss"));


        // is expiration time smaller than expiration check time unit (60s)
        if (this.timeLeft < this.__expireCheckTimeUnit) {
            expireCheckTime = (this.timeLeft) * 1000;
            litui.logger.warn("%os warning before logout", this.timeLeft);
        }

        // session has expired
        if (this.isExpired()) {
//            litui.logger.info("Current time %o vs expire time %o", moment().format("HH:mm:ss"));
            clearTimeout(this.__timeoutHanlder);
            this.doLogout();
        } else {
            // continue to observe
            this.__timeoutHanlder = setTimeout(function () {
                self.checkCount++;
                self.handleExpiration();
            }, expireCheckTime);
        }
    };

    LituiSessionHandler.prototype.predictExpire = function () {
        if (this.lastActivity > 0)
            return this.lastActivity + this.timespanSec();
        return moment().unix() + this.timespanSec();
    };

    LituiSessionHandler.prototype.isExpired = function () {
        return this.expirationTime <= moment().unix();
    };

    LituiSessionHandler.prototype.canProlong = function () {
        // current - last prolonged >= prolong frequency
        // or
        // last prolong time not set yet (0)
        return (moment().unix() - this.__lastProlongTime >= this.__prolongFrequency) || this.__lastProlongTime === 0;
    };

    LituiSessionHandler.prototype.timespanSec = function () {
        return moment.unix(this.sessionTimespan * 60 / 1000);// * 1000;
    };

    LituiSessionHandler.prototype.timespanToMs = function () {
        return this.sessionTimespan * 60 * 1000;// * 1000;
    };

    LituiSessionHandler.prototype.doLogout = function (rememberLocation) {
        var self = this;
        if (rememberLocation === undefined)
            rememberLocation = true;
        
        return this.securityProvider.logout().then(function(){
            localStorage.removeItem(self.__keyLS);
            self.broadcastLogout(rememberLocation);
            if (!self.isActive) {
                self.redirect(rememberLocation);
            }
        });
//        return $.ajax({
//            method: 'GET',
//            url: BASE_PATH + '/user-account/logout'
//        }).then(function () {
//            
//        });
    };

    LituiSessionHandler.prototype.broadcastLogin = function () {
        $.jStorage.publish(this.__keyLoginCmd, true);
    };

    LituiSessionHandler.prototype.broadcastLogout = function (rememberLocation) {
        $.jStorage.publish(this.__keyLogoutCmd, rememberLocation);
    };

    LituiSessionHandler.prototype.subscribeExpireChange = function () {
        var self = this;
        this.__recordObserverTimer = setTimeout(function () {
            self.handleExpireChange();

            clearTimeout(self.__recordObserverTimer);
            self.subscribeExpireChange();
        }, 10000);
    };

    LituiSessionHandler.prototype.handleExpireChange = function () {
        var expire = parseInt(localStorage.getItem(this.__keyLS));

        // when expire is NaN
        if (expire !== expire) {
            litui.logger.debug("[client session] Expiration time not found, reseting app...");
//            this.broadcastLogout();
//            document.location = "";
        }
    };

    LituiSessionHandler.prototype.setTimespan = function (minutes) {
        this.sessionTimespan = minutes * 1;
//        litui.logger.info("session timespan set to %o min", this.sessionTimespan, minutes);
    };

    LituiSessionHandler.prototype.redirect = function (rememberLocation) {
        if (!rememberLocation && location.href.indexOf('#') > -1)
            location.replace(location.href.substring(0, location.href.indexOf('#')));
        else
            location.reload();
    };



    // -----------------------------
    // --- LOGIN SCREEN HANDLING ---
    // -----------------------------
    /**
     * NOTE: Pings server every 60 sec so view does not expire if user is inactive for more than session timeout
     */
    LituiSessionHandler.prototype.initAtLoginScreen = function () {
        var self = this;

        // remove any session expiration timer - if login screen appears, this means session is invalid anyway
        if(localStorage.getItem(this.__keyLS)){
            localStorage.removeItem(this.__keyLS); 
            document.location = "";
        }

        // subscribe to login command
        $.jStorage.subscribe(this.__keyLoginCmd, function (channel, payload) {
//            litui.logger.debug("[client session] login command triggered");
            document.location = "" + window.location.hash;
            location.reload();
        });

        this.handleAtLoginScreen();
        this.detectLifeAtLoginScreen();

//        setTimeout(function(){
//            document.location = "";
//        }, 60 * 1000);
        setInterval(function () {
            self.pingServer();
        }, 60000); // every minute
    };

    /**
     * Ping server to prolong session in one (1) minute interval. Resolves View expired exception, which is 
     * thrown after session time has elapsed on server-side after user tries to 
     * login.
     */
    LituiSessionHandler.prototype.pingServer = function () {
        return this.securityProvider.authorize();
//        return $.ajax({
//            url: 'rest/user-account/is-loggedin',
//            method: 'POST'
//        });
    };

    LituiSessionHandler.prototype.handleAtLoginScreen = function () {
        this.expirationTime = parseInt(localStorage.getItem(this.__keyLS));

        // when this.expirationTime is not NaN
        if (this.expirationTime === this.expirationTime) {
            if (!this.isExpired()) {
                document.location = "";
            } else {
                $.localStorage.removeItem(this.__keyLS);
            }
        }
    };

    LituiSessionHandler.prototype.detectLifeAtLoginScreen = function () {
        var self = this;

        // mouse move
        $(document).mousemove(function () {
            if (self.__mouseClick) {
                self.__mouseClick = false;
                return;
            }
            self.handleAtLoginScreen();
        });

        // mouse click
        $(document).mousedown(function () {
            self.handleAtLoginScreen();
        });
        $(document).mouseup(function () {
            self.__mouseClick = true;
        });

        // mouse wheel
//        $(document).mousewheel(this.handleAtLoginScreen);
    };

    litui.$$register(LituiSessionHandler);
})();
'use strict';

(function(){
    LituiSecurity.__SINGLETON__ = { name: 'security', module: ''};
    function LituiSecurity(){
        var self = this;
        this.$$provider = {
            isAuthorized: function(val){
                if(litui.utils.isDefined(val) && (val === 'REJECT' || val.indexOf('REJECT') > -1))
                    return false;
                return true;
            },
            canView: function(val){
                if(litui.utils.isDefined(val) && (val === 'REJECT' || val.indexOf('REJECT') > -1))
                    return false;
                return true;
            },
            logout: function(val){
                return litui.async.promise();
            },
            getIdentity: function(val){
                return self.$$identity;
            },
            authorize: function(){
                return litui.async.promise();
            }
        };
        this.$$identity = null;
        this.sessionHandler = new litui.SessionHandler(this);
        this.settings = {
            passwordPatternRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
        };
    }

    LituiSecurity.prototype.setProvider = function(securityProvider){
        this.$$provider = securityProvider;
    };

    LituiSecurity.prototype.setIdentity = function(identity){
        this.$$identity = identity;
    };

    LituiSecurity.prototype.isAuthorized = function(privilege){
        return this.$$provider.isAuthorized(privilege);
    };

    LituiSecurity.prototype.canView = function(privilege){
        return this.$$provider.canView(privilege);
    };

    LituiSecurity.prototype.logout = function(){
        return this.$$provider.logout();
    };

    LituiSecurity.prototype.getIdentity = function(){
        return this.$$provider.getIdentity();
    };

    LituiSecurity.prototype.authorize = function(){
        return this.$$provider.authorize();
    };

    LituiSecurity.prototype.startClientSession = function(timeout){
        this.sessionHandler.setTimespan(timeout);
        this.sessionHandler.start();
        this.sessionHandler.broadcastLogin();
    };

    LituiSecurity.prototype.setPasswordPattern = function(passwordPatternRegex){
        this.settings.passwordPatternRegex = passwordPatternRegex;
    };

    LituiSecurity.prototype.getPasswordPattern = function(){
        return this.settings.passwordPatternRegex;
    };
    
    litui.$$register(LituiSecurity);
})();'use strict';

(function(){
    LituiComponentsBootstrapper.__SINGLETON__ = { name: 'components', module: '' };
    function LituiComponentsBootstrapper(){
        var self = this;
        $(document).ready(function(){
            self.bootstrapLituiComponents();
        });
        this.components = {};
        this.__incr = 0;
    }
    
    LituiComponentsBootstrapper.prototype.bootstrapLituiComponents = function(){
        for(var k in this.components){
            var com = this.components[k];
            this.bootstrapComponent(com);
            com.onInit();
            this.renderComponent(com);
        }
    };
    
    LituiComponentsBootstrapper.prototype.parseSignature = function(ann){
        return ann.module + "." + ann.name;
    };
    
    
    // TODO: this is insecure, secure it by escaping vulnerable tags
    LituiComponentsBootstrapper.prototype.secureDom = function(html){
//        if(html.indexOf('<script') > -1)
        return html;
    };
    
    LituiComponentsBootstrapper.prototype.getById = function(id){
        for(var k in this.components){
            var com = this.components[k];
            if(com.context.id === id)
                return com;
        }
    };
    
    LituiComponentsBootstrapper.prototype.getBySignature = function(signature){
        return this.components[signature];
    };
    
    LituiComponentsBootstrapper.prototype.register = function(Com){
        this.__incr++;
        var signature = this.parseSignature(Com.__CLASS__);
        var comSignature = signature + '#' + this.__incr;
        litui.$$register(Com);
        var inst = new Com();
        inst.$$signature = comSignature;
        this.components[comSignature] = inst;
    };
    
    LituiComponentsBootstrapper.prototype.deregister = function(ann){
        var signature = this.parseSignature(ann);
        litui.utils.deleteItem(signature, this.components);
    };
    
    LituiComponentsBootstrapper.prototype.destroyComponent = function(com){
        if(litui.utils.isFunction(com))
            com.onDestroy();
    };
    
    LituiComponentsBootstrapper.prototype.renderComponent = function(com){
        var tpl = this.secureDom(com.tpl);
        var html = '';
        for(var k in com.context){
            var prop = com.context[k];
            var val = undefined;
            if(litui.utils.isFunction(prop))
                val = prop();
            else
                val = prop;
            html = litui.utils.strReplace(tpl, '{{' + k + '}}', val);
        }
        com.$elt.html(html);
    };
    
    LituiComponentsBootstrapper.prototype.bootstrapComponent = function(com){
        com.$elt = $(com.selector);
        
        for(var k in com.bindings){
            com.context[k] = com.$elt.attr(k);
        }
    };
    
    LituiComponentsBootstrapper.prototype.remove = function(id){
        var com = this.getById(id);
        return com.remove();
    };
    
    litui.$$register(LituiComponentsBootstrapper);
})();'use strict';
(function () {
    LituiSound.__CLASS__ = {name: 'Sound', module: ''};

    function LituiSound(settings) {
        this.settings = litui.lang.merge({
            sources: [],
            loop: false,
            volume: 1,
            autoStart: false,
            onPlay: undefined,
            onPause: undefined,
            onStop: undefined,
            onLoop: undefined,
            loopDelay: -1
        }, settings || {});
        
        if(litui.utils.isUndefined(this.settings.sources) || this.settings.sources.length === 0)
            throw "Exception when creating sound: no sound sources provided!";
            
        this.state = 'STOPPED';
        
        this.isMuted = false;
        this.mutedVolume = null;
        this.currentVolume = this.settings.volume;
        this.loopDelayValue = this.settings.loopDelay;
    }
    
    LituiSound.States = {
        'PLAYING': 'PLAYING',
        'PAUSED': 'PAUSED',
        'STOPPED': 'STOPPED'
    };
    
    LituiSound.create = function(settings){
        var sound = new LituiSound(settings);
        sound.init();
        if(sound.settings.autoStart)
            sound.play();
        return sound;
    };
    
    LituiSound.prototype.init = function(){
        var self = this;
        this.$$howl = new Howl({
            urls: this.settings.sources,
            volume: this.settings.volume
        });
        if(this.settings.loop)
            this.$$howl.on('end', function () {
                if(self.loopDelayValue > -1){
                    litui.async.delay(function(){
                        self.loopPlay();
                    }, self.loopDelayValue);
                }
                else{
                    self.loopPlay();
                }
            });
    };
    
    LituiSound.prototype.play = function(){
        if(this.state === LituiSound.States.PLAYING)
            return ;
            
        this.state = LituiSound.States.PLAYING;
        this.$$howl.play();
        
        if(litui.utils.isFunction(this.settings.onPlay))
            this.settings.onPlay();
    };
    
    LituiSound.prototype.pause = function(){
        if(this.state !== LituiSound.States.PLAYING)
            return ;
        
        this.state = LituiSound.States.PAUSED;
        this.$$howl.stop();
        
        if(litui.utils.isFunction(this.settings.onPause))
            this.settings.onPause();
    };
    
    LituiSound.prototype.stop = function(){
        if(this.state !== LituiSound.States.PLAYING)
            return ;
        
        this.state = LituiSound.States.STOPPED;
        this.$$howl.stop();
        
        if(litui.utils.isFunction(this.settings.onStop))
            this.settings.onStop();
    };
    
    LituiSound.prototype.isPlaying = function(){
        return this.state === LituiSound.States.PLAYING;
    };
    
    LituiSound.prototype.loopPlay = function(){
        if(this.isPlaying()){
            this.$$howl.play();
            if(litui.utils.isFunction(this.settings.onLoop))
                this.settings.onLoop();
        }
        else
            this.stop();
    };
    
    LituiSound.prototype.volume = function(volume){
        if(this.isMuted){
            if(litui.utils.isSet(volume))
                this.mutedVolume = volume;
            return this.mutedVolume;
        }
            
        if(litui.utils.isSet(volume)){
            this.currentVolume = volume;
            this.$$howl.volume(volume);
        }
        return this.currentVolume;
    };
    
    /**
     * Howler mute function does not work per Howl instance,
     * so we provide own solution.
     */
    LituiSound.prototype.mute = function(){
        if(this.isMuted)
            return this.isMuted;
        this.mutedVolume = this.volume();
        this.volume(0);
        this.isMuted = true;
        
        return this.isMuted;
    };
    
    LituiSound.prototype.unmute = function(){
        if(!this.isMuted)
            return this.isMuted;
        this.isMuted = false;
        this.volume(this.mutedVolume);
        this.mutedVolume = null;
        
        return this.isMuted;
    };
    
    LituiSound.prototype.loopDelay = function(value){
        this.loopDelayValue = value;
        return this.loopDelayValue;
    };
    
    
    
    litui.$$register(LituiSound);
})();'use strict';

(function(){
    LituiPropertyObserver.__CLASS__ = {name: 'PropertyObserver', module: ''};
    function LituiPropertyObserver(callbacks, context, isManual) {
        this.callbacks = callbacks;
        this.context = context;
        this.isManual = isManual;
        this.origin = {};
    }
    
    LituiPropertyObserver.observe = function(callbacks, context, isManual){
        var po = new LituiPropertyObserver(callbacks, context, isManual);
        po.prepareOrigin();
        
        if(!isManual)
            po.registerObserverOnContext();
        return po;
    };

    LituiPropertyObserver.prototype.registerObserverOnContext = function(){
        var self = this;
        if(litui.utils.isFunction(this.context.$doCheck)){
            throw "Can not auto-register observer on context, $doCheck method already defined. Please manualy call valueCheck method!";
        }
        this.context.$doCheck = function(){
            self.valueCheck();
        };
    };

    LituiPropertyObserver.prototype.prepareOrigin = function(){
        for(var pname in this.callbacks){
            this.origin[pname] = null;
        }
    };
    
    LituiPropertyObserver.prototype.valueCheck = function(){
        for (var pname in this.origin) {
            var originPropVal = this.origin[pname];
            var propVal = this.context[pname];

            if (litui.dateTime.isMoment(propVal)) {
                if(!litui.dateTime.compare(originPropVal, propVal)){
                    if (litui.utils.isFunction(this.callbacks[pname])) {
                        this.callbacks[pname](originPropVal, propVal);
                    }
                    this.origin[pname] = litui.dateTime.copy(propVal);
                }
            } else {
                if (!litui.utils.equals(originPropVal, propVal)){
                    if (litui.utils.isFunction(this.callbacks[pname])) {
                        this.callbacks[pname](originPropVal, propVal);
                    }
                    if (litui.utils.isObject(propVal))
                        this.origin[pname] = litui.lang.deepCopy(propVal);
                    else if (litui.utils.isArray(propVal))
                        this.origin[pname] = litui.lang.copyArray(propVal);
                    else
                        this.origin[pname] = propVal;
                }
            }
        }
    };
    
    litui.$$register(LituiPropertyObserver);
})();(function(){    
    LituiStorage.__SINGLETON__ = { name: 'storage', module: ''};
    /**
     * <b>LT: <code>litui.storage</code> (singleton)</b><br />
     * 
     * @class
     * @memberOf litui.base
     */
    function LituiStorage(){
        
    }
    
    LituiStorage.prototype.set = function(key, value){
        this.wrap(litui.utils.updateItem(this.unwrap(), key, value));
    };
    
    LituiStorage.prototype.get = function(key){
        return litui.utils.extractItem(this.unwrap(), key);
    };
    
    LituiStorage.prototype.unwrap = function(){
        if(litui.utils.isString(localStorage.litui))
            return JSON.parse(localStorage.litui);
        return {};
    };
    
    LituiStorage.prototype.wrap = function(data){
        localStorage.litui = JSON.stringify(data || {});
    };
    
    litui.$$register(LituiStorage);
})();'use strict';

(function () {
    LituiResponsive.__CLASS__ = {name: 'Responsive', module: ''};
    function LituiResponsive(context, hooks, props, $rootElt, responsiveBindingName) {
        var self = this;
        
        this.context = context;

        this.hooks = hooks;
        litui.lang.prepareSettings({
            preCalc: function(){},
            postCalc: function(){},
            breakpoint: function(){},
            collapse: function(){}
        }, this, 'hooks');
        
        if(litui.utils.isUndefined(props))
            props = {};
        litui.lang.mergeB({
            collapse: undefined,
            breakpoints: {}
        }, props);
        litui.lang.prepareSettings(props, context, responsiveBindingName || 'responsive');

        this.$rootElt = $rootElt;
        
        this.$$calcResponsiveHandler = function(){
            return self.calc();
        };
        
        this.$$postResponsive = function(){
            self.hooks.postCalc(self.isTransformed, self.getRootElt().width());
        };
    }
    
    LituiResponsive.create = function(context, hooks, props, $rootElt, responsiveBindingName){
        return new LituiResponsive(context, hooks, props, $rootElt, responsiveBindingName);
    };
    
    
    LituiResponsive.prototype.init = function(){
        this.register();
        this.$$calcResponsiveHandler();
    };
    
    LituiResponsive.prototype.register = function(){
        litui.layoutMngr.provide().on('RESIZE', this.$$calcResponsiveHandler);
        litui.layoutMngr.provide().on('RESIZE_END', this.$$postResponsive);
    };
    
    LituiResponsive.prototype.destroy = function(){
        litui.layoutMngr.provide().off('RESIZE', this.$$calcResponsiveHandler);
        litui.layoutMngr.provide().off('RESIZE_END', this.$$postResponsive);
    };
    
    LituiResponsive.prototype.getRootElt = function(){
        return this.$rootElt || litui.layoutMngr.provide().getPanelElt('viewport');;
    };
    
    LituiResponsive.prototype.calc = function(){
        var self = this;
        var $root = this.getRootElt();
        var rwidth = $root.width();

        this.hooks.preCalc(rwidth, this.context.responsive);
        
        if(litui.utils.isDefined(this.context.responsive.collapse) && 
            rwidth <= this.context.responsive.collapse){
            this.hooks.collapse();
            return;
        }

        this.isTransformed = false;
        if(litui.utils.isDefined(this.context.responsive.breakpoints)){                
            var breakpoints = litui.utils.getKeys(this.context.responsive.breakpoints);
            var lastBp = -1;
            litui.utils.foreach(breakpoints, function(i, breakpointRaw){
                var breakpoint = litui.utils.strToNum(breakpointRaw);
                if(rwidth <= breakpoint && rwidth > lastBp){
                    var bpValue = self.context.responsive.breakpoints[breakpoint];
                    if(litui.utils.isFunction(bpValue)){
                        self.isTransformed = bpValue(rwidth, breakpoint);
                    }
                    else{
                        self.hooks.breakpoint(breakpoint, bpValue);
                        self.isTransformed = true;
                    }
                }
                lastBp = breakpoint;
            });
        }        
    };    

    litui.$$register(LituiResponsive);
})();'use strict';

(function () {
    LituiTween.__SINGLETON__ = {name: 'tween', module: ''};

    function LituiTween() {
        
    }
    
    LituiTween.prototype.to = function($elt, duration, settings){
        var d = litui.async.defer();
        var onCompleteCb = settings.onComplete;
        
        settings.onComplete = function(){
            if(litui.utils.isFunction(onCompleteCb))
                onCompleteCb(); 
            d.resolve();
        };
        
        TweenMax.to($elt, duration, settings);
        return d.promise;
    };
    
    litui.$$register(LituiTween);
})();'use strict';

(function(){
    LituiPreloaderPreinit.__CLASS__ = { name: 'PreloaderPreinit', module: 'com' };
    function LituiPreloaderPreinit(){
        this.selector = 'litui-preloader-preinit';
        this.$elt = null;
        this.bindings = {
            id: null,
            text: null
        };
        this.context = {};
        this.tpl = '<div class="litui-preloader-preinit-inner"><div class="litui-preloader-preinit-text"><span>{{text}}</span></div></div>';
    }    
    
    LituiPreloaderPreinit.dismiss = function(id, debounceTimeout){
        var d = litui.async.defer();
        new litui.utility.DebounceHandler(function(){
            litui.components.remove(id).then(function(){
                d.resolve();
            });
        }, {
            timeout: litui.utils.isUndefined(debounceTimeout)? 1000 : debounceTimeout
        }).debounce();
        return d.promise;
    };
    
    LituiPreloaderPreinit.prototype.onInit = function(){
        
    };
    
    LituiPreloaderPreinit.prototype.onDestroy = function(){
        
    };
    
    LituiPreloaderPreinit.prototype.onRemove = function(){
        var d = litui.async.defer();
        TweenMax.to(this.$elt, 0.6, {
            opacity: 0,
            onComplete: function(){
                d.resolve();
            }
        });
        return d.promise;
    };
    
    
    // -----------------------------
    // --- GENERIC COM. FEATURES ---
    // -----------------------------    
    LituiPreloaderPreinit.prototype.destroy = function(){
        litui.components.destroyComponent(this);
    };
    
    LituiPreloaderPreinit.prototype.remove = function(){
        var self = this;
        this.destroy();
        if(litui.utils.isFunction(this.onRemove))
            return litui.async.when(this.onRemove()).then(function(){
                self.$elt.remove();
            });
        return litui.async.promise();
    };
    
    litui.components.register(LituiPreloaderPreinit);
})();'use strict';

(function () {
    LituiFormatter.__SINGLETON__ = {name: 'formatter', module: 'utility'};
    function LituiFormatter() {
        
    }

    /**
     * 
     * @param {Number} val In miliseconds
     * @returns {Number|String} representation of SA
     */
    LituiFormatter.prototype.scheduleAdherence = function (val) {
        // you get miliseconds
        // convert to seconds
        val = Math.floor(val/1000/60);
        var sign = val>0? "+": "-";
        if(val === 0){
            sign = "";
        }

        val = Math.abs(val);
        return sign + val;
    };
    
    /**
     * 
     * @param {type} actualTimeDistance
     * @param {type} scheduledTimeDistance Can be null
     * @returns {String}
     */
    LituiFormatter.prototype.headwayAdherence = function(actualTimeDistance, scheduledTimeDistance){
        var scheduled = litui.utils.isSet(scheduledTimeDistance)?
                            Math.floor(scheduledTimeDistance/60/1000) :
                            "-";
        return litui.utils.isNull(actualTimeDistance)? "-/-" : scheduled + "/" + Math.floor(actualTimeDistance/60/1000);
    };
    
    LituiFormatter.prototype.rdv = function(rdv){
        if(!litui.utils.isObject(rdv)) 
            return "/";
        
        return rdv.route + " - " + rdv.destination + " - " + rdv.variant;
    };
    
    LituiFormatter.prototype.number = function(value, decimalLimit, delimiter){
        if(litui.utils.isUndefined(decimalLimit))
            decimalLimit = 4;
        if(litui.utils.isUndefined(delimiter))
            delimiter = ".";
        if(litui.utils.isNull(value) || litui.utils.isNaN(value) || litui.utils.isUndefined(value))
            return "/";
        var str = litui.utils.numToStr(value);
        var delimIndex = str.indexOf(delimiter);
        if(delimIndex === -1)
            return value;
        return litui.utils.cutTrailingDecimalZeros(value.toFixed(decimalLimit));
    };
    
    LituiFormatter.prototype.speed = function(value){
        value = this.number(value, 2);
        if(value !== "/")
            value += " km/h";
        return value;
    };
    
    LituiFormatter.prototype.eta = function(timestamp){
        // this is simplified version, use litui relative datetime
        var now = moment();
        var eta = moment(timestamp);
        var diff = parseInt(eta.diff(now) / 1000 / 60);
        if(diff < 1)
            return "Due";
        return diff + " min";
    };
    
    LituiFormatter.prototype.distance = function(distance, postfix){
        if(litui.utils.isUndefined(postfix))
            postfix = "m";
        if(litui.utils.isNull(distance))
            return "/";
        return this.number(distance, 2) + " " + postfix;
    };
    
    LituiFormatter.prototype.JSON = function(json, indent){
        if(litui.utils.isUndefined(indent))
            indent = '';
        var str = '{\n{{partial}}\n}';
        indent += '\t';
        var partial = "";
        for(var k in json){
            var val = json[k];
            if(partial.length > 0)
                partial += ",\n";
            
            if(litui.utils.isObject(val) || litui.utils.isArray(val)){
                partial += this.JSON(val, indent);
            }
            else{
                partial += indent +'"' + k + '": "' + val + '"';
            }
        }
        
        str = str.replace('{{partial}}', partial);
        return str;
    };
    
    LituiFormatter.prototype.currency = function(value){
        var symbol = litui.config.get('currencySymbol');
        return value + symbol;
    };
    
    LituiFormatter.prototype.weight = function(value, baseUnit){
        var weightUnitType = litui.config.get('weightUnitType');
        switch(weightUnitType){
            case 'kg':
            default:
                return value + baseUnit;
//                switch(baseUnit){
//                    case 'g':
//                    default:
//                        return value + 'g';
//                }
        }
    };
    
    litui.$$register(LituiFormatter);
})();'use strict';

(function(){
    LituiBenchmark.__CLASS__ = { name: 'Benchmark', module: 'utility' };
    /**
     * <b>LT: <code>litui.utility.Benchmark</code></b><br />
     * Intended to be used for benchmarking. By default reporting is disabled.
     * 
     * @class
     * @memberOf litui.utility
     * @param {Object} config Configuration object: { report:boolean }
     */
    function LituiBenchmark(config){
        this.config = litui.lang.merge({
            report: false
        }, config);
        
        this.startTime = 0;
        this.stopTime = 0;
    }
    
    /**
     * Starts benchmark.
     */
    LituiBenchmark.prototype.start = function(){
        this.startTime = moment();
    };
    
    /**
     * Stops benchmark.
     */
    LituiBenchmark.prototype.stop = function(){
        this.stopTime = moment();
    };
    
    /**
     * Resets the benchmark timer.
     */
    LituiBenchmark.prototype.reset = function(){
        this.startTime = 0;
    };
    
    /**
     * Calculates time difference between start and stop times.
     * 
     * @returns {Number} ms
     */
    LituiBenchmark.prototype.diff = function(){
        return this.stopTime.diff(this.startTime);
    };
    
    /**
     * Outputs the report to console.
     * 
     * @param {String} additionalInfo [optional]
     */
    LituiBenchmark.prototype.report = function(additionalInfo){
        if(this.config.report){
            if(litui.utils.isUndefined(additionalInfo))
                litui.logger.debug("[] started: %o, Stopped: %o, Duration: %oms", this.startTime.format("HH:mm:ss"), this.stopTime.format("HH:mm:ss"), this.diff());
            else
                litui.logger.debug("[" + this.settings.title + "] started: %o, Stopped: %o, Duration: %oms. " + additionalInfo, this.startTime.format("HH:mm:ss"), this.stopTime.format("HH:mm:ss"), this.diff());
        }
    };
    
    litui.$$register(LituiBenchmark);
})();'use strict';

(function(){
    LituiuiDebounceHandler.__CLASS__ = { name: 'DebounceHandler', module: 'utility' };
    function LituiuiDebounceHandler(cb, settings){
        var self = this;
        this.handle = null;
        this.cb = cb;
        this.settings = litui.lang.merge({
            timeout: 50 // ms
        }, settings || {});
        this.debounceStarted = null;
        
        this.delayExecutor = null;
    }
    
    LituiuiDebounceHandler.prototype.debounce = function(){
        var self = this;
        this.cancel();        
        var args = arguments;
        this.delayExecutor = function delayHandler(){
            self.instant.apply(self, args);
        };
        litui.async.delay(this.delayExecutor, this.settings.timeout);
    };
    
    LituiuiDebounceHandler.prototype.instant = function(){
        this.cancel();
        this.cb.apply(this, arguments);
    };
    
    LituiuiDebounceHandler.prototype.cancel = function(){        
        if(litui.utils.isNull(this.delayExecutor))
            return;
        litui.async.unsetDelay(this.delayExecutor);
    };
    
    litui.$$register(LituiuiDebounceHandler);
})();'use strict';

/**
 * @namespace utility
 * @memberOf lt
 */
(function (async) {    
    LituiEncryption.__SINGLETON__ = {name: 'encryption', module: 'utility', angular: false};
    /**
     * <b>LT: <code>litui.utility.encryption</code></b><br />
     * 
     * @class
     * @memberOf litui.utility
     */
    function LituiEncryption() {
        
    }
    
    LituiEncryption.prototype.md5FileHash = function(file){
        var d = async.defer();
        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");

        reader.onload = function(e){
            d.resolve(md5(e.currentTarget.result));
        };

        reader.onerror = function(e){
            d.reject(e);
        };

        return d.promise;
    };

    litui.$$register(LituiEncryption);
})(litui.async);(function(){
    LituiMainNav.__SINGLETON__ = { name: 'mainNav', module: 'utility' };
    function LituiMainNav(){
        this.mainNavItems = [];
    }
    
    LituiMainNav.prototype.add = function(mainNavItem){
        this.mainNavItems.push(mainNavItem);
    };
    
    LituiMainNav.prototype.get = function(){
        return this.mainNavItems;
    };
    
    litui.$$register(LituiMainNav);
})();(function(){
    LituiScreenFactory.__SINGLETON__ = { name: 'screenFactory', module: 'utility' };
    function LituiScreenFactory(){
        this.template = {};
    }
    
    LituiScreenFactory.prototype.produce = function(viewName, AngController, viewConfig){
        var finalUrl = '/' + viewName + '/' + (viewConfig.url? viewConfig.url : '');
        viewConfig = litui.lang.merge({
            module: 'litui',
            url: '',
            nav: {
                title: 'Menu item'
            },
            screen: undefined
            
        }, viewConfig || {});
        viewConfig.url = finalUrl;            
        
        var componentConfig = {
            controller: AngController,
            template: viewConfig.template,
            templateUrl: viewConfig.templateUrl
        };
        if(litui.utils.isDefined(viewConfig.screen)){
            componentConfig.template = this.getTemplate(viewConfig.screen).template;
            componentConfig.templateUrl = undefined;
        }
        
        var screenName = viewName; //viewName + '-mod';
        var modName = screenName + '-mod'; //viewName + '-mod';
        
        angular.module(viewConfig.module)
                .config(ModConfig)
                .component(litui.utils.kebabToCamelCase(modName), {
            controller: ModController,
            template: '<' + screenName + ' class="litui-screen">Loading screen...</' + screenName + '>',
//            templateUrl: viewConfig.templateUrl
        })
        .component(litui.utils.kebabToCamelCase(screenName), componentConfig);
        
        /** @ngInject */
        function ModConfig($stateProvider) {
            var stateName = litui.utils.kebabToCamelCase(viewConfig.module + '.' + viewName);
            $stateProvider.state(stateName, {
                url: viewConfig.url,
//                template: '<foo>Loaded???</foo>'
                template: '<' + modName + ' class="litui-screen"></' + modName + '>',
                params: viewConfig.stateParams
            });
            litui.logger.debug("Registered new router state %o for mod %o", stateName, viewName, viewConfig.url);

            // TODO: menu entry
            litui.utility.mainNav.add({
                parent: viewConfig.nav.parent,
                linked: viewConfig.nav.linked,
                title: viewConfig.nav.title, 
                sref: stateName, 
                functionalityId: 'PERFORMANCE_STATUS.TRIP.IN_MENU'
            });
        }
        
        /** @ngInject */
        function ModController(){
        }
        
        return angular;
    };
    
    LituiScreenFactory.prototype.registerTemplate = function(templateName, templateConfig){
        this.template[templateName] = {
            name: templateName,
            template: templateConfig.template
        };
        return angular;
    };
    
    LituiScreenFactory.prototype.getTemplate = function(templateName){
        return this.template[templateName];
    };
    
    litui.$$register(LituiScreenFactory);
})();'use strict';

(function () {
    LituiDomObserver.__SINGLETON__ = {name: 'domObserver', module: 'utility'};
    /**
     * DOM Change observer.
     * 
     * @class
     * @memberOf litui.utility
     */
    function LituiDomObserver() {

    }

    /**
     * Observes DOM change event. Intended for tracking reasons.
     */
    LituiDomObserver.prototype.observeDomChange = function () {
        var domChangeCountr = 0;

        var target = document.body;

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                domChangeCountr++;
                litui.logger.log("Detected DOM change no. %o, type %o", domChangeCountr, mutation.type, mutation, mutation.addedNodes, mutation.removedNodes);
            });
        });

        var config = {attributes: true, childList: true, characterData: true}
        observer.observe(target, config);
    };

    litui.$$register(LituiDomObserver);
})();'use strict';

(function (utils) {
    IndexedMap.__CLASS__ = { name: 'IndexedMap', module: 'utility' };
    /**
     * Constructs IndexedMap object.
     * 
     * @constructor
     * @param {Object} struct Structure (associative list, POJO, JS simple 
     * object) representing hash map; key => value pairs. For autokey feature 
     * to work, the keys must be of numeric values. If ommited it will default 
     * to an empty object.
     * @param {Boolean} autokey [optional, default=FALSE) Turn autokey feature 
     * ON/OFF. The value will go through autokey validation which will ensure 
     * that given keys are of numeric values.
     */
    function IndexedMap(struct, autokey) {
        this._struct = struct || {};
        this._autokey = this._validateAutokey(utils.defaultTo(autokey, false));
    }

    /**
     * Creates hash map out of given structure.
     * 
     * @static
     * @param {Object} struct reffer to constructor.
     * @param {Boolean} autokey reffer to constructor.
     * @returns {IndexedMap} new instance of HashMap.
     */
    IndexedMap.set = function (struct, autokey) {
        var hm = new IndexedMap(struct, autokey);
        return hm;
    };

    /**
     * Converts given structure, that represents hash map, to array. For the 
     * purpose of this conversion it appends __index property with key value for 
     * individual element of hash map structure. 
     * Using HashMap.fromArray(..) will unwrapp this into key and it will remove 
     * appended property from the element.
     * 
     * @param {Object} struct (associative list, POJO, JS simple object)
     * @returns {Array}
     */
    IndexedMap.toArray = function (struct) {
        var hm = IndexedMap.set(struct, true);
        var arr = [];
        hm.each(function (item, key) {
            item.__index = key * 1;
            arr.push(item);
        });
        return arr;
    };

    /**
     * Converts given array into hash map. 
     * If array was created using HashMap.toArray(..) it will use the value of 
     * each element's __index property to create a corresponding key and it will 
     * remove that property from the element.
     * If array element does not contain __index property the keys will be 
     * determined using autokey feature.
     * 
     * @param {Array} arr
     * @returns {IndexedMap}
     */
    IndexedMap.fromArray = function (arr) {
        var hm = new IndexedMap(undefined, true);
        for (var i = 0; i < arr.length; i++) {
            var item = arr[i];
            if (utils.isSet(item.__index)) {
                var index = utils.strToNum(item.__index);
                hm.add(utils.clone(item), index);
            } else {
                var index = hm.add(utils.clone(item));
                item.__index = index;
            }
        }
        return hm;
    };

    /**
     * Adds the item to the hash map.
     * 
     * @param {*} item
     * @param {String} key [optional] When the key is not specified and autokey 
     * feature is turned ON, the determined autokey value will be used for 
     * item's key. 
     * When autokey feature is turned OFF the key is MANDATORY argument.
     * @returns {String} a key that was set for this item either by autokey 
     * feature or by manual setting.
     */
    IndexedMap.prototype.add = function (item, key) {
        if (this._autokey && utils.isUndefined(key)) {
            key = this._autoIncrement();

            this._struct[key] = item;
        } else {
            this._struct[key] = item;
        }

        if (this._autokey) {
            if (!utils.isSet(item.__index))
                item.__index = key;
        }

        return key;
    };

    /**
     * Gets the element of the hash map by given key or it gets the entire 
     * hash map structure if the key is not specified.
     * 
     * @param {String} key [optional]
     * @returns {Object} representing hash map structure (associative list, 
     * POJO, JS simple object)
     */
    IndexedMap.prototype.get = function (key) {
        if (utils.isSet(key))
            return this._struct[key];
        return this._struct;
    };

    /**
     * Gets the last item of the hash map structure.
     * 
     * @returns {*} an element of the hash map structure.
     */
    IndexedMap.prototype.getLast = function () {
        var last = undefined;
        this.each(function (item) {
            last = item;
        });
        return last;
    };

    /**
     * Gets the first item of the hash map structure.
     * 
     * @returns {*} an element of the hash map structure.
     */
    IndexedMap.prototype.getFirst = function () {
        var first = undefined;
        this.each(function (item) {
            first = item;
            return false;
        });
        return first;
    };

    /**
     * Gets the key of the last item of the hash map structure.
     * 
     * @returns {key}
     */
    IndexedMap.prototype.getLastKey = function () {
        var last = this.getLast();
        return last.__index;
    };

    IndexedMap.prototype.getHighestIndex = function () {
        var indexes = [];
        this.each(function (item) {
            if (utils.isDefined(item.__index))
                indexes.push(item.__index);
        });
        if (indexes.length > 0)
            return Math.max.apply(Math, indexes);
        return 0;
    };

    /**
     * Gets the key of the first item of the hash map structure.
     * 
     * @returns {key}
     */
    IndexedMap.prototype.getFirstKey = function () {
        var first = undefined;
        this.each(function (item, key) {
            first = key;
            return false;
        });
        return first;
    };

    /**
     * Iterates through hash map structure and executes callback on each 
     * iteration injecting it with current item, its key and iteration step.
     * When the callback returns Boolean FALSE value, the iteration is stopped.
     * 
     * @param {Function} callback
     */
    IndexedMap.prototype.each = function (callback) {
        if (!utils.isFunction(callback))
            throw "Callback for HashMap::each must be of type Function";

        var i = 0;
        for (var k in this._struct) {
            if (callback(this._struct[k], k, i) === false) {
                break;
            }
            i++;
        }
    };

    IndexedMap.prototype.size = function () {
        return Object.keys(this._struct).length;
    };

    /**
     * Validates autokey feature. It checks the keys of the structure for 
     * numeric values. Note that ALL of the keys must be of numeric value for 
     * autokey feature to work.
     * It will always return TRUE if the hash map structure is empty.
     * 
     * @private
     * @param {Boolean} autokey
     * @returns {Boolean}
     */
    IndexedMap.prototype._validateAutokey = function (autokey) {
        if (!autokey)
            return false;
        if (utils.isEmpty(this._struct))
            return true;

        var numeric = false;
        for (var k in this._struct) {
            if (utils.isNumeric(k))
                numeric = true;
            else {
                numeric = false;
                break;
            }

        }

        // numeric key type defines if autokey is even possible
        return numeric;
    };

    /**
     * Performes auto increment for the new key. Note that this works only with 
     * key of numeric value.
     * 
     * @returns {String} a key.
     */
    IndexedMap.prototype._autoIncrement = function () {
        var lastKey = this.getHighestIndex() || 0;
        if (!utils.isNumber(lastKey) && !utils.isNumeric(lastKey))
            throw "Can not increment non-numeric key set!";
        else if (!utils.isNumber(lastKey) && utils.isNumeric(lastKey))
            lastKey = utils.strToNum(lastKey);
        lastKey++;
        return lastKey;
    };

    litui.$$register(IndexedMap);
})(litui.utils);
'use strict';

(function () {
    LituiCss.__SINGLETON__ = { 'name': 'css', module: 'utility' };
    /**
     * Helper class for working with CSS.
     * 
     * @class
     * @memberOf litui.utility
     * @dev Add code for your needs.
     */
    function LituiCss() {

    }

    /**
     * Will execute CSS calc function on given valid CSS calc expression. When 
     * working with percentage (%), element's parent container's dimension must 
     * be provided. 
     * If calculation is about height, than parent's height must be provided, 
     * otherwise width.
     * 
     * @param {*} dimension Can be a number, a string containing pixel 
     * information, a string containing dimension in percentage (%) or a string 
     * containing CSS calc expression.
     * @param {Number} containerDimension Container dimension (width or height).
     * @returns {Number} Calculated dimension, represented in pixels.
     */
    LituiCss.prototype.calc = function (dimension, containerDimension) {
        if (litui.utils.isUndefined(containerDimension))
            return this.px2num(dimension);

        if (dimension.indexOf('calc') > -1)
            return eval(dimension.replace('calc(', '').replace(')', '').replace('100%', containerDimension + 'px').replace(new RegExp('px', 'g'), ''));
        else if (dimension.indexOf('%') > -1)
            return dimension.replace('100%', containerDimension) * 1;
    };

    /**
     * Converts pixel(s) to number.
     * 
     * @param {String} px e.g. '10px'
     * @returns {Number} e.g. 10
     */
    LituiCss.prototype.px2num = function (px) {
        if (litui.utils.isString(px) && px.indexOf('px') > -1)
            return px.substring(0, px.indexOf('px')) * 1;
        return px;
    };

    /**
     * Converts number to pixel(s).
     * 
     * @param {Number} num e.g. 10
     * @returns {String} e.g. +10px'
     */
    LituiCss.prototype.num2px = function (num) {
        if (num === 0)
            return num;

        if (litui.utils.isString(num) && num.indexOf('px') > -1)
            return num;
        return num + 'px';
    };
    
    litui.$$register(LituiCss);
})();'use strict';

(function(){
    LituiMath.__SINGLETON__ = {name: 'math', module: ''};
    function LituiMath() {
        
    }
            
    /**
     * Calculates average for array of numeric values.
     * 
     * @param {Number} values Numerical values for average calculation.
     * @returns {Number} average.
     */
    LituiMath.prototype.average = function(values){
        var avg = 0;
        var length = values.length;
        for(var i = 0; i < length; i++){
            avg += values[i];
        }
        avg /= length;
        return avg;
    };

    /**
     * Gets minimum from array of numeric values.
     * 
     * @param {Number} values Numerical values for average calculation.
     * @returns {Number} minimum.
     */
//    LituiMath.prototype.min = function(values){
//        return d3.min(values);
//    };

    /**
     * Gets maximum from array of numeric values.
     * 
     * @param {Number} values Numerical values for average calculation.
     * @returns {Number} maximum.
     */
//    LituiMath.prototype.max = function(values){
//        return d3.max(values);
//    };

    LituiMath.prototype.round = function(value, decimals){
        decimals = (decimals === undefined)? 1 : decimals;
        return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
    };
})();


(function(){
    angular.module('litui', []);
})();"use strict";

(function () {

    angular.module('litui').service('lituiFormService',
    /** @ngInject */
    function () {

        function LituiFormService() {
            new litui.Subscribe(this, ['TRIGGER_SUBMIT', 'SUBMIT_FORM']);
        }
        
        LituiFormService.prototype.triggerSubmit = function(formId){
            this.trigger('TRIGGER_SUBMIT#' + formId);
        };
        
        LituiFormService.prototype.submitForm = function(formId){
            this.trigger('SUBMIT_FORM#' + formId);
        };
        
        LituiFormService.prototype.registerSubmitForm = function(formId, callback){
            this.on('SUBMIT_FORM#' + formId, callback);
        };
        
        LituiFormService.prototype.deregisterSubmitForm = function(formId){
            this.off('SUBMIT_FORM#' + formId);
        };

        return new LituiFormService();
    });
})();
'use strict';

(function () {
    angular.module('litui').component('lituiForm', {
        templateUrl: 'litui.base/com/litui-form/litui-form.html',
        controller: LituiFormCtrl,
        bindings: {
            formDefinition: '=',
            modelId: '=?',
            model: '=?',
            hooks: '=?',
            name: '@?'
        }
    });

    /** @ngInject */
    function LituiFormCtrl(lituiFormService) {
        var self = this;
        
        LituiFormCtrl.AI++;
        
        this.form = {};
        
        if(litui.utils.isUndefined(this.name))
            this.name = 'litui-form-' + LituiFormCtrl.AI;

        this.formError;
        

        this.$onInit = function () {
            litui.lang.prepareSettings({
                onSubmit: function () {
                    if (!self.form.$valid) {
                        self.formError = 'LITUI.FORM.ERROR';
                        return litui.async.promise(false);
                    }

                    processEachField(function (fname, value, field) {
                        self.model[fname] = value;
                    });

                    if (litui.utils.isFunction(self.formDefinition.onSubmit)) {
                        return self.formDefinition.onSubmit(self.model, self.form);
                    }
    //                return self.form;
                    return litui.async.promise(false);
                }
            }, this, 'hooks');



            if (litui.utils.isDefined(self.formDefinition.formId)) {
                lituiFormService.on('TRIGGER_SUBMIT#' + self.formDefinition.formId, function () {
                    self.hooks.onSubmit();
                });
            }
            
            if (litui.utils.isDefined(self.model)) {
                processEachField();
            } else if (litui.utils.isFunction(self.formDefinition.loadData))
                return self.formDefinition.loadData(self.modelId).then(function (model) {
                    self.model = model;

                    processEachField();
                });
        };

        this.$onDestroy = function () {
            litui.logger.log("Destroy form");
            lituiFormService.off('TRIGGER_SUBMIT#' + self.formDefinition.formId);
        };
        
        this.onFieldChange = function (e, val, field) {
            if (litui.utils.isUndefined(val))
                return;
            if (litui.utils.isFunction(field.onChange))
                field.onChange(e, val, field);
            self.model[field.modelKey] = val;
        };

        function processEachField(cb) {
            for (var fname in self.formDefinition.fields) {
                var field = self.formDefinition.fields[fname];

                // set values and remember model key
//                self.model[fname] = self.model[fname];
                field.modelKey = fname;

                // create depends on list
                if (litui.utils.isArray(field.dependsOn)) {
                    for (var i = 0; i < field.dependsOn.length; i++) {
                        var depKey = field.dependsOn[i];
                        var depField = getField(depKey);
                        if (litui.utils.isUndefined(depKey))
                            continue;

                        if (litui.utils.isUndefined(depField.$$linked))
                            depField.$$linked = {};
                        depField.$$linked[depKey] = field;
                    }
                }
            }
        }

        function getField(modelKey) {
            for (var fname in self.formDefinition.fields) {
                if (fname === modelKey)
                    return self.formDefinition.fields[fname];
            }
        }
    }
    
    LituiFormCtrl.__AI = 0;
})();
'use strict';

(function () {
    angular.module('litui').factory('LituiInputFieldFactory', LituiInputFieldFactoryWrapper);

    /** @ngInject */
    function LituiInputFieldFactoryWrapper($timeout) {
        function LituiInputFieldFactory(ctrl, $scope, $element, settings, hooks) {
            var self = this;

            this.ctrl = ctrl;
            
            if(litui.utils.isDefined(this.ctrl.field) && litui.utils.isUndefined(this.ctrl.field.messages))
                this.ctrl.field.messages = {};
            
            this.$scope = $scope;
            this.$element = $($element);
            this.settings = litui.lang.merge({
                predefinedActions: []
            }, settings || {});
            this.hooks = hooks || {};
            this.isInitialized = false;
        }
        
        LituiInputFieldFactory.AI = 0;

        LituiInputFieldFactory.prototype.init = function () {
            var self = this;
            LituiInputFieldFactory.AI++;
            self.ctrl.field.id = 'litui-field-' + LituiInputFieldFactory.AI;
            
            this.ctrl.ngModel.$render = function () {
                self.ctrl.value = self.ctrl.ngModel.$viewValue;
            };
            this.$scope.$watch(function () {
                return self.ctrl.value;
            }, function (value, oldValue) {                                
                self.ctrl.ngModel.$setTouched();
                self.ctrl.ngModel.$setDirty();
                self.ctrl.ngModel.$setViewValue(value);
                
                if(litui.utils.isSet(value) && litui.utils.notEmpty(value) && 
                    (litui.utils.notSet(oldValue) || litui.utils.isEmpty(oldValue)))
                    self.isInitialized = true;

                self.calcLabelPosition(value);
                self.validate(value);
                if(litui.utils.isFunction(self.hooks.onChange)){
                    self.hooks.onChange(self.ctrl.ngModel, value, self.ctrl.field);
                }
            });
            this.registerEvents();
            
            self.ctrl.field.$$validate = function(){
                return self.validate(self.ctrl.value);
            };
            
            this.validate(self.ctrl.value);
            
            this.ctrl.$lituiActions = litui.lang.mergeArr(this.ctrl.field.actions || [], this.settings.predefinedActions);
            
            litui.async.delay(function(){
                self.calcLabelPosition(self.ctrl.value);
            });
        };
        
        LituiInputFieldFactory.prototype.validate = function (value) {
            var self = this;
            
            var d = litui.async.defer();

            if (litui.utils.isSet(value)) {
                this.ctrl.field.forceDisabled = false;
                // regex pattern validation: 
                // 1. is validate pattern ON, 
                // 2. is validity pattern defined and 
                // 3. does it qualify
                if ((this.ctrl.field.isValidatePattern || litui.utils.isUndefined(this.ctrl.field.isValidatePattern)) && 
                        litui.utils.isDefined(this.ctrl.field.validityPattern) &&
                        litui.utils.isFunction(value.match) && 
                        !value.match(this.ctrl.field.validityPattern)) {
                    this.ctrl.ngModel.$setValidity("isPatternValid", false);
                    this.ctrl.$lituiFieldErrorMessage = this.ctrl.field.messages.patternValidity;
                    this.validateDependents();
                    this.disableDependents();
                    d.reject();
                }

                // custom validation function
                if (litui.utils.isFunction(this.ctrl.field.validate)) {
                    litui.async.when(this.ctrl.field.validate(value)).then(function(isValid){
                        if(isValid !== true){
                            self.ctrl.ngModel.$setValidity("isValueValid", false);
                            self.ctrl.$lituiFieldErrorMessage = isValid === false? self.ctrl.field.valueValidityMessage : self.ctrl.field.messages[isValid];
                            self.validateDependents();
                            self.disableDependents();
                            d.reject();
                        }
                    }).then(function(){
                        d.resolve();
                    }).catch(function(){});
                }
                else
                    d.resolve();
            }
            else if((this.ctrl.field.isRequired || this.ctrl.isRequired) && this.isInitialized && (litui.utils.notSet(value) || value.length === 0)){
                this.ctrl.ngModel.$setValidity("isRequired", false);
                this.ctrl.$lituiFieldErrorMessage = 'LITUI.INPUT_FIELD.IS_REQUIRED';
                this.validateDependents();
                this.disableDependents();
                d.reject();
            }
            else{
                d.resolve();
            }
            return d.promise.then(function(){
                // field is valid
                self.enableDependents();
                self.validateDependents();
                self.ctrl.field.forceDisabled = false;
                self.ctrl.$lituiFieldErrorMessage = "";
                self.ctrl.ngModel.$setValidity("isPatternValid", true);
                self.ctrl.ngModel.$setValidity("isValueValid", true);
                self.ctrl.ngModel.$setValidity("isDependencyValid", true);
                self.ctrl.ngModel.$setValidity("isRequired", true);
            }).catch(function(){
                
            });
        };

        LituiInputFieldFactory.prototype.destroy = function () {
            this.$scope.$destroy();
        };

        LituiInputFieldFactory.prototype.registerEvents = function () {
            var self = this;
            this.ctrl.$lituiInputEvents = {
                onChange: function (e, value, field) {
                    self.calcLabelPosition(value);
                    
                    if (litui.utils.isFunction(self.ctrl.onChange)) {
                        var e = {
                            $elt: self.$element,
                            ctrl: self.ctrl,
                            name: self.ctrl.name
                        };
                        self.ctrl.onChange({e: e, val: value, field: field});
                    }
                }
            };
        };

        LituiInputFieldFactory.prototype.isEmpty = function (value) {  
            return !litui.utils.isSet(value) || 
                    value === "" || 
                    (litui.utils.isString(value) && value.length === 0);
        };

        LituiInputFieldFactory.prototype.disableDependents = function () {  
            // validate also dependent fields
            if(litui.utils.isDefined(this.ctrl.field.$$linked))
                for(var k in this.ctrl.field.$$linked){
                    var linkedF = this.ctrl.field.$$linked[k];
                    linkedF.forceDisabled = true;
                }
            
            this.ctrl.ngModel.$setValidity("isDependencyValid", false);
        };

        LituiInputFieldFactory.prototype.enableDependents = function () {  
            // validate also dependent fields
            if(litui.utils.isDefined(this.ctrl.field.$$linked))
                for(var k in this.ctrl.field.$$linked){
                    var linkedF = this.ctrl.field.$$linked[k];
                    linkedF.forceDisabled = false;
                }
            
            this.ctrl.ngModel.$setValidity("isDependencyValid", true);
        };

        LituiInputFieldFactory.prototype.validateDependents = function () {  
            // validate also dependent fields
            if(litui.utils.isDefined(this.ctrl.field.$$linked))
                for(var k in this.ctrl.field.$$linked){
                    var linkedF = this.ctrl.field.$$linked[k];
                    linkedF.$$validate();
                }
            
//            this.ctrl.ngModel.$setValidity("isDependencyValid", true);
        };

//        LituiInputFieldFactory.prototype.calcLabelPosition = function (value) {  
//            this.ctrl.$isLabelStartPosition = this.isEmpty(value);
//            var validation = this.validate(value);
//            if(litui.utils.isUndefined(validation))
//                return;
//
//            
//        };
        LituiInputFieldFactory.prototype.calcLabelPosition = function (value) {  
            this.ctrl.$isLabelStartPosition = this.isEmpty(value);
            if(this.ctrl.$isLabelStartPosition){
                var topoffset = 18;
                var $noerror = this.$element.find('.litui-noerror');
                if($noerror.length > 0)
                    topoffset = 9;
                var props = {
                    top: this.$element.height()/2 - topoffset
                };
                if($('html').attr('dir') === 'rtl'){
                    props.right = 14;
                }
                else{
                    props.left = 14;
                }
                TweenMax.to(this.$element.find('label'), 0.2, props);
            }
            else{
                var props = {
                    top: 2
                };
                if($('html').attr('dir') === 'rtl'){
                    props.right = 2;
                }
                else{
                    props.left = 2;
                }
                TweenMax.to(this.$element.find('label'), 0.2, props);
            }
        };


        return LituiInputFieldFactory;
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInput', {
        controller: LituiInputCtrl,
        templateUrl: 'litui.base/com/litui-input/litui-input.html',
        bindings: {
            field: '=?',
            onChange: '&?',
            lituiForm: '=?',
            name: '@',
            placeholder: '@?',
            label: '@?',
            tab: '@?',
            value: '=?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInputCtrl(){
        var self = this;
        
        this.input = null;
        
        this.$onInit = function(){
            this.input = {
                field: this.field,
                value: this.value
            };

            if(litui.utils.isDefined(this.field)){
                if((litui.utils.isDefined(this.field.isDisabled))){
    //                litui.logger.warn("LITUI input deprecation: using 'isDisabled' or 'forceDisabled' in field definition is deprecated. Use component binding (is-disabled) instead!");
    //                litui.logger.log(this.field);
                }
            }
        }
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiTranslate', LituiTranslateDirective);

    /** @ngInject */
    function LituiTranslateDirective(lituiTranslate, lituiTranslatePreviewService) {
        return {
            restrict: 'EA',
            scope: {
                lituiTranslate: '=?',
                lituiTranslateValues: '=?'
            },
            link: {
                pre: function ($scope, $elt, attr) {
                    var key = "";
                    var value = "";
                    $scope.$watch('lituiTranslate', render);

                    if (litui.utils.isDefined($scope.lituiTranslateValues))
                        $scope.$watch('lituiTranslateValues', render, true);

                    lituiTranslatePreviewService.on('ENABLE_PREVIEW', enablePreview);
                    lituiTranslatePreviewService.on('DISABLE_PREVIEW', disablePreview);
                    
                    $scope.$on('$destroy', function(){
                        lituiTranslatePreviewService.off('ENABLE_PREVIEW', enablePreview);
                        lituiTranslatePreviewService.off('DISABLE_PREVIEW', disablePreview);
                    });
                    
                    function render() {
                        if (litui.utils.isDefined($scope.lituiTranslate))
                            key = $scope.lituiTranslate;
                        else {
                            key = $($elt).text();
                        }
                        if(litui.utils.notSet(key) || key.length === 0){
                            $($elt).html("");
                            return;
                        }

                        lituiTranslate.async(key, $scope.lituiTranslateValues).then(function (str) {
                            value = str;
                            $($elt).html(value);
                            enablePreview();
                        }).catch(function(){
                            $($elt).html(key);
                            enablePreview();
                        });
                    }

                    function enablePreview() {
                        if (litui.utils.isDefined(litui.config.get('translate')) && litui.config.get('translate').isPreview) {
                            $elt.attr('litui-translate-preview-key', lituiTranslatePreviewService.addEntry($elt, key, value));
                        }
                    }

                    function disablePreview() {
                        
                    }
                }
            }
        };
    }
})();

"use strict";

/**
 * Adapted from TMS.
 */
(function(){
    angular.module('litui').factory('lituiTranslate', LituiTranslateFactory);
    
    /** @ngInject */
    function LituiTranslateFactory($translate, $parse, lituiTranslateService) {
        /**
         * @ngdoc service
         * @name litui.service.class:translate
         * @param {string|Array} translationId A token which represents a translation id This can be 
         * optionally an array of translation ids which results that the function returns an 
         * object where each key is the translation id and the value the translation.
         * @param {Object} interpolateParams An object hash for dynamic values
         * @returns {string} translation
         */
         function LituiTranslate(translationId, interpolateParams) {
            if (!angular.isObject(interpolateParams)) {
                interpolateParams = $parse(interpolateParams)();
            }
            return $translate.instant(translationId, interpolateParams);
        };

        LituiTranslate.async = function(translationId, interpolateParams){
            if (!angular.isObject(interpolateParams)) {
                interpolateParams = $parse(interpolateParams)();
            }
            
            // as of Angular 1.8.3 we must manually skip empty translations,
            // otherwise exception is thrown
            if(litui.utils.notSet(translationId) || translationId.length === 0){
                return litui.async.promise();
            }
            return $translate(translationId, interpolateParams);
        };

        return LituiTranslate;
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiTranslate', LituiTranslateFilter);
    
    /** @ngInject */
    function LituiTranslateFilter(lituiTranslate){
        return function (value, params) {
            return lituiTranslate.apply(lituiTranslate, [value, params]);
        };
    }
})();
"use strict";

/**
 * Adapted from TMS.
 */
(function () {
    angular.module('litui').service('lituiTranslatePreviewService', LituiTranslatePreviewService);

    /** @ngInject */
    function LituiTranslatePreviewService(lituiPopupService, lituiTranslateService, lituiCompileService) {
        function LituiTranslatePreview() {
            this.currentEntries = {};
            this.periodicalObserver = null;
            this.translatorValuePop = null;
            new litui.Subscribe(this, ['ENABLE_PREVIEW', 'DISABLE_PREVIEW']);
        }

        LituiTranslatePreview.AI = 0;

        LituiTranslatePreview.prototype.enablePreview = function () {
            var self = this;
            
            litui.layoutMngr.on('PROVIDER_SET', function(){
                var layoutMngr = litui.layoutMngr.provide();
                layoutMngr.on('INIT', function(){
                    lituiCompileService.compile(layoutMngr.getPanelElt('central'), {
                        append: true,
                        component: '<litui-translate-preview-notification language-code="' + litui.config.get('language') + '"></litui-translate-preview-notification>'
                    });
                });
            });
            
            
            
            this.periodicalObserver = litui.async.periodical(function () {
                $('[litui-translate], [translate]').each(function () {
                    var $elt = $(this);
                    var key = $elt.attr('litui-translate-preview-key');
                    var entry = self.currentEntries[key];
                    if(litui.utils.isUndefined(entry)){
                        $elt.attr('litui-translate-preview-key', self.addEntry($elt, key, $elt.text()));
                    }

                    if (litui.utils.isDefined(entry) && !entry.isLoaded) {
                        self.enableEntry(entry);
                    }

                });
            }, 1000);
            this.trigger('ENABLE_PREVIEW');
        };

        LituiTranslatePreview.prototype.disablePreview = function () {
            var self = this;
            litui.async.unset(this.periodicalObserver);
            $('[litui-translate], [translate]').each(function () {
                var $elt = $(this);
                $elt.removeClass('litui-translate-value-translation');
                $elt.removeClass('litui-translate-value-no-translation');
                
                var key = $elt.attr('litui-translate-preview-key');
                var entry = self.currentEntries[key];
                if(litui.utils.isDefined(entry) && entry.isLoaded)
                    $elt.off('click', entry.onSelected);
            });
            this.trigger('DISABLE_PREVIEW');
            this.currentEntries = {};
        };

        LituiTranslatePreview.prototype.addEntry = function ($elt, key, value) {
            if (litui.utils.isUndefined(this.currentEntries[key]) && key !== value) {
                
                this.currentEntries[key] = {
                    $elt: [$elt],
                    key: key,
                    isLoaded: false,
                    value: value
                };
            } else if (litui.utils.isDefined(this.currentEntries[key])) {
                var entry = this.currentEntries[key];
                entry.isLoaded = false;
                entry.$elt.push($elt);
                
                if(value !== entry.value){
                    value = entry.value;
                    var removeQ = [];
                    for(var i = 0; i < entry.$elt.length; i++){
                        var $elt = entry.$elt[i];
                        if($elt.length === 0){
                            removeQ.push($elt);
                            continue;
                        }
                        $elt.text(entry.value);
                    }
                    litui.utils.deleteElements(entry.$elt, removeQ, function(a, b){
                        return a[0] === b[0];
                    });
                }
                
            } else {
                $elt.addClass('litui-translate-value-no-translation');
            }
            return key;
        };

        LituiTranslatePreview.prototype.enableEntry = function (entry) {
            var self = this;
            var originValue = entry.value;
            entry.isLoaded = true;
            entry.onSelected = function () {
                if(litui.utils.nonNull(self.translatorValuePop))
                    self.translatorValuePop = lituiPopupService.close(self.translatorValuePop);
                
                lituiPopupService.open({
                    header: {
                        title: litui.translator.translate('LITUI.TRANSLATE_PREVIEW.TITLE', {
                            languageCode: litui.config.get('language')
                        }),
                        actions: [
                            {
                                icon: 'icon-publish',
                                onSelected: function () {
                                    return lituiTranslateService.publishSingle(litui.config.get('language'), lituiTranslateService.appId, {
                                        key: entry.key,
                                        value: entry.value
                                    }).then(function(payload){
                                        for (var i = 0; i < entry.$elt.length; i++) {
                                            entry.$elt[i].text(entry.value);
                                        }
                                        return payload;
                                    });
                                }
                            },
                            {
                                icon: 'icon-save',
                                onSelected: function () {
                                    lituiTranslateService.saveTranslation(litui.config.get('language'), lituiTranslateService.appId, {
                                        key: entry.key,
                                        value: entry.value
                                    }).then(function () {
                                        for (var i = 0; i < entry.$elt.length; i++) {
                                            entry.$elt[i].text(entry.value);
                                        }

                                        litui.notify.success({
                                            title: 'LITUI.TRANSLATE_PREVIEW.SAVE.SUCCESS.TITLE',
                                            message: 'LITUI.TRANSLATE_PREVIEW.SAVE.SUCCESS.MESSAGE'
                                        });
                                    });
                                }
                            }
                        ],
                    },
                    isDraggable: true,
                    isDismissible: false,
                    onClose: function(){
                        entry.value = originValue;
                        self.translatorValuePop = null;
                    },
                    component: {
                        template: '<litui-translator-value translation-field="translatorField" ref-value="refValue"></litui-translator-value>',
                        params: {
                            translatorField: {
                                key: entry.key,
                                value: entry.value,
                                onChange: function (e, value) {
                                    if (entry.key === entry.key && entry.value !== value) {
                                        entry.value = value;
                                    }
                                }
                            },
                            refValue: entry.value
                        }
                    }
                }).then(function(pop){
                    self.translatorValuePop = pop;
                });
            };
            
            for (var i = 0; i < entry.$elt.length; i++) {
                var $elt = entry.$elt[i];
                $elt.addClass('litui-translate-value-translation');
                $elt.on('click', entry.onSelected);
            }
        };

        return new LituiTranslatePreview();
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiTranslateService', LituiTranslateServiceWrapper);
    
    /** @ngInject */
    function LituiTranslateServiceWrapper(lituiConfirmService) {
        function LituiTranslateService(){
            var self = this;
            
            this.refLang = 'en';
            this.path = {
                load: 'translation/load/{appId}',
                fetch: 'translation/fetch/{appId}/{languageCode}',
                refLang: 'translation/ref-lang/{appId}',
                languages: 'translation/languages/{appId}',
                save: 'translation/save/{languageCode}/{appId}',
                saveTranslation: 'translation/save-live/{languageCode}/{appId}',
                publish: 'translation/publish/{languageCode}/{appId}',
                applyToEqual: 'translation/apply-equal/{languageCode}/{appId}',
                appIds: 'translation/app-ids',
                preview: 'translation/preview/{languageCode}',
                exportTranslations: 'translation/export/{languageCode}/{appId}',
                importTranslations: 'translation/import/{languageCode}/{appId}',
                publishSingle: 'translation/publish-single/{languageCode}/{appId}'
            };
            
            this.store = [];
            this.appId = 'litui';
        }
//        
//        KEEP FOR REFERENCE
//        LituiTranslatorService.prototype.load = function(appId){
//            return litui.request.GET(this.path.i18n.replace('{appId}', appId));
//        };
        
        LituiTranslateService.prototype.setBasePath = function(basePath){
            for(var k in this.path){
                this.path[k] = this.path[k].replace('translation/', basePath + '/');
            }
        };
        
        LituiTranslateService.prototype.getPath = function(pathName, languageCode, appId){
            var p= this.path[pathName].replace('{languageCode}', languageCode).replace('{appId}', appId);
            return p;
        };
        
        LituiTranslateService.prototype.fetch = function(appId, languageCode, filter){
            return litui.request.POST(this.path.fetch.replace('{appId}', appId).replace('{languageCode}', languageCode), filter);
        };
        
        LituiTranslateService.prototype.load = function(appId, languageCode){
            return litui.request.GET(this.path.i18n.replace('{appId}', appId).replace('{languageCode}', languageCode));
        };
        
        LituiTranslateService.prototype.loadRef = function(appId){
            return litui.request.GET(this.path.refLang.replace('{appId}', appId));
        };
        
        LituiTranslateService.prototype.getLanguages = function(appId){
            return litui.request.GET(this.path.languages.replace('{appId}', appId));
        };
        
        LituiTranslateService.prototype.saveTranslations = function(languageCode, appId, translations){
            return litui.request.POST(this.path.save.replace('{languageCode}', languageCode).replace('{appId}', appId), translations);
        };
        
        LituiTranslateService.prototype.saveTranslation = function(languageCode, appId, liveTranslation){            
            return litui.request.POST(this.path.saveTranslation.replace('{languageCode}', languageCode).replace('{appId}', appId), liveTranslation);
        };
        
        LituiTranslateService.prototype.publish = function(languageCode, appId){
            return litui.request.POST(this.path.publish.replace('{languageCode}', languageCode).replace('{appId}', appId));
        };
        
        LituiTranslateService.prototype.applyToEqual = function(languageCode, appId, dto){
            var self = this;
            return lituiConfirmService.notify({
                icon: 'icon-apply_to_unit',
                label: 'LITUI.TRANSLATOR.APPLY_TO_EQUAL.CONFIRM.LABEL',
                title: 'LITUI.TRANSLATOR.APPLY_TO_EQUAL.CONFIRM.TITLE',
                text: 'LITUI.TRANSLATOR.APPLY_TO_EQUAL.CONFIRM.MESSAGE',
                onSubmit: function(){
                    return litui.request.POST(self.path.applyToEqual.replace('{languageCode}', languageCode).replace('{appId}', appId), dto);
                }
            }).resolution;
        };
        
        LituiTranslateService.prototype.appIds = function(){
            return litui.request.POST(this.path.appIds);
        };
        
        LituiTranslateService.prototype.preview = function(languageCode){
            return litui.request.POST(this.path.preview.replace('{languageCode}', languageCode)).then(function(){
                location.reload();
            });
        };
        
        LituiTranslateService.prototype.importTranslations = function(languageCode, appId){
            return litui.request.POST(this.path.preview.replace('{languageCode}', languageCode).replace('{appId}', appId));
        };
        
        LituiTranslateService.prototype.exportTranslations = function(languageCode, appId){
            window.open(litui.request.restBaseUrl + this.path.exportTranslations.replace('{languageCode}', languageCode).replace('{appId}', appId), '_self');
        };
        
        
        LituiTranslateService.prototype.publishSingle = function(languageCode, appId, dto){
            var self = this;            
            return lituiConfirmService.notify({
                icon: 'icon-publish',
                label: 'LITUI.TRANSLATOR.PUBLISH_SINGLE.CONFIRM.LABEL',
                title: 'LITUI.TRANSLATOR.PUBLISH_SINGLE.CONFIRM.TITLE',
                text: 'LITUI.TRANSLATOR.PUBLISH_SINGLE.CONFIRM.MESSAGE',
                onSubmit: function(){
                    return litui.request.POST(self.path.publishSingle.replace('{languageCode}', languageCode).replace('{appId}', appId), dto);
                }
            }).resolution.then(function(payload){
                litui.notify.success({
                    title: 'LITUI.TRANSLATOR.PUBLISH_SINGLE.SUCCESS.TITLE',
                    message: 'LITUI.TRANSLATOR.PUBLISH_SINGLE.SUCCESS.MESSAGE'
                });
                return payload;
            });
        };
        
        return new LituiTranslateService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTranslatorValue', {
        controller: LituiTranslatorValueCtrl,
        templateUrl: 'litui.base/com/litui-translate/litui-translator-value.html',
        bindings: {
            translationField: '=',
            refValue: '='
        }
    });
    
    /** @ngInject */
    function LituiTranslatorValueCtrl(){
        var self = this;
        
        this.editableField = {
            type: 'plain-text'
        };
        
        this.onValueChange = function(e, val, field){
            self.translationField.onChange(e, val);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').directive('lituiPreloader', LituiPreloaderDirective);
    
    /** @ngInject */
    function LituiPreloaderDirective(lituiPreloaderService){
        return { 
            restrict: 'A', 
            link: function($scope, $elt, attr){
                if(litui.utils.isUndefined(attr.lituiPreloader))
                    throw "Please specify preloader ID";
                if(litui.utils.isDefined(attr.lituiPreloaderInstant)){
                    lituiPreloaderService.activateInstant(attr.lituiPreloader, $elt, litui.utils.isBoolean(attr.lituiPreloaderPrevent) && litui.utils.toBoolean(attr.lituiPreloaderPrevent));
                }
                else{
                    lituiPreloaderService.activate(attr.lituiPreloader, $elt, litui.utils.isBoolean(attr.lituiPreloaderPrevent) && litui.utils.toBoolean(attr.lituiPreloaderPrevent));
                }
                $scope.$on('$destroy', function(){
                    lituiPreloaderService.destroy(attr.lituiPreloader);
                });
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiPreloaderService', LituiPreloaderServiceWrapper);
        
    /** @ngInject */
    function LituiPreloaderServiceWrapper(){
        function LituiPreloaderService(){
            this.$$preloaders = {};
            this.settings = {
                debounceTimeout: 100
            };
        }
        
        LituiPreloaderService.prototype.activate = function(preloaderId, $parent, prevent){            
            this.createPreloader($parent, preloaderId);
            if(!prevent)
                this.show(preloaderId);
            return this;
        };
        
        LituiPreloaderService.prototype.activateInstant = function(preloaderId, $parent, prevent){            
            this.createPreloader($parent, preloaderId);
            if(!prevent)
                this.show(preloaderId, true);
            return this;
        };
        
        LituiPreloaderService.prototype.activateExisting = function(preloader){            
            preloader.isActive = true;
            this.show(preloader.id);
        };
        
        LituiPreloaderService.prototype.show = function(preloaderId, isDebounce){
            var preloader = this.getPreloader(preloaderId);
            if(litui.utils.isUndefined(isDebounce) || isDebounce)
                preloader.debounceHandler.debounce();
            else
                preloader.debounceHandler.instant();
        };
        
        LituiPreloaderService.prototype.destroy = function(preloaderId){
           var preloader = this.getPreloader(preloaderId);
           if(litui.utils.isUndefined(preloader))
               return;
           preloader.debounceHandler.cancel();
           this.revertParent(preloader);
           preloader.$elt.remove();
           litui.utils.deleteItem(preloaderId, this.$$preloaders);
        };
        
        LituiPreloaderService.prototype.dismiss = function(preloaderId, delay){
            var self = this;
            litui.async.delay(function(){
                var preloader = self.getPreloader(preloaderId);
                if(litui.utils.isUndefined(preloader)){
                    return;
                }

                if(litui.utils.isUndefined(delay)){
                    self.$$hide(preloader);
                }
                else{
                    litui.async.delay(function(){
                        self.$$hide(preloader);
                    }, delay);
                }
            }, 50);
        };
        
        LituiPreloaderService.prototype.dismissAll = function($topParent, delay){
            for(var k in this.$$preloaders){
                var preloader = this.$$preloaders[k];
                if(preloader.isActive)
                    this.$$hide(preloader);
            }
        };
        
        LituiPreloaderService.prototype.$$show = function(preloader){
            preloader.isActive = true;
            preloader.$elt.css('top', preloader.$parent.scrollTop());
            preloader.$elt.css('display', 'block');
            TweenMax.to(preloader.$elt, 0.2, {
                opacity: 1
            });
        };
        
        LituiPreloaderService.prototype.$$hide = function(preloader){
            var self = this;
            TweenMax.to(preloader.$elt, 0.2, {
                opacity: 0,
                onComplete: function(){
                    self.destroy(preloader.id);
                }
            });
        };
        
        LituiPreloaderService.prototype.deactivate = function(preloaderId){       
            var self = this;
            var d = litui.async.defer();
            litui.async.delay(function(){
                var preloader = self.getPreloader(preloaderId);
                if(litui.utils.isUndefined(preloader) || !preloader.isActive)
                    return;
                
                preloader.debounceHandler.cancel();
                preloader.isActive = false;
                preloader.$elt.find('.litui-preloader-spinner').css('opacity', 1);
                TweenMax.to(preloader.$elt, 0.2, {
                    opacity: 0,
                    onComplete: function(){
                        preloader.$elt.css('display', 'none');
                        self.revertParent(preloader);
                        d.resolve();
                    }
                });
            }, this.settings.debounceTimeout);
            return d.promise;
        };
        
        LituiPreloaderService.prototype.getPreloader = function(preloaderId){
            return this.$$preloaders[preloaderId];
        };
        
        LituiPreloaderService.prototype.getPreloaderByParent = function($topParent){
            var $allPreloadersInParent = $topParent.find('.litui-preloader-holder');
            if($allPreloadersInParent.length === 0)
                return;
            var $preloader = $($allPreloadersInParent[$allPreloadersInParent.length - 1]);
            var preloader = this.$$preloaders[$preloader.parent().attr('litui-preloader-id')];
            
            if(!preloader.isActive){
                for(var k in this.$$preloaders){
                    var pl = this.$$preloaders[k];
                    if(pl.isActive)
                        return pl;
                }
            }
            return preloader;
        };
        
        LituiPreloaderService.prototype.prepareParent = function(preloader){
            preloader.origCss =  {
                position: preloader.$parent.css('position'),
                overflow: preloader.$parent.css('overflow')
            };
            preloader.$parent.css({
                position: 'relative',
                overflow: 'hidden'
            });
        };
        
        LituiPreloaderService.prototype.revertParent = function(preloader){
            preloader.$parent.css({
                position: '', // preloader.origCss.position || 'static',
                overflow: '',// preloader.origCss.overflow || 'visible'
           });
        };
        
        LituiPreloaderService.prototype.createPreloader = function($parent, preloaderId){
            var self = this;
            
            var preloader = this.getPreloader(preloaderId);
            if(litui.utils.isUndefined(preloader)){
                preloader = {
                    id: preloaderId,
                    isActive: true,
                    $parent: $parent,
                    origCss: {
                        position: $parent.css('position'),
                        overflow: $parent.css('overflow')
                    },
                    $elt: $('<div class="litui-preloader-holder"><div class="litui-preloader-spinner"></div></div>'),
                    started: moment(),
                    debounceHandler: new litui.utility.DebounceHandler(function(){
                        self.$$show(preloader);
                    }, {
                        timeout: self.settings.debounceTimeout// ms
                    })
                };
                preloader.$parent.append(preloader.$elt);
                this.$$preloaders[preloaderId] = preloader;
            }
            preloader.$elt.css('display', 'none');
            this.prepareParent(preloader);
            
            return preloader;
        };
        
        LituiPreloaderService.prototype.dismissPreinit = function(){
            var $preloader = $('body .litui-preloader-preinit');
            var d = litui.async.defer();
            new litui.utility.DebounceHandler(function(){
                TweenMax.to($preloader, 0.2, {
                    opacity: 0,
                    onComplete: function(){
                        
                        $preloader.remove();
                        d.resolve();
                    }
                });
            }, {
                timeout: 800 // ms
            }).debounce();
            return d.promise;
        };
        
        return new LituiPreloaderService();
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputError', {
        controller: LituiInputErrorCtrl,
        templateUrl: 'litui.base/com/litui-input/litui-input-error/litui-input-error.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            message: '='
        }
    });
    
    /** @ngInject */
    function LituiInputErrorCtrl(){
        var self = this;
        
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputField', {
        controller: LituiInputErrorCtrl,
        templateUrl: 'litui.base/com/litui-input/litui-input-field/litui-input-field.html',
//        require: {
//            ngModel: '^ngModel'
//        },
        transclude: true,
        bindings: {
            ref: '='
        }
    });
    
    /** @ngInject */
    function LituiInputErrorCtrl(){
        var self = this;
        
    }
})();
'use strict';

(function(){
    var chkboxid = 0;
    var tpl = '';
    tpl += '<input id="{{$ctrl.id}}" tabindex="{{$ctrl.tabindex}}" name="{{$ctrl.name}}" type="checkbox" ng-model="$ctrl.ngModel" ng-change="$ctrl.events.onChange($event, $ctrl.ngModel)" ng-disabled="$ctrl.ngDisabled" />';
    tpl += '<label for="{{$ctrl.id}}">';
    tpl += '    <span litui-translate="$ctrl.label"></span>';
    tpl += '</label>';
    
    angular.module('litui').component('lituiCheckbox', {
        controller: LituiCheckboxCtrl,
        template: tpl,
//        require: '^ngModel',
        bindings: {
            name: '@',
            ngDisabled: '=',
            label: '=',
            onChange: '=?',
            ngModel: '=',
            tab: '@?'
        }
    });
    
    /** @ngInject */
    function LituiCheckboxCtrl($element){
        var self = this;
        
        // for uniqueness
        chkboxid++; 
        this.id = chkboxid;

        this.events = {
            onChange: function(){
                if(litui.utils.isFunction(self.onChange)){
                    var e = {
                        $elt: $element,
                        ctrl: self,
                        name: self.name
                    };
                    self.onChange({e: e, val: self.ngModel});
                }
            }
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputEmail', {
        controller: LituiInputEmailCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-input-email/litui-input-email.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            name: '@',
            field: '=',
            label: '=',
            lituiForm: '=?',
            onChange: '=?',
            placeholder: '@?',
            tab: '@?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInputEmailCtrl($scope, $element, LituiInputFieldFactory){
        var self = this;
        var inputField = null;
        
        this.$onInit = function(){
            this.field.messages = litui.lang.merge({
                patternValidity: "LITUI.INPUT.EMAIL.INVALID_PATTERN"
            }, this.field.messages || {});

            inputField = new LituiInputFieldFactory(this, $scope, $element);        
            
            if(litui.utils.isUndefined(self.field.validityPattern))
                // RFC 5322 standard for email RegEx: http://emailregex.com/
                self.field.validityPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            inputField.init();
        };
        
        this.$onDestroy = function(){
            inputField.destroy();
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputNumber', {
        controller: LituiInputNumberCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-input-number/litui-input-number.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            name: '@',
            field: '=',
            label: '=',
            lituiForm: '=?',
            onChange: '=?',
            tab: '@?',
            type: '@?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInputNumberCtrl($scope, $element, LituiInputFieldFactory){
        var self = this;
        var inputField = null;
        
        this.$onInit = function(){
            this.field.messages = litui.lang.merge({
                patternValidity: "LITUI.INPUT.NUMBER.INVALID_PATTERN",
                notInteger: "LITUI.INPUT.NUMBER.NOT_INTEGER"
            }, this.field.messages || {});

            var $$validate = null;
            if(litui.utils.isFunction(this.field.validate))
                $$validate = this.field.validate;

            this.field.validate = function(value){
                if(self.type === 'int' && !litui.utils.isInteger(value)){
                    return "notInteger";
                }

                if(litui.utils.isFunction($$validate))
                    return $$validate.apply(this, arguments);
                return true;
            };

            inputField = new LituiInputFieldFactory(this, $scope, $element, undefined, {
                onChange: function(e, value, field){
                    if(self.type === 'int'){
                        litui.logger.log("Value changed", self.type, value);
                    }
                }
            }); 
        
            self.field.validityPattern = /^[\-\+]?\d+$/;
            inputField.init();
        };
        
        this.$onDestroy = function(){
            inputField.destroy();
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputPassword', {
        controller: LituiInputPasswordCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-input-password/litui-input-password.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            name: '@',
            field: '=',
            label: '=',
            lituiForm: '=?',
            onChange: '=?',
            placeholder: '@?',
            tab: '@?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInputPasswordCtrl($element, $scope, LituiInputFieldFactory, $timeout){
        var self = this;
        var inputField = null;
        
        this.$onInit = function(){
            // predefined messages
            this.field.messages = litui.lang.merge({
                patternValidity: "LITUI.INPUT.PASSWORD.INVALID_PATTERN"
            }, this.field.messages || {});

            inputField = new LituiInputFieldFactory(this, $scope, $element, {
                predefinedActions: [
                    {
                        featureId: 'show-password',
                        label: 'LITUI.INPUT.PASSWORD.SHOW_PASSWORD',
                        onSelected: function(e, item){
                            self.field.altType = 'text';                        
                            $timeout(function(){
                                self.field.altType = undefined;
                            }, 1000);
                        }
                    }
                ]
            });
            
            if(!litui.utils.isSet(self.field.validityPattern))
                self.field.validityPattern = litui.security.getPasswordPattern();
            inputField.init();
        };
        
        this.$onDestroy = function(){
            inputField.destroy();
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInputString', {
        controller: LituiInputStringCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-input-string/litui-input-string.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            name: '@',
            field: '=',
            label: '=',
            lituiForm: '=?',
            onChange: '=?',
            placeholder: '@?',
            tab: '@?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInputStringCtrl($element, $scope, LituiInputFieldFactory){
        var self = this;
        var inputField = null;
        
        this.$onInit = function(){
            if(litui.utils.isDefined(this.field)){
                this.field.messages = litui.lang.merge({
                    patternValidity: this.field.patternValidityMessage || "LITUI.INPUT.PASSWORD.INVALID_PATTERN"
                }, this.field.messages || {});
            }

            inputField = new LituiInputFieldFactory(this, $scope, $element);
            inputField.init();
        };
        
        this.$onDestroy = function(){
            inputField.destroy();
        };
    }
})();

'use strict';

(function(){
    
    
    angular.module('litui').component('lituiPlainText', {
        controller: LituiPlainTextCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-plain-text/litui-plain-text.html',
        require: {
            ngModel: '^ngModel'
        },
        bindings: {
            name: '@',
            field: '=',
            label: '=',
            lituiForm: '=?',
            onChange: '=?',
            placeholder: '@?',
            tab: '@?',
            isDisabled: '=?',
            isRequired: '=?'
        }
    });
    
    function LituiPlainTextCtrl($element, $scope, LituiInputFieldFactory){
        var self = this;
        var inputField = null;
        this.$onInit = function(){
            inputField = new LituiInputFieldFactory(self, $scope, $element);
            inputField.init();
        };
        
        this.$onDestroy = function(){
            inputField.destroy();
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiSelect', {
        controller: LituiSelectCtrl,
        templateUrl: 'litui.base/com/litui-input/fields/litui-select/litui-select.html',
        bindings: {
            name: '@',
            options: '<',
            field: '=',
            mapping: '=?',
            holderEltSelector: '=?',
            lituiForm: '=?',
            onChange: '&?',
            ngModel: '=',
            onChangeTrans: '=?',
            tab: '@?',
            isDisabled: '=?'
        }
    });
    
    /** @ngInject */
    function LituiSelectCtrl($scope){
        var self = this;
        
        var prevOptions = [];
        var prevVal;
        var optionSelecting = false;
        this.selectedLabel = null;
        this.selectedItem = null;
        this.dropdownItems = [];

        this.$onInit = function(){            

        };
        
        this.$doCheck = function(a){      
            
            if(litui.utils.isDefined(self.options) && 
                !litui.utils.equals(prevOptions, self.options)){
                if(!optionSelecting){
                    self.dropdownItems = buildList($scope.value);
                }
                else
                    optionSelecting = false;
                prevOptions = litui.utils.cloneObjects(self.options);
            }
            if(litui.utils.isSet(self.ngModel) && 
                !litui.utils.equals(prevVal, self.ngModel)){

                if(litui.utils.isObject(self.ngModel))
                    prevVal = litui.lang.copy(self.ngModel);
                else
                    prevVal = self.ngModel;
                self.dropdownItems = buildList(self.ngModel);
            }
        };
        
        this.onActionSelected = function(e, action){
            if(litui.utils.isFunction(action.onSelected))
                action.onSelected(e, action);
        };
        
        function onOptionSelected(selectedValue, item){
            optionSelecting = true;
            self.ngModel = selectedValue;

            if(litui.utils.isFunction(self.onChange) && litui.utils.notFunction(self.onChangeTrans)){
                var e = {
                    $elt: self.$element,
                    ctrl: self,
                    name: self.name
                };
                self.onChange({
                    e: e,
                    val: selectedValue,
                    field: self.field
                });
            }
            else if(litui.utils.isFunction(self.onChangeTrans)){
                var e = {
                    $elt: self.$element,
                    ctrl: self,
                    name: self.name
                };
                self.onChangeTrans(e, selectedValue, self.field);
            }
        };
        
        function buildList(value){
            var arr = [];
            if(litui.utils.isUndefined(self.options))
                return [];
            for(var i = 0; i < self.options.length; i++){
                var opt = mapOption(self.options[i]);            
                
                var val = undefined;
                if(litui.utils.isObject(value)){
                    val = mapOption(value).value;
                }
                else{
                    val = value;
                }
                if(opt.value === val){
                    self.selectedItem = litui.lang.copy(opt);

                    if(litui.utils.isDefined(self.field) && self.field.markSelected){
                        opt.isSelected = true;
                        arr.push(opt);
                    }
                }
                else if(opt.value !== val){
                    opt.isSelected = false;
                    arr.push(opt);
                }
                
            }
            return arr;
        }
        
        function mapOption(optionVal){
            var optItem = null;
            if(litui.utils.notSet(optionVal))
                return;
            
            if((litui.utils.isDefined(self.field) && litui.utils.isFunction(self.field.mapping)) || 
                litui.utils.isFunction(self.mapping)){
                var mapped = litui.utils.isFunction(self.mapping)? self.mapping(optionVal) : self.field.mapping(optionVal);
                if(!litui.utils.isSet(mapped))
                    return;
                optItem = {
                    label: mapped.label,
                    value: mapped.value,
                };
               
            }
            else{
                optItem = {
//                        icon: 'icon-info',
                    label: optionVal,
                    value: optionVal
                };
            }
            
            // set selected event handle
            optItem.onSelected = function(e, item){
                onOptionSelected(optionVal, item);
            };
            return optItem;
        }
        
        this.$onDestroy = function(){
//            litui.logger.log("Select destroyed...");
        };
    }
})();
angular.module("litui").run(function($templateCache){$templateCache.put("litui.base/com/litui-form/litui-form.html","<div ng-if=\"$ctrl.formDefinition.description && $ctrl.formDefinition.description.length > 0\">    <p litui-translate=$ctrl.formDefinition.description></p></div><form ng-submit=$ctrl.hooks.onSubmit($event) name=$ctrl.form ng-class=\"{'litui-form-invalid': !$ctrl.form.$valid, 'litui-form-valid': $ctrl.form.$valid}\">    <div class=litui-form-error-msg ng-if=\"!$ctrl.form.$valid && $ctrl.formError && $ctrl.formError.length > 0\">        <span litui-translate=$ctrl.formError></span>    </div>    <div class=litui-form-fields ng-if=\"$ctrl.formDefinition.fields !== undefined\">        <div class={{field.styleClass}} ng-repeat=\"(fname,field) in $ctrl.formDefinition.fields\" ng-if=\"field.isVisible === undefined || field.isVisible\">            <litui-input name={{fname}} field=field value=$ctrl.model[fname] litui-form=$ctrl.form on-change=\"$ctrl.onFieldChange(e, val, field)\"></litui-input>        </div>    </div>    <div class=litui-form-fields ng-if=\"$ctrl.formDefinition.fields === undefined\">        <div class=litui-form-fields-error>            <span litui-translate=\"'LITUI.FORM.NO_FIELDS_ERROR'\"></span>        </div>    </div>    <button type=submit class=\"litui-btn-submit {{$ctrl.formDefinition.submitBtn.styleClass}}\" ng-if=$ctrl.formDefinition.showSubmit litui-ripple-fx ng-disabled=!$ctrl.form.$valid>        <span class=\"litui-icon {{$ctrl.formDefinition.submitBtn.icon}}\" ng-if=$ctrl.formDefinition.submitBtn.icon></span>        <span class=litui-label litui-translate=\"$ctrl.formDefinition.submitBtn.label || 'LITUI.FORM.SUBMIT_BTN'\"></span>    </button></form>");$templateCache.put("litui.base/com/litui-input/fields/litui-input-email/litui-input-email.html","<litui-input-field ref=$ctrl>    <input id={{$ctrl.field.id}} name={{$ctrl.name}} type=text placeholder={{$ctrl.placeholder}} autocomplete={{$ctrl.name}} tabindex={{$ctrl.tab}} ng-model=$ctrl.value ng-change=\"$ctrl.$lituiInputEvents.onChange($event, $ctrl.value, $ctrl.field)\" ng-required=$ctrl.isRequired ng-disabled=\"$ctrl.isDisabled || $ctrl.field.forceDisabled || $ctrl.field.isDisabled\"></litui-input-field>");$templateCache.put("litui.base/com/litui-input/fields/litui-input-number/litui-input-number.html","<litui-input-field ref=$ctrl>    <input id={{$ctrl.field.id}} name={{$ctrl.name}} type=number placeholder={{$ctrl.placeholder}} autocomplete={{$ctrl.name}} tabindex={{$ctrl.tab}} ng-model=$ctrl.value ng-change=\"$ctrl.$lituiInputEvents.onChange($event, $ctrl.value, $ctrl.field)\" ng-required=$ctrl.isRequired ng-disabled=\"$ctrl.isDisabled || $ctrl.field.forceDisabled || $ctrl.field.isDisabled\"> </litui-input-field>");$templateCache.put("litui.base/com/litui-input/fields/litui-input-password/litui-input-password.html","<litui-input-field ref=$ctrl>        <input id={{$ctrl.field.id}} name={{$ctrl.name}} type=\"{{$ctrl.field.altType || 'password'}}\" placeholder={{$ctrl.placeholder}} autocomplete=password tabindex={{$ctrl.tab}} ng-model=$ctrl.value ng-change=\"$ctrl.$lituiInputEvents.onChange($event, $ctrl.value, $ctrl.field)\" ng-required=$ctrl.isRequired ng-disabled=\"$ctrl.isDisabled || $ctrl.field.forceDisabled || $ctrl.field.isDisabled\"></litui-input-field>");$templateCache.put("litui.base/com/litui-input/fields/litui-input-string/litui-input-string.html","<litui-input-field ref=$ctrl>    <input id={{$ctrl.field.id}} name={{$ctrl.name}} type=text placeholder={{$ctrl.placeholder}} autocomplete={{$ctrl.name}} tabindex={{$ctrl.tab}} ng-model=$ctrl.value ng-change=\"$ctrl.$lituiInputEvents.onChange($event, $ctrl.value, $ctrl.field)\" ng-required=$ctrl.isRequired ng-disabled=\"$ctrl.isDisabled || $ctrl.field.forceDisabled || $ctrl.field.isDisabled\"></litui-input-field>");$templateCache.put("litui.base/com/litui-input/fields/litui-plain-text/litui-plain-text.html","<textarea id={{$ctrl.field.id}} class=litui-form-control name={{$ctrl.name}} tabindex={{$ctrl.tab}} ng-model=$ctrl.value ng-style=\"{ 'resize': ($ctrl.field.resize || 'none') }\" ng-change=\"$ctrl.$lituiInputEvents.onChange($event, $ctrl.value, $ctrl.field)\" ng-disabled=\"$ctrl.isDisabled || $ctrl.field.forceDisabled || $ctrl.field.isDisabled\" ng-required=$ctrl.isRequired></textarea>");$templateCache.put("litui.base/com/litui-input/fields/litui-select/litui-select.html","<div class=\"litui-select-trigger litui-select-trigger-empty\" ng-if=\"$ctrl.dropdownItems.length === 0\">    <div class=litui-select-label-holder>        {{$ctrl.selectedItem.label}}    </div></div><div class=litui-select-trigger ng-if=\"$ctrl.dropdownItems.length > 0\" litui-dropdown-trigger appid=2 entity-id=1234 dropdown-items=$ctrl.dropdownItems position=\"'left'\" holder-elt-selector=$ctrl.holderEltSelector is-disabled=$ctrl.isDisabled tab=\"{{$ctrl.tab || 0}}\" litui-ripple-fx>    <div class=litui-select-label-holder>        {{$ctrl.selectedItem.label}}    </div>    <div class=litui-select-delimiter></div>    <div class=litui-select-icon-holder>        <span class=\"litui-icon icon-dropdown\"></span>    </div>    </div><div class=litui-select-actions>    <button ng-repeat=\"action in $ctrl.field.actions\" ng-click=\"$ctrl.onActionSelected($event, action)\">        <span class=\"litui-icon {{action.icon}}\"></span>    </button></div>");$templateCache.put("litui.base/com/litui-input/litui-input-error/litui-input-error.html","<div class=litui-input-error-inner>    <span litui-translate=$ctrl.message></span></div>");$templateCache.put("litui.base/com/litui-input/litui-input-field/litui-input-field.html","<div class=litui-input-field-inner ng-class=\"{ 'litui-nolabel': $ctrl.ref.field.label === undefined || ($ctrl.ref.field.label !== undefined && $ctrl.ref.field.label.length === 0), 'litui-invalid': !$ctrl.ref.ngModel.$valid, 'litui-noerror': !$ctrl.ref.field.enableError && $ctrl.ref.field.enableError !== undefined }\">    <div class=litui-input-field-control>        <label for={{$ctrl.ref.field.id}} litui-translate=$ctrl.ref.field.label ng-class=\"{'litui-start-position': $ctrl.ref.$isLabelStartPosition }\" ng-if=\"$ctrl.ref.field.label !== undefined && $ctrl.ref.field.label.length > 0\"></label>        <div class=litui-input-field-control-holder>            <ng-transclude></ng-transclude>            <div class=litui-input-field-inline-actions ng-if=$ctrl.ref.$lituiActions>                <button type=button tabindex=-1 class=\"\" ng-repeat=\"action in $ctrl.ref.$lituiActions\" ng-click=\"action.onSelected($event, action)\" ng-if=\"$ctrl.ref.field.features.indexOf(action.featureId) > -1 || action.isDefault\">                    <span class=\"litui-icon icon-visibility_on\"></span>                </button>            </div>        </div>    </div>    <litui-input-error message=$ctrl.ref.$lituiFieldErrorMessage ng-if=\"$ctrl.ref.field.enableError || $ctrl.ref.field.enableError === undefined\"></litui-input-error></div>");$templateCache.put("litui.base/com/litui-input/litui-input.html","<div style=\"height: 100%;\">    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'boolean'\">        <litui-checkbox ng-model=$ctrl.value ng-disabled=\"$ctrl.isDisabled || $ctrl.field.disabled\" name={{$ctrl.name}} on-change=$ctrl.onChange label=\"$ctrl.label || $ctrl.field.label\" is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-checkbox>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'string'\">        <litui-input-string ng-model=$ctrl.value name={{$ctrl.name}} field=$ctrl.field on-change=$ctrl.onChange label=\"$ctrl.label || $ctrl.field.label\" is-disabled=$ctrl.isDisabled placeholder=\"{{$ctrl.placeholder || $ctrl.field.placeholder}}\" is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-input-string>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'plain-text' || $ctrl.field.type === 'json'\">        <litui-plain-text ng-model=$ctrl.value name={{$ctrl.name}} field=$ctrl.field on-change=$ctrl.onChange is-disabled=$ctrl.isDisabled is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-plain-text>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'email'\">        <litui-input-email name={{$ctrl.name}} ng-model=$ctrl.value field=$ctrl.field on-change=$ctrl.onChange label=$ctrl.field.label is-disabled=$ctrl.isDisabled is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-input-email>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'number'\">        <litui-input-number name={{$ctrl.name}} ng-model=$ctrl.value field=$ctrl.field on-change=$ctrl.onChange label=\"$ctrl.label || $ctrl.field.label\" is-disabled=$ctrl.isDisabled tab={{$ctrl.tab}}></litui-input-number>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'integer'\">        <litui-input-number name={{$ctrl.name}} type=int ng-model=$ctrl.value field=$ctrl.field on-change=$ctrl.onChange label=\"$ctrl.label || $ctrl.field.label\" is-disabled=$ctrl.isDisabled is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-input-number>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'password'\">        <litui-input-password name={{$ctrl.name}} ng-model=$ctrl.value field=$ctrl.field on-change=$ctrl.onChange label=\"$ctrl.label || $ctrl.field.label\" is-disabled=$ctrl.isDisabled is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-input-password>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'select'\">        <litui-select name={{$ctrl.name}} ng-model=$ctrl.value options=$ctrl.field.options field=$ctrl.field on-change=\"$ctrl.onChange(e, val, field)\" on-change-trans=$ctrl.field.onChange label=\"$ctrl.label || $ctrl.field.label\" is-disabled=$ctrl.isDisabled is-required=$ctrl.isRequired tab={{$ctrl.tab}}></litui-select>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'file'\">        <span litui-translate=$ctrl.field.label></span>        <litui-upload settings=$ctrl.field.upload></litui-upload>    </div>    <div class=litui-input-inner ng-if=\"$ctrl.field.type === 'component'\">        <litui-compile component=$ctrl.field component-name={{$ctrl.name}}></litui-compile>    </div></div>");$templateCache.put("litui.base/com/litui-translate/litui-translator-value.html","<div class=litui-translator-value-inner>    <div class=litui-transltor-value-key>        {{$ctrl.translationField.key}}    </div>    <div class=litui-translator-ref-value>        {{$ctrl.refValue}}    </div>    <div class=litui-translator-value-actual>        <litui-input name={{$ctrl.translationField.key}} field=$ctrl.editableField value=$ctrl.translationField.value on-change=\"$ctrl.onValueChange(e, val, field)\"></litui-input>        <div class=litui-translator-value-actions>            <button class=litui-btn-minimal ng-if=\"$ctrl.translationField.hints.length > 0\" ng-click=\"$ctrl.hintsTrigger.onOpen($event, $ctrl.translationField)\">                <span class=\"litui-icon icon-info\"></span>            </button>            <button class=litui-btn-minimal litui-tooltip=LITUI.TRANSLATOR.APPLY_EQUAL position=left ng-if=\"$ctr.refTranslations && $ctrl.translationField.value !== $ctrl.refTranslations[$ctrl.translationField.key]\" ng-click=\"$ctrl.onApplyToAllEqual($event, $ctrl.translationField, $ctrl.refTranslations[$ctrl.translationField.key])\">                <span class=\"litui-icon icon-apply_to_unit\"></span>            </button>        </div>    </div></div>");$templateCache.put("litui.base/directive/litui-fancy-json/litui-fancy-json-directive.html","<div>    <div ng-repeat=\"(pname, value) in json\">        <span litui-translate=pname></span>        <span>{{value}}</span>    </div></div>");});"use strict";

(function(){
    /**
     * @description 
     * <p>
     * Tests if current user is authorized for specified functionality (pattern: <module>.<moduleView>.<name>). If current user is not authorized for specified 
     * functionality, the DOM element to which this directive is binded to, will be removed and thus be made unaccessible.
     * </p>
     * <p>
     * When we want to protect the View, all we have to do is specify additional attribute <code>litui-view</code>. If current user is not authorized for specified functionality, the 
     * content of element will be se to access denied message.
     * </p>
     * 
     * @ngdoc directive
     * @name litui.class:LituiAuthorizedDirective 
 
     */
    angular.module('litui').directive('lituiAuthorized', LituiAuthorizedDirective);
    
    /** @ngInject */
    function LituiAuthorizedDirective(){
        return{
            restrict: 'A',
            link: function(scope, element, attrs) {
                if(litui.utils.isUndefined(attrs.lituiAuthorized) || attrs.lituiAuthorized.length === 0) return;
                
                var $elt = $(element);
                var isAuthorized = litui.security.isAuthorized(attrs.lituiAuthorized); 
                var isView = litui.utils.isDefined(attrs.lituiView)? true : false;

                if(!isAuthorized){             
                    if(isView){
                        $elt.html("<h1>Access to view denied</h1>");
                    }
                    else{
                        $elt.remove();
                    }
                }
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').directive('lituiCanView', LituiCanViewDirective);
    
    /** @ngInject */
    function LituiCanViewDirective(){
        return{
            restrict: 'A',
            link: function(scope, element, attrs) {
                if(litui.utils.isUndefined(attrs.lituiCanView) || attrs.lituiCanView.length === 0) return;
                
                var $elt = $(element);
                var canView = litui.security.canView(attrs.lituiCanView); 
                var isView = litui.utils.isDefined(attrs.lituiView)? true : false;
                if(!canView){             
                    if(isView){
                        $elt.html("<h1>Access to view denied</h1>");
                    }
                    else{
                        $elt.remove();
                    }
                }
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiCompile', LituiCompileDirective);

    /** @ngInject */
    function LituiCompileDirective($compile, $rootScope, $timeout) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                component: '=',
                isDynamic: '=?',
                onCompiled: '&?',
                isDeep: '=?',
                additionalParams: '=?'
            },
            link: function ($scope, $elt, attrs) {
                var self = this;
                var scopeWatch = $scope.$watch('component', lituiCompile, litui.utils.isDefined($scope.isDeep)? $scope.isDeep : false);
                var $scopeBindings = null;
                function lituiCompile(component) {
                    if (litui.utils.isUndefined(component) || litui.utils.isNull(component))
                        return;
                    var template = null;
                    
                    if(litui.utils.isObject(component) && litui.utils.isDefined(component.template))
                        template = component.template;

                    if(litui.utils.isObject(component) && (litui.utils.isDefined(component.controller) || litui.utils.isDefined(component.compileScope))){
                        
                        if(litui.utils.isDefined(component.controller) && litui.utils.isDefined(component.compileScope))
                            throw "Controller and compiled scope can't be used at the same time when compiling component!";
                        if(litui.utils.isUndefined(component.template))
                            throw "Template must be defined when compiling component!";
                        
                        if (litui.utils.isString(component.compileScope)) {
                            $scopeBindings = createChildScope($scope);
                            $scopeBindings.$eval($scope.compileScope);
                        }
                        else if(litui.utils.isObject(component.compileScope)) {
                            $scopeBindings = component.compileScope;
                        }
                        else if (litui.utils.isFunction(component.controller)) {
                            $scopeBindings = createChildScope($scope);
                            $scopeBindings.ctrl = component.controller;
                            template = "<div ng-controller='ctrl'>" + template + "</div>";
                        }
                        else {
                            $scopeBindings = createChildScope($scope);
                        }
                    }
                    else if(litui.utils.isString(component)){
                        template = component;
                        $scopeBindings = createChildScope($scope);
                    }
                    else{
                        $scopeBindings = createChildScope($scope);
                    }
                    
                    if (litui.utils.isDefined(component.params)) {
                        litui.lang.mergeB(component.params, $scopeBindings);
                    }
                    
                    if(litui.utils.isDefined($scope.additionalParams)){
                        for(var k in $scope.additionalParams){
                            $scopeBindings[k] = $scope.additionalParams[k];
                        }
                    }
                    
                    if(!litui.utils.isNull(template)){
                        if(litui.utils.isDefined(attrs.componentName)){
                            if(template.indexOf('<') === -1 && template.indexOf('>') === -1)
                                template = '<div>' + template + '</div>';
                            
                            var $tpl = $(template);
                            $tpl.attr('name', attrs.componentName);
                            $elt.html($tpl);
                        }
                        else
                            $elt.html(template);
                    }
                    
                    if(litui.utils.isDefined(component.watch)){
                        for(var k in component.watch){
                            $scopeBindings.$watch(k, component.watch[k]);
                        }
                    }
                    
                    $compile($elt.get(0))($scopeBindings);
                    $timeout(function(){
                        if(litui.utils.isFunction($scope.onCompiled))
                            $scope.onCompiled({
                                $elt: $elt,
                                $scopeBindings: $scopeBindings
                            });
                    }, component.compileTimeout || 50);
                    
                    if(!$scope.isDynamic)
                        scopeWatch();
                }
                
                $scope.$on('$destroy', function(){
                    scopeWatch();
                    if(!litui.utils.isNull($scopeBindings))
                        $scopeBindings.$destroy();  
                });
                
                function createChildScope(parentScope){
                    return $rootScope.$new(true, parentScope);
                }
            }
            
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').directive('lituiDynamicFilter', LituiDynamicFilterDirective);
    
    /** @ngInject */
    function LituiDynamicFilterDirective($interpolate, $rootScope){
        return{
            restrict: 'A',
            replace: true,
            scope: {
                settings: '=lituiDynamicFilter'
            },
            link: function($scope, $elt, attrs) {
                var filterExpression = 'entity[col.field] | ' + $scope.settings.filter;
                var sc = $rootScope.$new();
                sc.entity = $scope.settings.entity;
                sc.col = $scope.settings.col;
                var evaluatedExpression = $interpolate('{{' + filterExpression + '}}')(sc);
                $elt.text(evaluatedExpression);
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiEqWidth', LtuiEqWidthDirective);

    /** @ngInject */
    function LtuiEqWidthDirective($timeout) {
        return {
            restrict: 'A',
            link: {
                post: function ($scope, $element, attrs) {                        
                    $timeout(function(){
                        var $elt = $($element);
                        var selector = attrs.lituiEqWidth;
                        var $item = $elt.find(selector);
                        $item.width($elt.innerWidth()/$item.length);
                    },50);
                }
            }
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').directive("lituiFileRead", [function () {
        return {
            restrict: 'A',
            scope: {
                fileread: "=lituiFileRead",
                onChange: "=?"
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                            if(litui.utils.isFunction(scope.onChange))
                                scope.onChange(changeEvent, scope.fileread);
                        });
                    };
                    if(litui.utils.isSet(changeEvent.target.files[0]))
                        reader.readAsText(changeEvent.target.files[0]);
                });
            }
        }
    }]);
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiValue', LituiApplyPipes);

    /** @ngInject */
    function LituiApplyPipes($compile) {
        return {
            restrict: 'A',
            scope: {
                value: '=lituiValue',
                pipes: '@?lituiPipes'
            },
            link: function ($scope, $elt, attrs) {    
                $scope.$watch('value', function(){
                    var valStr = "";
                    var pipesStr = "";
                    if(litui.utils.isDefined($scope.pipes)){
                        var pipesArr = null;
                        if($scope.pipes.indexOf(',') > -1){
                            pipesArr = $scope.pipes.split(',');
                        }
                        else{
                            pipesArr = $scope.$eval($scope.pipes);
                        }
                        
                        if(litui.utils.isSet(pipesArr)){
                            for(var i = 0; i < pipesArr.length; i++){
                                var pipe = pipesArr[i];
                                if(pipe.length > 0){
                                    pipesStr += " | " + pipe;
                                }
                            }
                        }
                        
                    }
                    if(pipesStr.length > 0)
                        valStr = '<span>{{%o}}</span>'.replace('%o', $scope.value + pipesStr, arguments);
                    else
                        valStr = "<span>" + $scope.value + "</span>";
                    
                    var $val = $(valStr);
                    $elt.html($val);
                    $elt.addClass('litui-transition-value');
                    litui.async.delay(delayTransitionRemove, 1000);
                    $compile($val.get(0))($scope);
                    
                });
                
                $scope.$on('$destroy', function(){
                    litui.async.unsetDelay(delayTransitionRemove);
                });
                
                function delayTransitionRemove(){
                    $elt.removeClass('litui-transition-value');
                }
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiRippleFx', LtuiRippleFxDirective);

    /** @ngInject */
    function LtuiRippleFxDirective($timeout) {
        return {
            restrict: 'A',
            link: function ($scope, $elt, attrs) {    
                $elt.addClass('litui-ripple-fx');
                
                $elt.bind('click', function(e){
                    var $ripple = $('<div class="litui-ripple-effect"></div>');
                    var offset =  $(this).offset();
                    var x = e.pageX - offset.left;
                    var y = e.pageY - offset.top;
                    
                    $elt.append($ripple);
                    $ripple.css({
                        top: y - ($ripple.height()/2),
                        left: x - ($ripple.width()/2)
                    });
                    
                    $timeout(function(){
                        $ripple.remove();
                    }, 500);
                });
                
                $scope.$on('$destroy', function(){
                    $elt.unbind('click');
                });
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiDatetimeFormatter', LituiDatetimeFormatterDirective);

    /** @ngInject */
    function LituiDatetimeFormatterDirective($compile, $rootScope, $timeout, tmsDatetimeUtils) {
        return {
            restrict: 'A',
            scope: {
                value: '=lituiDatetimeFormatter',
                format: '=?',
                splitRows: '=?',
                emptySymbol: '=?',
                isDynamic: '=?'
            },
            link: function ($scope, $elt, attrs) {                                                
                var scopeValueWatch = $scope.$watch('value', format);
                
                var emptySymbol = $scope.emptySymbol || "";
                
                $scope.$on('$destroy', function(){
                    scopeValueWatch(); 
                });
                
                function format(val){
                    if(litui.utils.isUndefined(val)){
                        $elt.html(emptySymbol);
                        return;
                    }
                    
                    var formatted = tmsDatetimeUtils.format(moment(val), $scope.format || 'datetime', true);
                    if($scope.splitRows){
                        var part = formatted.split(' ');
                        $elt.html('<div class="litui-datetime-row">' + part[0] + '</div><div class="litui-datetime-row">' + part[1]+ '</div>');
                    }
                    else
                        $elt.html(formatted);

                    if(!$scope.isDynamic)
                        scopeValueWatch();
                }
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiFancyJson', LituiFancyJsonDirective);

    /** @ngInject */
    function LituiFancyJsonDirective() {
        return {
            restrict: 'A',
            scope: {
                json: '=lituiFancyJson'
            },
            templateUrl: 'litui.base/directive/litui-fancy-json/litui-fancy-json-directive.html',
            link: function ($scope, $elt, attrs) {
                
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiFancyJsonService', LituiFancyJsonServiceWrapper);
    
    /** @ngInject */
    function LituiFancyJsonServiceWrapper() {
        function LituiFancyJsonService(){
            
        }
        
        return new LituiFancyJsonService();
    }
})();


'use strict';

(function(){
    angular.module('litui').filter('lituiCount', LituiCountFilter);
    
    /** @ngInject */
    function LituiCountFilter(){
        return function (value) {
            return litui.utils.count(value);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiRound', LituiRoundFilter);
    
    function LituiRoundFilter(){
        return function (value) {
            return Math.round(value);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiStringifyValue', LituiStringifyValueFilter);
    
    /** @ngInject */
    function LituiStringifyValueFilter(){
        return function (value, type) {
            return litui.utils.stringifyValue(value, type || 'ENUM_KEY');
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiToUpperCase', LituiToUpperCaseFilter);
    
    function LituiToUpperCaseFilter(){
        return function (value) {
            return litui.utils.toUpperCase(value);
        };
    }
})();
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiTrimm', LituiTrimmFilter);
    
    function LituiTrimmFilter(){
        return function (value, limit) {
            return litui.utils.trimm(value, limit)
        };
    }
})(litui.utility.formatter);
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiCurrencyFormatter', LituiCurrencyFormatterFilter);
    
    function LituiCurrencyFormatterFilter(){
        return function (value) {
            return formatter.currency(value);
        };
    }
})(litui.utility.formatter);
'use strict';

(function(){
    angular.module('litui').filter('lituiDateFormatter', LituiDateFormatterFilter);
    
    function LituiDateFormatterFilter(config){
        return function (value, format, tz) {
            if(litui.utils.isUndefined(value) || litui.utils.isNull(value))
                return "/";
//            return tmsDatetimeUtils.format(value, config.dateFormat, true);
            return litui.dateTime.format(value, format || config.dateFormat, tz || config.timezone);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiDatetimeFormatter', LituiDatetimeFormatterFilter);
    
    /** @ngInject */
    function LituiDatetimeFormatterFilter(config){
        return function (value, format, tz) {            
            return litui.dateTime.format(litui.dateTime.datetime(value, tz || config.timezone), format, tz);
        };
    }
})();
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiDistanceFormatter', LtDistanceFormatter);
    
    function LtDistanceFormatter(){
        return function (value) {
            return formatter.distance(value);
        };
    }
})(litui.utility.formatter);
'use strict';

(function(){
    angular.module('litui').filter('lituiDurationFormatter', LituiDurationFormatterFilter);
    
    /** @ngInject */ 
    function LituiDurationFormatterFilter(lituiRelativeTimeService){
        return function (startTime, endTime, format) {
            return lituiRelativeTimeService.formatCustom(endTime, format || 'HH:mm:ss', true, startTime);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').filter('lituiTimeFormatter', LituiTimeFormatterFilter);
    
    function LituiTimeFormatterFilter(tmsDatetimeUtils, config){
        return function (value, format, tz) {
            if(litui.utils.isUndefined(value) || litui.utils.isNull(value))
                return "/";
            var formatted = config.timeShortFormat;
            if(format === 'full')
                formatted = config.timeFormat;
            return litui.dateTime.format(value, formatted, tz || config.timezone);
        };
    }
})();
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiWeightFormatter', LituiWeightFormatterFilter);
    
    function LituiWeightFormatterFilter(){
        return function (value, baseUnit) {
            return formatter.weight(value, baseUnit || 'g');
        };
    }
})(litui.utility.formatter);
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiNumberFormatter', LituiNumberFormatterFilter);
    
    function LituiNumberFormatterFilter(){
        return function (value) {
            return formatter.number(value);
        };
    }
})(litui.utility.formatter);
'use strict';

(function(formatter){
    angular.module('litui').filter('lituiRdvFormatter', LituiRdvFormatterFilter);
    
    function LituiRdvFormatterFilter(){
        return function (value) {
            return formatter.rdv(value);
        };
    }
})(litui.utility.formatter);
"use strict";

(function(){
    angular.module('litui').service('lituiCompileService', LituiCompileServiceWrapper);
    
    /** @ngInject */
    function LituiCompileServiceWrapper($compile, $rootScope) {
        function LituiCompileService(){
            
        }
        
        LituiCompileService.prototype.compile = function($holder, compileSettings, scopeParams){
            if(litui.utils.isUndefined(compileSettings))
                throw "LITUI Compile service exception: compile settings must be specified!";
            
            litui.lang.ensure('component', compileSettings);
            
            if(!litui.utils.isSet($holder) || $holder.length === 0)
                throw "LUTUI Compile service exception: no root element specified or non-existent!";
            
            var settings = litui.lang.merge({
                append: false,
                compileTimeout: 50
            }, compileSettings);
            
            var template = "";
            var sc = litui.lang.merge($rootScope.$new(), scopeParams || {});
            if(litui.utils.isString(compileSettings.component)){
                template = compileSettings.component;
            }
            else if(litui.utils.isObject(compileSettings.component)){
                litui.lang.ensure('template', compileSettings.component);
                template = compileSettings.component.template;
                if (litui.utils.isDefined(compileSettings.component.params)) {
                    if(!litui.utils.isObject(compileSettings.component.params))
                        throw "LITUI Compile service exception: binding parameters must be Hash map (JS object).";
                    litui.lang.mergeB(compileSettings.component.params, sc);
                }   
            }
            
            var $elt = $(template);
            if(settings.append)
                $holder.append($elt);
            else
                $holder.html($elt);
            $compile($elt)(sc);
            return litui.async.delay(function(){
                return {
                    $scope: sc,
                    $elt : $elt,
                    destroy: function(){
                        sc.$destroy();
                        $elt.remove();
                        return null;
                    }
                };
            }, settings.compileTimeout);
        };
        
        LituiCompileService.prototype.destroy = function(component){
            return component.destroy();
        };
        
        return new LituiCompileService();
    }
})();


'use strict';

(function () {
    angular.module('litui').service('lituiDateTimeService', LituiDateTimeServiceWrapper);

    /** @ngInject */
    function LituiDateTimeServiceWrapper() {
//        return litui.dateTime;

        function LituiDateTimeService() {
            
        }

        
        
        return new LituiDateTimeService();
    }


})();
"use strict";

(function(){
    angular.module('litui').service('lituiFunctionalitiesMappingService', LituiFunctionalitiesMappingServiceWrapper);
    
    /** @ngInject */
    function LituiFunctionalitiesMappingServiceWrapper() {
        function LituiFunctionalitiesMappingService(){
            this.functionalitiesMap = {
                
            };
        }
        
        LituiFunctionalitiesMappingService.prototype.setDefaultMapping = function(functionalitiesMap){
            this.functionalitiesMap = functionalitiesMap;
        }
        
        LituiFunctionalitiesMappingService.prototype.set = function(functionalitiesMap){
            litui.lang.merge(this.functionalitiesMap, functionalitiesMap);
            litui.logger.log("Functionality IDs mapping is changed");
        };
        
        LituiFunctionalitiesMappingService.prototype.getMap = function(){
            return this.functionalitiesMap;
        };
        
        LituiFunctionalitiesMappingService.prototype.get = function(fid){
            return this.functionalitiesMap[fid];
        };
        
        return new LituiFunctionalitiesMappingService();
    }
})();


'use strict';

(function(){
    angular.module('litui').service('lituiProvidersService', LituiProvidersServiceWrapper);
    
    /** @ngInject */
    function LituiProvidersServiceWrapper(lituiNotification, lituiTranslate, lituiTranslatePreviewService, $q, $interval, $timeout,
                                            lituiFunctionalitiesMappingService){
        function LituiProvidersService(){
            
        }
        
        LituiProvidersService.prototype.setup = function(providers){
            litui.utils.ensureProperties(providers, [
                'userAccount', 'config'
            ]);
            litui.config.set(providers.config);
            litui.notify.setProvider(lituiNotification);
            litui.async.setQ($q);
            litui.async.setTimeoutProvider({
                set: function(callback, duration){
                    return $timeout(callback, duration);
                },
                unset: function(a){
                    if(litui.utils.isDefined(a) && litui.utils.isDefined(a.__lituiTimeout)){
                        $timeout.cancel(a.__lituiTimeout);
                    }
                }
            });
            litui.async.setIntervalProvider({
                set: function(callback, duration){
                    return $interval(callback, duration);
                },
                unset: function(a){
                    $interval.cancel(a);
                }
            });
            litui.security.setProvider({
                isAuthorized: function (functionalityId) {
                    if (litui.utils.isUndefined(functionalityId))
                        return true;
                    return providers.userAccount.isAuthorized(functionalityId);
                },
                canView: function (functionalityId) {
                    if (litui.utils.isUndefined(functionalityId))
                        return true;
                    if(litui.utils.isFunction(providers.userAccount.canViewColumn))
                        return providers.userAccount.canViewColumn(functionalityId);
                    return providers.userAccount.canView(functionalityId);
                },
                logout: function () {
                    if(litui.utils.isFunction(providers.userAccount.logout))
                        return providers.userAccount.logout();
                    throw "LITUI Security provider exception: No logout proceedure specified!";
                },
                getIdentity: function () {
                    return providers.userAccount.get();
                },
                authorize: function () {
                    return providers.userAccount.authorize();
                }
            });
            litui.translator.setProvider({
                translate: function(str, params){
                    return lituiTranslate(str, params);
                }
            });
            
            if(litui.utils.isDefined(litui.config.get('translate')) && litui.config.get('translate').isPreview){
                lituiTranslatePreviewService.enablePreview();
            }
            
            if(litui.utils.isDefined(providers.functionalitiesMapping)){
                lituiFunctionalitiesMappingService.set(providers.functionalitiesMapping);
            }
        };  
        return new LituiProvidersService();
    } 
})();
'use strict';

(function(){
    angular.module('litui').service('lituiSecurity', LituiSecurityService);
    
    /** @ngInject */
    function LituiSecurityService(){
        
        
        return litui.security;
    } 
})();
'use strict';

(function(){
    angular.module('litui').service('lituiSubscribe', LituiSubscribeService);
    
    /** @ngInject */
    function LituiSubscribeService(){
        function LituiSubscribeProvider(){
            new litui.Subscribe(this);
        }
        
        LituiSubscribeProvider.prototype.produce = function(context, eventsDeclaration){
            return new litui.Subscribe(context, eventsDeclaration);
        };
        
        return new LituiSubscribeProvider();
    } 
})();

'use strict';

(function () {
    angular.module('litui').directive('lituiCount', LtuiCountDirective);

    /** @ngInject */
    function LtuiCountDirective() {
        return {
            restrict: 'A',
            scope: {
                items: '=lituiCount'
            },
            link: function ($scope, $elt, attrs) {
                var count = litui.utils.count($scope.items);
                $($elt).addClass("litui-count-" + count);
            }
        };
    }
})();
"use strict";

(function () {
    angular.module('litui').service('lituiBootstrapService', LituiBootstrapServiceWrapper);

    /** @ngInject */
    function LituiBootstrapServiceWrapper(lituiProvidersService, lituiFunctionalitiesMappingService) {
        function LituiBootstrapService() {

        }

        LituiBootstrapService.prototype.bootstrap = function (providersSettings) {
            lituiFunctionalitiesMappingService.setDefaultMapping({
                "FEATURE.SYS.VERSION": "FEATURE.SYS.VERSION",
                "TRANSLATOR.FEATURE.SAVE": "TRANSLATOR.FEATURE.SAVE",
                "TRANSLATOR.FEATURE.PREVIEW": "TRANSLATOR.FEATURE.PREVIEW",
                "TRANSLATOR.FEATURE.PUBLISH": "TRANSLATOR.FEATURE.PUBLISH",
                "TRANSLATOR.FEATURE.IMPORT": "TRANSLATOR.FEATURE.IMPORT",
                "TRANSLATOR.FEATURE.EXPORT": "TRANSLATOR.FEATURE.EXPORT",
                "TRANSLATOR.FEATURE.HINTS": "TRANSLATOR.FEATURE.HINTS",
                "TRANSLATOR.FEATURE.APPLY_TO_EQUAL": "TRANSLATOR.FEATURE.APPLY_TO_EQUAL"
            });
            
            lituiProvidersService.setup(providersSettings);
        };

        return new LituiBootstrapService();
    }
})();

"use strict";

(function () {
    angular.module('litui').service('lituiConfirmService', LituiConfirmServiceWrapper);

    /** @ngInject */
    function LituiConfirmServiceWrapper(lituiDialogService, lituiNotification) {
        function LituiConfirmService() {

        }

        LituiConfirmService.prototype.dialog = function (settings) {
            return lituiDialogService.open({
                header: {
                    title: settings.title || 'LITUI.DIALOG.CONFIRM.DEFAULT_TITLE'
                },
                onSubmit: settings.onSubmit,
                onCancel: settings.onCancel,
                component: settings.component || litui.translator.translate('LITUI.DIALOG.CONFIRM.DEFAULT_TEXT'),
                styleClass: 'litui-dialog-confirm',
                btnSubmit: {
                    icon: 'icon-check',
                    label: 'LITUI.DIALOG.CONFIRM.YES'
                },
                btnCancel: {
                    label: 'LITUI.DIALOG.CONFIRM.NO'
                }
            });
        };

        LituiConfirmService.prototype.notify = function (settings) {
            var d = litui.async.defer();
            var p = lituiNotification.info({
                title: settings.title || 'LITUI.NOTIFY.CONFIRM.DEFAULT_TITLE',
                message: settings.text || 'LITUI.NOTIFY.CONFIRM.DEFAULT_TEXT',
                ttl: -1,
                disableCloseBtn: true,
                actions: [
                    litui.lang.merge({
                        icon: 'icon-check',
                        label: 'LITUI.NOTIFY.CONFIRM.YES',
                        styleClass: 'litui-btn-submit',
                        onSelect: function (e, context) {
                            var p = null;
                            if (litui.utils.isFunction(settings.onSubmit))
                                p = settings.onSubmit(e);
                            else
                                p = litui.async.promise();
                            return litui.async.when(p).then(function (payload) {
                                d.resolve(payload);
                                return context.close();
                            });
                        }
                    }, settings.btnSubmit || {}),
                    litui.lang.merge({
                        icon: 'icon-clear',
                        label: 'LITUI.NOTIFY.CONFIRM.NO',
                        onSelect: function (e, context) {
                            var p = null;
                            if (litui.utils.isFunction(settings.onCancel))
                                p = litui.async.when(settings.onCancel(e));
                            else
                                p = litui.async.promise();
                            return p.then(function (payload) {
                                d.reject(payload);
                                return context.close();
                            });
                        }
                    }, settings.btnCancel || {})
                ]
            });
            return this.produceNotifyModel(d.promise, p);
        };
        
        LituiConfirmService.prototype.produceNotifyModel = function (resolution, notify) {
            if(arguments.length < 2){
                return {
                    promise: null,
                    notify: null,
                    resolution: litui.async.promise(resolution)
                };
            }
            return {
                promise: notify,
                notify: notify,
                resolution: resolution
            };
        };
        
        

        return new LituiConfirmService();
    }
})();


"use strict";

(function(){
    angular.module('litui').service('lituiSoundService', LituiSoundServiceWrapper);
    
    /** @ngInject */
    function LituiSoundServiceWrapper() {
        function LituiSoundService(){
            
        }
        
        return new LituiSoundService();
    }
})();


"use strict";

(function(){
    angular.module('litui').service('lituiTabsetService', LituiTabsetServiceWrapper);
    
    /** @ngInject */
    function LituiTabsetServiceWrapper() {
        function LituiTabsetService(){
            
        }
        
        return new LituiTabsetService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTabset', {
        controller: LituiTabsetCtrl,
        templateUrl: 'litui/com/litui-tabset/litui-tabset.html',
        bindings: {
            tabs: '=',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiTabsetCtrl($element, lituiCompileService){
        var self = this;
        var $elt = $($element);
        var activeSc = null;
        
        this.tabMenuSettings = null;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                isDetachedHeader: false,
                defaultTabIndex: 0,
                activeTabIndex: -1
            }, this);

            this.tabMenuSettings = {
                showLabel: true,
                onItemSelected: function(e, tab, entity, index){
                    return selectTab(e, tab, index);
                }
            };
            
            return selectTab(null, self.tabs[self.settings.defaultTabIndex], self.settings.defaultTabIndex);
        };
        
        function selectTab(e, tab, index){
            if(index === self.settings.activeTabIndex)            
                return;
            
            if(litui.utils.nonNull(activeSc))
                lituiCompileService.destroy(activeSc);
            
            self.settings.activeTabIndex = index;
            return lituiCompileService.compile($elt.find('.litui-tabset-body'), {
                component: tab.component || '<span style="color: red; font-weight: bold;">Please provide component to be displayed inside tab</span>'
            }).then(function(sc){
                activeSc = sc;
                if(litui.utils.isFunction(tab.onSelected))
                    tab.onSelected(e, tab);
            });
        }
    }
})();

'use strict';

(function () {
    angular.module('litui').directive('lituiInteracted', LituiInteractedDirective);

    /** @ngInject */
    function LituiInteractedDirective() {
        return {
            restrict: 'A',
            scope: {
                value: '=lituiInteracted',
                settings: '=?lituiInteractedSettings'
            },
            link: function ($scope, $element, attrs) {
                var $elt = $($element);
                
                if(litui.utils.isUndefined($scope.settings))
                    $scope.settings = {};
                
                litui.lang.mergeB({
                    type: 'select',
                    onInteracted: undefined
                }, $scope.settings);
                
                if($scope.settings.type === 'select'){
                    $elt.on('click', function(){
                        var $a = $('<div style="position: absolute; color: white; background: black;">' + $scope.value + '</div>');
                        $a.css('left', $elt.offset().left);
                        $a.css('top', $elt.offset().top);
                        $elt.parent().append($a);
                    });
                }
                
                $scope.$on('$destroy', function(){
                    $elt.off();
                });
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiInteractedService', LituiInteractedServiceWrapper);
    
    /** @ngInject */
    function LituiInteractedServiceWrapper() {
        function LituiInteractedService(){
            
        }
        
        return new LituiInteractedService();
    }
})();


'use strict';

(function(){
    litui.utility.screenFactory.registerTemplate('litui-datagrid-screen', {
        template: '<litui-datagrid-screen header="$ctrl.headerOptions" datagrid="$ctrl.datagridOptions" settings="$ctrl.settings" features="$ctrl.features"></litui-datagrid-screen>',
//        required: ['settings', 'header', 'datagrid']
    });
    
    
    
    angular.module('litui').component('lituiDatagridScreen', {
        templateUrl: 'litui/screen/litui-datagrid-screen/litui-datagrid-screen.html',
        controller: LituiDatagridScreenCtrl,
        bindings: {
            datagrid: '=',
            header: '=?',
            settings: '=?',
            features: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDatagridScreenCtrl($element, LituiViewHeaderBuilder, filterDataProviderService, FilterDataType, TmsFilter, uiGridConstants, lituiPopupService){  
        var self = this;
        var $elt = $($element);        
        
        this.$onInit = function(){
            var layoutMngr = litui.layoutMngr.provide();

            // --------------
            // --- HEADER ---
            // --------------
            if(litui.utils.isDefined(this.header))
                this.headerOptions = new LituiViewHeaderBuilder()
                        .setTitle(this.header.title)
                        .build();
            else
                layoutMngr.hidePanel('view-header');

            var mainTools = [];
            var rowMenu = [];

            this.settings = litui.lang.merge({
                features: {}
            }, this.settings || {});


            // --------------------------
            // --- ADD ADMIN FEATURES ---
            // --------------------------
            if(this.settings.features.admin){
                var featureCreate = self.features.admin.create || self.features.admin;
                mainTools.push({
                    icon: 'icon-add',
                    onClick: function(){
                        lituiPopupService.open({
                            type: 'litui-medium',
                            header: {
                                title: featureCreate.title
                            },
                            content: {
                                template: '<litui-form form-definition="formDefinition"></litui-form>',
                                params: featureCreate.component || {
                                    formDefinition: featureCreate.form
                                }
                            }
                        });
                    },
                    functionalityId: this.settings.features.admin.create,
                    tooltip: featureCreate.tooltip || litui.translator.translate('ADD'),
                    label: featureCreate.label || litui.translator.translate('ADD')
                });

                var featureUpdate = self.features.admin.update || self.features.admin;
                rowMenu.push({
                    title: featureUpdate.title,
                    icon: 'icon-edit',
                    onClick: function(e, row, menuItem){
                        lituiPopupService.open({
                            type: 'litui-medium',
                            header: {
                                title: featureUpdate.title
                            },
                            content: featureUpdate.component || {
                                template: '<litui-form form-definition="formDefinition" model-id="modelId"></litui-form>',
                                params: {
                                    formDefinition: featureCreate.form,
                                    modelId: row.entity.id
                                }
                            }
                        });
                    },
    //                isActive: function gridAssignCondition(row) {
    //                    return row.entity.unitId === null;
    //                },
                    functionalityId: this.settings.features.admin.update
                });

                var featureRemove = self.features.admin.update || self.features.admin;
                rowMenu.push({
                    title: featureRemove.title,
                    icon: 'icon-delete',
                    onClick: function(){

                    },
    //                isActive: function gridAssignCondition(row) {
    //                    return row.entity.unitId === null;
    //                },
                    functionalityId: this.settings.features.admin.remove
                });
            }

            if(this.settings.features.importer > -1){
                var feature = self.features.importer;
                mainTools.push({
                    icon: 'icon-import',
                    onClick: function(){
                        lituiPopupService.open({
                            type: 'litui-big',
                            header: {
                                title: feature.title
                            },
                            content: {
                                template: 'FOO',
                                params: {

                                }
                            }
                        });
                    },
                    functionalityId: 'ADMIN.ASSETS.CREATE',
                    tooltip: litui.translator.translate('ADD'),
                    label: litui.translator.translate('ADD')
                });
            }

            // splash mode
            mainTools.push({
                icon: 'icon-split_screen_menu',
                onClick: function(){
                    if(layoutMngr.$$mode === 'SPLASH_MODE')
                        layoutMngr.exitSplashMode();
                    else
                        layoutMngr.enterSplashMode();
                }
            });

            litui.lang.mergeArr(mainTools, this.datagrid.mainTools);
            litui.lang.mergeArr(rowMenu, this.datagrid.rowMenu);

            // --------------------
            // --- TMS DATAGRID ---
            // --------------------
            this.datagridOptions = {
                selectedData: [],
                options: {
    //                filterEnabled: false,
                    filter: this.datagrid.filter,
                    tools: {
                        menu: {
                            inlineMenuThreshold: 3,
                            items: mainTools
                        },
                        refresh: {
                            autoRefreshActive: true,
                            autoRefreshEnabled: true,
                            autoRefreshInterval: 30
                        }
                    },
                    grid: {
    //                    tmsMultiColumnHeader: false,
                        onRegisterApi: function (gridApi) {
                            self.datagridOptions.gridApi = gridApi;
    //                        gridApi.selection.on.rowSelectionChanged($scope, function(){});
    //                        gridApi.selection.on.rowSelectionChangedBatch($scope, function(){});
                        },
                        appendGroupCategories: true,
                        tmsInlineMenuThreshold: 3,
                        enableSorting: true,
                        enableSortingDefaultColumn: false,
                        paginationPageSize: 50,
    //                    multiColumnDefs:[],
                        columnDefs: this.datagrid.columns,
                        tmsMenuDefs: rowMenu,
    //                    tmsMenuDefs: [
    //                        {
    //                            title: 'Edit',
    //                            icon: 'icon-edit',
    //                            onClick: function(){
    //                                
    //                            },
    //                            functionalityId: 'ADMIN.ASSETS.EDIT'
    //                        },
    //                        {
    //                            title: 'Delete',
    //                            icon: 'icon-delete',
    //                            onClick: function(){
    //                                
    //                            },
    //                            functionalityId: 'ADMIN.ASSETS.DELETE'
    //                        }
    //                    ],
                        features: [
                            '!ui-grid-move-columns',
                            'tms-multi-column-header'
                        ]
                    },
                    onGetData: this.datagrid.onGetData || function(){
                        litui.logger.warn("No data for datagrid is being set!");
                    }
                }
            };
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').factory('lituiImageCacheService', LituiImageCacheServiceWrapper);

    /** @ngInject */
    function LituiImageCacheServiceWrapper() {
        function LituiImageCacheService() {
            this.$$cache = {};
            this.cachedSrcs = [];
        }
        
        LituiImageCacheService.prototype.cache = function(src, img){
            this.$$cache[src] = img;
            this.cachedSrcs.push(src);
        };
        
        LituiImageCacheService.prototype.isCached = function(src){
            return this.cachedSrcs.indexOf(src) > -1;
        };
        
        LituiImageCacheService.prototype.get = function(src){
            return this.$$cache[src];
        };
        
        return new LituiImageCacheService();
    }
})();
'use strict';

(function () {
    angular.module('litui').factory('LituiImageFactory', LituiImageFactoryWrapper);

    /** @ngInject */
    function LituiImageFactoryWrapper(lituiPreloaderService) {
        function LituiImageFactory($elt, ctrl) {
            var self = this;
            LituiImageFactory.__inc++;

            this.$elt = $elt;
            this.ctrl = ctrl;

            this.currentImg = null;
            this.$currentImg = null;
            this.originW = 0;
            this.originH = 0;
            this.originHolderW = 0;
            this.originHolderH = 0;
            this.orientation = "landscape";
            this.isInitialized = false;
            this.src = null;
            
            litui.lang.mergeB({
                scale: 'contain'
            }, this.ctrl.settings);
            this.ctrl.isError = false;

            this.preloaderId = 'imgPreloader' + LituiImageFactory.__inc;

            this.eventListeners = {
                resize: function resize() {
                    return self.resize();
                },
                resizeEnd: function resizeEnd() {
                    return self.resize();
                }
            };
        }

        LituiImageFactory.__inc = 0;

        LituiImageFactory.create = function ($elt, ctrl) {
            var imageFactory = new LituiImageFactory($elt, ctrl);
            imageFactory.init();
            return imageFactory;
        };

        LituiImageFactory.prototype.init = function () {
            this.registerEventListeners();
            this.fitToHolder();
        };

        LituiImageFactory.prototype.destroy = function () {
            litui.layoutMngr.provide().off('RESIZE', this.eventListeners.resize);
            litui.layoutMngr.provide().off('RESIZE_END', this.eventListeners.resizeEnd);
        };

        LituiImageFactory.prototype.registerEventListeners = function () {
            litui.layoutMngr.provide().on('RESIZE', this.eventListeners.resize);
            litui.layoutMngr.provide().on('RESIZE_END', this.eventListeners.resizeEnd);
        };

        LituiImageFactory.prototype.loadImageOrAlt = function (src, alt) {
            var self = this;

            this.src = src;
            this.alt = alt;

            return this.loadImage(src).catch(function () {
                if(litui.utils.isUndefined(src) || src.length === 0)
                    return;
                
                // load alt image
                if (litui.utils.isDefined(alt)) {
                    return self.loadImage(alt).catch(function () {
                        self.ctrl.isError = true;
                    });
                }
                self.ctrl.isError = true;
            }).finally(function () {
                lituiPreloaderService.deactivate(self.preloaderId);
                self.isInitialized = litui.utils.nonNull(self.currentImg);
            });
        };

        LituiImageFactory.prototype.loadImage = function (src) {
            var self = this;
            if (litui.utils.isUndefined(src) || src.length === 0) {
                self.ctrl.isError = false;
                return litui.async.promise();
            }
            
            lituiPreloaderService.activateInstant(this.preloaderId, this.$elt);
            
            return this.loadSrc(src).then(function () {
                if(litui.utils.isNull(self.currentImg)){
                    return ;
                }
                
                self.prepareImageElt();
                self.determineOrientation();
                return self.scaleImage().then(function(){
                    self.backgroundAttachment();
                    
                    self.ctrl.isError = false;
                    lituiPreloaderService.deactivate(self.preloaderId);
                });
            });
        };

        LituiImageFactory.prototype.loadSrc = function (src) {
            var self = this;

            return litui.request.getImage(src).then(function (img) {
                self.currentImg = img;
                self.src = src;
                return img;
            });
        };

        LituiImageFactory.prototype.prepareImageElt = function () {
            this.$currentImg = $('<div class="litui-image-elt" style="background-image: url(' + this.currentImg.src + ');"></div>');
            this.$currentImg.attr('width', '');
            this.$currentImg.attr('height', '');
            this.$elt.find('.litui-image-inner').html(this.$currentImg);
            return this.$currentImg;
        };

        LituiImageFactory.prototype.scaleImage = function () {
            if (litui.utils.isNull(this.currentImg)) {
                return litui.async.promise();
            }

            

            // scale contain
            var scaledW = 0;
            var scaledH = 0;

            if (litui.utils.isNull(this.originHolderW) && litui.utils.isNull(this.originHolderH)) {
                this.ctrl.settings.scale = 'natural';
            }
                
            switch (this.ctrl.settings.scale) {
                case 'none':
                    return litui.async.promise();
                case 'natural':
                    scaledW = this.currentImg.width;
                    scaledH = this.currentImg.height;
                    break;
                case 'cover':
                    var ratio = this.currentImg.width / this.originHolderW;
                    if (this.originHolderW < this.originHolderH)
                        ratio = this.currentImg.height / this.originHolderH;

                    scaledW = Math.floor(this.currentImg.width / ratio);
                    scaledH = Math.floor(this.currentImg.height / ratio);
                    break;
                case 'contain':
                default:
                    // calc default for landscape
                    var ratio = this.currentImg.width / this.originHolderW;
                    if (this.orientation === 'portrait' && this.originHolderH > 0){
                        ratio = this.currentImg.height / this.originHolderH;

                        scaledW = Math.floor(this.currentImg.width / ratio);
                        scaledH = Math.floor(this.currentImg.height / ratio);
                        
                        if(scaledW > this.originHolderW){
                            ratio = this.currentImg.width / this.originHolderW;
                            
                            scaledW = Math.floor(this.currentImg.width / ratio);;
                            scaledH = Math.floor(this.currentImg.height / ratio);
                        }
                        break;
                    }
                    
                    ratio = this.currentImg.width / this.originHolderW;
                    scaledW = Math.floor(this.currentImg.width / ratio);
                    scaledH = Math.floor(this.currentImg.height / ratio);
                    
                    if(scaledH > this.originHolderH && this.originHolderH > 0){
                        ratio = this.currentImg.height / this.originHolderH;
                        scaledW = Math.floor(this.currentImg.width / ratio);
                        scaledH = Math.floor(this.currentImg.height / ratio);
                    }
                    break;
            }
            
            if (((scaledW === this.currentImg.width && scaledH === this.currentImg.height) ||
                    litui.utils.isNaN(scaledW) || litui.utils.isNaN(scaledH)) && (this.ctrl.settings.scale !== 'natural')) {
                return litui.async.promise();
            }

            var d = litui.async.defer();
            if(this.isInitialized){
                TweenMax.to(this.$elt, 0.3, {
                    width: scaledW,
                    height: scaledH,
                    onComplete: function () {
                        d.resolve();
                    }
                });                
            }
            else{
                this.$elt.width(scaledW);
                this.$elt.height(scaledH);
                d.resolve();
            }

            return d.promise;
        };

        LituiImageFactory.prototype.fitToHolder = function () {
            this.originHolderW = this.$elt.parent().width();
            this.originHolderH = this.$elt.parent().height();

            if (this.originHolderW === 0 && this.originHolderH === 0) {
                this.originHolderW = null;
                this.originHolderH = null;
                return;
            }
            
            if(this.ctrl.settings.scale !== 'none'){
                this.$elt.width(this.originHolderW);
                this.$elt.height(this.originHolderH);
            }
        };

        LituiImageFactory.prototype.resize = function () {
            this.fitToHolder();
            return this.scaleImage();
        };

        LituiImageFactory.prototype.determineOrientation = function () {            
            if(this.currentImg.width < this.currentImg.height)
                this.orientation = "portrait";
            else
                this.orientation = "landscape";
        };

        LituiImageFactory.prototype.backgroundAttachment = function () {            
            var attachment = this.$currentImg.css('background-attachment');
            var size = this.$currentImg.css('background-size');
            
//            if(attachment === 'fixed' && size === 'cover'){
//                this.$currentImg.css('background-size', 'contain');
//            }
//            else if(attachment === 'fixed' && this.orientation === 'portrait'){
//                this.$currentImg.css('background-size', 'cover');
//            }
        };





        return LituiImageFactory;
    }
})();
'use strict';

(function () {
    angular.module('litui').component('lituiImage', {
        templateUrl: 'litui/com/base/litui-image/litui-image.html',
        controller: LituiImageCtrl,
        bindings: {
            src: '<',
            settings: '=?',
            alt: '@?'
        }
    });

    /** @ngInject */
    function LituiImageCtrl($element, LituiImageFactory) {
        var self = this;
        this.isError = false;
        
        var src = null;
        
        var imageFactory = null;
        
        this.$onInit = function () {
            src = this.src;

            if(litui.utils.isUndefined(this.settings))
                this.settings = {};
            
            imageFactory = LituiImageFactory.create($element, self);
            
            return imageFactory.loadImageOrAlt(src, self.alt);
        };

        this.$onChanges = function () {
            if (src !== self.src) {
                src = self.src;
                if(litui.utils.isSet(imageFactory)){
                    imageFactory.loadImageOrAlt(src, self.alt);
                }
            }
        };
        
        this.$onDestroy = function () {
            imageFactory.destroy();
        };
    }
    
    LituiImageCtrl.__inc = 0;
})();
"use strict";

(function(){
    angular.module('litui').service('lituiRangeService', LituiRangeServiceWrapper);
    
    /** @ngInject */
    function LituiRangeServiceWrapper() {
        function LituiRangeService(){
            
        }
        
        LituiRangeService.prototype.registerHandleDragEvent = function($elt, handleSelector, handle, hooks) {
            var self = this;
            var $handle = $elt.find(handleSelector);
            var $bar = $elt.find('.litui-range-bar[name=handle-bar]');
            $handle.drag("start", function (e, dd) {
                $elt.addClass('litui-dragging');
                $handle.addClass('litui-dragging');
                TweenMax.to($bar, 0.3, {
                    opacity: 0.5
                });
                return handle.onDragStart(e, dd, $handle);
            }).drag(function (e, dd) {
                hooks.setPosition(dd.offsetX);
                return handle.onDrag(e, dd, $handle);
            }).drag("end", function (e, dd) {
                $elt.removeClass('litui-dragging');
                $handle.removeClass('litui-dragging');
                TweenMax.to($bar, 0.3, {
                    opacity: 1
                });
                return handle.onDragEnd(e, dd, $handle);
            });
        };

        
        LituiRangeService.prototype.setBarSize = function($elt) {
            var $a = $elt.find('.litui-range-handle[name=handle-a]');
            var $b = $elt.find('.litui-range-handle[name=handle-b]');
            
            if($b.length === 0)
                return;
            
            var w = $b.offset().left - $a.offset().left;
            $elt.find('.litui-range-bar[name=handle-bar]').width(w);
        };
        
        LituiRangeService.prototype.registerDragHandleBar = function($elt, handle, hooks) {
            return;
//            var $handle = $elt.find('.litui-range-bar[name=handle-bar]');
//            var $handleA = $elt.find('.litui-range-handle[name=handle-a]');
//            $handle.drag("start", function (e, dd) {
//                return self.handleBar.onDragStart(e, dd, $handle);
//            }).drag(function (e, dd) {
//                var x = dd.offsetX - $elt.parent().offset().left - $handleA.width();
//                var delta = positionA.lastX - x;
//                $elt.css('left', x - delta);
//                positionA.lastX = x;
//                return self.handleBar.onDrag(e, dd, $handle);
//            }).drag("end", function (e, dd) {
//                return self.handleBar.onDragEnd(e, dd, $handle);
//            });
        };       
        
        return new LituiRangeService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiRange', {
        controller: LituiRangeCtrl,
        templateUrl: 'litui/com/base/litui-range/litui-range.html',
        bindings: { 
            handleA: '=?',
            handleB: '=?',
            handleBar: '=?',
            hooks: '=?'
        }
    });

    /** @ngInject */
    function LituiRangeCtrl($element, lituiRangeService) {
        var self = this;
        var $elt = $($element);

        var positionA = {
            lastX: 0
        };
        var positionB = {
            lastX: 0
        };


        this.$onInit = function () {
            litui.lang.prepareSettings({
                label: '',
                onDragStart: function () {},
                onDrag: function () {},
                onDragEnd: function () {

                }
            }, this, 'handleA');
            litui.lang.prepareSettings({
                label: '',
                isRange: true,
                onDragStart: function () {},
                onDrag: function () {},
                onDragEnd: function () {}
            }, this, 'handleB');
            litui.lang.prepareSettings({
                label: '',
                onDragStart: function () {},
                onDrag: function () {},
                onDragEnd: function () {}
            }, this, 'handleBar');
            litui.lang.prepareSettings({
                handleA: {
                    setPosition: function (ddX, isAnimate) {
                        var x = ddX - $elt.parent().offset().left;

                        var collisionCondition = false;
                        if(self.handleB.isRange)
                            collisionCondition = x + $elt.find('.litui-range-handle[name=handle-a]').width() <= $elt.find('.litui-range-handle[name=handle-b]').offset().left - $elt.parent().offset().left;
                        else
                            collisionCondition = true;

                        if (collisionCondition) {
                            var delta = positionA.lastX - x;
                            var w = $elt.width() + delta;
                            positionA.lastX = x;
                            if(!isAnimate){
                                $elt.css('left', x);
                                if(self.handleB.isRange)
                                    $elt.width(w);
                                lituiRangeService.setBarSize($elt);
                            }
                            else{
                                var tweenSettings = {
                                    left: x,
                                    onUpdate: function(){
                                        lituiRangeService.setBarSize($elt);
                                    }
                                };
                                if(self.handleB.isRange){
                                    tweenSettings.width = w;
                                }

                                return TweenMax.to($elt, 0.2, tweenSettings);
                            }
                        }
                    }
                },
                handleB: {
                    setPosition: function (ddX, isAnimate) {
                        var $handleA = $elt.find('.litui-range-handle[name=handle-a]');
                        var x = ddX - $elt.parent().offset().left - $handleA.width();
                        if (x >= $handleA.offset().left - $elt.parent().offset().left) {
                            var delta = positionB.lastX - x;
                            var w = $elt.width() - delta;
                            positionB.lastX = x;

                            if(!isAnimate){
                                $elt.width(w);
                                lituiRangeService.setBarSize($elt);
                            }
                            else
                                return TweenMax.to($elt, 0.2, {
                                    width: w,
                                    onUpdate: function(){
                                        lituiRangeService.setBarSize($elt);
                                    }
                                });
                        }
                    }
                }
            }, this, 'hooks');
            
            lituiRangeService.registerHandleDragEvent($elt, '.litui-range-handle[name=handle-a]', self.handleA, self.hooks.handleA);
            return litui.async.delay(function(){
                lituiRangeService.registerHandleDragEvent($elt, '.litui-range-handle[name=handle-b]', self.handleB, self.hooks.handleB);
                lituiRangeService.registerDragHandleBar($elt, self.handleBar, self.hooks.handleBar);
            });
        };

        this.$onDestroy = function () {
            $elt.find('.litui-range-handle[name=handle-a]').off();
            $elt.find('.litui-range-handle[name=handle-b]').off();
            $elt.find('.litui-range-bar[name=handle-bar]').off();
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiDatePeriodActivityService', LituiDatePeriodActivityServiceWrapper);
    
    /** @ngInject */
    function LituiDatePeriodActivityServiceWrapper() {
        function LituiDatePeriodActivityService(){
            
        }
        
        return new LituiDatePeriodActivityService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDatePeriodActivity', {
        controller: LituiDatePeriodActivityCtrl,
        templateUrl: 'litui/com/datetime/litui-date-period-activity/litui-date-period-activity.html',
        bindings: {
            datetimeA: '=',
            datetimeB: '=',
            activity: '=?',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDatePeriodActivityCtrl(){
        var self = this;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                dateA: {
                    tz: 'UTC'
                },
                dateB: {
                    tz: 'UTC'
                }
            }, this);
        };
        
        this.isInfinityMin = function(dt){
            return litui.dateTime.isInfinityMin(dt);
        };
        
        this.isInfinityMax = function(dt){
            return litui.dateTime.isInfinityMax(dt);
        };
    }
})();
'use strict';

(function () {


    angular.module('litui').component('lituiDatePeriodPicker', {
        controller: LituiDatePeriodPickerCtrl,
        templateUrl: 'litui/com/datetime/litui-date-period-picker/litui-date-period-picker.html',
        bindings: {
            datetimeA: '<',
            datetimeB: '<',
            onDatetimeAChange: '=?',
            onDatetimeBChange: '=?',
            entity: '=?',
            settings: '=?',
            isDisabled: '=?'
        }
    });

    /** @ngInject */
    function LituiDatePeriodPickerCtrl() {
        var self = this;
        var datetimeAtmp = null;
        var datetimeBtmp = null;
        var isInit = false;

        this.$onInit = function () {
            litui.lang.prepareSettings({
                date: {
                    dateA: {
                        tz: litui.utils.isDefined(this.settings) && litui.utils.isDefined(this.settings.tz) ? this.settings.tz : undefined,
                        type: litui.utils.isDefined(this.settings) && litui.utils.isDefined(this.settings.type) ? this.settings.type : 'date',
                        maxDate: this.datetimeB,
                        isInfinity: false
                    },
                    dateB: {
                        tz: litui.utils.isDefined(this.settings) && litui.utils.isDefined(this.settings.tz) ? this.settings.tz : undefined,
                        type: litui.utils.isDefined(this.settings) && litui.utils.isDefined(this.settings.type) ? this.settings.type : 'date',
                        minDate: this.datetimeA,
                        isInfinity: false
                    }
                },
                enableInfinity: false
            }, this);

            this.settings.date.dateA.closeOnDateSelected = this.settings.closeOnDateSelected;
            this.settings.date.dateB.closeOnDateSelected = this.settings.closeOnDateSelected;

            this.foreverMinField = {
                type: 'boolean',
                label: 'LITUI.PERIOD_SELECTION.INFINITY_MIN',
                onChange: function (e, value, field) {
                    if (value) {
                        datetimeAtmp = litui.dateTime.updateDatetime(litui.dateTime.now(self.settings.date.dateA.tz), self.datetimeA, self.settings.date.dateA.tz);
                        litui.dateTime.setInfinityMin(self.datetimeA);
                    } else if (litui.utils.nonNull(datetimeAtmp)) {
                        if (litui.dateTime.isInfinityMin(datetimeAtmp))
                            litui.dateTime.updateDatetime(self.datetimeA, litui.dateTime.now(self.settings.date.dateA.tz), self.settings.date.dateA.tz);
                        else
                            litui.dateTime.updateDatetime(self.datetimeA, datetimeAtmp, self.settings.date.dateA.tz);
                    }
                }
            };

            this.foreverMaxField = {
                type: 'boolean',
                label: 'LITUI.PERIOD_SELECTION.INFINITY_MAX',
                onChange: function (e, value, field) {
                    if (value) {
                        datetimeBtmp = litui.dateTime.updateDatetime(litui.dateTime.now(self.settings.date.dateB.tz), self.datetimeB, self.settings.date.dateB.tz);
                        litui.dateTime.setInfinityMax(self.datetimeB);
                    } else if (litui.utils.nonNull(datetimeBtmp)) {
                        if (litui.dateTime.isInfinityMax(datetimeBtmp)) {
                            if (litui.dateTime.isInfinityMin(self.datetimeA))
                                litui.dateTime.updateDatetime(self.datetimeB, litui.dateTime.now(self.settings.date.dateB.tz).add('days', 1), self.settings.date.dateB.tz);
                            else
                                litui.dateTime.updateDatetime(self.datetimeB, self.datetimeA, self.settings.date.dateB.tz).add('days', 1);
                        } else
                            litui.dateTime.updateDatetime(self.datetimeB, datetimeBtmp, self.settings.date.dateB.tz);

                        if (litui.dateTime.isInfinityMin(self.datetimeA)) {
                            var localDt = litui.dateTime.now(self.settings.date.dateB.tz);
                            if (litui.dateTime.datesEquals(localDt, self.datetimeB) && localDt.hour() === self.datetimeB.hour()) {
                                self.datetimeB.add('hours', 1);
                            }
                        } else if (litui.dateTime.datesEquals(self.datetimeA, self.datetimeB) && self.datetimeA.hour() === self.datetimeB.hour()) {
                            self.datetimeB.add('hours', 1);
                        }
                    }
                }
            };
        
            self.settings.date.dateA.isInfinity = litui.dateTime.isInfinityMin(self.datetimeA);
            self.settings.date.dateB.isInfinity = litui.dateTime.isInfinityMax(self.datetimeB);
            isInit = true;
        };

        this.$onChanges = function () {
            if(!isInit){
                return;
            }
            if (!litui.dateTime.compare(self.datetimeA, datetimeAtmp)) {
                self.settings.date.dateB.minDate = self.datetimeA;
                self.settings.date.dateA.isInfinity = litui.dateTime.isInfinityMin(self.datetimeA);
                datetimeAtmp = litui.dateTime.copy(self.datetimeA, self.settings.date.dateA.tz || 'UTC'); // default TZ to UTC
            }
            if (!litui.dateTime.compare(self.datetimeB, datetimeBtmp)) {
                self.settings.date.dateA.maxDate = self.datetimeB;
                self.settings.date.dateB.isInfinity = litui.dateTime.isInfinityMax(self.datetimeB);
                datetimeBtmp = litui.dateTime.copy(self.datetimeB, self.settings.date.dateB.tz || 'UTC'); // default TZ to UTC
            }
        };

        this.onDatetimeAChanged = function (e, value) {
            if (litui.utils.isFunction(self.onDatetimeAChange))
                self.onDatetimeAChange(e, value, self.entity);
        };

        this.onDatetimeBChanged = function (e, value) {
            if (litui.utils.isFunction(self.onDatetimeBChange))
                self.onDatetimeBChange(e, value, self.entity);
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiDatePickerService', service);

    /** @ngInject */
    function service(lituiPopoverService) {
        function LituiDatePickerService() {
            this.activePopover = undefined;
        }
        
        LituiDatePickerService.prototype.popover = function($binder, datetime, settings){
            var self = this;
            return lituiPopoverService.open($binder, {
                component: {
                    template: '<litui-date-picker datetime="datetime" settings="settings" on-change="onChange"></litui-date-picker>',
                    params: {
                        datetime: datetime,
                        settings: {
                            showSelected: settings.showSelected
                        },
                        onChange: function (dt) {
                            lituiPopoverService.close(self.activePopover);
                            if (litui.utils.isFunction(settings.onChange))
                                return settings.onChange(dt);
                        }
                    }
                },
                bindedPosition: settings.bindedPosition || 'bottom',
                onClose: function(){
                    self.activePopover = undefined;
                }
            }).then(function(popover){
                self.activePopover = popover;
                return popover;
            });
        };

        return new LituiDatePickerService();
    }
})();
'use strict';

(function () {
    angular.module('litui').component('lituiDatePicker', {
        templateUrl: 'litui/com/datetime/litui-date-picker/litui-date-picker.html',
        controller: LituiDatePickerCtrl,
        bindings: {
            datetime: '<',
            onChange: '=?',
            settings: '=?'
        }
    });

    /** @ngInject */
    function LituiDatePickerCtrl($scope) {
        var self = this;
        var lastDatetime = null;

        var time = null;
        var isUpdateDate = false;

        $scope.model = {
            formatted: undefined
        };

        $scope.options = {

        };

        $scope.$watch('date', function (date) {
            if(isUpdateDate){
                isUpdateDate = false;
                return;
            }
            
            if (dateToFormatted(date) === $scope.formatted)
                return;

            // date to moment
            var dt = litui.dateTime.toDateTime(date, self.settings.tz || litui.config.get('timezone'));
            litui.dateTime.setTime(dt, self.datetime);
            
            if(litui.dateTime.readable(dt) === litui.dateTime.readable(self.datetime)){
                return;
            }
            
            if (litui.dateTime.compare(dt, self.datetime) &&
                    isInRange(dt) === false)
                return;
            
            litui.dateTime.setDate(self.datetime, dt);
            $scope.model.formatted = datetimeToFormatted(dt);

            if (litui.utils.isFunction(self.onChange)) {
                self.onChange(self.datetime);
            }
        });
        $scope.$watch('model.formatted', function (formatted) {
            if (dateToFormatted($scope.date) === formatted)
                return;
            $scope.date = formattedToDate(formatted);
        });

        this.$doCheck = function () {
            if (litui.utils.isUndefined(self.datetime) || litui.dateTime.readable(self.datetime) === lastDatetime)
                return;

            if (litui.utils.isDefined(self.settings.tz))
                self.datetime.tz(self.settings.tz);

            if (!datetimeToFormatted(self.datetime) !== $scope.model.formatted)
                $scope.model.formatted = datetimeToFormatted(self.datetime);
            if (!litui.dateTime.compare($scope.date, self.datetime)) {
                time = litui.dateTime.getTime(self.datetime);
                isUpdateDate = true;
                $scope.date = litui.dateTime.toDate(self.datetime);
            }
            lastDatetime = litui.dateTime.readable(self.datetime);
        };

        this.$onInit = function () {
            litui.lang.prepareSettings({
                maxDate: undefined,
                minDate: undefined,
                tz: undefined
            }, this);
            
            if (litui.utils.isUndefined(self.datetime))
                self.datetime = litui.dateTime.now();

            if (litui.utils.isDefined(self.settings.tz))
                self.datetime.tz(self.settings.tz);

            $scope.model.formatted = datetimeToFormatted(self.datetime);
            $scope.date = litui.dateTime.toDate(self.datetime);

            if (litui.utils.isDefined(self.settings.minDate))
                $scope.options.minDate = self.settings.minDate;

            if (litui.utils.isDefined(self.settings.maxDate))
                $scope.options.maxDate = self.settings.maxDate;
        };

        function dateToFormatted(date) {
            return datetimeToFormatted(litui.dateTime.datetime(date, self.settings.tz));
        }
        function datetimeToFormatted(dt) {
            // TODO: make custom parser for config
            if (litui.utils.isDefined(self.settings.tz))
                dt.tz(self.settings.tz);
            return dt.format('YYYY-MM-DD');
        }
        function formattedToDate(formatted) {
            var dvals = formatted.split('-');
            var date = new Date(litui.utils.strToNum(dvals[0]),
                    litui.utils.strToNum(dvals[1] - 1),
                    litui.utils.strToNum(dvals[2]));
            return date;
        }
        function isInRange(dt) {
            if (litui.utils.isUndefined(self.settings))
                return;

            return (litui.utils.isDefined(self.settings.maxDate) && dt.isAfter(litui.dateTime.datetime(self.settings.maxDate, self.settings.tz))) ||
                    (litui.utils.isDefined(self.settings.minDate) && dt.isBefore(litui.dateTime.datetime(self.settings.minDate, self.settings.tz)));
        }
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiDateTimePickerService', LituiDateTimePickerServiceWrapper);

    /** @ngInject */
    function LituiDateTimePickerServiceWrapper(lituiPopoverService) {
        function LituiDateTimePickerService() {
            
        }

        LituiDateTimePickerService.prototype.popover = function ($binder, datetime, settings) {
            var self = this;
            return lituiPopoverService.open($binder, {
                component: {
                    template: '<litui-date-time-picker datetime="datetime" on-change="onChange" settings="settings"></litui-date-time-picker>',
                    params: {
                        datetime: datetime,
                        settings: settings,
                        onChange: function (dt) {
                            if (litui.utils.isFunction(settings.onChange))
                                return settings.onChange(dt);
                        }
                    }
                },
                bindedPosition: settings.bindedPosition || 'bottom',
                showClose: settings.showClose,
                onClose: function () {
                    self.activePopover = undefined;
                    if(litui.utils.isDefined(settings.onClose))
                        settings.onClose.apply(this, arguments);
                }
            });
        };

        return new LituiDateTimePickerService();
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiDateTimePicker', {
        templateUrl: 'litui/com/datetime/litui-date-time-picker/litui-date-time-picker.html',
        controller: LituiDateTimeCtrl,
        bindings: {
            datetime: '<',
            settings: '=?',
            onChange: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDateTimeCtrl($element, $timeout){  
        var self = this;
        
        this.onDatetimeChange = function(datetime){
            self.datetime = datetime;
            if(litui.utils.isFunction(self.onChange)){
                self.onChange(datetime);
            }
                
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDateTimePickerTrigger', {
        controller: LituiDateTimePickerTriggerCtrl,
        templateUrl: 'litui/com/datetime/litui-date-time-picker-trigger/litui-date-time-picker-trigger.html',
        bindings: {
            datetime: '=',
            settings: '=?',
            onChange: '=?',
            isDisabled: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDateTimePickerTriggerCtrl(lituiDateTimePickerService, lituiPopoverService){  
        var self = this;
        var popover = null;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                type: 'datetime',
                closeOnDateSelected: true,
                showClose: true,
                onClose: function(){
                    popover = null;
                }
            }, this);

            var fxTmp = this.settings.onChange;
            this.settings.onChange = function(){
                var result = undefined;
                if(litui.utils.isFunction(self.onChange)){
                    result = self.onChange.apply(this, arguments);
                }
                else if(litui.utils.isFunction(fxTmp)){
                    result = fxTmp.apply(this, arguments);
                }
                closeOnDateSelect();
                return result;
            };
        };
        
        this.$onDestroy = function(){
            if(litui.utils.nonNull(popover))
                popover = lituiPopoverService.close(popover);
        };
        
        this.onSelected = function(e){
            if(self.isDisabled)
                return;
            lituiDateTimePickerService.popover($(e.currentTarget), self.datetime, self.settings).then(function(pop){
                popover = pop;
            });
        };
        
        function closeOnDateSelect(){
            // only picker of type date can be closed by date selection
            if((self.settings.type === 'date') && self.settings.closeOnDateSelected && litui.utils.nonNull(popover)){
                popover = lituiPopoverService.close(popover);
            }
        }
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDayOfWeekIndentifier', {
        controller: LituiDayOfWeekIndentifierCtrl,
        templateUrl: 'litui/com/datetime/litui-day-of-week-indentifier/litui-day-of-week-indentifier.html',
        bindings: {
            days: '<'
        }
    });
    
    /** @ngInject */
    function LituiDayOfWeekIndentifierCtrl(){
        var self = this;
        var daysA = [];
        
        this.state = -1; // 0 - single, 1 - weekdays, 2 - weekend, 3 - every day, 4 - selected days
        
        this.$onInit = function(){
            self.state = calcState();
        };
        
        this.$doCheck = function(){
            if(!litui.utils.equals(daysA, self.days)){
                daysA = litui.lang.copyArray(self.days);
                self.state = calcState();
            }
        };
        
        function calcState(){
            // single day
            if(self.days.length === 1){
                return 0;
            }
            
            // weekday
            if(self.days.length === 5 && 
                self.days.indexOf(1) > -1 &&
                self.days.indexOf(2) > -1 &&
                self.days.indexOf(3) > -1 &&
                self.days.indexOf(4) > -1 &&
                self.days.indexOf(5) > -1){
                return 1;
            }
            
            // weekend
            if(self.days.length === 2 &&
                self.days.indexOf(6) > -1 &&
                self.days.indexOf(7) > -1)
                return 2;
            
            if(self.days.length === 7){
                return 3;
            }
            
            // selected days
            if(self.days.length > 0){
                return 4;
            }
            return -1;
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiDayOfWeekActivityService', LituiDayOfWeekActivityServiceWrapper);
    
    /** @ngInject */
    function LituiDayOfWeekActivityServiceWrapper() {
        function LituiDayOfWeekActivityService(){
            
        }
        
        return new LituiDayOfWeekActivityService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDayOfWeekActivity', {
        controller: LituiDayOfWeekActivityCtrl,
        templateUrl: 'litui/com/datetime/litui-day-of-week-activity/litui-day-of-week-activity.html',
        bindings: {
            days: '=',
            activity: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDayOfWeekActivityCtrl(lituiDayOfWeekPickerService){
        var self = this;        
        
        this.$onInit = function(){
            this.daysOfWeek = lituiDayOfWeekPickerService.generateDaysOfWeek();
            
            litui.PropertyObserver.observe({
                days: function(){
                    self.todayValue = litui.dateTime.now().day();
                }
            }, this);
        };
    }
})();
"use strict";

(function () {
    angular.module('litui').service('lituiDayOfWeekPickerService', LituiDayOfWeekPickerServiceWrapper);

    /** @ngInject */
    function LituiDayOfWeekPickerServiceWrapper() {
        function LituiDayOfWeekPickerService() {

        }

        LituiDayOfWeekPickerService.prototype.generateDaysOfWeek = function () {
            return [
                {
                    value: 1,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.MONDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.MONDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.MONDAY_SHORT',
                },
                {
                    value: 2,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.TUESDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.TUESDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.TUESDAY_SHORT',
                },
                {
                    value: 3,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.WEDNESDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.WEDNESDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.WEDNESDAY_SHORT',
                },
                {
                    value: 4,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.THURSDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.THURSDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.THURSDAY_SHORT',
                },
                {
                    value: 5,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.FRIDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.FRIDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.FRIDAY_SHORT',
                },
                {
                    value: 6,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.SATURDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.SATURDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.SATURDAY_SHORT',
                },
                {
                    value: 7,
                    symbol: 'LITUI.DAY_OF_WEEK_PICKER.SUNDAY_SYMBOL',
                    name: 'LITUI.DAY_OF_WEEK_PICKER.SUNDAY',
                    nameShort: 'LITUI.DAY_OF_WEEK_PICKER.SUNDAY_SHORT',
                }
            ];
        };

        return new LituiDayOfWeekPickerService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiDayOfWeekPicker', {
        controller: LituiDayOfWeekPickerCtrl,
        templateUrl: 'litui/com/datetime/litui-day-of-week-picker/litui-day-of-week-picker.html',
        bindings: {
            days: '=',
            settings: '=?',
            isDisabled: '=?'
        }
    });

    /** @ngInject */
    function LituiDayOfWeekPickerCtrl(lituiDayOfWeekPickerService) {
        var self = this;

        this.daysOfWeek = null;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                onDaySelected: undefined,
                isAllowEmpty: true,
    //            isAllowOne: true
            }, this);

            this.daysOfWeek = lituiDayOfWeekPickerService.generateDaysOfWeek();
        };

        this.onDaySelected = function (e, day) {
            if(self.isDisabled)
                return ;
            
            if (self.settings.isAllowEmpty) {
                toggleDay(day.value);
            } 
            else{
                toggleDayNoEmpty(day.value);
            }
            
            if (litui.utils.isFunction(self.settings.onDaySelected)) {
                self.settings.onDaySelected(e, day, self.days);
            }
        };

        function toggleDay(dayId) {
            if (self.days.indexOf(dayId) === -1) {
                self.days.push(dayId);
            }
            else{
                litui.utils.deleteElement(self.days, self.days.indexOf(dayId));
            }
        }

        function toggleDayNoEmpty(dayId) {
            if (self.days.indexOf(dayId) === -1) {
                self.days.push(dayId);
            }
            else if(self.days.length > 1){
                litui.utils.deleteElement(self.days, self.days.indexOf(dayId));
            }
        }
    }

})();
"use strict";

(function(){
    angular.module('litui').service('lituiPeriodActivityService', LituiPeriodActivityServiceWrapper);
    
    /** @ngInject */
    function LituiPeriodActivityServiceWrapper() {
        function LituiPeriodActivityService(){
            var self = this;
            
            this.activities = {};
            this.registered = 0;
            this.periodicalHandler = function(){
                self.activityTimer();
            };
        }
        
        LituiPeriodActivityService.__AI = 0;
        
        LituiPeriodActivityService.prototype.registerActivity = function(activityCallback){
            var self = this;
            LituiPeriodActivityService.__AI++;
            this.activities[LituiPeriodActivityService.__AI] = activityCallback;
            this.registered++;
            if(this.registered === 1){
                litui.async.periodical(this.periodicalHandler, 1000);
            }
            return LituiPeriodActivityService.__AI;
        };
        
        LituiPeriodActivityService.prototype.deregisterActivity = function(id){
            var cb = this.activities[id];
            if(litui.utils.isDefined(cb)){
                litui.utils.deleteItem(id, this.activities);
                this.registered--;
            }
            
            if(this.registered === 0 && litui.utils.nonNull(this.periodicalHandler)){
                litui.async.unset(this.periodicalHandler);
            }
        };
        
        LituiPeriodActivityService.prototype.activityTimer = function(){
            for(var k in this.activities){
                this.activities[k]();
            }
        };
        
        return new LituiPeriodActivityService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiPeriodActivity', {
        controller: LituiPeriodActivityCtrl,
        templateUrl: 'litui/com/datetime/litui-period-activity/litui-period-activity.html',
        bindings: {
            datetimeA: '<?',
            datetimeB: '<?',
            timeA: '<?',
            timeB: '<?',
            reccuringDays: '<?',
            isCurrentlyActive: '=?',
            settings: '=?'
        }
    });

    /** @ngInject */
    function LituiPeriodActivityCtrl($element, lituiPeriodActivityService) {
        var $elt = $($element);
        var self = this;
        this.activity = {
            date: 'non-active',
            day: 'non-active',
            time: 'non-active'
        };

        this.$onInit = function () {
            litui.lang.prepareSettings({
                dateA: {}
            }, this);
            
            litui.PropertyObserver.observe({
                datetimeA: function (oldVal, val) {
                    calcActivity();
                },
                datetimeB: function (oldVal, val) {
                    calcActivity();
                },
                timeA: function (oldVal, val) {
                    calcActivity();                
                },
                timeB: function (oldVal, val) {
                    calcActivity();
                },
                reccuringDays: function (oldVal, val) {
                    calcActivity();
                }
            }, this);

            lituiPeriodActivityService.registerActivity(calcActivity);
            
            calcActivity();
        };
        
        function calcActivity() {
            var now = litui.dateTime.now(self.settings.dateA.tz);
            var isDate = litui.dateTime.isInPeriod(litui.dateTime.now(self.settings.dateA.tz), self.datetimeA, self.datetimeB);
            var isTime = litui.dateTime.isInTimePeriod(litui.dateTime.now(self.settings.dateA.tz), self.timeA, self.timeB);
            var isDay = self.reccuringDays.indexOf(now.day()) > -1;
            
            if((isDate && isTime && isDay && litui.utils.isUndefined(self.isCurrentlyActive)) || self.isCurrentlyActive){
                self.activity.date = 'current';
                self.activity.day = 'current';
                self.activity.time = 'current';
                return;
            }
            
            if(!isDate){
                self.activity.date = 'obsolete';
                self.activity.day = 'obsolete';
                self.activity.time = 'obsolete';
                return;
            }
            
            if(isDate){
                self.activity.date = 'active';
            }
            else
                self.activity.date = 'non-active';
            
            if(isTime){
                self.activity.time = 'active';
            }
            else
                self.activity.time = 'non-active';
            
            if(isDay){
                self.activity.day = 'active';
            }
            else
                self.activity.day = 'non-active';
        }
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiPeriodSelection', {
        templateUrl: 'litui/com/datetime/litui-period-selection/litui-period-selection.html',
        controller: LituiDateTimeCtrl,
        bindings: {
            datetimeA: '<',
            datetimeB: '<',
            timeA: '<',
            timeB: '<',
            entity: '=?',
            reccuringDays: '=?',
            isReccuring: '=?',
            isPeriodical: '=?',
            settings: '=?',
            onDatetimeAChange: '=?',
            onDatetimeBChange: '=?',
            onTimeAChange: '=?',
            onTimeBChange: '=?',
            onDaySelected: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDateTimeCtrl(){  
        var self = this;
        
        this.isPeriodicalField = {
            type: 'boolean',
            label: 'LITUI.PERIOD_SELECTION.IS_PERIODICAL'
        };
        
        this.reccuringDaysSettings = {
            isAllowEmpty: false,
            onDaySelected: this.onDaySelected
        };
        
        this.$onInit = function(){    
            litui.lang.prepareSettings({
                tz: undefined,
                enableInfinity: true,
                isPeriodicalDisabled: false,
                isReccuringTimeDisabled: false,
                isDaySelectionDisabled: false,
                date: {
                    dateA: {
                        tz: 'UTC',
                        type: 'date'
                    },
                    dateB: {
                        tz: 'UTC',
                        type: 'date'
                    }
                },
                time: {
                    timeA: {
                        tz: 'UTC',
                        type: 'time'
                    },
                    timeB: {
                        tz: 'UTC',
                        type: 'time'
                    }
                },
                onRepeatInPeriod: function(){},
                onRepeatInTimePeriod: function(){}
            }, this);
            
            this.reccurancePeriod = {
                timeA: {
                    onChange: function(e, datetime){
                        if(litui.utils.isFunction(self.onTimeAChange)){
                            self.onTimeAChange(e, datetime, self.entity);
                        }
                    }
                },
                timeB: {
                    onChange: function(e, datetime){
                        if(litui.utils.isFunction(self.onTimeBChange)){
                            self.onTimeBChange(e, datetime, self.entity);
                        }
                    } 
                },
                field: {
                    type: 'boolean',
                    label: 'LITUI.PERIOD_SELECTION.REPEAT_IN_TIME_PERIOD'
                }
            };
            
            if(litui.utils.isUndefined(self.isPeriodical))
                self.isPeriodical = false;

            if(litui.utils.isUndefined(self.isReccuring))
                self.isReccuring = false;
            
            if(litui.utils.isDefined(self.reccuringDays) && self.reccuringDays.length === 0){
                self.reccuringDays.push(litui.dateTime.now().day());
            }
        };
        
        
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiRelativeTime', LituiRelativeTimeDirective);
    
    /**
     * For custom texts, use text:
     * {
     *   upcomingExactly:String,
     *   upcomingCca:String,
     *   passedExactly:String,
     *   passedCca:String
     * },
     * otherwise defaults to translation values.
     */
    /** @ngInject */
    function LituiRelativeTimeDirective(lituiRelativeTimeService) {
        return {
            restrict: 'A',
            template: '{{value}}',
            scope: {
                time: '=lituiRelativeTime',
                now: '=?',
                text: '=?',
                autosync: '=?',
                isExact: '=?',
                limitTimeActors: '=?',
                format: '=?',
                isAbsolute: '=?'
            },
            link: function ($scope, $elt, attrs) {
                $scope.value;
                calcRelativeTime();
                
                if($scope.autosync === false && litui.utils.isUndefined($scope.now)){
                    return;
                }
                else if(litui.utils.isDefined($scope.now))
                    $scope.$watch('now', function(){
                        calcRelativeTime();
                    });
                else{
                    lituiRelativeTimeService.on(calcRelativeTime);
                }
                
                function calcRelativeTime(){
                    var diff = lituiRelativeTimeService.calcRelativeDiff($scope.time, $scope.now);
                    if(litui.utils.isUndefined($scope.format))
                        $scope.value = lituiRelativeTimeService.formatDateTime(diff, $scope.isExact, $scope.limitTimeActors, $scope.text) || '/';
                    else{
                        $scope.value = lituiRelativeTimeService.formatCustom($scope.time, $scope.format, $scope.isAbsolute) || '/';
                    }
                }
                
                $scope.$on('$destroy', function(){
                    lituiRelativeTimeService.off(calcRelativeTime);
                });
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiRelativeTimeService', service);

    /** @ngInject */
    function service($interval, tmsDatetimeUtils) {
        function LituiRelativeDateTimeService() {
            this.intervalHandler = null;
            this.intervalSubscribers = [];
            this.startInterval();
        }

        LituiRelativeDateTimeService.prototype.on = function (subscription) {
            this.intervalSubscribers.push(subscription);
        };

        LituiRelativeDateTimeService.prototype.off = function (subscription) {
            var index = this.intervalSubscribers.indexOf(subscription);
            if (index > -1)
                litui.utils.deleteElement(this.intervalSubscribers, index);
        };

        LituiRelativeDateTimeService.prototype.startInterval = function () {
            var self = this;
            this.intervalHandler = $interval(function () {
                for (var i = 0; i < self.intervalSubscribers.length; i++) {
                    self.intervalSubscribers[i]();
                }
            }, 1000);
        };

        LituiRelativeDateTimeService.prototype.stopInterval = function () {
            return this.intervalHandler.cancel();
        };

        LituiRelativeDateTimeService.prototype.calcRelativeDateTimeDiff = function (datetimeA, datetimeB, isAfter) {
            var diff = {
                year: 0,
                month: 0,
                day: 0,
                hour: 0,
                minute: 0,
                second: 0,
                isAfter: isAfter
            };

            diff.milis += datetimeB.milis - datetimeA.milis;
            if (diff.milis < 0) {
                diff.second -= 1;
                diff.milis = 1000 - Math.abs(diff.milis);
            }

            diff.second += datetimeB.second - datetimeA.second;
            if (diff.second < 0) {
                diff.minute -= 1;
                diff.second = 60 - Math.abs(diff.second);
            }

            diff.minute += datetimeB.minute - datetimeA.minute;
            if (diff.minute < 0) {
                diff.hour -= 1;
                diff.minute = 60 - Math.abs(diff.minute);
            }

            diff.hour += datetimeB.hour - datetimeA.hour;
            if (diff.hour < 0) {
                diff.day -= 1;
                diff.hour = 24 - Math.abs(diff.hour);
            }

            diff.day += datetimeB.day - datetimeA.day;
            if (diff.day < 0) {
                diff.month -= 1;
                // -1 - do not count "today"
                var daysInOrigin = litui.dateTime.getDaysInMonth(datetimeA.month, datetimeA.year);
                diff.day = daysInOrigin - datetimeA.day + (datetimeB.day);
            }
            diff.month += datetimeB.month - datetimeA.month;
            if (diff.month < 0) {
                diff.year--;
                diff.month = 12 - Math.abs(diff.month);
            }
            diff.year += datetimeB.year - datetimeA.year;
            return diff;
        };

        LituiRelativeDateTimeService.prototype.calcRelativeDiff = function (datetime, currentDatetime) {
            if (litui.utils.isUndefined(datetime))
                return;

            if (litui.utils.isString(datetime) || litui.utils.isNumber(datetime)) {
                datetime = tmsDatetimeUtils.toAppTimezone(moment(datetime));
            }

            var now = litui.utils.isDefined(currentDatetime) ? currentDatetime : tmsDatetimeUtils.toAppTimezone(moment());
            
            if (litui.utils.isNull(datetime))
                throw "Provided DateTime relative datetime diff calculation is invalid!";

            if (litui.utils.isDefined(currentDatetime) && litui.utils.isNull(currentDatetime))
                throw "Provided current DateTime relative datetime diff calculation is invalid!";

            var origin = {
                year: now.year(),
                month: now.month(), // index, not actual
                day: now.date(),
                hour: now.hour(),
                minute: now.minute(),
                second: now.second(),
                milis: now.millisecond(),
                isLeapYear: litui.dateTime.isLeapYear(now.year())
            };
            var target = {
                year: datetime.year(),
                month: datetime.month(), // index, not actual
                day: datetime.date(),
                hour: datetime.hour(),
                minute: datetime.minute(),
                second: datetime.second(),
                milis: datetime.millisecond(),
                isLeapYear: litui.dateTime.isLeapYear(datetime.year())
            };
            var isAfter = datetime.isAfter(now);
            if (isAfter)
                return this.calcRelativeDateTimeDiff(origin, target, isAfter);
            return this.calcRelativeDateTimeDiff(target, origin, isAfter);
        };

        LituiRelativeDateTimeService.prototype.formatTimeComponent = function (value, singularStr, dualStr, pluralStr) {
            if (value === 1)
                return litui.translator.translate(singularStr, {
                    time: value
                });
            else if (value === 2)
                return litui.translator.translate(dualStr, {
                    time: value
                });
            else if (value > 2)
                return litui.translator.translate(pluralStr, {
                    time: value
                });
            return "";
        };

        LituiRelativeDateTimeService.prototype.formatRelativeDatetimeDiff = function (diff, limit, isExact) {
            var actors = [
                this.formatTimeComponent(diff.year, 'LITUI.RELATIVE_TIME.YEAR_SINGULAR', 'LITUI.RELATIVE_TIME.YEAR_DUAL', 'LITUI.RELATIVE_TIME.YEAR_PLURAL'),
                this.formatTimeComponent(diff.month, 'LITUI.RELATIVE_TIME.MONTH_SINGULAR', 'LITUI.RELATIVE_TIME.MONTH_DUAL', 'LITUI.RELATIVE_TIME.MONTH_PLURAL'),
                this.formatTimeComponent(diff.day, 'LITUI.RELATIVE_TIME.DAY_SINGULAR', 'LITUI.RELATIVE_TIME.DAY_DUAL', 'LITUI.RELATIVE_TIME.DAY_PLURAL'),
                this.formatTimeComponent(diff.hour, 'LITUI.RELATIVE_TIME.HOUR_SINGULAR', 'LITUI.RELATIVE_TIME.HOUR_DUAL', 'LITUI.RELATIVE_TIME.HOUR_PLURAL'),
                this.formatTimeComponent(diff.minute, 'LITUI.RELATIVE_TIME.MINUTE_SINGULAR', 'LITUI.RELATIVE_TIME.MINUTE_DUAL', 'LITUI.RELATIVE_TIME.MINUTE_PLURAL'),
                this.formatTimeComponent(diff.second, 'LITUI.RELATIVE_TIME.SECOND_SINGULAR', 'LITUI.RELATIVE_TIME.SECOND_DUAL', 'LITUI.RELATIVE_TIME.SECOND_PLURAL')
            ];

            if (litui.utils.isUndefined(limit)) {
                if (!isExact)
                    limit = 2;
                else
                    limit = actors.length - 1;
            }
            var addedCountr = 0;
            var formatted = "";
            var isNow = true;
            for (var i = 0; i < actors.length; i++) {
                var actor = actors[i];
                if (actor.length > 0) {
                    isNow = false;
                    addedCountr++;
                    if ((addedCountr === limit)) {
                        formatted += (addedCountr > 1 ? litui.translator.translate('LITUI.RELATIVE_TIME.AND') + " " : "") + actor;
                        break;
                    }
                    formatted += actor + " ";

                }
            }
            if (isNow)
                return null;
            return formatted;
        };

        LituiRelativeDateTimeService.prototype.formatDateTime = function (diff, isExact, limit, text) {
            if (litui.utils.isUndefined(diff))
                return;

            var formatStr = "";
            text = litui.lang.merge({
                upcomingExactly: 'LITUI.RELATIVE_TIME.UPCOMING_EXACTLY',
                upcomingCca: 'LITUI.RELATIVE_TIME.UPCOMING_CCA',
                passedExactly: 'LITUI.RELATIVE_TIME.PASSED_EXACTLY',
                passedCca: 'LITUI.RELATIVE_TIME.PASSED_CCA'
            }, text || {});
            if (diff.isAfter) {
                var formatted = this.formatRelativeDatetimeDiff(diff, limit, isExact);
                if (litui.utils.isSet(formatted))
                    formatStr = litui.utils.trimWhitespaces(litui.translator.translate(isExact ? text.upcomingExactly : text.upcomingCca, {
                        formatted: formatted
                    }));
                else
                    formatStr = litui.translator.translate('LITUI.RELATIVE_TIME.NOW');
            } else {
                var formatted = this.formatRelativeDatetimeDiff(diff, limit, isExact);
                if (litui.utils.isSet(formatted))
                    formatStr = litui.utils.trimWhitespaces(litui.translator.translate(isExact ? text.passedExactly : text.passedCca, {
                        formatted: formatted
                    }));
                else
                    formatStr = litui.translator.translate('LITUI.RELATIVE_TIME.NOW');
            }
            return formatStr;
        };
        
        LituiRelativeDateTimeService.prototype.formatCustom = function(time, format, isAbsolute, refTime){
            if(litui.utils.isUndefined(time))
                return ;
            
            var now = refTime || litui.dateTime.now();
//            var now = litui.dateTime.now();
            var diff = this.calcRelativeDiff(time, now);
            
            var mapped = {
                DD: {
                    val: diff.day,
                    format: 'D'
                },
                MM: {
                    val: diff.month,
                    format: 'M'
                },
                YYYY: {
                    val: diff.year,
                    format: 'Y'
                },
                HH: {
                    val: diff.hour,
                    format: 'H'
                },
                mm: {
                    val: diff.minute,
                    format: 'm'
                },
                ss: {
                    val: diff.second,
                    format: 's'
                },
                ms: {
                    val: diff.milis,
                    format: 'ms'
                }
            };
            
            var splitted = format.split(':');
            var formattedStr = (!diff.isAfter && !isAbsolute)? "-" : "";
            for(var i = 0; i < splitted.length; i++){
                var ch = splitted[i];
                var formatter = mapped[ch];
                if(formatter.val === 0)
                    continue;
                
                if(i > 0)
                    formattedStr += ' ';
                formattedStr += formatter.val + formatter.format;
            }
            return formattedStr;
        };

        return new LituiRelativeDateTimeService();
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiTimePeriodActivityService', LituiTimePeriodActivityServiceWrapper);
    
    /** @ngInject */
    function LituiTimePeriodActivityServiceWrapper() {
        function LituiTimePeriodActivityService(){
            
        }
        
        return new LituiTimePeriodActivityService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTimePeriodActivity', {
        controller: LituiTimePeriodActivityCtrl,
        templateUrl: 'litui/com/datetime/litui-time-period-activity/litui-time-period-activity.html',
        bindings: {
            timeA: '=',
            timeB: '=',
            activity: '=',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiTimePeriodActivityCtrl(){
        var self = this;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                timeA: {
                    tz: 'UTC'
                },
                timeB: {
                    tz: 'UTC'
                }
            }, this);
        };
        
        this.isInfinityMin = function(time){
            return litui.dateTime.isInfinityTimeMin(time);
        };
        
        this.isInfinityMax = function(time){
            return litui.dateTime.isInfinityTimeMax(time);
        };
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTimePeriodPicker', {
        controller: LituiTimePeriodPickerCtrl,
        templateUrl: 'litui/com/datetime/litui-time-period-picker/litui-time-period-picker.html',
        bindings: {
            datetimeA: '<',
            datetimeB: '<',
            onDatetimeAChange: '=?',
            onDatetimeBChange: '=?',
            entity: '=?',
            settings: '=?',
            isDisabled: '=?'
        }
    });
    
    /** @ngInject */
    function LituiTimePeriodPickerCtrl(){
        this.$onInit = function(){
            litui.lang.prepareSettings({
                timeA: {
                    type: 'time'
                },
                timeB: {
                    type: 'time'
                }
            }, this);
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiTimePickerService', service);

    /** @ngInject */
    function service(lituiPopoverService) {
        function LituiTimePickerService() {
            
        }

        LituiTimePickerService.prototype.popover = function ($binder, datetime, settings) {
            var self = this;
            return lituiPopoverService.open($binder, {
                component: {
                    template: '<litui-time-picker datetime="datetime" on-change="onChange" settings="settings"></litui-time-picker>',
                    params: {
                        datetime: datetime,
                        settings: settings,
                        onChange: function (dt) {
                            if (litui.utils.isFunction(settings.onChange))
                                return settings.onChange(dt);
                        }
                    }
                },
                bindedPosition: settings.bindedPosition || 'bottom',
                onClose: function () {
                    self.activePopover = undefined;
                }
            });
        };

        return new LituiTimePickerService();
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiTimePicker', {
        templateUrl: 'litui/com/datetime/litui-time-picker/litui-time-picker.html',
        controller: LituiDateTimeCtrl,
        bindings: {
            datetime: '<',
            onChange: '=?',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDateTimeCtrl($element, config){  
        var self = this;
        var $elt = $($element);
        
        var lastDatetime = null;
        
        this.formatted = {};
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                tz: undefined,
                type: 'time'
            }, this);
        };
        
        this.$onChanges = function(){
            if(lastDatetime === null || 
                (lastDatetime !== null && !lastDatetime.isSame(self.datetime))){
                if(litui.utils.isString(self.datetime) || 
                    litui.dateTime.isDate(self.datetime)){
                    litui.lang.merge(self.datetime, litui.dateTime.datetime(self.datetime));
                }
                
                self.formatted.hours = datetimeToFormattedHours(self.datetime);
                self.formatted.minutes = datetimeToFormattedMinutes(self.datetime);
                lastDatetime = self.datetime;
            }
        };
        
        this.onIncrementHours = function(){
            self.datetime.add(1, 'h');
            self.formatted.hours = datetimeToFormattedHours(self.datetime);
            onChange();
        };
        
        this.onDecrementHours = function(){
            self.datetime.subtract(1, 'h');
            self.formatted.hours = datetimeToFormattedHours(self.datetime);            
            onChange();
        };
        
        this.onIncrementMinutes = function(){
            self.datetime.add(1, 'm');
            self.formatted.minutes = datetimeToFormattedMinutes(self.datetime);
            self.formatted.hours = datetimeToFormattedHours(self.datetime);            
            onChange();
        };
        
        this.onDecrementMinutes = function(){
            self.datetime.subtract(1, 'm');
            self.formatted.minutes = datetimeToFormattedMinutes(self.datetime);
            self.formatted.hours = datetimeToFormattedHours(self.datetime);            
            onChange();
        };
        
        this.onHourChange = function(e){
            self.datetime.tz(self.settings.tz || config.timezone).hours(self.formatted.hours);
            self.formatted.hours = datetimeToFormattedHours(self.datetime);
            onChange();
        };
        
        this.onMinuteChange = function(e){
            self.datetime.tz(self.settings.tz || config.timezone).minutes(self.formatted.minutes);
            self.formatted.minutes = datetimeToFormattedMinutes(self.datetime);
            self.formatted.hours = datetimeToFormattedHours(self.datetime);
            
            onChange();
        };
        
        function datetimeToFormattedHours(dt){
            return litui.dateTime.format(dt, "HH", self.settings.tz || config.timezone);
        }
        
        function datetimeToFormattedMinutes(dt){
            return litui.dateTime.format(dt, "mm", self.settings.tz || config.timezone);
        }
        
        function onChange(){
            lastDatetime = self.datetime;
            
            if(litui.utils.isFunction(self.onChange))
                self.onChange(self.datetime);
        }
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiCountdown', {
        controller: LituiCountdown,
        templateUrl: 'litui/com/info/litui-countdown/litui-countdown.html',
        bindings: {
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiCountdown(TmsFilter){
        var self = this;
        
        this.lastRefreshTime = null;
        
        this.$onInit = function(){
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            litui.lang.mergeB({
                tooltipDelay: -1,
                indicator: litui.lang.mergeB({
                    enabled: true,
                    autoRefreshActive: true,
                    autoRefreshEnabled: true,
                    autoRefreshInterval: 15
                }, this.settings.indicator || {})
            }, this.settings);  
            
            if(litui.utils.isUndefined(this.settings.filter)){    
                this.filter = TmsFilter.create().autoApply().onApply(function(dto){
                    return self.onLoad(dto);
                });
                this.filter.init();
            }
            else
                this.filter = this.settings.filter;
        };
        
        this.onLoad = function(dto){
            if(litui.utils.isFunction(self.settings.onLoad)){
                return litui.async.when(self.settings.onLoad(dto)).then(function(payload){
                    self.lastRefreshTime = litui.dateTime.now();
                    return payload;
                });
            }
        };
        
        this.onSelected = function(e){
            if(litui.utils.isFunction(self.settings.onSelected))
                self.settings.onSelected(e);
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiDashboard', LituiDashboardDirective);

    /** @ngInject */
    function LituiDashboardDirective($timeout, $compile, lituiDashboardSectionService, lituiCompileService) {
        return {
            restrict: 'E',
            transclude: {
                'widgets': '?lituiDashboardWidgets',
                'content': '?lituiDashboardContent'
            },
            scope: {
                banner: "=",
                sections: "=?",
                settings: "=?"
            },
            //Let's change the order of elements
            templateUrl: 'litui/com/info/litui-dashboard/litui-dashboard.html',
            link: function ($scope, $elt) {
                var headerComponent = null;

                if (litui.utils.isUndefined($scope.settings))
                    $scope.settings = {};

                litui.lang.mergeB({
                    noDefaultState: false
                }, $scope.settings);

                var $dashboardHolder = $elt.find('.litui-dashboard-holder');
                $dashboardHolder.css({
                    display: 'block',
                    opacity: 0
                });
                
                $scope.$watch('settings', function(){
                    $scope.header.noDefaultState = $scope.settings.noDefaultState;
                }, true);
                
                
                $scope.header = litui.lang.merge({
                    showLabels: true,
                    onLoad: $scope.settings.onLoad,
                    refreshFrequency: 15,
                    noDefaultState: $scope.settings.noDefaultState
                }, $scope.settings.header || {});

                $scope.sectionsSettings = {
                    defaultSectionId: $scope.settings.defaultSectionId,
                    noDefaultState: $scope.settings.noDefaultState
                };


                if (litui.utils.isDefined($scope.sections)) {
                    lituiCompileService.compile(litui.layoutMngr.provide().getPanelElt('viewport').parent(), {
                        append: true,
                        component: {
                            template: '<litui-dashboard-header settings="header" sections="sections" banner="banner"></litui-dashboard-header>',
                            params: {
                                header: $scope.header,
                                sections: $scope.sections,
                                banner: $scope.banner
                            }
                        }
                    }).then(function(component){
                        headerComponent = component;
                    })
                }


                lituiDashboardSectionService.on('SET_BANNER_OPACITY', setBannerOpacityHandler);

                $timeout(function () {
                    TweenMax.to($dashboardHolder, 0.2, {
                        opacity: 1,
                        onComplete: function () {

                        }
                    });
                }, 300);

                $scope.$on('$destroy', function () {
                    lituiDashboardSectionService.off('SET_BANNER_OPACITY', setBannerOpacityHandler);

                    if (!litui.utils.isNull(headerComponent))
                        headerComponent.destroy();
                });

                function setBannerOpacityHandler(opacity) {
                    var $overlay = $elt.find('.litui-dashboard-header .litui-dashboard-banner-overlay');
                    if (opacity > 0)
                        $overlay.css('display', 'block');
                    else
                        $overlay.css('display', 'none');
                    $overlay.css('opacity', opacity);
                }
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiDatatableService', LituiDatatableServiceWrapper);
    
    /** @ngInject */
    function LituiDatatableServiceWrapper() {
        function LituiDatatableService(){
            
        }
        
        return new LituiDatatableService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDatatable', {
        controller: LituiDatatable,
        templateUrl: 'litui/com/info/litui-datatable/litui-datatable.html',
        bindings: {
            tableDefinition: '=',
            tableData: '=',
            hooks: '='
        }
    });
    
    /** @ngInject */
    function LituiDatatable($element){        
        
        this.$elt = $($element);
        this.items = [];
        
        this.$onInit = function(){     
            var self = this;
            if(litui.utils.isDefined(this.hooks)){
                this.hooks.setData = function(data){
                    return self.setData(data);
                };
            }
            
            this.mapData(this.tableData);
        };
        this.$onDestroy = function(){
            
        };
        
        this.setData = function(data){
            return this.mapData(data);
        };
        
        this.mapData = function(data){
            var self = this;
            var valueFilters = this.getValueFilters();
            var cellFormatters = this.getCellFormatter();
            
            var dataHolder = [];
            var formattedCells = undefined;
            litui.utils.foreach(data, function(rowIndex, entity){
                var item = {};
                litui.utils.foreach(entity, function(pname, pvalue){
                    var valueFilter = valueFilters[pname];
                    if(litui.utils.isFunction(valueFilter)){
                        var val = valueFilter(pvalue);
                        item[pname] = litui.utils.isUndefined(val)? '' : val;
                    }
                    else{
                        item[pname] = pvalue;
                    }
                    
                    var cellFormatter = cellFormatters[pname];
                    if(litui.utils.isFunction(cellFormatter)){
                        if(litui.utils.isUndefined(formattedCells))
                            formattedCells = {};
                            
                        if(litui.utils.isUndefined(formattedCells[pname])){
                            formattedCells[pname] = {};
                        }
                        var formatted = cellFormatter(entity);
                        formattedCells[pname][rowIndex] = litui.utils.isUndefined(formatted)? '' : formatted;
                    }
                });
                
                dataHolder.push(item);
            });
            
            var hideInitial = false;
            if(litui.utils.isSet(formattedCells) && this.items.length === 0){
                hideInitial = true;
            }
            
            this.items = dataHolder;
            
            if(litui.utils.isSet(formattedCells))
                return litui.async.delay(50).then(function(){                
                    litui.utils.foreach(formattedCells, function(fname, rows){
                        litui.utils.foreach(rows, function(rowIndex, formattedCell){
                            self.$elt.find('tbody tr.litui-datatable-row_' + rowIndex + ' .litui-datatable-cell_' + fname).html(formattedCell);
                        });
                    });
                    self.$elt.find('tbody tr').css('visibility', 'visible');
                });
            self.$elt.find('tbody tr').css('visibility', 'visible');
        };
        
        this.getCellFormatter = function(){
            var cellFormatters = {};
            litui.utils.foreach(this.tableDefinition.columns, function(i, col){
                if(litui.utils.isFunction(col.cellFormatter))
                    cellFormatters[col.field] = col.cellFormatter;
            });
            return cellFormatters;
        };
        
        this.getValueFilters = function(){
            var filters = {};
            litui.utils.foreach(this.tableDefinition.columns, function(i, col){
                if(litui.utils.isFunction(col.valueFilter))
                    filters[col.field] = col.valueFilter;
            });
            return filters;
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiDetails', {
        templateUrl: 'litui/com/info/litui-details/litui-details.html',
        controller: LituiDetailsCtrl,
        bindings: {
            detailsData: '=',
            detailsDefinition: '='
        }
    });
    
    /** @ngInject */
    function LituiDetailsCtrl($element){  
        var self = this;
        var $elt = $($element);
        
        this.isObject = function(a){
            return litui.utils.isObject(a);
        };
        
        this.$onInit = function(){
            
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiHelpLegendService', LituiHelpLegendServiceWrapper);

    /** @ngInject */
    function LituiHelpLegendServiceWrapper() {
        function LituiHelpLegendService() {

        }

        LituiHelpLegendService.prototype.produceTriggerSettings = function (helpSettings, popoverSettings) {
            if (litui.utils.isUndefined(helpSettings))
                throw "Settings for help component must be provided!";

            litui.lang.mergeB({
                title: 'Help',
                description: "Help",
                legend: undefined,
            }, helpSettings);

            if (litui.utils.isUndefined(popoverSettings))
                popoverSettings = {};
            litui.lang.mergeB({
                bindedPosition: 'bottom'
            }, popoverSettings);

            popoverSettings.component = {
                template: '<litui-help-legend content="content"></litui-help-legend>',
                params: {
                    content: helpSettings
                }
            };

            return {
                popover: popoverSettings
            };
        };

        return new LituiHelpLegendService();
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiHelpLegend', {
        controller: LtuiLinetrackHelpCtrl,
        templateUrl: 'litui/com/info/litui-help-legend/litui-help-legend.html',
        bindings: {
            content: '='
        }
    });
    
    /** @ngInject */
    function LtuiLinetrackHelpCtrl(){
        
    }
})();
"use strict";

(function(){
    
    angular.module('litui').directive('lituiNotification', LituiNotificationDirective);
    
    /** @ngInject */
    function LituiNotificationDirective(lituiNotification) {
        return {
            restrict: 'AE',
            scope: {},
            link: postLink,
            templateUrl: 'litui/com/info/litui-notification/litui-notification.html'
        };

        function postLink($scope, element, attrs) {            
            $scope.notify = litui.lang.merge({
                notifications: lituiNotification.$$getNotifications(),
                toggle: function() {
                    $scope.notify.collapsed = !$scope.notify.collapsed;
                },
                close: lituiNotification.remove,
                onAction: lituiNotification.$$onAction
            }, lituiNotification.$$getOptions());
            
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').provider('lituiNotification', LituiNotificationProvider);
    
    /** @ngInject */
    function LituiNotificationProvider() {
            var types = {
                'SUCCESS': "success",
                'INFO': "info",
                'WARNING': "warning",
                'ERROR': "error"
            };

            var constants = {
                "TTL_INFINITY": -1
            };

            var typeValues = _.values(types);

            var options = {
                collapsed: false,
                animations: true,
                grouping: false,
                TTL: -1
            };

            this.setCollapsed = function (collapsed) {
                options.collapsed = collapsed === true;
            };

            this.setTimeToLive = function (TTL) {
                if (angular.isNumber(TTL)) {
                    options.TTL = TTL;
                }
            };

            this.enableAnimations = function (enabled) {
                options.animations = enabled === true;
            };

            this.enableGrouping = function (enabled) {
                options.grouping = enabled === true;
            };

            // --- Notification factory ---
            this.$get = ["$timeout", '$sce', notificationFactory];

            function notificationFactory($timeout, $sce) {
                var thiz = this;
                var notifications = [];
                var exposed = {
                    $$getOptions: getOptions,
                    $$getNotifications: getNotifications,
                    $$onAction: onAction,
                    remove: removeNotification,
                    notify: notify
                };
                //Expose types and constants
                angular.extend(exposed, types, constants);
                //Expose notification method per notification type. types.SUCCESS -> tmsNotification.success(...)
                angular.forEach(typeValues, function (type) {
                    exposed[type] = notify.bind(thiz, type);
                });

                // ----------------
                // --- Funtions ---
                // ----------------
                function notify(type, title, message, ttl, icon, data, onRemoveCallback) {
                    var notification = null;
                    
                    // complex content notification - in this case title 
                    // represents settings object
                    if(typeExist(type) && litui.utils.isObject(title) && arguments.length === 2)
                        notification = produceWithSetup(type, title);
                    else if (!typeExist(type) || !chechMessageAndTitle(message, title)) {
                        return;
                    }
                    // simple content notification
                    else{
                        notification = new Notification(type, title, message, ttl, false, icon, data);
                        notification.setOnRemoveCallback(onRemoveCallback);
                    }
                    
                    var oldNotification = options.grouping ? notificationExists(notification) : undefined;
                    if (angular.isDefined(oldNotification)) {
                        oldNotification.increment();
                        oldNotification.restartTimer();
                    }
                    else {
                        notification.startTimer();
                        notifications.push(notification);
                    }
                    return notification;
                }
                
                function produceWithSetup(type, settings){
                    var s = litui.lang.merge({
                        title: undefined,
                        message: undefined,
                        ttl: undefined,
                        sanitize: undefined,
                        icon: undefined,
                        data: undefined,
                        markup: undefined,
                        onRemoveCallback: undefined,
                        disableCloseBtn: false,
                        actions: []
//                        resolve: undefined // support if we must
                    }, settings);
                    
                    var isComponent = litui.utils.isSet(s.markup) || litui.utils.isSet(settings.component);
                    var content = isComponent? s.markup : s.message;

                    var notif = new Notification(type, s.title, isComponent? "" : content, s.ttl, s.sanitize, s.icon, s.data, s.actions);
                    notif.disableCloseBtn = s.disableCloseBtn;
                    notif.setOnRemoveCallback(settings.onRemoveCallback);
                    notif.isComponent = isComponent;
                    notif.component = settings.component;
                    return notif;
                }
                
                function onAction(e, action, notification){
                    // every action callback gets context input, which carries 
                    // methods to work with current notification 
                    action.onSelect(e, {
                        notification: notification,
                        close: function(e){
                            removeNotification(notification);
                        }
                    });
                }

                function getOptions() {
                    return options;
                }

                function getNotifications() {
                    return notifications;
                }

                function removeNotification(notification) {
                    if (angular.isUndefined(notification)) {
                        return;
                    }
                    notification.stopTimer();
                    var removedNotifications = _.remove(notifications, function (n) {
                        return n.id === notification.id;
                    });
                    angular.forEach(removedNotifications, function (n) {
                        n.removed = true;
                        (n.onRemoveCallback || angular.noop)();
                    });
                }

                function typeExist(type) {
                    for (var i = 0; i < typeValues.length; i++) {
                        if (typeValues[i] === type) {
                            return true;
                        }
                    }
                    return false;
                }

                function chechMessageAndTitle(message, title) {
                    if (angular.isUndefined(message) && angular.isUndefined(title)) {
                        return false;
                    }
                    if (angular.isDefined(message) && angular.isString(message)) {
                        if (message.length > 0) {
                            return true;
                        }
                    }
                    if (angular.isDefined(title) && angular.isString(title)) {
                        if (title.length > 0) {
                            return true;
                        }
                    }
                    return false;
                }

                function notificationExists(notification) {
                    if (angular.isUndefined(notification)) {
                        return undefined;
                    }
                    for (var i = 0; i < notifications.length; i++) {
                        if (notificationEqual(notification, notifications[i])) {
                            return notifications[i];
                        }
                    }
                    return undefined;
                }

                function notificationEqual(n1, n2) {
                    if (angular.isUndefined(n1) || angular.isUndefined(n2)) {
                        return false;
                    }
                    var typeEqual = n1.type === n2.type;
                    var titleEqual = n1.title === n2.title;
                    var messageEqual = n1.message === n2.message;
                    return (typeEqual && titleEqual && messageEqual);
                }

                function getIcon(type, icon) {
                    if (angular.isDefined(icon) && !_.isNull(icon)) {
                        return icon;
                    }
                    switch (type) {
                        case types.SUCCESS:
                            return "icon-refresh";
                        case types.INFO:
                            return "icon-info";
                        case types.WARNING:
                        case types.ERROR:
                            return "icon-alert";
                    }
                }

                function generateID() {
                    var d = new Date().getTime();
                    var uuid = 'xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                        var r = (d + Math.random() * 16) % 16 | 0;
                        d = Math.floor(d / 16);
                        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                    });
                    return uuid;
                }
                
                // --------------------------
                // --- Notification model ---                
                // --------------------------
                function Notification(type, title, message, TTL, sanitize, icon, data, actions) {
                    this.id = generateID();
                    this.type = type;
                    this.icon = getIcon(type, icon);
                    this.message = message || "";
                    this.title = title || "";
                    this.count = 1;
                    this.TTL = TTL || options.TTL;
                    this.timerPromise;
                    this.data = data || {};
                    this.onRemoveCallback = angular.noop;
                    this.removed = false;
                    this.actions = actions || [];
                    this.disableCloseBtn = false;

                    if (angular.isUndefined(message) && angular.isDefined(title)) {
                        this.title = "";
                        this.message = title;
                    }

                    if (sanitize) {
                    }

                }

                Notification.prototype.setTitle = function (title) {
                    if (angular.isDefined(title)) {
                        this.title = title;
                    }
                };

                Notification.prototype.setMessage = function (message) {
                    if (angular.isDefined(message)) {
//                        this.message = $sce.trustAsHtml(message);
                        this.message = message;
                    }
                };

                Notification.prototype.setOnRemoveCallback = function (callback) {
                    if (angular.isFunction(callback)) {
                        this.onRemoveCallback = callback;
                    }
                };

                Notification.prototype.increment = function () {
                    this.count++;
                    return this;
                };

                Notification.prototype.startTimer = function () {
                    if (!angular.isNumber(this.TTL) || this.TTL <= 10 || angular.isDefined(this.timerPromise)) {
                        return this;
                    }
                    var thiz = this,
                            TTLtime = this.TTL + (options.animations ? 500 : 0);
                    this.timerPromise = $timeout(onTTL, TTLtime);
                    function onTTL() {
                        removeNotification(thiz);
                    }
                    return this;
                };

                Notification.prototype.stopTimer = function () {
                    if (angular.isUndefined(this.timerPromise)) {
                        return this;
                    }
                    $timeout.cancel(this.timerPromise);
                    this.timerPromise = undefined;
                    return this;
                };

                Notification.prototype.restartTimer = function () {
                    return this.stopTimer().startTimer();
                };

                Notification.prototype.remove = function () {
                    removeNotification(this);
                };

                return exposed;
            }
        }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiPaginationService', LituiPaginationServiceWrapper);
    
    /** @ngInject */
    function LituiPaginationServiceWrapper() {
        function LituiPaginationService(){
            
        }
        
        return new LituiPaginationService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiPagination', {
        controller: LituiPaginationCtrl,
        templateUrl: 'litui/com/info/litui-pagination/litui-pagination.html',
        bindings: {
            pagination: '<',
            settings: '=?'
        }
    });

    /** @ngInject */
    function LituiPaginationCtrl($element, $q) {
        var self = this;
        var $elt = $($element);

        var paginationOld = {foo: "w"};
        var isSelectPage = false;

        this.selectedPageLink = null;
        this.pageLinks = [];
        this.selectedItemsPerPage = null;

        this.$onInit = function () {
            litui.lang.prepareSettings({
                onPrevious: function () {},
                onNext: function () {},
                onPage: function () {},
                onPerPageChanged: function () {}
            }, this);

            litui.lang.prepareSettings({
                totalCount: -1,
                pageCount: -1,
                itemPerPageCount: 200,
                currentPage: 0,
                availablePerPage: null
            }, this, 'pagination');
        };

        this.$doCheck = function () {
            if (!litui.utils.equals(paginationOld, self.pagination) && !isSelectPage) {
                generatePageLinks();
                paginationOld = litui.lang.copy(self.pagination);
            }
        };

        this.onPreviousPage = function () {
            if (self.pagination.currentPage > 0) {
                self.pagination.currentPage--;
            }
            return selectPageLink(self.pageLinks[self.pagination.currentPage], self.settings.onPrevious);
        };

        this.onNextPage = function () {
            if (self.pagination.currentPage < self.pagination.pageCount - 1) {
                self.pagination.currentPage++;
            }
            return selectPageLink(self.pageLinks[self.pagination.currentPage], self.settings.onNext);
        };

        this.onFirstPage = function () {
            self.pagination.currentPage = 0;
            return selectPageLink(self.pageLinks[self.pagination.currentPage], self.settings.onNext);
        };

        this.onLastPage = function () {
            self.pagination.currentPage = self.pagination.pageCount - 1;
            return selectPageLink(self.pageLinks[self.pagination.currentPage], self.settings.onNext);
        };

        this.onSelectPage = function (e, pageLink) {
            isSelectPage = true;
            self.pagination.currentPage = pageLink.linkValue;
            return selectPageLink(pageLink, self.settings.onPage).then(function () {
                isSelectPage = false;
            });
        };
        
        this.onPaginationItemsChanged = function(){
            self.pagination.currentPage = 0;
            $q.when(self.settings.onPerPageChanged(self.pagination));
        };
        

        function selectPageLink(pageLink, onSelected) {
            self.selectedPageLink = pageLink;
            return litui.async.when(function () {
                return setHolderPosition(pageLink.linkValue);
            }()).then(function () {
                return onSelected(pageLink.linkValue, self.pagination);
            });
        }

        function setHolderPosition(currentValue) {
            var $holder = $element.find('.litui-pagination-links-holder-inner');
            var $parent = $holder.parent();
            
            if(litui.utils.isUndefined(currentValue))
                currentValue = self.pagination.currentPage;
            var totalW = 0;
            var parentW = 200;
            var unitW = 28;

            $holder.find('button').width(unitW);
            parentW = (unitW) * 10;
            totalW = (unitW) * self.pagination.pageCount;

            $parent.width(parentW);
            $holder.width(totalW);

            var offset = 0;
            if (currentValue < 9) {
                offset = 0;
            } else if (currentValue > self.pagination.pageCount - 10) {
                offset = -(self.pagination.pageCount * unitW - parentW);
            } else {
                offset = -currentValue * unitW + (parentW / 2) - unitW / 2;
            }


            $holder.css('left', litui.utils.numToPx(offset));
//            
            TweenMax.to($holder, 1.5, {
                left: offset
            });
        }
        
        function generatePageLinks() {
            if (self.pagination.pageCount === self.pageLinks.length)
                return;

            var pageLinks = [];
            for (var i = 0; i < self.pagination.pageCount; i++) {
                pageLinks.push({
                    linkValue: i
                });
            }

            self.pageLinks = pageLinks;

//            if(litui.utils.isNull(self.selectedPageLink))
            self.selectedPageLink = self.pageLinks[0];

            litui.async.delay(function () {
                setHolderPosition();
            });
        }
    }
})();
'use strict';

/**
 * @description This is directive for tooltip component. Can accept tms-position = [top | right | bottom | left] argument which will define the position of displayed tooltip.
 */
angular.module('litui').directive('lituiTooltip', [
    'LituiTooltipHandler', 'lituiTranslate',
    function (LituiTooltipHandler, lituiTranslate) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                content: '@lituiTooltip'
            },
            link: function ($scope, elem, attrs) {
                var val = attrs.lituiTooltip;
                
                var t = new LituiTooltipHandler($scope, {
                    element: elem,
                    text: lituiTranslate($scope.content),
                    type: 'tooltip',
                    position: attrs.position,
                    delay: attrs.delay || 1.5
                });
                
                // make content observable
                $scope.$watch('content', function(){  
                    t.update(lituiTranslate($scope.content));
//                    console.log("CHANGE T CONTENT: %o, %o", $scope.content);
                });

                //If the scope is destroyed
                $scope.$on('$destroy', function () {
                    onDestroy();
                });

                function onDestroy() {
                    if (angular.isDefined(t) && (t !== null)) {
                        t.destroy();
                        t = null;
                    }
                    elem.off('$destroy');
//                    console.log("tooltip destroyed");
                }
            }
        };
    }
]);
'use strict';

/**
 * @description Represents tooltip component behaviour. This module comes with class LituiTooltip and enum LituiTooltipTypeE, but unwrapps LituiTooltip class.
 * @ngdoc function
 * @name litui.directive.class:LituiTooltipHandler 

 */
angular.module('litui').factory('LituiTooltipHandler', [
'$compile',
function($compile){
    // this will set unique index for tooltips. it auto-increments.
    var tooltipIndexer = 0;

    /**
     * LituiTooltip type enumerator. Possible values: LituiTooltip, Hint, Error.
     * 
     * @type {Object}
     */
    var LituiTooltipTypeE = {
        Tooltip: "tooltip",
        Hint: "hint",
        Error: "error"
    };


    /**
     * @description Constructs new tooltip with given options.
     * @constructor
     * @ngdoc function
     * @name LituiTooltipHandler
     * @methodOf litui.directive.class:LituiTooltip 
     * @param {Object} options Options for tooltip.
     */
    var LituiTooltipHandler = function($scope, options){
        var self = this;

        var defSettings = {
            element: undefined,
            text: undefined,
            onHover: true,
            type: LituiTooltipTypeE.Tooltip,
            position: 'top',
            offset: {
                top: 0,
                left: 0
            },
            parentSelector: null,
            layerSelector: '#litui-tooltip-layer',
            delay: 1.5,
            fadeLength: 0.2,
            isError: false
        };

        // ---------------
        // -- VARIABLES --
        // ---------------
        var tooltipSelector = '.tooltip-holder';
        var type = "tooltip";
        var settings = { };

        // handle display because of delay
        var visible = false;
        var text;
        var $elt; // element
        var index;
        var showTimer;
        var observerTimer;
        var $tooltip;
        
        self.LituiTooltipTypeE = LituiTooltipTypeE;


        // -----------
        // -- LOGIC --
        // -----------
        /**
         * @description Creates new tooltip with given options. It's called when LituiTooltipHandler object is created. 
         * @constructor
         * @ngdoc function
         * @name c
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {Object} opts Options for tooltip.
         */
        self.c = function(opts){      
            if(_.isUndefined(opts)){
                console.error("Error creating tooltip. LituiTooltipHandler needs to have properties element and text. No settings were given.");
                return ; 
            }
            else if(_.isUndefined(opts.element) || _.isUndefined(opts.text)){
                console.error("Error creating tooltip. LituiTooltipHandler needs to have properties element (%o) and text (%o).", opts.element, opts.text);
                return ; 
            }

            // set settings
            settings = $.extend(defSettings, opts);

            // set text value
            $scope.text = settings.text;

            if($(settings.element).length > 0){           
                settings.isError = (settings.type === LituiTooltipTypeE.Error)? true : false;
                settings.isHint = (settings.type === LituiTooltipTypeE.Hint)? true : false;

                // create layer, if doesn't exist
                if($(settings.layerSelector).length === 0){
                    $('body').append('<div id="litui-tooltip-layer"></div>');
                }

                // HOVER - register event handler
                self.listen(settings.onHover); // default to true
            }
        };

        /**
         * Create tooltip element. When created it's hidden. It will be shown when hovering element.
         */
        var createLituiTooltip = function(){            
            index = tooltipIndexer; // set index
            tooltipSelector = '#tooltip_' + index; // set tooltip element selector

            // create dummy content element somewhere in the layer. It's used for setting width of the content, because it can't be set automatically...
            // it's more of a hack to force scope evaluation with $compile to get the real value of text and with it the width of the tooltip and than render actual
            // tooltip
            $(settings.layerSelector).append('<div id="dummy-tooltip-content_'+ index +'">' + $scope.text + '</div>');
            $compile($('dummy-tooltip-content_'+ index +'').contents())($scope);
            
            var contentWidth = $('#dummy-tooltip-content_'+ index).width();
            $('#dummy-tooltip-content_'+ index).remove(); // remove dummy content element

            // create
            var tpl = getViewTemplate();            

            // add to tooltip layer
            $(settings.layerSelector).append(tpl);

            // set inner width. inner's max width will block this, if content width > inner's max width.
            $(tooltipSelector + ' .tooltip-inner').width(contentWidth);

            // assign tooltip DOM elt
            $tooltip = $('#litui-tooltip-layer ' + tooltipSelector);
            
//            console.log("LituiTooltip::create() -> tooltip %o", tooltipSelector);
        };

        /**
         * @description Prepare tooltip. It creates, tests position, sets observer and styles tooltip.
         * @ngdoc function
         * @name prepareLituiTooltipHandler
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.prepareLituiTooltip = function(){
            // create tooltip
            createLituiTooltip();

            // test position to verify tooltip is displayed inside the screen
            if(!testAxisPosition()){
                // re-create tooltip
                self.destroy();
                createLituiTooltip();
            }

            if(settings.isHint){
                $(tooltipSelector).addClass('hint');
                settings.delay = 0.5;
                settings.offset = {
                    top: -5,
                    left: 0
                };
            }
            else if(settings.isError){
                $(tooltipSelector).addClass('error');
            }

            tooltipIndexer++;
            observeEltPosition();
        };

        /**
         * @description Shows tooltip.
         * @ngdoc function
         * @name show
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.show = function(){
            visible = true;
            
            stopTimers();            
            showTimer = setTimeout(function(){
//                console.log("TIMEOUT FOR SHOW::");
                if(visible && litui.utils.isDefined(self.getText()) && self.getText().length > 0){
                    // prepare tooltip - it creates and tests it - prepares for render
                    self.prepareLituiTooltip();
                    calcPosition();
                    
                    // position and view correction for mirrored
                    self.prepareLituiTooltip();
                    calcPosition();
                    
                    // show tooltip
                    $(tooltipSelector).fadeIn(settings.fadeLength*1000);
                }
            }, settings.delay*1000);
        };
        
        self.update = function(text){
            self.setText(text);
            
            if(visible){
                self.destroy();
                    
                // prepare tooltip - it creates and tests it - prepares for render
                self.prepareLituiTooltip();
                calcPosition();
                
                // position and view correction for mirrored
                self.prepareLituiTooltip();
                calcPosition();

                // (re)show tooltip
                $(tooltipSelector).css('display', 'block');
            }
        };

        /**
         * @description Hides displayed tooltip. It also removes tooltip after it has been hidden.
         * @ngdoc function
         * @name hide
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.hide = function(){
            visible = false;

            stopTimers();

//            console.log("hide:: %o", $(tooltipSelector));
            $(tooltipSelector).fadeOut(settings.fadeLength*0.5*1000, function(){
//                self.destroy();
            });
        };

        /**
         * @description Displays tooltip.
         * @ngdoc function
         * @name display
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.display = function(){
            visible = true;
            $(tooltipSelector).css({
                display: 'block'
            });
        };

        /**
         * @description Hides displayed tooltip. It doesn't remove tooltip after it has been hidden.
         * @ngdoc function
         * @name undisplay
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.undisplay = function(){
            visible = false;
            $(tooltipSelector).css({
                display: 'none'
            });
        };

        /**
         * @description Destroys tooltip.
         * @ngdoc function
         * @name destroy
         * @methodOf litui.directive.class:LituiTooltipHandler 
         */
        self.destroy = function(){
            stopTimers();

            $(tooltipSelector).remove();      
//            console.log("LituiTooltip::destroy() -> tooltip %o, tooltip elt: %o", tooltipSelector, $(tooltipSelector));
        };

        /**
         * @description Sets tooltip text.
         * @ngdoc function
         * @name setText
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {string} txt Text to be displayed.
         */
        self.setText = function(txt){
            $scope.text = txt;
//            self.render();
        };
        
        self.getText = function(){
            return $scope.text;
        };

        /**
         * @description Gets tooltip ID (selector).
         * @ngdoc function
         * @name getId
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {String} tooltip selector
         */
        self.getId = function(){
            return tooltipSelector;
        };

        /**
         * @description Gets tooltip binding element.
         * @ngdoc function
         * @name getElement
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {HTMLElement} binded element.
         */
        self.getElement = function(){
            return $elt.get(0);
        };

        /**
         * @description Sets tooltip binding element.
         * @ngdoc function
         * @name setElement
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {HTMLElement} elt Binded element.
         */
        self.setElement = function(elt){
            $elt = $(elt);
        };

        /**
         * @description Calculates if tooltip's binded element is visible (Y axis ONLY) in scrollable area.
         * @ngdoc function
         * @name inView
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {string} holder scrollable area selector
         */
        self.inView = function(holder){
            if($elt.offset().top - $(holder).offset().top < 0){
                self.undisplay();
            }
            else{
                self.display();
            }
        };


        /**
         * @description Register event handler for hover.
         * @ngdoc function
         * @name listen
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {Booelan} onHover TRUE - tooltip will be displayed on hover event, else it will be displayed by default.
         */
        self.listen = function(onHover){         
            // hover
            if(onHover){
                $(settings.element).unbind('hover').hover(function(e){
                    e.preventDefault();

                    $elt = $(this);
//                    console.log("hover elt ON (visible: %o, index: %o, text: %o)", visible, index, text);
                    // show tooltip
                    if(!visible)
                        self.show();
                }, function(){
//                    console.log("hover elt OFF (visible: %o)", visible);
                    self.hide();
                });
            }
            else{
                // make element available to tooltip
                $elt = $(settings.element);
            }
        };


        // --------------------
        // -- POSITION LOGIC --
        // --------------------     
        /**
         * @description Sets tooltip position descriptor.
         * @ngdoc function
         * @name setPosition
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @param {string} position Value defines where tooltip will be spawned. Possible values: top | right | bottom | left,
         * default: top
         */
        self.setPosition = function(position){
            if(position === "top" || position === "right" || position === "left" || position === "bottom")
                settings.position = position;
            else
                throw "Failed to set tooltip position " + position + ". LituiTooltipHandler only supports top and right positions.";
        };

        /**
         * @description Calculates top position. X is general X coordinate.
         * @ngdoc function
         * @name calcTopPosition
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcTopPosition = function(){
            return {
                x: self.calcGeneralX(), 
                y: $elt.offset().top - $(tooltipSelector).outerHeight() + settings.offset.top
            };
        };

        /**
         * @description Calculates right position. Y is general Y coordinate.
         * @ngdoc function
         * @name calcRightPosition
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcRightPosition = function(){
            return {
                x: $elt.offset().left + $elt.outerWidth() + settings.offset.left, 
                y: self.calcGeneralY()
            };
        };

        /**
         * @description Calculates bottom position. X is general X coordinate.
         * @ngdoc function
         * @name calcBottomPosition
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcBottomPosition = function(){
            return {
                x: self.calcGeneralX(), 
                y: $elt.offset().top + $elt.outerHeight() + settings.offset.top
            };
        };

        /**
         * @description Calculates top position. Y is general Y coordinate.
         * @ngdoc function
         * @name calcLeftPosition
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcLeftPosition = function(){
            return {
                x: $elt.offset().left - $(tooltipSelector).outerWidth() + settings.offset.left, 
                y: self.calcGeneralY()
            };
        };

        /**
         * @description Calculates general X coordinate. This coordinate is the same for positions TOP and BOTTOM.
         * @ngdoc function
         * @name calcGeneralX
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcGeneralX = function(){
            return $elt.offset().left + $elt.outerWidth()/2 - $(tooltipSelector).outerWidth()/2 + settings.offset.left;
        };

        /**
         * @description Calculates general Y coordinate. This coordinate is the same for positions LEFT and RIGHT.
         * @ngdoc function
         * @name calcGeneralY
         * @methodOf litui.directive.class:LituiTooltipHandler 
         * @returns {Object} object with properties x and y, which represent coordinates.
         */
        self.calcGeneralY = function(){
            return $elt.offset().top + $elt.outerHeight()/2 - $(tooltipSelector).height()/2 + settings.offset.top;
        };

        /**
         * Calculate tooltip position. It automatically calculates coordinates dependent of tooltip position descriptor. LituiTooltipHandler
         * position TOP and BOTTOM share the same X position, tooltip position LEFT and RIGHT share the same Y position.
         */
        var calcPosition = function(){
            if(!_.isUndefined($elt)){
                var coord = {
                    x: 0,
                    left: 0
                };

//                console.log("calc position: %o", settings.position);

                switch(settings.position){
                    case 'top':
                        coord = self.calcTopPosition();
                        break;
                    case 'right':
                        coord = self.calcRightPosition();
                        break;
                    case 'bottom':
                        coord = self.calcBottomPosition();
                        break;
                    case 'left':
                        coord = self.calcLeftPosition();
                        break;
                }
                setCoordinates(coord.x, coord.y);
            }
        };

        /**
         * Set tooltip position.
         */
        var setCoordinates = function(x, y){
//            console.log("X: %o, Y: %o", x, y);
            $(tooltipSelector).css({
                top: y,
                left: x
            });
        };


        // ----------------------
        // -- HELPER FUNCTIONS --
        // ----------------------
        /**
         * Custom subscription method for element change coordinates event. It's based on timer 50 ms span.
         */
        var observeEltPosition = function(prevVal){
            observerTimer = setTimeout(function(){
                if(!_.isUndefined($elt) && $elt.css('display').length > 0){                    
                    if(!_.isUndefined(prevVal) && ($elt.offset().left !== prevVal.left || $elt.offset().top !== prevVal.top)){
                        calcPosition();
                    }
                    observeEltPosition($elt.offset());
                }
                else{
                    $(tooltipSelector).css('display', 'none');
                    clearTimeout(observerTimer);
                }
            }, 50);
        };

        /**
         * Test tooltip position. If it's detected that tooltip will not fully be positioned inside of the screen, method determines to which position it must be placed. If position 
         * is not valid its mirror position is than set.
         */
        var testAxisPosition = function(){
            switch(settings.position){
                case "top":
                    var pos = self.calcTopPosition();
                    if(pos.y < 0){
                        settings.position = "bottom";
                    }

                    transformAxisX(pos.x);
                    break;
                case "bottom":
                    var pos = self.calcBottomPosition();
                    if(pos.y + $(tooltipSelector).outerHeight() > $(document).height()){
                        settings.position = "top";
                    }

                    transformAxisX(pos.x, 'top');
                    break;
                case "left":
                    if(self.calcLeftPosition().x < 0){
                        settings.position = "right";
                        return false;
                    }
                    break;
                case "right":
                    if(self.calcBottomPosition().x + $(tooltipSelector).outerWidth() > $(document).width()){
                        settings.position = "left";
                        return false;
                    }
                    break;
            }
            return true;
        };

        /**
         * Spawn arrow at the center of the element.
         */
        var arrowXtoCenter = function(vposition, hoffset){
            // move arrow to center of element
            var rightX = $(tooltipSelector).outerWidth() - $(settings.element).outerWidth() + $(settings.element).outerWidth()/2; // x calculated for right side positioning

            var arrowX = (hoffset && hoffset === 'right')? rightX : $(settings.element).outerWidth()/2;
            $(tooltipSelector).css('background-position', arrowX +'px '+ (vposition || 'bottom'));
        };

        var transformAxisX = function(x, vposition){            
            if(x < 0){
                $(tooltipSelector).margin({
                    left: x*(-1) + $(settings.element).offset().left
                });

                arrowXtoCenter(vposition);
            }
            else if(x + $(tooltipSelector).outerWidth() > $(document).width()){
                var p = (x + $(tooltipSelector).outerWidth()) - ($(settings.element).offset().left + $(settings.element).outerWidth());
                $(tooltipSelector).margin({
                    left: -p
                });

                arrowXtoCenter(vposition, 'right');
            }
        };

        // -----------------------
        // -- TOOLTIP TEMPLATES --
        // -----------------------
        /**
         * Get tooltip HTML template.
         */
        var getViewTemplate = function(){
            var arrowClass = "tooltip-arrow-bottom";

            // set arrow - depends on position descriptor
            switch(settings.position){
                case 'top':
                    arrowClass = "tooltip-arrow-bottom";
                    break;
                case 'right':
                    arrowClass = "tooltip-arrow-left";
                    break;
                case 'bottom':
                    arrowClass = "tooltip-arrow-top";
                    break;
                case 'left':
                    arrowClass = "tooltip-arrow-right";
                    break;
            }
//            console.log('LituiTooltip::getViewTemplate() -> arrow class: .%o, position descriptor: %o, content: %o', arrowClass, settings.position, settings.text);
            return '<div id="tooltip_' + index + '" class="litui-tooltip '+ arrowClass +'"><div class="tooltip-inner">' + $scope.text + '</div></div>';
        };

        var stopTimers = function(){
            if(!_.isUndefined(observerTimer))
                clearTimeout(observerTimer);

            if(!_.isUndefined(showTimer))
                clearTimeout(showTimer);
        };
        
        /**
         * Renders tooltip with angular $compile.
         */
        self.render = function(){
            if(litui.utils.isDefined($tooltip)){
                $compile($tooltip.contents())($scope);
            }
        };

        // do construct self
        self.c(options);
        return self;
    };
    
    return LituiTooltipHandler;
}]);
"use strict";

(function () {
    angular.module('litui').service('lituiUserInfoService', LituiUserInfoServiceWrapper);

    /** @ngInject */
    function LituiUserInfoServiceWrapper() {
        function LituiUserInfoService() {
            this.signatureDef = [
                'firstName',
                'lastName'
            ];
            this.identityDef = [
                'username'
            ];

            this.detailsDef = {
                username: {
                    label: 'LITUI.USER.USERNAME'
                },
                firstName: {
                    label: 'LITUI.USER.FIRST_NAME'
                },
                lastName: {
                    label: 'LITUI.USER.LAST_NAME'
                },
                userRole: {
                    roleName: {
                        label: 'LITUI.USER.ROLE_NAME'
                    }
                }
            };
        }

        return new LituiUserInfoService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiUserInfo', {
        controller: LituiUserInfoCtrl,
        templateUrl: 'litui/com/info/litui-user-info/litui-user-info.html',
        bindings: {
            model: '=',
            infoType: '@?'
        }
    });

    /** @ngInject */
    function LituiUserInfoCtrl(lituiUserInfoService) {
        
        this.signatureDef = null;
        this.identityDef = null;
        
        
        this.$onInit = function(){
            if(litui.utils.isUndefined(this.infoType)){
                this.infoType = 'signature';
            }
            
            this.signatureDef = lituiUserInfoService.signatureDef;
            this.identityDef = lituiUserInfoService.identityDef;        

            this.identityDetailsTrigger = {
                popover: {
                    bindedPosition: 'bottom',
                    component: {
                        template: '<litui-details details-data="details.data" details-definition="details.definition"></litui-details>',
                        params: {
                            details: {
                                data: this.model,
                                definition: lituiUserInfoService.detailsDef
                            }
                        }
                    }
                }
            };
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiUserProfileInfoService', LituiUserProfileInfoServiceWrapper);

    /** @ngInject */
    function LituiUserProfileInfoServiceWrapper(lituiAppMenuService) {
        function LituiUserProfileService(){
            
        }
        
        LituiUserProfileService.prototype.open = function(data, detailsDef, actionMenu){
            lituiAppMenuService.showDrawer(null, {
                header: {
                    title: 'LITUI.USER_PROFILE.TITLE'
                },
                component: {
                    template: '<litui-user-profile-info data="data" settings="settings"></litui-user-profile-info>',
                    params: {
                        data: data,
                        settings: {
                            details: {
                                detailsDef: detailsDef
                            },
                            actionMenu: actionMenu
                        }
                    }
                }
            });
        };
        
        LituiUserProfileService.prototype.close = function(){
            lituiAppMenuService.hideDrawer();
        };
        
        return new LituiUserProfileService();
    }
})();
'use strict';

(function () {
    angular.module('litui').component('lituiUserProfileInfo', {
        templateUrl: 'litui/com/info/litui-user-profile-info/litui-user-profile-info.html',
        controller: LituiUserProfileCtrl,
        bindings: {
            data: '=',
            settings: '='
        }
    });

    /** @ngInject */
    function LituiUserProfileCtrl($element, $state) {
        var self = this;
        var $elt = $($element);
        
        this.onLogout = function(){
            litui.security.logout().then(function(){
                $state.go('app.login');
            });
        };
        
        this.$onInit = function () {

        };
    }
})();
'use strict';

(function () {
    var anglepickerid = 0;

    angular.module('litui').component('lituiAnglePicker', {
        controller: LituiAnglePickerCtrl,
        templateUrl: 'litui/com/input/litui-angle-picker/litui-angle-picker.html',
        require: '^ngModel',
        bindings: {
            ngModel: '=',
            ngDisabled: '=?',
            onChange: '&?',
            onStart: '&?',
            onEnd: '&?',
            name: '@?'
        }
    });

    /** @ngInject */
    function LituiAnglePickerCtrl($element, $timeout, $scope) {
        var self = this;
        var $elt = $($element);
        var $handle = null;
        var $circle = null;

        // for uniqueness
        anglepickerid++;

        this.id = anglepickerid;
        this.radius = 0;
        this.center = null;
        this.events = null;
        
        this.$onInit = function(){
            $handle = $elt.find('.litui-angle-picker-handle');
            $circle = $elt.find('.litui-angle-picker-circle');
            
            this.radius = $circle.outerWidth()/2;
            this.center = {
                x: $circle.outerWidth()/2 - $handle.outerWidth()/2, //this.radius - $handle.outerWidth(),
                y: $circle.outerHeight()/2 - $handle.outerHeight()/2 //this.radius - $handle.outerWidth()
            }; 
            
            this.events = {
                onChange: function (val) {
                    // val is in deg
                    if(litui.utils.isDefined(val)){
                        if(!isValueAllowed(val)){
                            self.$$validity = false;
                            return;
                        }
                        self.$$validity = true;
                        setAngleValue(litui.utils.degToRad(val));
                        positionHandle();
                    }

                    self.ngModel = self.angleRad;

                    if (litui.utils.isFunction(self.onChange)) {
                        var e = {
                            $elt: $element,
                            ctrl: self
                        };
                        self.onChange({e: e, val: self.ngModel});
                    }
                }
            };

            $handle.drag('start', function(e){
                if(litui.utils.isFunction(self.onStart))
                    self.onStart(e);
            }).drag('end', function(e){
                if(litui.utils.isFunction(self.onEnd))
                    self.onEnd(e);
            }).drag(function (ev, dd) {
                setAngleValue(Math.atan2(ev.pageX - self.center.x - $circle.offset().left, ev.pageY - self.center.y - $circle.offset().top));
                $timeout(function(){
                    setHandle();
                });
            });

            $scope.$on('LITUI_RESET_CONTROLS', function(e, defaultValue){
                setAngleValue(defaultValue[self.name]);
                setHandle();
            });

            setAngleValue(this.ngModel);
            setHandle();
        };
        
        function positionHandle(){
            var x = self.center.x + (Math.sin( self.angleRad )) * self.radius;
            var y = self.center.y + (Math.cos( self.angleRad )) * self.radius;
            
            $handle.css({
                left: x,
                top: y
            });
        }
        
        function setHandle(){
            positionHandle();
            self.events.onChange();
        }
        
        function setAngleValue(val){
            self.$$validity = isValueAllowed(val);
            self.angleRad = val;
            self.angleDeg = Math.floor(litui.utils.radToDeg(val));
        }
        
        function isValueAllowed(val){
            if((litui.utils.isNumber(val)) || (litui.utils.isNumeric(val) && val.match(/^-?\d+\.?\d*$/)))
                return true;
            return false;
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiChecklistService', LituiChecklistServiceWrapper);
    
    /** @ngInject */
    function LituiChecklistServiceWrapper() {
        function LituiChecklistService(){
            
        }
        
        return new LituiChecklistService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiChecklist', {
        controller: LituiChecklistCtrl,
        templateUrl: 'litui/com/input/litui-checklist/litui-checklist.html',
        bindings: {
            items: '<',
            mapping: '=?',
            visibility: '=?'
        }
    });
    
    /** @ngInject */
    function LituiChecklistCtrl(){
        var self = this;
        
        this.$onInit = function(){
            this.inputField = {
                type: 'boolean'
            };
        };
        
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiIntervalService', LituiIntervalServiceWrapper);
    
    /** @ngInject */
    function LituiIntervalServiceWrapper(lituiCompileService) {
        function LituiIntervalService(){
            
        }
        
         LituiIntervalService.prototype.generateScale = function($elt, scale, scaleNumbers){
            for (var i = scale.range[0]; i <= scale.range[1]; i++) {
                scaleNumbers.push(i);
            }
            return litui.async.delay(function(){
                TweenMax.to($elt.find('.litui-interval-scale-number'), 0.2, {
                    opacity: 1
                });
            }, 100);
        };
        
        LituiIntervalService.prototype.getScaleNumberFromPosition = function($elt, x){
            var numbers = [];
            x = x - $elt.offset().left;
            $elt.find('.litui-interval-scale-number').each(function(){
                var $this = $(this);
                var tx = $this.offset().left - $elt.offset().left;
                numbers.push({
                    x: tx,
                    $elt: $this,
                    value: litui.utils.strToNum($this.attr('name'))
                });    
            });
            
            var nextNumber = null;
            for(var i = 0; i < numbers.length; i++){
                var number = numbers[i];
                if(i === numbers.length - 1){
                    break;
                }
                nextNumber = numbers[i+1];
                
                if(x >= number.x && x < nextNumber.x){
                    if(x < (nextNumber.$elt.offset().left - number.$elt.offset().left) * 0.5 + number.$elt.offset().left - $elt.parent().offset().left){
                        return number;
                    }
                    return nextNumber;
                }
            }
            
            if(x < 0)
                return numbers[0];
            return numbers[numbers.length - 1];
        }
        
        LituiIntervalService.prototype.positionScaleNumbers = function($elt){
            var totalW = $elt.width();
            var itemW = $elt.find('.litui-interval-scale-number').width();
            var eltCount = $elt.find('.litui-interval-scale-number').length;
            var remainingSpace = totalW - (itemW * eltCount);
            var margin = (remainingSpace / (eltCount - 1));
            
            $elt.find('.litui-interval-scale-number').each(function(i){
                var $this = $(this);
                if(i === 0){
                    $this.css('left', 0);
                    return;
                }
                $this.css('left', litui.utils.numToPx(i * margin + i * $this.width()));
            });
        };
        
        LituiIntervalService.prototype.generateRanges = function($elt, intervals, onChange){
            var self = this;
            var interval = intervals[0];
            var handleA = {
                label: interval[0],
                onDrag: function(e, dd, $handle){
                    var number = self.getScaleNumberFromPosition($elt, $handle.offset().left, $handle);
                    dd.value = number.value;
                    litui.async.delay(function(){
                        handleA.label = number.value;
                    });
                },
                onDragEnd: function(e, dd, $handle){
                    var $number = $elt.find('.litui-interval-scale-number[name=' + dd.value + ']');
                    var x = $number.offset().left;
                    compileScope.hooks.handleA.setPosition(x, true);
                    interval[0] = litui.utils.strToNum($number.attr('name'));
                    if(litui.utils.isFunction(onChange))
                        onChange(interval);
                }
            };
            var handleB = {
                label: interval[1],
                isRange: interval.length > 1,
                onDrag: function(e, dd, $handle){
                    var number = self.getScaleNumberFromPosition($elt, $handle.offset().left, $handle);
                    dd.value = number.value;
                    litui.async.delay(function(){
                        handleB.label = number.value;
                    });
                },
                onDragEnd: function(e, dd, $handle){
                    var $number = $elt.find('.litui-interval-scale-number[name=' + dd.value + ']');
                    compileScope.hooks.handleB.setPosition($number.offset().left, true);   
                    interval[1] = litui.utils.strToNum($number.attr('name'));
                    if(litui.utils.isFunction(onChange))
                        onChange(interval);
                }
            };
            var handleBar = {
                onDrag: function(){
                    handleBar.label = "D";
                },
                onDragEnd: function(){
                    handleBar.label = "E";
                }
            };
            
            var compileScope = {
                handleA: handleA,
                handleB: handleB,
                handleBar: handleBar,
                hooks: {}
            };
            
            return lituiCompileService.compile($elt.find('.litui-interval-scale'), {
                append: true,
                component: '<litui-range handle-a="handleA" handle-b="handleB" handle-bar="handleBar" hooks="hooks" name="litui-range-0" on-resize="onResize"></litui-range>'
            }, compileScope).then(function(com){
                $elt.find('litui-range').css('opacity', 0);
                return litui.async.delay(function(){
                    self.setIntervalPosition($elt, interval, compileScope.hooks.handleA.setPosition, compileScope.hooks.handleB.setPosition);
                    TweenMax.to($elt.find('litui-range'), 0.2, {
                        opacity: 1
                    });
                }, 100).then(function(){
                    return com; 
                });
            });
        };
        
        LituiIntervalService.prototype.setIntervalPosition = function($elt, interval, setPositionA, setPositionB, isAnimate){
            if(interval.length > 1){
                var $numberB = $elt.find('.litui-interval-scale-number[name=' + interval[1] + ']');
                setPositionB($numberB.offset().left, isAnimate);
            }
            
            var $numberA = $elt.find('.litui-interval-scale-number[name=' + interval[0] + ']');
            setPositionA($numberA.offset().left, isAnimate);
        };
        
        return new LituiIntervalService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiInterval', {
        controller: LituiIntervalCtrl,
        templateUrl: 'litui/com/input/litui-interval/litui-interval.html',
        bindings: {
            intervals: '=',
            scale: '<',
            onChange: '=?'
        }
    });

    /** @ngInject */
    function LituiIntervalCtrl($element, lituiIntervalService) {
        var self = this;
        var $elt = $($element);

        this.scaleNumbers = [];
        
        var rangeCom = null;
        
        this.$onInit = function () {
            litui.layoutMngr.provide().on('RESIZE_END', onResizeEnd);            
            return lituiIntervalService.generateScale($elt, self.scale, self.scaleNumbers).then(function(){
                lituiIntervalService.positionScaleNumbers($elt);
                return generateRanges();
            });
        };
        
        this.$onDestroy = function () {
            litui.layoutMngr.provide().off('RESIZE_END', onResizeEnd);
            destroyRanges();
        };
        
        this.onNumberSelected = function(e, numberValue){
            if(self.intervals[0].length === 1){
                var $number = $elt.find('.litui-interval-scale-number[name=' + numberValue + ']');
                if(litui.utils.nonNull(rangeCom)){
                    self.intervals[0][0] = litui.utils.strToNum($number.attr('name'));
                    rangeCom.$scope.handleA.label = self.intervals[0][0];
                    lituiIntervalService.setIntervalPosition($elt, self.intervals[0], rangeCom.$scope.hooks.handleA.setPosition, rangeCom.$scope.hooks.handleB.setPosition, true);
                    
                    if(litui.utils.isFunction(self.onChange))
                        self.onChange(self.intervals[0]);
                }
            }
        };

        function onResizeEnd() {            
            lituiIntervalService.positionScaleNumbers($elt);
            if(litui.utils.nonNull(rangeCom))
                lituiIntervalService.setIntervalPosition($elt, self.intervals[0], rangeCom.$scope.hooks.handleA.setPosition, rangeCom.$scope.hooks.handleB.setPosition);
            
        }
        
        function generateRanges(){
            return lituiIntervalService.generateRanges($elt, self.intervals, self.onChange).then(function(com){
                rangeCom = com;
            });
        }
        
        function destroyRanges(){
            if(litui.utils.nonNull(rangeCom))
                rangeCom = rangeCom.destroy();
        }
    }
})();
'use strict';

(function(){
    var numberpickerid = 0;
    
    angular.module('litui').component('lituiNumberPicker', {
        controller: LituiNumberPickerCtrl,
        templateUrl: 'litui/com/input/litui-number-picker/litui-number-picker.html',
        require: '^ngModel',
        bindings: {
            ngModel: '=',
            ngDisabled: '=?',
            step: '=?',
            min: '=?',
            max: '=?',
            symbol: '@?',
            stepControls: '=?',
            onChange: '&?',
            name: '@?'
        }
    });
    
    /** @ngInject */
    function LituiNumberPickerCtrl($element, $scope){
        var self = this;

        // for uniqueness
        numberpickerid++; 
        
        this.id = numberpickerid;
        this.value = null;
        this.events = null;

        this.$onInit = function(){
            // defaults
            if(litui.utils.isUndefined(this.step))
                this.step = 1;

            if(litui.utils.isUndefined(this.symbol))
                this.symbol = "";

            if(litui.utils.isUndefined(this.stepControls))
                this.stepControls = true;

            this.value = decorateSymbol(this.ngModel);

            this.events = {
                onChange: function(newValue){
                    var v = litui.utils.isUndefined(newValue)? stripSymbol(self.value) : newValue;

                    if(((litui.utils.isUndefined(self.min) || v >= self.min) && (litui.utils.isUndefined(self.max) || v <= self.max))){
                        setValue(v);
                    }
                },
                onIncrementValue: function(){   
                    self.events.onChange(stripSymbol(self.value) + self.step);              
                },
                onDecrementValue: function(){
                    self.events.onChange(stripSymbol(self.value) - self.step);
                }
            };

            $scope.$on('LITUI_RESET_CONTROLS', function(e, defaultValue){
                setValue(defaultValue[self.name]);
            });
        };
        
        function stripSymbol(val){
            return litui.utils.strToNum(self.symbol.length > 0? val.substring(0, val.length - self.symbol.length) : val);
        }
        
        function decorateSymbol(val){
            return val + self.symbol;
        }
        
        function setValue(v){
            self.value = decorateSymbol(v);
            self.ngModel = v;
            
            if(litui.utils.isFunction(self.onChange)){
                var e = {
                    $elt: $element,
                    ctrl: self
                };
                self.onChange({e: e, val: self.ngModel});
            }
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiStateSwitchService', LituiStateSwitchServiceWrapper);
    
    /** @ngInject */
    function LituiStateSwitchServiceWrapper() {
        function LituiStateSwitchService(){
            
        }
        
        return new LituiStateSwitchService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiStateSwitch', {
        controller: LituiStateSwitchCtrl,
        templateUrl: 'litui/com/input/litui-state-switch/litui-state-switch.html',
        bindings: {
            value: '=',
            settings: '=?',
            onChange: '=?'
        }
    });
    
    /** @ngInject */
    function LituiStateSwitchCtrl($element){
        var lituiLayoutMngr = litui.layoutMngr.provide();
        var self = this;
        var $elt = $($element);
        var lastValue = null;
        
        this.buttonLabel = '';
        
        
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                labelA: 'YES',
                labelB: 'NO',
                showStateLabel: true,
                showBackgroundStateLabels: false
            }, this);
            
            lastValue = this.value;
            
            setValue(self.value);
            lituiLayoutMngr.on('RESIZE', onResize);
        };
        
        this.$onDestroy = function(){
            lituiLayoutMngr.off('RESIZE', onResize);
        };
        
        this.onSelect = function(e){
            e.stopPropagation();
            e.preventDefault();
            
            setValue(!self.value);
        };
        
        function setValue(value){
            self.value = value;
            
            if(self.value){
                self.buttonLabel = self.settings.labelA;
                litui.tween.to($elt.find('button'), 0.2, {
                    left: 0
                });
                $elt.removeClass('litui-state-switch-state-b');
                $elt.addClass('litui-state-switch-state-a');
            }
            else{
                self.buttonLabel = self.settings.labelB;
                litui.tween.to($elt.find('button'), 0.2, {
                    left: $elt.find('.litui-state-switch-bar').width()/2
                });
                $elt.removeClass('litui-state-switch-state-a');
                $elt.addClass('litui-state-switch-state-b');
            }
            if(lastValue !== self.value && litui.utils.isFunction(self.onChange))
                self.onChange(value);
            
            lastValue = self.value;
        }
        
        function onResize(){
            setValue(self.value);
        }
    }
})();
'use strict';

/**
 * When default "upload" button is not displayed (depends on provided 
 * component settings):
 * - Component listens for 'lituiUploadExecute' event .
 * - Component emits 'lituiUploadDisable' (true|false) when upload is 
 *   disabled/enabled
 *   
 * Wrapps $upload service (ref: https://github.com/danialfarid/ng-file-upload)
 */
(function(){
    angular.module('litui').component('lituiUpload', {
        controller: TmsUploadCtrl,
        templateUrl: 'litui/com/input/litui-upload/litui-upload.html',
        bindings: {
            settings: '=',
            formData: '=?'
        }
    });
    
    /** @ngInject */
    function TmsUploadCtrl(lituiTranslate, $upload, $scope, $timeout, $element){
        var self = this;
        var $elt = $($element);
        
        this.showProgress = false;
        this.isFilePending = false;
        this.isValid = false;
        this.error = "";
        this.file = undefined;
        this.previewSrc = "";
        this.isPreviewMode = false;

        this.$onInit = function(){
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            // create config object
            this.fupload = litui.lang.merge({
                isCalcMd5: false,
                regex: this.settings.regex || litui.utils.regexForFormat(this.settings.format), ///\.(gif|jpg|jpeg|tiff|png)$/i,
                url: undefined,
                method: 'POST',
                showUploadBtn: true,
                showHitArea: true,
                enableProgressBar: false,
                text: 'LITUI.UPLOAD.TEXT',
                format: 'txt',
                hooks: {},
                onSuccess: function(payload){},
                onFail: function(err){},
                onProgress: function(e){},
                onClear: function(e){},
                onFileSelected: function(e){}
            }, this.settings);

            this.imageSettings = {
                scale: 'cover'
            };

            if(litui.utils.isUndefined(this.settings.hooks))
                this.settings.hooks = {};

            if(litui.utils.isDefined(this.settings.regex))
                this.fupload.regex = this.settings.regex;

            // URL MUST BE PROVIDED or throw error
            if(litui.utils.isUndefined(this.fupload.url))
                throw "No upload URL provided!";

            this.settings.hooks.onUpload = function(){
                return upload();
            };
            
            if(!this.fupload.showUploadBtn)
                $scope.$on('lituiUploadExecute', function(e, ev){
                    return upload(ev);
                });
        };
        
        
        
        // -----------------
        // --- FUNCTIONS ---
        // -----------------
        function isValid($files){
            // $files must be an array with at least 1 item, 
            // validation regex must be defined and pass
            var v = litui.utils.isArray($files) && $files.length > 0 &&
                    (litui.utils.isDefined(self.fupload.regex) && validateRegex(self.fupload.regex, $files[0].name));
            if(v)
                self.error = "";
            return v;
        }
        
        function clearState(){
            self.isFilePending = false;
            self.isValid = false;
            self.error = "";
            notifyUploadDisabled();
            self.fupload.onClear();
            self.file = undefined;
        }
        
        function notifyUploadDisabled(){
            if(!self.fupload.showUploadBtn){
                $scope.$emit('lituiUploadDisable', !self.isValid);
            }
        }
        
        function notifyUploadStarted(){
            $scope.$emit('lituiUploadStarted', true);
        }
        
        function calcMd5hash(file){
            if(!self.fupload.isCalcMd5 || litui.utils.isUndefined(file)) return;
            
            return litui.utility.encryption.md5FileHash(file).then(function(hash){
                self.md5hash = hash;
                $scope.$emit('lituiUploadImgMd5Hash', self.md5hash);
            });
        }
        
        function validateRegex(regex, value){
            if(litui.utils.isArray(regex)){
                var isValid = false;
                litui.utils.foreach(regex, function(i, reg){
                    if((reg).test(value)){
                        isValid = true;
                        return false;
                    }
                });
                return isValid;
            }
            return (self.fupload.regex).test(value);
        }
        
        function upload(ev){
            var p = self.onUpload(ev).then(function(){
                $scope.$emit('lituiUploadFinished', p);
            });
            return p;
        }
        
        // ------------------------
        // --- USER INTERACTION ---
        // ------------------------
        this.onFileSelect = function ($files) {
            var file = $files[0];
            if (isValid($files)){                
                clearState();
                
                self.file = file;
                self.isFilePending = true;
                self.isValid = true;
                calcMd5hash(file);
            }
            else{
                self.isValid = false;
                self.error = lituiTranslate('LITUI.UPLOAD.FORMAT_INVALID', {format: self.fupload.format, filename: file.name});
            }
            notifyUploadDisabled();
            self.fupload.onFileSelected(self.file, self.isValid, self.md5hash);
        };
        
        this.onClear = function(){
            clearState();
        };
        
        this.onUpload = function(ev){
            self.showProgress = true;
            self.isValid = false;

            notifyUploadDisabled();
            notifyUploadStarted();

            return $upload.upload({
                url: self.settings.url,
                method: 'POST',
                file: self.file,
                data: self.formData || {},
//                transformRequest: function(formData, a){
//                    console.log("Form data", formData, a("preference"));
//                    return JSON.stringify(formData);
//                }
                    
            }).progress(function (e) {
                self.fupload.uploadProgress = parseInt(100.0 * e.loaded / e.total);
                self.fupload.onProgress(e);
            }).success(function (payload) {
                self.fupload.uploadProgress = 100;
                self.fupload.onSuccess(payload);
                self.showProgress = false;
                self.isFilePending = false;
            }).error(function (msg, statusCode, fn, obj) {
                self.error = lituiTranslate('LITUI.UPLOAD.ERROR');
                self.fupload.onFail(msg, statusCode, obj);
                self.showProgress = false;
                self.isFilePending = false;
            });
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiUploadImg', {
        controller: LituiImgUpload,
        templateUrl: 'litui/com/input/litui-upload-img/litui-upload-img.html',
        bindings: {
            settings: '=',
            formData: '=?'
        }
    });
    
    /** @ngInject */
    function LituiImgUpload(lituiTranslate, $upload, $scope, $timeout, $element){
        var self = this;
        var $elt = $($element);
        
        this.showProgress = false;
        this.isFilePending = false;
        this.isValid = false;
        this.error = "";
        this.file = undefined;
        this.previewSrc = "";
        this.isPreviewMode = false;

        this.$onInit = function(){
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            // create config object
            this.fupload = litui.lang.merge({
                isCalcMd5: false,
                regex: /\.(gif|jpg|jpeg|tiff|png)$/i,
                url: undefined,
                method: 'POST',
                showUploadBtn: false,
                showHitArea: true,
                enableProgressBar: true,
                text: 'FILE_UPLOAD_DEFAUL_TEXT',
                format: 'image',
                onSuccess: function(payload){},
                onFail: function(err){},
                onProgress: function(e){},
                onClear: function(e){}
            }, this.settings);

            this.imageSettings = {
                scale: 'cover'
            };

            if(litui.utils.isDefined(this.settings.regex))
                this.fupload.regex = this.settings.regex;

            // URL MUST BE PROVIDED or throw error
            if(litui.utils.isUndefined(this.fupload.url))
                throw "No upload URL provided!";

            self.imgPosition = {
                top: 0,
                left: 0
            };

            self.lastImgPosition = {
                top: 0,
                left: 0
            };

            registerImagePositioning();


            // --------------------
            // --- SCOPE EVENTS ---
            // --------------------
            if(!this.fupload.showUploadBtn)
                $scope.$on('lituiUploadImgExecute', function(e, ev){
                    var p = self.onUpload(ev).then(function(){
                        $scope.$emit('lituiUploadImgFinished', p);
                    });
                });
        };
        
        // -----------------
        // --- FUNCTIONS ---
        // -----------------
        function isValid($files){
            // $files must be an array with at least 1 item, 
            // validation regex must be defined and pass
            var v = litui.utils.isArray($files) && $files.length > 0 &&
                    (litui.utils.isDefined(self.fupload.regex) && (self.fupload.regex).test($files[0].name));
            if(v)
                self.error = "";
            return v;
        }
        
        function clearState(){
            self.isFilePending = false;
            self.isValid = false;
            self.error = "";
            notifyUploadDisabled();
            self.fupload.onClear();
            self.file = undefined;
        }
        
        function notifyUploadDisabled(){
            if(!self.fupload.showUploadBtn){
                $scope.$emit('lituiUploadImgDisable', !self.isValid);
            }
        }
        
        function notifyUploadStarted(){
            $scope.$emit('lituiUploadImgStarted', true);
        }
        
        function calcMd5hash(file){
            if(!self.fupload.isCalcMd5 || litui.utils.isUndefined(file)) return;
            
            return litui.utility.encryption.md5FileHash(file).then(function(hash){
                self.md5hash = hash;
                $scope.$emit('lituiUploadImgMd5Hash', self.md5hash);
            });
        }
        
        function previewImg(imagesrc){
            self.isPreviewMode = true;

            if(litui.utils.isString(imagesrc)){
                self.previewSrc = imagesrc;
            }
            else{
                var reader = new FileReader();

                reader.onload = function (e) {
                    $timeout(function(){
                        self.previewSrc = e.target.result;
                    });

                };

                reader.readAsDataURL(imagesrc);
            }
        }
        
        function registerImagePositioning(){
            $elt.drag(function(e, dd){
                $timeout(function(){
                    if(!self.isPreviewMode)
                        return;
                    var y = dd.offsetY;
                    self.lastImgPosition.top = self.imgPosition.top;
                    self.imgPosition.top = y;
                });
            });
        }
        
        $scope.$on('lituiUploadImgPreview', function(e, obj){
            self.imgPosition = obj.position;
            previewImg(obj.imagesrc);
        });
        
        $scope.$on('lituiUploadImgPreviewExit', function(e, obj){
            self.isPreviewMode = false;
        });
        
        // ------------------------
        // --- USER INTERACTION ---
        // ------------------------
        this.onFileSelect = function ($files) {
            var file = $files[0];
            if (isValid($files)){                
                clearState();
                
                self.file = file;
                self.isFilePending = true;
                self.isValid = true;
                calcMd5hash(file);
                previewImg(file);
                $scope.$emit('lituiUploadImgSelected', true);
            }
            else{
                self.isValid = false;
                self.error = lituiTranslate('LITUI_FILE_UPLOAD_FORMAT_ERROR', {format: self.fupload.format, filename: file.name});
            }
            notifyUploadDisabled();
            
        };
        
        this.onClear = function(){
            clearState();
        };
        
        this.onUpload = function(ev){
            self.showProgress = true;
            self.isValid = false;

            notifyUploadDisabled();
            notifyUploadStarted();

            return $upload.upload({
                url: self.settings.url,
                method: 'POST',
                file: self.file,
                data: litui.lang.merge({
                    position: {
//                        top: $elt.height() / self.imgPosition.top,
//                        left: $elt.width() / self.imgPosition.left
                        top: self.imgPosition.top,
                        left: self.imgPosition.left
                    }
                }, self.formData || {}),
//                transformRequest: function(formData, a){
//                    console.log("Form data", formData, a("preference"));
//                    return JSON.stringify(formData);
//                }
                    
            }).progress(function (e) {
                self.fupload.uploadProgress = parseInt(100.0 * e.loaded / e.total);
                self.fupload.onProgress(e);
            }).success(function (payload) {
                self.fupload.uploadProgress = 100;
                self.fupload.onSuccess(payload);
                self.showProgress = false;
                self.isFilePending = false;
                $scope.$emit('lituiUploadImgSelected', false);
            }).error(function (msg, statusCode, fn, obj) {
                self.error = lituiTranslate('TMS_FILE_UPLOAD_ERROR');
                self.fupload.onFail(msg, statusCode, obj);
                self.showProgress = false;
                self.isFilePending = false;
                $scope.$emit('lituiUploadImgSelected', false);
            });
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiLayoutMngr', LituiLayoutMngrDirective);

    /** @ngInject */
    function LituiLayoutMngrDirective(lituiLayoutMngrService, $window) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'litui/com/layout/litui-layout-mngr/litui-layout-mngr.html',
            transclude: {
                panelNorth: '?panelNorth',
                panelSouth: '?panelSouth',
                panelWest: '?panelWest',
                panelEast: '?panelEast',
                panelCentral: '?panelCentral',
                panelViewHeader: '?panelViewHeader',
                panelViewFooter: '?panelViewFooter',
                panelRibbon: '?panelRibbon',
                panelViewport: '?panelViewport'
            },
            scope: {
                settings: '=?lituiLayoutMngr'
            },
            link: {
                pre: function ($scope, $elt) {
                    var self = this;
                    
//                if($($elt).find(lituiLayoutMngrService.defaultHolderEltSelector).length === 0)
//                if($(lituiLayoutMngrService.defaultHolderEltSelector).length === 0)
//                    throw "Active viewport not found. Make sure you've added an element with the class '.litui-active-viewport' to the element that represents active viewport";
                    
                    litui.lang.prepareSettings({
                        panelsConfig: undefined
                    }, $scope);
                    
                    this.drawers = lituiLayoutMngrService.drawers;
                    
                    var $vp = null;
                    lituiLayoutMngrService.setup($($elt), $scope.settings.panelsConfig).then(function(){
                        $vp = lituiLayoutMngrService.getPanelElt('viewport').find('.litui-active-viewport');
                        $vp.bind('scroll', scrollHandler);
                    });
                    
                    var viewportScrollDebounce = new litui.utility.DebounceHandler(function(){
                        lituiLayoutMngrService.trigger('VIEWPORT_SCROLL_END', $vp);
                    });
                    
                    var resizeDebounce = new litui.utility.DebounceHandler(function(){
                        lituiLayoutMngrService.trigger('RESIZE_END', $vp);
                    });
                    
                    angular.element($window).bind('resize', function () {
                        lituiLayoutMngrService.resize();
                        resizeDebounce.debounce();
                    });
                    
                    function scrollHandler(){
                        lituiLayoutMngrService.trigger('VIEWPORT_SCROLL', $vp);
                        viewportScrollDebounce.debounce();
                    }
                    
                    $scope.onSkipToContent = function () {
                        var mainContent = $('.litui-layout-panel-central')[0];
                        mainContent.tabIndex = -1;
                        mainContent.focus();
                    };

                    $scope.$on('$destroy', function () {
                        viewportScrollDebounce.cancel();
                        resizeDebounce.cancel();
                        lituiLayoutMngrService.off();
                        lituiLayoutMngrService.$layoutRootElt = null;
                        angular.element($window).unbind('resize');
                        if(!litui.utils.isNull($vp))
                            $vp.unbind('scroll', scrollHandler);
                    });

                }
            }
        };
    }
})();
'use strict';

/**
 * FULL SCREEN http://www.codingscripts.com/working-with-javascript-fullscreen-api/
 */
(function () {
    angular.module('litui').service('lituiLayoutMngrService', LituiLayoutMngrService);

    /** @ngInject */
    function LituiLayoutMngrService(lituiSubscribe, $timeout, $compile, $rootScope, lituiCompileService) {
        function LituiLayoutMngr() {
            this.$layoutRootElt = $('<div></div>');
            this.$$mode = 'DEFAULT'; // DEFAULT, SPLASH_MODE
//            this.defaultLayoutConfig = 'litui-layout-panel-east-none litui-layout-panel-view-footer-none litui-layout-panel-ribbon-collapsed';
            this.defaultLayoutConfig = 'litui-layout-panel-ribbon-collapsed';
            this.lastLayoutConfig = this.defaultLayoutConfig;
            this.isInitialized = false;
            this.isEnableTransitions = true;

            this.layoutPanels = [
                'north',
                'middle',
                'south',
                'east',
                'west',
                'central',
                'view-header',
                'ribbon',
                'viewport',
                'view-footer',
                'wizard'
            ];

            this.defaults = {
                visible: ['west', 'central', 'viewport', 'view-header', 'middle'],
                collapsed: ['west', 'ribbon', 'view-footer']
            };

            this.panelStructure = {
                pivot: {
                    width: 'central',
                    height: 'viewport'
                },
                link: {
                    width: ['east', 'west'],
                    height: ['north', 'central', 'south']
                }
            };

            this.panelRelation = {
                horizontal: [
                    {
                        holder: 'middle',
                        pivot: 'central',
                        panels: [
                            'west', 'central', 'east'
                        ]
                    }
                ],
                vertical: [
                    {
                        holder: 'root',
                        pivot: 'middle',
                        panels: [
                            'north', 'middle', 'south'
                        ]
                    },
                    {
                        holder: 'central',
                        pivot: 'viewport',
                        panels: [
                            'view-header', 'viewport', 'view-footer'
                        ]
                    }
                ]
            };

            this.panelState = {};
            this.$layoutPanelsLookup = {};
            this.panelComponents = {};
            
            this.drawers = {
                west: {
                    isDrawn: false
                }
            };
            
            lituiSubscribe.produce(this);

        }

        LituiLayoutMngr.prototype.setup = function ($layoutRootElt, panelsConfig) {
            var self = this;
            this.$layoutRootElt = $layoutRootElt;
            
            litui.layoutMngr.setProvider(this);

            return this.setupPanelConfig(panelsConfig).then(function () {
                self.isInitialized = true;
                self.trigger('INIT', self);
            });
        };

        LituiLayoutMngr.prototype.setupPanelConfig = function (panelsConfig) {
            var self = this;
            var d = litui.async.defer();
            this.setPanelConfig(panelsConfig);
            this.buildPanelsLookup();
            this.buildPanelsStates();

            var $overlay = $('<div style="position: absolute; top: 0; left: 0; background: #C0C0C0; width: 100%; height: 100%;"></div>');
            this.$layoutRootElt.append($overlay);
            $timeout(function () {
                for (var pname in self.panelState) {
                    var panel = self.panelState[pname];
                    if (!panel.visible)
                        self.hidePanel(pname);
                    else if (panel.collapsed)
                        self.collapsePanel(pname);
                }
                TweenMax.to($overlay, 0.2, {
                    opacity: 0,
                    onComplete: function () {
                        $overlay.remove();
                        d.resolve();
                    }
                });
            }, 300);
            return d.promise;
        };

        LituiLayoutMngr.prototype.setPanelConfig = function (panelsConfig) {
            if (litui.utils.isDefined(panelsConfig) && litui.utils.isDefined(panelsConfig.definition))
                this.layoutPanels = panelsConfig.definition;
            if (litui.utils.isDefined(panelsConfig) && litui.utils.isDefined(panelsConfig.structure))
                this.panelStructure = panelsConfig.structure;
            if (litui.utils.isDefined(panelsConfig) && litui.utils.isDefined(panelsConfig.visible))
                this.defaults.visible = panelsConfig.visible;
            if (litui.utils.isDefined(panelsConfig) && litui.utils.isDefined(panelsConfig.collapsed))
                this.defaults.collapsed = panelsConfig.collapsed;
        };

        LituiLayoutMngr.prototype.buildPanelsLookup = function () {
            this.$layoutPanelsLookup['root'] = this.$layoutRootElt;
            for (var i = 0; i < this.layoutPanels.length; i++) {
                var layoutPanel = this.layoutPanels[i];
                this.$layoutPanelsLookup[layoutPanel] = this.$layoutRootElt.find('.litui-layout-panel-' + layoutPanel);
            }
        };

        LituiLayoutMngr.prototype.buildPanelsStates = function () {
            for (var i = 0; i < this.layoutPanels.length; i++) {
                var layoutPanel = this.layoutPanels[i];
                var isVisible = this.defaults.visible.indexOf(layoutPanel) > -1;
                var isCollapsed = this.defaults.collapsed.indexOf(layoutPanel) > -1;
                this.panelState[layoutPanel] = {
                    visible: isVisible,
                    collapsed: isCollapsed
                };
            }
        };

        LituiLayoutMngr.prototype.getPanelElt = function (pname) {
            return this.$layoutPanelsLookup[pname];
        };

        LituiLayoutMngr.prototype.getLinkDirection = function (pname) {
            var widthLink = this.panelStructure.link.width;
            for (var i = 0; i < widthLink.length; i++) {
                if (widthLink[i] === pname)
                    return 'width';
            }
            var heightLink = this.panelStructure.link.height;
            for (var i = 0; i < heightLink.length; i++) {
                if (heightLink[i] === pname)
                    return 'height';
            }
        };

        LituiLayoutMngr.prototype.setLayoutConfiguration = function (layoutConfig) {
            var configs = layoutConfig.split(' ');
            this.$layoutRootElt.removeClass();
            this.$layoutRootElt.addClass('litui-layout');
            for (var i = 0; i < configs.length; i++) {
                this.$layoutRootElt.addClass(configs[i]);
            }
        };

        LituiLayoutMngr.prototype.showPanel = function (name, allowResize) {
            if (this.$$mode === 'SPLASH_MODE')
                return;
            
            if(litui.utils.isUndefined(allowResize))
                allowResize = true;
            
            var $elt = this.getPanelElt(name);
            
            if(litui.utils.isUndefined($elt))
                return litui.async.promise();
            
            $elt.css('display', 'block');
            this.panelState[name].visible = true;
            this.calcPanelRelation(name);
            this.trigger('SHOW_PANEL_' + name.toUpperCase());
            if(allowResize)
                this.resize();
            return litui.async.promise();
        };

        LituiLayoutMngr.prototype.hidePanel = function (name, allowResize) {            
            if (this.$$mode === 'SPLASH_MODE')
                return;
            
            if(litui.utils.isUndefined(allowResize))
                allowResize = true;
            
            var $elt = this.getPanelElt(name);
            
            if(litui.utils.isUndefined($elt))
                return litui.async.promise();
            
            $elt.css('display', 'none');
            this.panelState[name].visible = false;
            this.calcPanelRelation(name);
            this.trigger('HIDE_PANEL_' + name.toUpperCase());
            if(allowResize)
                this.resize();
            return litui.async.promise();
        };

        LituiLayoutMngr.prototype.calcPanelRelation = function (pname) {
            var self = this;

            // calc horizontal (width)
            for (var i = 0; i < this.panelRelation.horizontal.length; i++) {
                if (this.panelRelation.horizontal[i].panels.indexOf(pname) === -1)
                    continue;

                var holder = this.panelRelation.horizontal[i].holder;
                var pivot = this.panelRelation.horizontal[i].pivot;
                var pivotW = 0;
                for (var j = 0; j < this.panelRelation.horizontal[i].panels.length; j++) {
                    var panel = this.panelRelation.horizontal[i].panels[j];
                    if (panel === pivot || !this.panelState[panel].visible)
                        continue;
                    pivotW += this.getPanelElt(panel).outerWidth();
                }
                pivotW = this.getPanelElt(holder).innerWidth() - pivotW;
                this.getPanelElt(pivot).width(Math.floor(pivotW));
            }

            // calc vertical (height)
            for (var i = 0; i < this.panelRelation.vertical.length; i++) {
                if (this.panelRelation.vertical[i].panels.indexOf(pname) === -1)
                    continue;

                var holder = this.panelRelation.vertical[i].holder;
                var pivot = this.panelRelation.vertical[i].pivot;
                var pivotH = 0;
                for (var j = 0; j < this.panelRelation.vertical[i].panels.length; j++) {
                    var panel = this.panelRelation.vertical[i].panels[j];
                    if (panel === pivot || !this.panelState[panel].visible)
                        continue;
                    pivotH += this.getPanelElt(panel).innerHeight();
                }
                pivotH = this.getPanelElt(holder).innerHeight() - pivotH;
                this.getPanelElt(pivot).height(Math.floor(pivotH));
            }
            
            // drawers
            litui.utils.foreach(this.drawers, function(drawerName, drawer){
                drawer.$elt = self.$layoutRootElt.find('.litui-layout-panel-drawer-' + drawerName);
            });
        };

        LituiLayoutMngr.prototype.calcDivSum = function (calculants, calc) {
            var calcSum = 0;
            for (var i = 0; i < calculants.length; i++) {
                var cname = calculants[i];
                if (this.panelState[cname].visible)
                    calcSum += calc(cname);
            }
            return calcSum;
        };

        LituiLayoutMngr.prototype.isDisplayed = function (name) {
            return this.panelState[name].visible;
        };

        LituiLayoutMngr.prototype.isHidden = function (name) {
            return !this.panelState[name].visible;
        };

        LituiLayoutMngr.prototype.collapsePanel = function (name) {
            this.getPanelElt(name).addClass('litui-collapsed');
            this.panelState[name].collapsed = true;
            this.calcPanelRelation(name);
            this.trigger('COLLAPSE_PANEL_' + name.toUpperCase());
            this.resize();
            return litui.async.promise();
        };

        LituiLayoutMngr.prototype.expandPanel = function (name) {
//            if (this.$$mode === 'SPLASH_MODE')
//                return;
            if (!this.panelState[name].visible)
                return;
            this.getPanelElt(name).removeClass('litui-collapsed');
            this.panelState[name].collapsed = false;
            this.calcPanelRelation(name);
            this.trigger('EXPAND_PANEL_' + name.toUpperCase());
            this.resize();
            return litui.async.promise();
        };

        LituiLayoutMngr.prototype.isCollapsed = function (name) {
            return this.panelState[name].collapsed;
        };

        LituiLayoutMngr.prototype.isExpanded = function (name) {
            return !this.panelState[name].collapsed;
        };

        LituiLayoutMngr.prototype.showPanels = function (names, allowResize) {
            if(litui.utils.isUndefined(allowResize))
                allowResize = true;
            
            for (var i = 0; i < names.length; i++) {
                this.showPanel(names[i]);
            }
            
            if(allowResize)
                this.resize();
        };

        LituiLayoutMngr.prototype.hidePanels = function (names, allowResize) {
            if(litui.utils.isUndefined(allowResize))
                allowResize = true;
            
            var p = [];
            for (var i = 0; i < names.length; i++) {
                this.hidePanel(names[i], false);
            }
            
            if(allowResize)
                this.resize();
        };

        LituiLayoutMngr.prototype.enterSplashMode = function () {
            var self = this;
            
            if (this.$$mode === 'SPLASH_MODE')
                return;
            this.lastLayoutConfig = litui.lang.deepCopy(this.panelState);
            return litui.async.when(this.hidePanels(['west', 'east', 'view-header', 'view-footer'], false)).then(function(){
                self.$$mode = 'SPLASH_MODE';
                self.resize();
            });
        };

        LituiLayoutMngr.prototype.exitSplashMode = function () {
            if (this.$$mode !== 'SPLASH_MODE')
                return;
            this.$$mode = 'DEFAULT';
            for (var pname in this.lastLayoutConfig) {
                var config = this.lastLayoutConfig[pname];
                if (config.visible)
                    this.showPanel(pname, false);
            }
            this.resize();
        };

        LituiLayoutMngr.prototype.isSplashMode = function () {
            return this.$$mode === 'SPLASH_MODE';
        };

        LituiLayoutMngr.prototype.resetLayout = function () {
            this.setLayoutConfiguration(this.defaultLayoutConfig);
        };

        LituiLayoutMngr.prototype.enterFullScreen = function () {
            var elem = this.$layoutRootElt.get(0);
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            }
        };

        LituiLayoutMngr.prototype.exitFullScreen = function () {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        };

        LituiLayoutMngr.prototype.resize = function () {
            for (var i = 0; i < this.layoutPanels.length; i++) {
                this.calcPanelRelation(this.layoutPanels[i]);
            }
            
            this.trigger('RESIZE');
            this.trigger('RESIZE_END');
        };

        LituiLayoutMngr.prototype.find = function (selector) {
            return this.$layoutRootElt.find(selector);
        };

        LituiLayoutMngr.prototype.setPanelComponent = function (pname, component) {
            var $panel = this.getPanelElt(pname);
            var $elt = $('<litui-compile component="component"></litui-compile>');
            var sc = $rootScope.$new();
            sc.component = component;
            $compile($elt)(sc);
            $panel.html($elt);
            this.panelComponents[pname] = sc;
        };

        LituiLayoutMngr.prototype.unsetPanelComponent = function (pname) {
            this.panelComponents[pname].$destroy();
            litui.utils.deleteItem(pname, this.panelComponents);
        };
        
        LituiLayoutMngr.prototype.getDrawer = function (drawerName) {
            var drawer = this.drawers[drawerName];
            if(litui.utils.isUndefined(drawer))
                throw "LITUI Layout Manager exception: drawer " + drawerName + " does not exist!";
            
            return drawer;
        };
        
        LituiLayoutMngr.prototype.isDrawn = function (drawerName) {
            return this.getDrawer(drawerName).isDrawn;
        };
        
        LituiLayoutMngr.prototype.showDrawer = function (drawerName) {            
            var drawer = this.getDrawer(drawerName);
            drawer.$elt.css('left', litui.utils.numToPx(drawer.$elt.width()) * -1);
            drawer.$elt.css('display', 'block');
            return litui.tween.to(drawer.$elt, 0.2, {
                left: 0,
                opacity: 1,
            }).then(function(){
                drawer.isDrawn = true;
            });
        };
        
        LituiLayoutMngr.prototype.hideDrawer = function (drawerName) {            
            var drawer = this.getDrawer(drawerName);
            return litui.tween.to(drawer.$elt, 0.2, {
                left: -drawer.$elt.width(),
                opacity: 0
            }).then(function(){
                drawer.$elt.css('display', 'none');
                drawer.isDrawn = false;
            });
        };
        
        LituiLayoutMngr.prototype.toggleDrawer = function (drawerName) {            
            var drawer = this.getDrawer(drawerName);
            if(drawer.isDrawn)
                return this.hideDrawer(drawerName);
            return this.showDrawer(drawerName);
        };
        
        LituiLayoutMngr.prototype.setDrawerComponent = function (drawerName, component) {            
            var drawer = this.getDrawer(drawerName);
            return lituiCompileService.compile(drawer.$elt, component).then(function(cc){
                drawer.compiled = cc;
                return cc;
            });
        };
        
        LituiLayoutMngr.prototype.unsetDrawerComponent = function (drawerName) {            
            var drawer = this.getDrawer(drawerName);
            if(litui.utils.isDefined(drawer.compiled))
                drawer.compiled.destroy();
        };


        return new LituiLayoutMngr();
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiViewFooterService', LituiViewFooterServiceWrapper);
    
    /** @ngInject */
    function LituiViewFooterServiceWrapper(lituiViewFooterDrawerService) {
        function LituiViewFooterService(){
            this.panelName = 'view-footer';
        }
        
        LituiViewFooterService.prototype.toggleCollapse = function(){
            if(litui.layoutMngr.provide().isCollapsed(this.panelName))
                return this.expand();
            return this.collapse();
        };
        
        LituiViewFooterService.prototype.expand = function(){
            litui.layoutMngr.provide().$rootLayoutElt.removeClass('litui-view-footer-collapsed');
            return litui.layoutMngr.provide().expandPanel(this.panelName);
        };
        
        LituiViewFooterService.prototype.collapse = function(){
            litui.layoutMngr.provide().$rootLayoutElt.addClass('litui-view-footer-collapsed');
            return litui.layoutMngr.provide().collapsePanel(this.panelName);
        };
        
        LituiViewFooterService.prototype.show = function(){
            litui.layoutMngr.provide().$rootLayoutElt.removeClass('litui-nofooter');
            return litui.layoutMngr.provide().showPanel(this.panelName);
        };
        
        LituiViewFooterService.prototype.hide = function(){
            litui.layoutMngr.provide().$rootLayoutElt.addClass('litui-nofooter');
            return litui.layoutMngr.provide().hidePanel(this.panelName);
        };
        
        LituiViewFooterService.prototype.toggleDrawer = function(){
            this.collapse();
            return lituiViewFooterDrawerService.toggle();
        };
        
        return new LituiViewFooterService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiViewFooter', {
        controller: LituiViewFooter,
        templateUrl: 'litui/com/layout/litui-view-footer/litui-view-footer.html',
        bindings: {
            footer: '=',
            footerDrawer: '=?'
        }
    });
    
    /** @ngInject */
    function LituiViewFooter(lituiViewFooterDrawerService){
        var self = this;
        
        this.$onInit = function(){
            if(litui.utils.isDefined(self.footerDrawer) && lituiViewFooterDrawerService.isInitialized)
                lituiViewFooterDrawerService.setComponent(self.footerDrawer);
            else
                lituiViewFooterDrawerService.on('READY', setFooterDrawerComponent);
        };
        
        this.$onDestroy = function(){
            lituiViewFooterDrawerService.off('READY', setFooterDrawerComponent);
        };
        
        function setFooterDrawerComponent(){
            if(litui.utils.isDefined(self.footerDrawer))
                lituiViewFooterDrawerService.setComponent(self.footerDrawer);
        }
            
    }
})();
"use strict";



(function(){
    angular.module('litui').factory('LituiViewHeaderBuilder', LituiViewHeaderBuilderFactory);
    
    /** @ngInject */
    function LituiViewHeaderBuilderFactory(LituiViewHeaderCom) {

        /**
         * @ngdoc function
         * @name litui.model.builder.class:TmsViewHeaderBuilder
         * @description Helper service that helps to create configuration for litui-view-header directive.
         * @param {Object} splitter If the header is loaded inside splitter container, splitter reference should be provided.
         * 
         */
        function LituiViewHeaderBuilder(splitter) {
            this.title = undefined;
            this.titleValues = undefined;
            this.nav = undefined;
            this.actions = undefined;
            this.extendAction = true;
            this.splitter = splitter;
            this.breadcrumbs;
            this.open;
            this.selectedIndex = undefined;
            this.mainTools = undefined;
            this.help = undefined;
            this.excludedActions = [];
            this.iconClassname;
        }

        /**
         * @ngdoc function
         * @name setTitle
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @description Set view title
         * @param {string} title page title in view header (shut be an translation key)
         * @param {string} titleValues title values to be replaced in translation
         * @returns {object} self -> TmsViewHeaderBuilder
         * 
         */
        LituiViewHeaderBuilder.prototype.setTitle = function(title, titleValues) {
            if (angular.isDefined(title) && angular.isString(title)) {
                this.title = title;
            }
            if (angular.isDefined(titleValues) && angular.isObject(titleValues)) {
                this.titleValues = titleValues;
            }
            return this;
        };
        
        LituiViewHeaderBuilder.prototype.setIcon = function(iconClassname){
            this.iconClassname = iconClassname;
            return this;
        };

        LituiViewHeaderBuilder.prototype.setTitleWithoutTranslation = function(title) {
            if (angular.isDefined(title) && angular.isString(title)) {
                this.titleWithoutTranslation = title;
            }
            return this;
        };
        
        /**
         * @description
         * Sets the breadcrumbs for header.
         * @ngdoc function
         * @name setBreadcrumbs
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @param {string} moduleId Module ID
         * @param {string} a First part of title, usually parent container (splitter) name.
         * @param {string} b second part of title.
         * @returns {Object} self -> TmsViewHeaderBuilder
        
         */
        LituiViewHeaderBuilder.prototype.setBreadcrumbs = function(moduleId, a, b){
            this.breadcrumbs = {
                moduleId: moduleId,
                a: a,
                b: b
            };
            
            return this;
        };
        
        /**
         * @description
         * Sets title with back button.
         * @ngdoc function
         * @name setTitleWithBackButton
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @param {string} title should have attributes:
         *                   sref of site that is opened on back button click
         *                   a First part of title, usually parent container name.
         *                   b second part of title. (can be undefined)
         * @returns {Object} self -> TmsViewHeaderBuilder
        
         */
        LituiViewHeaderBuilder.prototype.setTitleWithBackButton = function(title){
            this.breadcrumbs = title;
            return this;
        };
        
        /**
         * @description
         * Sets help text
         * @ngdoc function
         * @name setHelp
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @param {string} text text for help 
         * @returns {Object} self -> TmsViewHeaderBuilder
         */
        LituiViewHeaderBuilder.prototype.setHelp = function(text){
            this.help = text;
            return this;
        };

        /**
         * @ngdoc function
         * @name setViewNav
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @description Set navigation in view header.
         * @param {Array} navOptions View navigation items. Item has properties:
         *
         *  - `{string}`  `title` - Translation key or value (is mandatory)
         *  - `{boolean}` `translate` - If title should be used as translation key
         *  - `{string}`  `sref` - Ui router state name
         *   
         * @param {int} selectedIndex Set active tab by matching given index (references index in the given array).
         * @returns {object} self -> TmsViewHeaderBuilder
         */
        LituiViewHeaderBuilder.prototype.setViewNav = function(navOptions, selectedIndex) {
            this.nav = navOptions;
            this.selectedIndex = selectedIndex;
            return this;
        };

        /**
         * @ngdoc function
         * @name setActionOptions
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @param {Array} actionOptions View navigation action options. Action item has properties: 
         * 
         *  - `{string}`   `icon` - Icon name
         *  - `{string}`   `tooltip` - Tooltip text
         *  - `{boolean}`  `translate` - If tooltip text should be used as translation key (default true)
         *  - `{string function}`   `onClick` - onClick callback function. Can be an function or path to an function on the scope.
         * 
         * @param {boolean} extend If it should extend default action options or override (is optional, default value is false). Default options:
         * 
         *  - Open current location in new tab.
         *  - Close current tab (Not working).
         * @returns {object} self -> TmsViewHeaderBuilder
         * 
         */
        LituiViewHeaderBuilder.prototype.setActionOptions = function(actionOptions, extend) {
            if (!angular.isArray(actionOptions)) {
                throw Error("setActionOptions: Must be an array!");
            }
            this.extendAction = litui.utils.isDefined(extend)? extend : true;
            this.actions = actionOptions;
            return this;
        };
        
        LituiViewHeaderBuilder.prototype.setMainToolsMenu = function(mainTools) {
            if (!angular.isArray(mainTools)) {
                throw Error("mainTools: Must be an array!");
            }
            this.mainTools = mainTools;
            return this;
        };
        
        /**
         * 
         * @param {Array} excluded
         */
        LituiViewHeaderBuilder.prototype.excludeActions = function(excludes){
            this.excludedActions = excludes;
            return this;
        };

        /**
         * @ngdoc function
         * @name build
         * @methodOf litui.model.builder.class:TmsViewHeaderBuilder
         * @description Creates a configuration object for lituiViewHeader directive.
         * @param {boolean} recompile Re-compile on directive settings change.
         * @returns {object} Configuration object for lituiViewHeader directive.
         */
        LituiViewHeaderBuilder.prototype.build = function(recompile) {
            var self = this;
            var options = {};
            if (angular.isDefined(this.title)) {
                options.title = this.title;
            }
            if (angular.isDefined(this.titleWithoutTranslation)) {
                options.titleWithoutTranslation = this.titleWithoutTranslation;
            }
            if (angular.isDefined(this.titleValues)) {
                options.titleValues = this.titleValues;
            }
            if (angular.isDefined(this.nav)) {
                options.nav = this.nav;
            }
            if (angular.isDefined(this.actions)) {
                options.actions = this.actions;
            }
            if(angular.isDefined(this.open)){
                options.open = this.open;
            }
            if(angular.isDefined(this.breadcrumbs)){
                options.breadcrumbs = this.breadcrumbs;
            }
            if(angular.isDefined(this.selectedIndex)){
                options.selectedIndex = this.selectedIndex;
            }
            if(angular.isDefined(this.mainTools)){
                options.mainTools = this.mainTools;
            }
            if(angular.isDefined(this.help)){
                options.help = this.help;
            }
            if(angular.isDefined(this.excludedActions)){
                options.excludedActions = this.excludedActions;
            }
            if(angular.isDefined(recompile)){
                options.recompile = recompile;
            }
            if(angular.isDefined(this.iconClassname)){
                options.iconClassname = this.iconClassname;
            }
            
            if (this.extendAction) {
                if (angular.isUndefined(options.actions)) {
                    options.actions = [];
                }
                if(angular.isDefined(self.splitter) && !self.splitter.isFullSize()){                    
                    var open =true;
                    var spO = {
                        icon: 'icon-view_expand_up',
                        tooltip: 'EXPAND',
                        translate: true,
                        display: true,
                        onClick: function(e) {
                            self.splitter.fullSize(open);
                            open = !open;
                            spO.icon = open ? 'icon-view_expand_up' : 'icon-view_contract_down';
                            spO.tooltip = open ? 'EXPAND' : 'COLLAPSE';
                        }
                    };
                    options.actions.push(spO);
                }
                
                // disable from splitter - not working yet
                if(litui.utils.isUndefined(this.splitter)){
//                    options.actions.push({
//                        icon: 'icon-help',
//                        tooltip: 'Help information',
//                        translate: false,
//                        onClick: function(e) {
//                            var elm=$(e.target).closest(".litui-view-header").find(".litui-view-help-holder");
//                            
//                            TweenMax.to(elm, 0.5, {
//                                opacity: 1,
//                                onComplete: function() {
//                                    elm.css('display', 'block');
//                                    $(window).resize();
//                                }
//                            });
//                        },
//                        functionalityId: 'HELP.FEATURE.ACCESS'
//                    });
//                    options.actions.push({
//                        icon: 'icon-new_window',
//                        tooltip: 'Open in new window',
//                        translate: false,
//                        onClick: function(e) {
//                            $window.open($window.location.href);
//                        },
//                        functionalityId: 'FEATURE.NEW_WINDOW'
//                    });
                }
                
                if(litui.utils.isDefined(this.splitter)){
                    options.actionsOrientation = LituiViewHeaderCom.ActionsOrientation.LEFT;
                    options.actions.push('screen-help');
                    options.actions.push('new-window');
                    
                    options.actions.push({
                        icon: 'icon-close',
                        tooltip: 'Close window',
                        translate: false,
                        display: true,
                        onClick: function(e) {
                            litui.logger.debug("TO-DO: onCloseWindow");

                            if(angular.isDefined(self.splitter))
                                self.splitter.close();
                        }
                    });
                }
            }
            
//            options.actions = this.__excludeActions(options.actions);

            return options;
        };

        return LituiViewHeaderBuilder;
    }
})();
'use strict';

/**
 * Is built on top of angular. Uses angular $scope.
 * 
 * It has two modes: NORMAL and TRANSFORMED. In normal mode navigation tabs are 
 * located in between title (breadcrumbs) and view actions.
 * In transformed mode navigation tabs are displayed in a row bellow title and 
 * actions.
 * 
 * It displays help bubble if help property in settings is defined.
 * It displays 2nd level navigation if set. It is set per navigation tab.
 * 
 * It has predefined actions for help and new window. 
 * 
 * setScope($scope) method takes existing scope that can be either scope from 
 * directive or controller. 
 * It will expose certain properties and methods to
 * $scope.$$lituiViewHeader...
 * 
 * setSettings(settings) method takes property name that is on scope and 
 * represents settings. It will expose settings to $scope.$$lituiViewHeader once 
 * scope is set.
 * 
 * NAVIGATION TAB usage
 * (incomplete info, fill out)
 * - if tab has associated child navigation, it will build it automatically and 
 * handle the displaying of the correct sub-menu.
 * - sref: link with module for displaying "tabbed content".
 * - open: will work for $splitter switching of the "tabbed content".
 * - onSelect(..) callback:
 * If we don't want to use (navigation) header tab as navigation between 
 * various views, we can define tab.onSelect(tab:Object, e:Event):boolean 
 * callback for tab. Returning TRUE value in callback will make this tab 
 * have "active" style for tab menu.
 * 
 * 
 * NOTE:
 * Show/hide help bubble triggers window resize event, because of synchronicity 
 * of screen rendering.
 * 
 * @param {type} param1
 * @param {type} param2
 */
angular.module('litui').factory('LituiViewHeaderCom',
        ['$compile', '$parse', '$q', '$state', '$window', 'lituiSecurity', 'lituiTranslate', 'lituiAppMenuNavItemsFactory', 'lituiAppMenuService',
            function ($compile, $parse, $q, $state, $window, lituiSecurity, lituiTranslate, lituiAppMenuNavItemsFactory, lituiAppMenuService) {

                function LituiViewHeader($elt, $scope, settings, isTopLevelScreen) {
                    var self = this;

                    this.__origSettingsKey = "";
                    this.__isInit = false;
                    this.__isInSplitter = $scope.$splitter === undefined ? false : true;

                    if (!this.__isInSplitter)
                        this.$elt = $('.litui-header-exposure');
                    else
                        this.$elt = $elt;

                    this.mode = LituiViewHeader.Modes.NORMAL;
                    this.functionalityId = isTopLevelScreen ? "FEATURE.HELP_TOP_LEVEL" : "FEATURE.HELP_LOW_LEVEL";
                    this.isAppMenuBtn = false;

                    // --- PREDEFINED ACTIONS ---
                    this.predefinedActions = {
                        'screen-help': {
                            id: 'screen-help',
                            type: LituiViewHeader.ActionTypes.PREDEFINED,
                            icon: 'icon-help',
                            tooltip: 'Help information',
                            onClick: function (e) {
                                self.showHelp();
                            },
                            functionalityId: this.functionalityId
                        },
                        'new-window': {
                            id: 'new-window',
                            type: LituiViewHeader.ActionTypes.PREDEFINED,
                            icon: 'icon-new_window',
                            tooltip: 'Open in new window',
                            onClick: function (e) {
                                $window.open($window.location.href);
                            },
                            functionalityId: 'FEATURE.NEW_WINDOW'
                        }
                    };
                    this.setSettings(settings);
//            this.setSettings($.extend({
//                disabledActions: []
//            }, 
//            settings));
                    this.setScope($scope);
                    this.exposeApi($scope);
                }


                // --------------
                // --- STATIC ---
                // --------------
                /**
                 * TRANSFORMED mode when "new line" navigation is needed
                 */
                LituiViewHeader.Modes = {
                    NORMAL: 'NORMAL',
                    TRANSFORMED: 'TRANSFORMED'
                };

                LituiViewHeader.ActionTypes = {
                    PREDEFINED: 'PREDEFINED'
                };

                LituiViewHeader.ActionsOrientation = {
                    LEFT: 'LEFT',
                    RIGHT: 'RIGHT'
                };


                /**
                 * Takes the scope provided by directive (or controller) and exposes
                 * settings, event handlers and certain methods to 
                 * $scope.$$lituiViewHeader.
                 * 
                 * @param {Scope} $scope
                 */
                LituiViewHeader.prototype.setScope = function ($scope) {
                    var self = this;
                    this.$scope = $scope;

                    if (this.$scope.$$lituiViewHeader)
                        throw "Only one TMS View header can exist on the $scope.";

                    this.$scope.$$lituiViewHeader = this.settings;

                    // ------------
                    // --- VARS ---
                    // ------------
                    this.$scope.$$lituiViewHeader.__isInSplitter = this.__isInSplitter;


                    // ------------------
                    // --- FUNCTIONS ---
                    // ------------------
                    this.$scope.$$lituiViewHeader.$$sref = function (navItem) {
                        return self.getSref(navItem);
                    };
                    this.$scope.$$lituiViewHeader.$$getActiveRootNavigationItem = function () {
                        return self.getActiveRootNavigationItem();
                    };
                    this.$scope.$$lituiViewHeader.countAvailableTabs = function () {
                        return self.countAvailableTabs();
                    };


                    // --------------
                    // --- EVENTS ---
                    // --------------
                    this.$scope.$$lituiViewHeader.onOptionClick = function (index, e) {
                        for (var i = 0; i < index + 1; i++) {
                            var action = self.settings.actions[i];
                            if (i === index && litui.utils.isFunction(action.onClick)) {
                                action.onClick(e);
                                break;
                            }
                        }
                    };

                    this.$scope.$$lituiViewHeader.onHelpClose = function (e) {
                        self.hideHelp();
                    };

                    this.$scope.$$lituiViewHeader.selectTab = function () {

                    };

                    this.$scope.$$lituiViewHeader.isTabActive = function (arg) {
                        return self.isTabActive(arg);
                    };

                    this.$scope.$$lituiViewHeader.onTabSelect = function (tabIndex, e) {
                        var tab = self.settings.nav[tabIndex];



                        if (litui.utils.isFunction(tab.onSelect)) {

                            var selectResult = tab.onSelect(tab, e);

                            // select tab if result is true
                            if (selectResult === true) {
                                var $activeTab = self.$elt.find('.litui-tab.litui-active');
                                for (var i = 0; i < self.settings.nav.length; i++) {
                                    self.settings.nav[i].active = false;
                                }
                                $activeTab.each(function () {
                                    $(this).removeClass('litui-active');
                                });
                                tab.active = true;


                                $(e.currentTarget).addClass('litui-active');
                            }
                        }
                    };

                    this.$scope.$$lituiViewHeader.onBack = function (e) {
                        if(litui.utils.isString(self.$scope.$$lituiViewHeader.breadcrumbs.sref))
                            $state.go(self.$scope.$$lituiViewHeader.breadcrumbs.sref);
                        else if(litui.utils.isObject(self.$scope.$$lituiViewHeader.breadcrumbs.sref))
                            $state.go(self.$scope.$$lituiViewHeader.breadcrumbs.sref.location, self.$scope.$$lituiViewHeader.breadcrumbs.sref.params);
                    };

                    this.$scope.$$lituiViewHeader.onAppMenu = function (e) {
                        lituiAppMenuService.toggle();
                    };
                };

                /**
                 * Sets settings from property that is located on scope. Also sets 
                 * predefined actions.
                 * 
                 * @param {String} settings
                 */
                LituiViewHeader.prototype.setSettings = function (settings) {
                    var self = this;
                    if (typeof settings === "string" && this.__origSettingsKey.length === 0) {
                        this.__origSettingsKey = settings;
                        settings = $parse(settings)(this.$scope);
                    } else if (settings === undefined && this.__origSettingsKey.length > 0) {
                        settings = $parse(this.__origSettingsKey)(this.$scope);
                    }

                    // use default settings or provided settings
                    if (this.settings === undefined)
                        this.settings = $.extend({
                            __mode: this.mode,
                            title: "View title",
                            breadcrumbs: null,
                            actions: [],
                            actionsOrientation: LituiViewHeader.ActionsOrientation.RIGHT,
                            selectedTab: null,
                            nav: [],
                            selectedIndex: null,
                            mainTools: null,
                            help: null,
                            displayHelp: null,
                            predefinedActions: [
                                'screen-help',
                                'new-window'
                            ],
                            excludedActions: [],
                            iconClassname: null
                        }, settings);
                    else {
                        this.settings = $.extend(this.settings, settings);
                    }

                    this.setHelp();

                    // auto-set icon if not set in settings
                    var navItem = lituiAppMenuNavItemsFactory.getActiveItem();
                    if (litui.utils.isDefined(navItem)) {
                        if (litui.utils.isNull(this.settings.iconClassname)) {
                            if (litui.utils.isDefined(navItem.parent))
                                this.settings.iconClassname = navItem.parent.icon;
                            else if (litui.utils.isDefined(navItem.item.icon))
                                this.settings.iconClassname = navItem.item.icon;
                        }
                        if(litui.utils.isDefined(navItem.item.backsref)){
                            this.settings.breadcrumbs = {
                                sref: navItem.item.backsref,
                                a: navItem.item.title,
                            };
                        }
                    }

                    // set breadcrumbs "b" (view title) prop
                    if (litui.utils.isObject(this.settings.breadcrumbs)) {
                        this.settings.breadcrumbs.b = litui.utils.isDefined(this.settings.breadcrumbs.b) ? this.settings.breadcrumbs.b : this.settings.title;
                    }

                    this.__setPredefinedActions();
                };

                LituiViewHeader.prototype.destroy = function () {

                    // clear HTML content of the DOM node if not in splitter - for case
                    // when "next" view doesn't have header
                    if (!this.__isInSplitter) {
                        this.$elt.html("");
                    }
                };

                /**
                 * Applies normal mode.
                 */
                LituiViewHeader.prototype.toNormalMode = function () {
                    var $nav = this.$elt.find('.litui-view-nav-holder:not(.litui-new-line)');
                    var $navAlt = this.$elt.find('.litui-view-nav-holder.litui-new-line');

                    this.settings.__mode = LituiViewHeader.Modes.NORMAL;

                    $nav.css('margin-left', this.calcNavigationCenter($nav));
                    $navAlt.css('display', 'none');

                    if (this.countAvailableTabs() > 1)
                        $nav.css('display', 'block');

//            console.info("TMS View header: switched to NORMAL mode.");
                };

                /**
                 * Applies transformed mode.
                 */
                LituiViewHeader.prototype.toTransformedMode = function () {
                    var $nav = this.$elt.find('.litui-view-nav-holder.litui-new-line');
                    var $navAlt = this.$elt.find('.litui-view-nav-holder:not(.litui-new-line)');

                    this.settings.__mode = LituiViewHeader.Modes.TRANSFORMED;

                    $navAlt.css('display', 'none');

                    if (this.countAvailableTabs() > 1)
                        $nav.css('display', 'block');

                    $nav.css('margin-left', this.calcNavigationCenter($nav));

//            console.info("TMS View header: switched to TRANSFORMED mode.");
                };

                /**
                 * Checks if space is available for navigation in NORMAL mode.
                 * 
                 * @returns {Boolean}
                 */
                LituiViewHeader.prototype.isNavSpaceAvailable = function () {
                    var $nav = this.$elt.find('.litui-view-nav-holder:not(.litui-new-line)');

                    $nav.css('width', '');
                    $nav.css('left', '0');

//            console.log("Is navigation space available: %o, space: %opx",  
//                    this.calcHeaderEmptySpace() > $nav.outerWidth(), this.calcHeaderEmptySpace(), $nav.outerWidth(), $nav.find('.litui-tab'), $nav.outerHeight(), this.$elt.height());
                    return this.calcHeaderEmptySpace() > $nav.outerWidth();
                };

                /**
                 * Calculates empty space between title (breadcrumbs) and view actions.
                 * 
                 * @returns {Number}
                 */
                LituiViewHeader.prototype.calcHeaderEmptySpace = function () {
                    var $title = this.$elt.find('.litui-title');
                    var $breadcrumbs = this.$elt.find('.litui-breadcrumbs');
                    var $actions = this.$elt.find('.litui-view-options');

                    var taken = $title.outerWidth() + $breadcrumbs.outerWidth() + $actions.outerWidth();
                    return this.$elt.find('.litui-view-header-inner').innerWidth() - taken;
                };
//        TmsViewHeader.prototype.calcHeaderEmptySpace = function(){
//            var $title = this.$elt.find('.litui-title');
//            var $breadcrumbs = this.$elt.find('.litui-breadcrumbs');
//            var $actions = this.$elt.find('.litui-view-options');
//            // try to calculate header empty space
//            var titleWidth = 0;
//            var breadcrumbsWidth = 0;
//            if(this.settings.breadcrumbs){
//                breadcrumbsWidth = 36 + 15 + ((translate(this.settings.breadcrumbs.a)).length + 3 + (translate(this.settings.breadcrumbs.b)).length) * 9.274;
//            }else{
//                titleWidth = 24 + (translate(this.$scope.$$lituiViewHeader.title)).length * 9.274;
//            }
//            var actionsWidth = 4 + this.settings.actions.length * 36  + this.$elt.find('.litui-main-tools').outerWidth();
//            var myDist = this.$elt.width() - titleWidth - breadcrumbsWidth - actionsWidth;
//            //var theirDist = this.$elt.width() - $title.outerWidth() - $breadcrumbs.outerWidth() - $actions.outerWidth();
//            //console.log("Dist:" + (myDist - theirDist) + ";T:" + (titleWidth-$title.outerWidth())+";B:"+
//            //        (breadcrumbsWidth- $breadcrumbs.outerWidth())+";A:"+(actionsWidth- $actions.outerWidth()));
//            //console.log("dist:" + myDist)
//            return myDist;
//        };

                /**
                 * Calculates the center position in the view header for given element.
                 * 
                 * @returns {Number}
                 */
                LituiViewHeader.prototype.calcNavigationCenter = function ($nav) {
                    if (litui.utils.isUndefined($nav))
                        return 0;

//            var $nav = litui.utils.isDefined($navHolder) && $navHolder.length > 0? $navHolder : this.$elt.find('.litui-view-nav-holder');
                    var $viewheader = this.$elt.find('.litui-view-header');
                    var $title = this.$elt.find('.litui-title');
                    var $breadcrumbs = this.$elt.find('.litui-breadcrumbs');

                    // in normal mode navigation is in between the title and actions
                    if (this.settings.__mode === LituiViewHeader.Modes.NORMAL) {
                        return this.calcHeaderEmptySpace() / 2 - $nav.width() / 2;

                    }

                    return $viewheader.width() / 2 - $nav.outerWidth() / 2;
                };


                // ----------------------
                // --- HELP FUNCTIONS ---
                // ----------------------
                LituiViewHeader.prototype.setHelp = function () {
                    // set help content wether from provided settings help property or 
                    // from $state.current.name for automatic screen help assignment
                    if (lituiSecurity.isAuthorized(this.functionalityId)) {
                        if ((this.settings.help === undefined || this.settings.help === null)) {
                            this.settings.help = "HELP_" + $state.current.name;
                        }
                    }

                    // show or hide help?
                    if (this.settings.displayHelp === null && this.settings.help !== null) {
                        this.hideHelp();
                    } else {
                        this.showHelp();
                    }
                };

                LituiViewHeader.prototype.showHelp = function () {
                    var $help = this.$elt.find('.litui-view-help-holder');
                    $help.css('display', 'block');
                    this.settings.displayHelp = true;

                    // this.resize();
                    if (litui.utils.isUndefined(this.$scope))
                        $(window).resize();
                };

                LituiViewHeader.prototype.hideHelp = function () {
                    var $help = this.$elt.find('.litui-view-help-holder');
                    $help.css('display', 'none');
                    this.settings.displayHelp = false;

                    //this.resize();
                    if (litui.utils.isUndefined(this.$scope))
                        $(window).resize();
                };


                // ---------------
                // --- HELPERS ---
                // ---------------
                /**
                 * Reads predefined actions from this.predefinedActions declaration 
                 * array and inserts them into actions.
                 */
                LituiViewHeader.prototype.__setPredefinedActions = function () {
                    for (var i = 0; i < this.settings.predefinedActions.length; i++) {
                        var actionId = this.settings.predefinedActions[i];
                        var action = this.predefinedActions[actionId];

                        if (action === undefined) {
                            console.warning("[TMS View Header] predefined action %o does not exist!", action);
                            continue;
                        }

                        // check if action already exists
                        var exists = false;
                        for (var j = 0; j < this.settings.actions.length; j++) {
                            var a = this.settings.actions[j];

                            if ((a.type === LituiViewHeader.ActionTypes.PREDEFINED && a.id === actionId) || (litui.utils.isString(a) && a === actionId)) {
//                        console.log("Action %o already exists!", actionId);
                                exists = true;
                                break;
                            }
                        }

                        if (!exists) {
                            this.settings.actions.push(action);
                        }
                    }
                };

                LituiViewHeader.prototype.__set2ndLevelNavigation = function (nav) {
                    this.$scope.$$lituiViewHeader.navigation2 = undefined;
                    if (litui.utils.isDefined(nav.nav2) && !litui.utils.isNull(nav.nav2))
                        this.$scope.$$lituiViewHeader.navigation2 = nav.nav2;
                };

                /**
                 * Gets DOM node that represents navigation holder. Which node is 
                 * returned depends upon mode.
                 * 
                 * @returns {$DOM}
                 */
                LituiViewHeader.prototype.getNavigationElt = function () {
                    var $nav = this.$elt.find('.litui-view-nav-holder.litui-new-line');
                    var $navAlt = this.$elt.find('.litui-view-nav-holder:not(.litui-new-line)');

                    if ($nav.length > 0)
                        return $nav;
                    if ($navAlt.length > 0)
                        return $navAlt;
                    return null;
                };

                /**
                 * Gets active root navigation item for current view.
                 * 
                 * @returns {Object}
                 */
                LituiViewHeader.prototype.getActiveRootNavigationItem = function () {
                    if (litui.utils.isDefined(this.settings) && this.settings.nav.length > 0) {
                        var current = $state.current;
                        for (var i = 0; i < this.settings.nav.length; i++) {
                            var nav = this.settings.nav[i];

                            var partialSref = nav.sref.substring(0, nav.sref.lastIndexOf('.'));
                            if (partialSref === current.parent) {
                                return nav;
                            }
                        }
                    }

                    return undefined;
                };

                /**
                 * Checks if tab in 1st level of navigation is active. This method is 
                 * needed due to ui-sref-active directive bug.
                 * 
                 * @param {Object} tab
                 * @returns {Boolean}
                 */
                LituiViewHeader.prototype.isTabActive = function (tab) {
                    if (tab.sref === undefined)
                        return false;

                    var partialSref = tab.sref.substring(0, tab.sref.lastIndexOf('.'));
                    var parentId = $state.current.parent;

                    if (parentId === undefined) {
                        parentId = $state.current.name;

                        if (tab.sref === parentId)
                            return true;
                        return false;
                    }

                    if (partialSref === parentId)
                        return true;

                    return false;
                };

                /**
                 * Returns sref property of navigation item.
                 * 
                 * @param {Object} item
                 * @returns {String}
                 */
                LituiViewHeader.prototype.getSref = function (item) {
                    var r = item.params ? item.sref + '(' + JSON.stringify(item.params) + ')' : item.sref;
                    return r;
                };

                LituiViewHeader.prototype.isNav2TabActive = function (nav2) {
                    if (litui.utils.isArray(nav2) && nav2.length > 0) {
                        for (var i = 0; i < nav2.length; i++) {
                            var params = litui.utils.isDefined(nav2[i].params) ? nav2[i].params : {};
                            if ($state.includes(nav2[i].sref, params)) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

                LituiViewHeader.prototype.countAvailableTabs = function () {
                    var count = 0;
                    for (var i = 0; i < this.settings.nav.length; i++) {
                        var nav = this.settings.nav[i];

                        if ((litui.utils.isDefined(nav.functionalityId) && !lituiSecurity.isAuthorized(nav.functionalityId)) ||
                                (litui.utils.isDefined(nav.display) && !nav.display))
                            continue;

                        count++;
                    }
                    return count;
                };


                // ---------------------
                // --- GENERAL STUFF ---
                // ---------------------
                LituiViewHeader.prototype.exposeApi = function () {
                    var self = this;
                    this.$scope.$$lituiViewHeader.resize = function () {
                        return self.resize();
                    };
                };

                LituiViewHeader.prototype.resize = function () {
                    var $viewheader = this.$elt.find('.litui-view-header');
//            this.$elt.parents('.litui-content-holder').css('margin-top', $viewheader.outerHeight());
//            this.$elt.parents('.litui-content-holder').css('overflow', 'auto');
//            this.$elt.parents('.litui-content-holder').height($window.innerHeight - $viewheader.outerHeight());


                    if (!this.__isInSplitter) {
//                var width = $('[main-nav]').length > 0? $('[main-nav]').outerWidth(true) : 220;

                        //            this.$elt.width($window.innerWidth - width);
//                this.$elt.css('margin-left', width);
                    }

                    // can nav fit into header row?
                    if (!this.isNavSpaceAvailable() || !litui.utils.isNull(this.settings.mainTools)) {
//                if(this.mode === TmsViewHeader.Modes.NORMAL)
                        this.toTransformedMode();
                    } else {
                        this.toNormalMode();
                    }

                    // content holder positioning is binded to main layer > header elt, not every view header element
                    // this prevents jumping when (any) view header is being rendered (we can have multiple view headers in one page)
                    var $mainHeader = $viewheader.parents('.litui-header-exposure');
                    if ($mainHeader.length > 0 && $('.content.litui-content-holder').attr('is-full-sized') !== 'true') {
                        $('.content.litui-content-holder').height($window.innerHeight - $viewheader.outerHeight(true));
                        $('.content.litui-content-holder').css('top', $viewheader.outerHeight(true));
                    }

//            var $viewheader =  self.$elt.find('.litui-view-header');
//            console.log("Navigation center: %o", this.calcNavigationCenter());
                };

                LituiViewHeader.prototype.render = function () {
                    var self = this;
                    var d = $q.defer();
                    this.setSettings();

                    var _apply = function () {


                        var $viewheader = self.$elt.find('.litui-view-header');
                        var $nav = self.$elt.find('.litui-view-nav-holder');
                        var $nav2 = self.$elt.find('.litui-view-nav2-holder');
                        var $help = self.$elt.find('.litui-view-help-holder');
//                $nav.css('display', 'none');

                        $nav2.css('display', 'block');

//                $nav.css('display', 'block');

                        if ($('#screen-help').lenght > 0)
                            $help.find('.litui-help-arrow').css('left', $('#screen-help').position().left + 10);

//                console.info("TMS view header rendered!", $viewheader.height());
                        if (!self.__isInit)
                            self.__isInit = true;

                        self.resize();

                        d.resolve();
                    };

//            if(!this.__isInit){
                    this.$elt.html(this.template());



                    $compile(this.$elt.contents())(this.$scope);

//                $timeout(function(){
                    _apply();
//                });
//            }
//            else{
//                _apply();
//            }

                    return d.promise;
                };

                /** 
                 * @returns {String}
                 */
                LituiViewHeader.prototype.template = function () {
                    var self = this;

                    var titleWidth = 0;
                    var breadcrumbsWidth = 0;
                    if (this.settings.breadcrumbs) {
                        if(litui.utils.isDefined(this.settings.breadcrumbs.a) && litui.utils.isDefined(this.settings.breadcrumbs.b))
                            breadcrumbsWidth = 36 + 15 + ((lituiTranslate(this.settings.breadcrumbs.a)).length + 3 + (lituiTranslate(this.settings.breadcrumbs.b)).length) * 9.274;
                        else{
                            titleWidth = 24 + (lituiTranslate(this.$scope.$$lituiViewHeader.title)).length * 9.274 + 36;
                        }
                    } else {
                        titleWidth = 24 + (lituiTranslate(this.$scope.$$lituiViewHeader.title)).length * 9.274;
                    }

                    // reset navigation2...
                    this.$scope.$$lituiViewHeader.navigation2 = undefined;

                    // make navigation HTML makro
                    var mkNav = function () {
                        var html = "";
                        for (var i = 0; i < self.settings.nav.length; i++) {
                            var tab = self.settings.nav[i];

                            tab.index = i;

                            if (tab.display === false || (litui.utils.isDefined(tab.functionalityId) && !lituiSecurity.isAuthorized(tab.functionalityId)))
                                continue;

                            if (self.isNav2TabActive(tab.nav2) && litui.utils.isDefined(tab.sref) && tab.sref.length > 0) {
                                html += '            <a ui-sref="' + tab.sref + '"  class="litui-tab litui-active" type="button" litui-ripple-fx>' + lituiTranslate(tab.title) + '</a>';
                                self.__set2ndLevelNavigation(tab);
                            } else if (litui.utils.isDefined(tab.sref) && tab.sref.length > 0) {
                                html += '            <a ui-sref="' + tab.sref + '" ui-sref-active="litui-active"  class="litui-tab" type="button" litui-ripple-fx>' + lituiTranslate(tab.title) + '</a>';
                            } else if (tab.open && self.$scope.$splitter)
                                html += '            <a class="litui-tab ' + (tab.active ? 'litui-active' : '') + '" ng-click="$splitter.open(\'' + tab.open.module + '\', ' + tab.open.data + ', $event)" type="button">' + lituiTranslate(tab.title) + '</a>';
                            else if (litui.utils.isFunction(tab.onSelect)) {
                                html += '            <a class="litui-tab ' + (tab.active ? 'litui-active' : '') + '" ng-click="$$lituiViewHeader.onTabSelect(' + i + ', $event)" type="button" litui-ripple-fx>' + lituiTranslate(tab.title) + '</a>';
                            }
                            // tab button when no event or sref
                            else if ((!tab.sref || tab.sref.length === 0) && !tab.open)
                                html += '            <a class="litui-tab" type="button" litui-ripple-fx>' + lituiTranslate(tab.title) + '</a>';


                            // ng-class="{ \'litui-active\': $$lituiViewHeader.isTabActive(tab) }"
                        }
                        return html;
                    };

                    var mkActions = function () {
                        var _f_ = function (action) {
                            // check for exclusion
                            if (self.settings.excludedActions)
                                for (var j = 0; j < self.settings.excludedActions.length; j++) {
                                    if ((litui.utils.isString(action) && action === self.settings.excludedActions[j]) ||
                                            (litui.utils.isObject(action) && action.id === self.settings.excludedActions[j]))
                                        return;
                                }

                            if (litui.utils.isDefined(action.functionalityId) && !lituiSecurity.isAuthorized(action.functionalityId))
                                return;

                            if (litui.utils.isString(action) && self.predefinedActions[action] !== undefined) {
                                action = self.predefinedActions[action];
                            }

                            if (action.id === undefined)
                                action.id = "vh-action-" + i;


                            if ((action.display === true || action.display === undefined))
                                html += '           <button id="' + action.id + '" class="litui-btn-icon ' + action.icon + '" ng-click="$$lituiViewHeader.onOptionClick(' + i + ', $event)" litui-tooltip="' + action.tooltip + '"></button>';
                        };

                        var html = "";
//                if(self.settings.actionsOrientation === TmsViewHeader.ActionsOrientation.LEFT){
                        for (var i = 0; i < self.settings.actions.length; i++) {
                            _f_(self.settings.actions[i]);
                        }
//                }
//                else{
//                    for(var i = self.settings.actions.length - 1; i >= 0; i--){
//                        _f_(self.settings.actions[i]);
//                    }
//                }
                        return html;
                    };
                    
                    var mkBreadcrumbs = function(){
                        html += '    <div class="litui-breadcrumbs" style="min-width:' + breadcrumbsWidth + 'px">';

                        // back btn 1 (splitter) - UNTESTED SCENARIO
                        //            html += '        <div class="litui-back-btn" ng-if="$$lituiViewHeader.breadcrumbs.sref === undefined">';
                        //            html += '            <button class="btn btn-primary btn-sm" type="button" ng-click="$splitter.open(\'{{$$lituiViewHeader.breadcrumbs.moduleId}}\', \'{{$$lituiViewHeader.breadcrumbs.data}}\')">';
                        //            html += '                <span class="litui-icon icon-previous"></span>';
                        //            html += '            </button>';
                        //            html += '        </div>';

                        // back btn 2 (main view)
                        html += '        <div class="litui-back-btn" ng-if="$$lituiViewHeader.breadcrumbs.sref !== undefined">';
                        html += '            <button class="btn btn-primary btn-sm" type="button" ng-click="$$lituiViewHeader.onBack($event)">';
                        html += '                <span class="litui-icon icon-previous"></span>';
                        html += '            </button>';
                        html += '        </div>';
                        html += '        <div class="litui-breadcrumbs-title">';

                        if (!litui.utils.isNull(self.$scope.$$lituiViewHeader.breadcrumbs) && self.$scope.$$lituiViewHeader.breadcrumbs.a.indexOf('{{') > -1 && self.$scope.$$lituiViewHeader.breadcrumbs.a.indexOf('}}') > -1)
                            html += '            <span class="underline">' + self.$scope.$$lituiViewHeader.breadcrumbs.a + '</span>';
                        else if (!litui.utils.isNull(self.$scope.$$lituiViewHeader.breadcrumbs))
                            html += '            <span class="underline">' + lituiTranslate(self.$scope.$$lituiViewHeader.breadcrumbs.a) + '</span>';

                        html += '            <span>&nbsp/&nbsp;</span>';

                        if (!litui.utils.isNull(self.$scope.$$lituiViewHeader.breadcrumbs) && self.$scope.$$lituiViewHeader.breadcrumbs.b.indexOf('{{') > -1 && self.$scope.$$lituiViewHeader.breadcrumbs.b.indexOf('}}') > -1)
                            html += '            <span>' + self.$scope.$$lituiViewHeader.breadcrumbs.b + '</span>';
                        else if (!litui.utils.isNull(self.$scope.$$lituiViewHeader.breadcrumbs))
                            html += '            <span>' + lituiTranslate(self.$scope.$$lituiViewHeader.breadcrumbs.b) + '</span>';

                        html += '        </div>';
                        html += '    </div>';
                    };
                    
                    var mkTitle = function(){
                        html += '    <div class="litui-title" style="min-width:' + titleWidth + 'px;">';
                        html += '        <span class="litui-icon {{$$lituiViewHeader.iconClassname}}" ng-if="$$lituiViewHeader.iconClassname"></span>';
                        html += '        <span>' + (lituiTranslate(self.$scope.$$lituiViewHeader.title)) + '</span>';
                        html += '    </div>';
                    };
                    
                    var mkTitleWithBackBtn = function(){
                        html += '    <div class="litui-title litui-clearfix" style="min-width:' + titleWidth + 'px;">';
                        html += '        <div class="litui-back-btn" ng-if="$$lituiViewHeader.breadcrumbs.sref !== undefined">';
//                        html += '            <button class="btn btn-primary btn-sm" type="button" ui-sref="{{$$lituiViewHeader.breadcrumbs.sref}}">';
                        html += '            <button class="btn btn-primary btn-sm" type="button" ng-click="$$lituiViewHeader.onBack($event)">';
                        html += '                <span class="litui-icon icon-previous"></span>';
                        html += '            </button>';
                        html += '        </div>';
                        html += '        <div class="litui-float-left">';
                        html += '            <span class="litui-icon {{$$lituiViewHeader.iconClassname}}" ng-if="$$lituiViewHeader.iconClassname"></span>';
                        html += '            <span>' + (lituiTranslate(self.$scope.$$lituiViewHeader.title)) + '</span>';
                        html += '        </div>';
                        html += '    </div>';
                    };
                    
                    var mkAppMenuBtn = function(){
                        var tpl = '';
                        if(self.isAppMenuBtn){
                            tpl += '<button class="litui-view-header-app-menu-btn" ng-click="$$lituiViewHeader.onAppMenu($event)"><span class="litui-icon icon-menu"></span></button>';
                        }
                        return tpl;
                    };
                    
                    var html = '';
                    
                    html += '<div id="showLicenceBanner"></div>';
                    html += '<div id="headerRow" class="litui-view-header" ng-class="{ \'litui-has-navigation\': $$lituiViewHeader.countAvailableTabs() > 1 || $$lituiViewHeader.__isInSplitter }">';

                    html += '<div class="litui-view-header-inner litui-clearfix">';
                    
                    html += mkAppMenuBtn();
                    
                    // title
                    if (this.$scope.$$lituiViewHeader.breadcrumbs === null) {
                        mkTitle();
                    }


                    // breadcrumbs
                    if (this.$scope.$$lituiViewHeader.breadcrumbs !== null && litui.utils.isDefined(this.$scope.$$lituiViewHeader.breadcrumbs.a)) {
                        mkBreadcrumbs();
                    }
                    else if(!litui.utils.isNull(this.$scope.$$lituiViewHeader.breadcrumbs)){
                        mkTitleWithBackBtn();
                    }
                    // -- breadcrumbs

                    // view navigation
//            html += '    <div class="litui-view-nav-holder" ng-show="$$lituiViewHeader.__mode === \'NORMAL\' && $$lituiViewHeader.nav.length > 1">';
                    html += '    <div class="litui-view-nav-holder">';
                    html += '        <div class="litui-tab-group litui-clearfix">';
                    html += mkNav();
                    html += '        </div>';
                    html += '    </div>';
                    // -- view navigation


                    // view actions
                    html += '    <div class="litui-view-options litui-clearfix unselectable">';

                    if (this.settings.mainTools !== undefined) {
                        html += '       <div class="litui-float-left">';
                        html += '           <div data-main-tools-menu="$$lituiViewHeader.mainTools"></div>';
                        html += '       </div>';
                    }

                    html += '       <div class="litui-float-left">';

                    html += mkActions();

                    html += '       </div>';
                    html += '    </div>';
                    // -- view actions

                    html += '</div>';
                    // -- first header row

                    // view navigation
//            html += '<div class="litui-view-nav-holder litui-new-line litui-float-left litui-clearfix" ng-show="$$lituiViewHeader.__mode === \'TRANSFORMED\' && $$lituiViewHeader.nav.length > 1">';
                    html += '<div class="litui-view-nav-holder litui-new-line litui-float-left litui-clearfix">';
                    html += '    <div class="litui-tab-group litui-clearfix">';
                    html += mkNav();
                    html += '    </div>';
                    html += '</div>';
                    html += '<div class="clear"></div>';
                    // -- view navigation

                    // view 2nd level navigation
                    if (this.$scope.$$lituiViewHeader.navigation2 !== undefined) {
                        html += '    <div class="litui-view-nav2-holder">';
                        for (var i = 0; i < this.$scope.$$lituiViewHeader.navigation2.length; i++) {
                            var tab = this.$scope.$$lituiViewHeader.navigation2[i];
                            html += '        <span class="litui-nav2-item" ui-sref=\'' + this.getSref(tab) + '\' ui-sref-active="litui-nav2-item-active" type="button" translate="' + tab.title + '"></span>';
                        }
                        html += '    </div>';
                    }
                    // --view 2nd level navigation

                    // help
                    if ((this.settings.help !== null && this.settings.help !== undefined) && this.settings.help !== lituiTranslate(this.settings.help)) {
                        html += '    <div class="litui-view-help-holder" is-authorized="' + this.functionalityId + '">';
                        html += '        <div class="litui-help-arrow"></div>';
                        html += '        <span class="litui-view-help-close litui-icon icon-close" ';
                        html += '                ng-click="$$lituiViewHeader.onHelpClose($event)"></span>';
                        html += '        <div class="litui-view-help-content">' + lituiTranslate(this.settings.help) + '</div>';
                        html += '    </div>';
                    }
                    // -- help

                    html += '</div>';
                    // --- viewheader

                    return html;
                };

                return LituiViewHeader;
            }
        ]);

"use strict";

/**
 * @description 
 * Renders View header component with Title, Action buttons and navigation tabs (if set).
 * For easier settings setup we can use ViewHeaderBuilder.
 * 
 * @example
 * <b>Usage for main View</b> 
 * $scope.headerOptions = lituiBuilder.getViewHeaderBuilder()
        .setTitle('MY_TITLE_TRANSLATION_KEY')
        .setViewNav([
            {title: 'MY_LABEL_TRANSLATION_KEY', sref: 'my.module.id', tooltip: 'My tab link', display: true|false},
        ])
        .setActions(
            { 
                icon: 'icon-message', 
                tooltip: 'Example', 
                onClick: function(e){
                    console.info("Example clicked);
                },
                display: true|false
            }
        )
        .build();
 * 
 * <b>Usage for main Splitter component</b> 
 * $scope.headerOptions = lituiBuilder.getViewHeaderBuilder($scope.$splitter)
        .setTitle('MY_TITLE_TRANSLATION_KEY')
        .setViewNav([
            {
                title: 'MY_TITLE_TRANSLATION_KEY',
                open: {
                    module: 'module-id-as-defined-for-splitter',
                    data: "objectOnScope"
                },
                tooltip: 'My tab link',
                display: true|false
            }
        ])
        .setActions(
            { 
                icon: 'icon-message', 
                tooltip: 'Example', 
                display: true|false,
                onClick: function(e){
                    console.info("Example clicked);
                } 
            }
        )
        .build();

 * NOTE: Navigation tab's and header action's property display is by default set to TRUE.

 * Additionally we can set "back" button with breadcrumbs:
   lituiBuilder.getViewHeaderBuilder($scope.$splitter)
        .setBreadcrumbs('toModuleId', translate("parent title"), translate("current children title"))
        ...
    
    Where toModuleId is your module ID as defined for splitter.
 * 
 * @ngdoc directive
 * @name litui.directive.class:TmsViewHeader 
 */
angular.module('litui').directive('lituiViewHeader', [
    '$parse', 'LituiViewHeaderCom', 'lituiAppMenuService',
    function ($parse, LituiViewHeaderCom, lituiAppMenuService) {
        return{
            restrict: 'A',
            replace: true,
            link: function ($scope, $elt, attrs) {  
                var com = new LituiViewHeaderCom($elt, $scope, attrs.lituiViewHeader, _.has(attrs, "isTopLevelScreen"));       
                com.__isInit = true;
                
                var resizeHandler = function(){
                    if(!com.__isInit){
                        com.resize();
                        com.__isInit = false;
                    }
                };
                $(window).resize(resizeHandler);
                
                $scope.$watch(attrs.lituiViewHeader, function(){
                    var opts = $parse(attrs.lituiViewHeader)($scope);
                    if(litui.utils.isDefined(opts.recompile)){
                        com.__isInit = !opts.recompile;
                    }
                    
                    com.render();
                }, true);
                
                com.isAppMenuBtn = !lituiAppMenuService.isVisible;
                
                lituiAppMenuService.on('AUX_APP_MENU_BTN', onShowAuxAppMenuBtn);
                
                $scope.$on('$destroy', function(){
//                    console.info("Viewheader destroyed");
                    $(window).off('resize', resizeHandler);
                    lituiAppMenuService.off('AUX_APP_MENU_BTN', onShowAuxAppMenuBtn)
                    com.destroy();
                });
                
                function onShowAuxAppMenuBtn(isShow){
                    if(isShow === com.isAppMenuBtn)
                        return ;
                    com.isAppMenuBtn = isShow;
                    com.render();
                }
            }
        };
    }
]);
'use strict';

(function () {
    angular.module('litui').directive('lituiViewOptionsPanelControlArrangement', LituiViewOptionsPanelControlArrangement);

    /** @ngInject */
    function LituiViewOptionsPanelControlArrangement($timeout) {
        return {
            restrict: 'A',
            scope: {
                count: '=lituiViewOptionsPanelControlArrangement'
            },
            link: {
                pre: function ($scope, $elt, attrs) {
//                    if (litui.utils.count($scope.count) > 2) {
                        $elt.addClass('litui-view-options-controls-inline');
//                    }
                }
            }
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').service('lituiViewOptionsPanelService', service);
    
    /** @ngInject */
    function service(lituiSubscribe){
        function LituiViewOptionsPanelService(){
            lituiSubscribe.produce(this, [
                'OPEN_VIEW_OPTIONS_PANEL',
                'CLOSE_VIEW_OPTIONS_PANEL',
                'EXPAND_VIEW_OPTIONS_PANEL',
                'COLLAPSE_VIEW_OPTIONS_PANEL'
            ]);
            this.panel = 'ribbon';
        }
        
        LituiViewOptionsPanelService.prototype.open = function(viewOptionsConfig){
            litui.layoutMngr.provide().collapsePanel(this.panel);
            litui.layoutMngr.provide().showPanel('ribbon');
            this.trigger('OPEN_VIEW_OPTIONS_PANEL', viewOptionsConfig);
        };
        
        LituiViewOptionsPanelService.prototype.close = function(){
            litui.layoutMngr.provide().hidePanel(this.panel);
            this.trigger('CLOSE_VIEW_OPTIONS_PANEL');
        };
        
        LituiViewOptionsPanelService.prototype.expand = function(){
            litui.layoutMngr.provide().expandPanel(this.panel);
            this.trigger('EXPAND_VIEW_OPTIONS_PANEL');
        };
        
        LituiViewOptionsPanelService.prototype.collapse = function(){
            litui.layoutMngr.provide().collapsePanel(this.panel);
            this.trigger('COLLAPSE_VIEW_OPTIONS_PANEL');
        };
        
        return new LituiViewOptionsPanelService();
    }
})();
'use strict';

(function(){    
    angular.module('litui').component('lituiViewOptionsPanel', {
        controller: LituiViewOptionsPanelCtrl,
        templateUrl: 'litui/com/layout/litui-view-options-panel/litui-view-options-panel.html',
        bindings: {
            panelName: '=',
            settings: '<'
        }
    });
    
    /** @ngInject */
    function LituiViewOptionsPanelCtrl($element, lituiViewOptionsPanelService, $scope){
        var self = this;
        var $elt = $($element);
        var isOrigin = false;
        
        this.$onInit = function(){
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            litui.lang.mergeB({
                initialCollapsed: true,
                isHeader: true,
                isTrigger: true
            }, this.settings);
            
            lituiViewOptionsPanelService.on('OPEN_VIEW_OPTIONS_PANEL', function(viewOptionsConfig){
                if(litui.utils.isDefined(viewOptionsConfig)){
                    if(litui.utils.isDefined(viewOptionsConfig.component))
                        self.settings.mainTools = viewOptionsConfig.component;
                    if(litui.utils.isDefined(viewOptionsConfig.component))
                        self.settings.isTrigger = viewOptionsConfig.isToggleEnabled;
                }
            });
            lituiViewOptionsPanelService.on('CLOSE_VIEW_OPTIONS_PANEL', function(){
                collapse($elt.find('button.litui-view-options-trigger'));
            });
        };
        
        this.onToggle = function(){
            
            var $triggerBtn = $elt.find('button.litui-view-options-trigger');
            if(litui.layoutMngr.provide().isExpanded(self.panelName)){
                collapse($triggerBtn);
            }
            else{
                expand($triggerBtn);
            }
            
            if(litui.utils.isFunction(self.settings.trigger.onTrigger)){
                self.settings.trigger.onTrigger(litui.layoutMngr.provide().isCollapsed(self.panelName));
            }
        };
        
        this.onReset = function(){
            if(litui.utils.isUndefined(self.settings.defaultValues)){
                throw "Can't reset values; no default values specified for View options component!";
                return;
            }
            
            for(var gname in self.settings.groups){
                var group = self.settings.groups[gname];
                
                for(var cname in group.controls){
                    var control = group.controls[cname];
                    
                    if(litui.utils.isFunction(control.onReset))
                        control.onReset(self.settings.defaultValues[cname], control);
                    
                    // skip components, they need to impl. $scope event
                    if(control.type === 'component')
                        continue;
                    
                    control.value = self.settings.defaultValues[cname];
                    if(litui.utils.isFunction(control.onChange)){
                        control.onChange(null, control.value, cname);
                    }
                }
            }
            
            // trigger reset event
            $scope.$broadcast('LITUI_RESET_CONTROLS', self.settings.defaultValues);

            if(litui.utils.isFunction(self.settings.onReset))
                self.settings.onReset(self.settings.defaultValues);
            
            litui.notify.info({
                title: "LITUI.VIEW_OPTIONS.RESET_TITLE",
                message: "LITUI.VIEW_OPTIONS.RESET_TEXT"
            });
        };
        
        this.onActionSelected = function(e, action){
            if(litui.utils.isFunction(action.onSelected))
                action.onSelected(e, action);
        };
        
        function collapse($triggerBtn){
            isOrigin = true;
            litui.layoutMngr.provide().collapsePanel(self.panelName);
            isOrigin = false;
            $triggerBtn.removeClass('litui-active');
        }
        
        function expand($triggerBtn){
            isOrigin = true;
            litui.layoutMngr.provide().expandPanel(self.panelName);
            isOrigin = false;
            $triggerBtn.addClass('litui-active');
            
        }
    }
})();
'use strict';

(function(){
    angular.module('litui').factory('lituiAppMenuItemsFactory', LituiAppMenuItemsFactory);
    
    /** @ngInject */
    function LituiAppMenuItemsFactory(appMenuItems, lituiSecurity){
        // --- FUNCTIONS ---
        function filter(list) {
            var filtered = [];
            for (var i = 0; i < list.length; i++) {
                var obj = list[i];
                
                if (filterCriteria(obj)) {
                    filtered.push(obj);
                }

            }
            return filtered;
        }

        function filterCriteria(obj) {
            return (litui.utils.isUndefined(obj.functionalityId) || lituiSecurity.isAuthorized(obj.functionalityId)) &&
                    (litui.utils.isUndefined(obj.display) || obj.display);
        }

        // --- RETURN OBJ. ---
        return {
            'filter': function (list) {
                return filter(appMenuItems.getItems() || list);
            }
        };
    }
})();
'use strict';

/**
 * Adaptation of main-man-service.js; no changes were made to the returning 
 * methods (getMainNav, getSubMenuData.
 * Use 'app/config/main-nav-items.js' to setup main navigation items.
 */
angular.module('litui').factory('lituiAppMenuNavItemsFactory', [
    'lituiSecurity', '$state', 'mainNavItems',
    function (lituiSecurity, $state, mainNavItems) {
        
        
        // --- FUNCTIONS ---
        // NOTE: for n-levels (root) parent must be auto-detected
        function getActiveItem(items, parent){
            for(var k in items){
                var item = items[k];
                if(litui.utils.isDefined(item.sref)){
                    var srefBase;
                    
                    // find delimiter symbol and set sref base
                    var delimiterIndex = item.sref.indexOf("(");
                    if(delimiterIndex > -1){
                        srefBase = item.sref.substring(0, delimiterIndex);
                    }
                    else
                        srefBase = item.sref;
                    
                    // is sref base matching current state?
                    if(srefBase === $state.current.name){  
                        return {
                            item: item,
                            parent: parent
                        };
                    }
                }
                
                
                
                // check if look-up item is in sub menu
                if(litui.utils.isArray(item.subMenu)){
                    var activeItem = getActiveItem(item.subMenu, item);
                    if(litui.utils.isDefined(activeItem))
                        return activeItem;
                }
                
                // check if look-up item is in linked modules
                if(litui.utils.isArray(item.linkedModules)){
                    var activeItem = getActiveItem(item.linkedModules, parent);
                    if(litui.utils.isDefined(activeItem)){
                        return activeItem;
                    }
                }
            }
        }
        
        function filter(list, parent){
            var filtered = [];
            for(var i = 0; i < list.length; i++){
                var obj = list[i];
                obj.parent = parent;
                
                if(litui.utils.isArray(obj.subMenu)){
                    obj.subMenu = filter(obj.subMenu, obj);
                }
                
                if(filterCriteria(obj)){
                    filtered.push(obj);  
                    if(litui.utils.isUndefined(obj.__index)){
                        obj.__index = filter.__ai;
                        filter.__ai++;
                    }
                }
                    
            }
            return filtered;
        }
        filter.__ai = 0;
        
        function filterCriteria(obj){
            var c1 = litui.utils.isUndefined(obj.functionalityId) || lituiSecurity.isAuthorized(obj.functionalityId);
            var c2 = litui.utils.isUndefined(obj.display) || obj.display;
            var c3 = litui.utils.isUndefined(obj.sref) || (litui.utils.isString(obj.sref) && obj.sref.length > 0);
            var c4 = litui.utils.isUndefined(obj.subMenu) || (litui.utils.isArray(obj.subMenu) && obj.subMenu.length > 0);
            return c1 && c2 && c3 && c4;
        }
        
        // --- RETURN OBJ. ---
        return {
            'filter': function(list){
                return filter(list || mainNavItems.getItems().data);
            },
            getActiveItem: function(list){
                var a = getActiveItem(filter(list || mainNavItems.getItems().data));
                return a;
            },
            
            // --- main-nav-service.js adaptation ---
            'getMainNav': function () {
                return mainNavItems.getItems();
            },
            'getSubMenuData': function (subMenuSref) {
                var mainNav = mainNavItems.getItems();
                for (var i = 0; i < mainNav.data.length; i++)
                {
                    if (mainNav.data[i].hasOwnProperty('subMenu') === false) {
                        continue;
                    }

                    var subMenu = mainNav.data[i].subMenu;

                    for (var i2 = 0; i2 < subMenu.length; i2++) {
                        var sref = subMenu[i2].sref;
                        if (sref === subMenuSref)
                            return {
                                subMenu: subMenu,
                                model: subMenu[i2]
                            };
                    }
                }
                return null;
            }
            // --- end main-nav-service.js adaptation ---
        };
    }
]);

'use strict';

/**
 * Requires system services:
 * - layoutManagerService
 * - weatherService
 * - serverTimeService
 * 
 * Requires system configuration:
 * - config
 * - mainNavItems
 * - appMenuItems
 */
(function () {
    angular.module('litui').directive('lituiAppMenu', directive);

    /** @ngInject */
    function directive(lituiAppMenuService, lituiLayoutMngrService) {
        return {
            restrict: 'E',
            replace: true,
            controller: LituiAppMenuCtrl,
            templateUrl: 'litui/com/menu/litui-app-menu/litui-app-menu.html',
            scope: {
                brand: '=',
                displayedPanel: '=?',
                features: '=?',
                settings: '=?',
                type: '@?'
            },
            link: function($scope, $elt, attr, ctrl){
                lituiAppMenuService.onReady(bodyHeightCalcHandler);
                
                function bodyHeightCalcHandler(){
                    if(lituiAppMenuService.isCollapsing && lituiAppMenuService.defaultToggle !== 'collapse'){
                        return ;
                    }
                        
                    litui.async.delay(function(){
                        lituiAppMenuService.calcBodyHeight($elt);
                    }, 100);
                }
                
                lituiLayoutMngrService.on('RESIZE_END', bodyHeightCalcHandler);
                
                $scope.$on('$destroy', function(){
                    lituiLayoutMngrService.off('RESIZE_END', bodyHeightCalcHandler);
                });
            }
        };
    }

    /** @ngInject */
    function LituiAppMenuCtrl($scope, $element, $timeout, lituiAppMenuService, lituiAppMenuNavItemsFactory, lituiAppMenuItemsFactory, 
                                lituiAppMenuServerTimeService, lituiAppMenuWeatherService, lituiLayoutMngrService, lituiFunctionalitiesMappingService) {
        var defaultFeatures = ['time', 'version'];
        if(litui.config.get('weather').isEnabled)
            defaultFeatures.push('weather');
        
        
        $scope.navItems = lituiAppMenuNavItemsFactory.filter();
        $scope.menuItems = lituiAppMenuItemsFactory.filter();
        $scope.isAppMenuCollapsed = lituiAppMenuService.isCollapsed;
        $scope.activeFeatures = $scope.features || ['weather', 'time', 'version'];
        $scope.quickTools = null;
        $scope.fmap = lituiFunctionalitiesMappingService.getMap();
        
        if(litui.utils.contains($scope.activeFeatures, 'time') && litui.utils.isDefined($scope.settings)){
            lituiAppMenuServerTimeService.setSyncService($scope.settings.serverTimeSync);
        }
        
        if(litui.utils.contains($scope.activeFeatures, 'weather') && litui.utils.isDefined($scope.settings)){
            lituiAppMenuWeatherService.setWeatherService($scope.settings.weatherService);
        }
        
        lituiAppMenuService.displayedPanel = $scope.displayedPanel || 'west';
        
        var expandedItems = [];
        var createdItems = 0;
        var notificationsActivated = false;
        
        var debounceBodyCalc = new litui.utility.DebounceHandler(function(){
            lituiAppMenuService.calcBodyHeight($($element));
        }, {
            timeout: 100
        });
        
        $scope.$on('$stateChangeSuccess', function(){
            if(lituiAppMenuService.isTransformed && lituiAppMenuService.isVisible){
                lituiAppMenuService.hide();
            }
        });        
        
        $scope.$on('$destroy', function(){
            lituiAppMenuService.deactivateNotifications();
            lituiAppMenuService.off('COLLAPSE_APP_MENU', onCollapseAppMenu);
            lituiAppMenuService.off('EXPAND_APP_MENU', onExpandAppMenu);
            lituiAppMenuService.off('ITEM_CREATED', onItemCreated);
            lituiAppMenuService.off('ITEM_EXPANDED', onItemExpanded);
            lituiAppMenuService.off('SET_QUICK_TOOLS', onSetQuickTools);
            lituiAppMenuService.off('COLLAPSE_EXPANDED_ITEMS', onCollapseExpandedItems);
            lituiAppMenuService.off('FEATURE', onFeature);
            lituiAppMenuService.off('NAVIGATION_MENU_READY', onNavigationMenuReady);
            lituiAppMenuService.off('TOGGLE_APP_MENU', onToggleAppMenu);
            responsive.destroy();
        });
        
        
        $scope.onSelectBrand = function(e){
            if(litui.utils.isFunction($scope.brand.onSelected))
                $scope.brand.onSelected(e);
        };


        // --- SUBSCRIBE ---        
        lituiAppMenuService.on('COLLAPSE_APP_MENU', onCollapseAppMenu);
        lituiAppMenuService.on('EXPAND_APP_MENU', onExpandAppMenu);
        lituiAppMenuService.on('ITEM_CREATED', onItemCreated);
        lituiAppMenuService.on('ITEM_EXPANDED', onItemExpanded);
        lituiAppMenuService.on('SET_QUICK_TOOLS', onSetQuickTools);
        lituiAppMenuService.on('COLLAPSE_EXPANDED_ITEMS', onCollapseExpandedItems);
        lituiAppMenuService.on('FEATURE', onFeature);
        lituiAppMenuService.on('NAVIGATION_MENU_READY', onNavigationMenuReady);
        lituiAppMenuService.on('TOGGLE_APP_MENU', onToggleAppMenu);
        
        var responsive = null;
        var isResponsiveResize = false;
        responsive = litui.Responsive.create(this, {
            postCalc: function(isTransformed, width){
                if(!isResponsiveResize)
                    return;
                
                if(width > 1024){
                    isResponsiveResize = false;
                    destroyMenuAsDrawer();
                    lituiAppMenuService.show();
                }
            }
        }, {
            breakpoints: {
                1024: function(width){
                    if(isResponsiveResize){
                        return false;
                    }
                    
                    if(lituiAppMenuService.isVisible){
                        isResponsiveResize = true;
                        lituiAppMenuService.hide();    
                        lituiAppMenuService.expand();
                        transformMenuAsDrawer();
                        return true;
                    }
                    return false;
                }
            }
        }, lituiLayoutMngrService.$layoutRootElt);
        responsive.init();
        
        function calcBodyHeight(){
            return debounceBodyCalc.debounce();
        }
        
        function transformMenuAsDrawer(){
            if(lituiAppMenuService.isTransformed){
                return;
            }
            var layoutMngr = litui.layoutMngr.provide();
            if(litui.utils.isFunction(layoutMngr.setDrawerComponent))
                layoutMngr.setDrawerComponent('west', {
                    component: {
                        template: '<litui-app-menu brand="brand" displayed-panel="displayedPanel" features="features" settings="settings" type="{{type}}"></litui-app-menu>',
                        params: {
                            brand: $scope.brand,
                            displayedPanel: $scope.displayedPanel,
                            features: $scope.features,
                            settings: $scope.settings,
                            type: $scope.type
                        }
                    }
                });
            lituiAppMenuService.isTransformed = true;
        }
        
        function destroyMenuAsDrawer(){
            if(!lituiAppMenuService.isTransformed){
                return;
            }
            var layoutMngr = litui.layoutMngr.provide();
            layoutMngr.hideDrawer('west').then(function(){
                var drawer = layoutMngr.getDrawer('west');
                if(litui.utils.isDefined(drawer))
                    layoutMngr.getDrawer('west').compiled.destroy();
            });
            lituiAppMenuService.isTransformed = false;
        }
        
        function onCollapseAppMenu() {
            $scope.isAppMenuCollapsed = true;
        }
        
        function onExpandAppMenu() {
            $scope.isAppMenuCollapsed = false;
        }
        
        function onItemCreated(item) {
            createdItems++;
            // not trully the best solution, but it works
            if(createdItems >= $scope.navItems.length && !notificationsActivated){
                lituiAppMenuService.trigger('NAVIGATION_MENU_READY');
            }
        }
        
        function onItemExpanded($expandedItem) {
            // check if item maybe already exists in expanded items list
            var expanded = false;
            for(var i = 0; i < expandedItems.length; i++){
                var $item = expandedItems[i];
                if($item.item.__index === $expandedItem.item.__index)
                    expanded = true;
            }
            
            // insert new expanded item
            if(!expanded){
                expandedItems.push($expandedItem);
            }
        }
        
        function onSetQuickTools(component) {
            $scope.quickTools = component;
            calcBodyHeight();
        }
        
        function onCollapseExpandedItems($collapsedItem){
            // check the parent; if parents DON'T match, collapse all items
            // and empty expandedItems array
            if(expandedItems.length > 0){
                var isAnyParent = false;
                for(var i = 0; i < expandedItems.length; i++){
                    var $item = expandedItems[i];
                    
                    if(litui.utils.isDefined($collapsedItem) && litui.utils.isDefined($collapsedItem.item.parent) && $item.item.__index === $collapsedItem.item.parent.__index){
                        isAnyParent = true;
                        break;
                    }
                }
                
                if(!isAnyParent){
                    var removeQ = [];
                    for(var i = 0; i < expandedItems.length; i++){
                        var $item = expandedItems[i];
                        if($item.isExpanded){
                            $item.collapse();
                            removeQ.push($item.item.__index);
                        }
                    }
                    
                    litui.utils.deleteElements(expandedItems, removeQ, function(a, b){
                        return a.item.__index === b;
                    });
                }    
            }
        }
        
        function onFeature(feature){
            litui.async.delay(function(){
                var activeIndex = $scope.activeFeatures.indexOf(feature.featureId);
                if(!feature.isEnabled && activeIndex > -1)
                    litui.utils.deleteElement($scope.activeFeatures, activeIndex);
                else if(feature.isEnabled && activeIndex === -1)
                    $scope.activeFeatures.push(feature.featureId);
            }).then(function(){
                return calcBodyHeight();
            });
        }
        
        function onNavigationMenuReady(){
            lituiAppMenuService.activateNotifications();
            notificationsActivated = true;
        }
        
        function onToggleAppMenu(){
            calcBodyHeight();
        }
    }
})();

'use strict';

(function () {
    angular.module('litui').service('lituiAppMenuService', service);

    /** @ngInject */
    function service(lituiAppMenuNavItemsFactory, $state, lituiSubscribe, $rootScope) {        
        function LituiAppMenuService() {
            this.isCollapsed = false;
            this.displayedPanel = 'west';
            this.defaultToggle = 'collapse';
            this.isInternalEvent = false;
            this.notifications = {};
            this.registeredPeriodicalNotifications = {};
            this.isDrawerActive = false;
            this.isInitialized = false;
            this.isCollapsing = false;
            this.isVisible = true;
            this.isTransformed = false;
            
            lituiSubscribe.produce(this, [
                'SHOW_COLLAPSED_SUB',
                'HIDE_COLLAPSED_SUB',
                'UPDATE_ITEM_NOTIFICATION',
                'COLLAPSE_EXPANDED_ITEMS',
                'ITEM_EXPANDED',
                'TOGGLE_APP_MENU',
                'COLLAPSE_APP_MENU',
                'EXPAND_APP_MENU',
                'SET_QUICK_TOOLS',
                'FEATURE'
            ]);
        }

        LituiAppMenuService.prototype.setDisplayedPanel = function (panelName) {
            this.deregisterLayoutEvents();
            this.displayePanel = panelName;
            this.registerLayoutEvents();
        };

        LituiAppMenuService.prototype.getSubMenuData = function (submenuSref) {
            return lituiAppMenuNavItemsFactory.getSubMenuData(submenuSref);
        };

        LituiAppMenuService.prototype.goto = function (sref) {
            // parse to params if they exist
            if (sref.indexOf("(") > -1 && sref.indexOf("{") > -1 && sref.indexOf("}") > -1 && sref.indexOf(")")) {
                var srefStr = sref.substr(0, sref.indexOf("("));
                var toParamsP0 = sref.substr(sref.indexOf("{"));
                var str = toParamsP0.substr(0, toParamsP0.indexOf("}") + 1);
                var toParams = eval("(" + str + ")");
                $state.go(srefStr, toParams);
            } else
                $state.go(sref);
        };

        LituiAppMenuService.prototype.isAnyOfChild = function (sref, parent) {
            // check if parent itself maybe matches 'sref'
            if (litui.utils.isDefined(parent.sref) && this.srefEquals(parent.sref, sref))
                return true;

            // check if any of child matches 'sref'
            if (litui.utils.isDefined(parent.subMenu))
                for (var i = 0; i < parent.subMenu.length; i++) {
                    var item = parent.subMenu[i];

                    if (litui.utils.isDefined(item.sref) && this.srefEquals(item.sref, sref)) {
                        return true;
                    }

                    if (this.isAnyOfChild(sref, item))
                        return true;
                }

            // check if any of the parent's linked modules match 'sref'
            if (litui.utils.isDefined(parent.linkedModules))
                for (var i = 0; i < parent.linkedModules.length; i++) {
                    var item = parent.linkedModules[i];
                    if (item.sref === sref)
                        return true;
                }
            return false;
        };

        LituiAppMenuService.prototype.srefEquals = function (srefA, srefB) {
            var srefBase;

            // THE PROBLEM THAT REMAINS
            // We cannot determine if given srefs are equal when srefs have path parameters
            // $state or angular router does not provide any method aswell

            // find delimiter symbol and set sref base
//            var delimiterIndex = srefA.indexOf("(");
//            if(delimiterIndex > -1){
//                srefBase = srefA.substring(0, delimiterIndex);
//            }
//            else
//                srefBase = srefA;
            return srefA === srefB;
        };

        LituiAppMenuService.prototype.hide = function () {
            if(!this.isTransformed)
                litui.layoutMngr.provide().hidePanel(this.displayedPanel);
            else
                litui.layoutMngr.provide().hideDrawer(this.displayedPanel);
            this.isVisible = false;
            $rootScope.$broadcast('APP_MENU_HIDE');
            this.trigger('TOGGLE_APP_MENU', true);
            this.trigger('AUX_APP_MENU_BTN', true);
            return litui.async.promise();
        };

        LituiAppMenuService.prototype.show = function () {
            if(!this.isTransformed)
                litui.layoutMngr.provide().showPanel(this.displayedPanel);
            else
                litui.layoutMngr.provide().showDrawer(this.displayedPanel);
            this.isVisible = true;
            $rootScope.$broadcast('APP_MENU_SHOW');
            this.trigger('TOGGLE_APP_MENU', false);
            this.trigger('AUX_APP_MENU_BTN', false);
            return litui.async.promise();
        };

        LituiAppMenuService.prototype.toggleVisibility = function () {
            if (litui.layoutMngr.provide().isDisplayed(this.displayedPanel)) {
                this.isCollapsing = true;
                return this.hide();
            }
            this.isCollapsing = false;
            return this.show();
        };

        LituiAppMenuService.prototype.expand = function () {
            var p = litui.async.promise();
            this.isCollapsing = true;
            if (this.isInternalEvent)
                p = litui.layoutMngr.provide().expandPanel(this.displayedPanel);
            this.isCollapsed = false;
            this.trigger('EXPAND_APP_MENU');
            $rootScope.$broadcast('APP_MENU_EXPANDED');
            this.isCollapsing = false;
            return p;
        };

        LituiAppMenuService.prototype.collapse = function () {
            var p = litui.async.promise();
            this.isCollapsing = true;
            if (this.isInternalEvent)
                p = litui.layoutMngr.provide().collapsePanel(this.displayedPanel);
            this.isCollapsed = true;            
            this.trigger('COLLAPSE_APP_MENU');
            $rootScope.$broadcast('APP_MENU_COLLAPSED');
            this.isCollapsing = false;
            return p;
        };

        LituiAppMenuService.prototype.toggleCollapse = function () {
            var self = this;
            var p = null;
            this.isInternalEvent = true;
            if (litui.layoutMngr.provide().isCollapsed(this.displayedPanel)) {
                p = this.expand();
            } else{
                p = this.collapse();
            }
            return p.then(function () {
                self.trigger('TOGGLE_APP_MENU');
                self.trigger('COLLAPSE_EXPANDED_ITEMS');
                self.isInternalEvent = false;
            });

        };

        LituiAppMenuService.prototype.toggle = function () {
            if(this.isTransformed){
                if(litui.layoutMngr.provide().isDrawn(this.displayedPanel))
                    return this.hide();
                else
                    return this.show();
            }
            
            if (this.defaultToggle === 'collapse')
                return this.toggleCollapse();
            return this.toggleVisibility();
        };

        LituiAppMenuService.prototype.registerLayoutEvents = function () {
            var self = this;
            this.collapseEventHandler = function () {
                if(self.isCollapsing)
                    return litui.async.promise();
                
                self.isInternalEvent = false;
                return self.collapse().then(function () {
                    self.isInternalEvent = true;
                });

            };
            this.expandEventHandler = function () {
                if(self.isCollapsing)
                    return litui.async.promise();
                
                self.isInternalEvent = false;
                return self.expand().then(function () {
                    self.isInternalEvent = true;
                });
            };

            litui.layoutMngr.provide().on('COLLAPSE_PANEL_' + this.displayedPanel.toUpperCase(), this.collapseEventHandler);
            litui.layoutMngr.provide().on('EXPAND_PANEL_' + this.displayedPanel.toUpperCase(), this.expandEventHandler);
        };

        LituiAppMenuService.prototype.deregisterLayoutEvents = function () {
            litui.layoutMngr.provide().off('COLLAPSE_PANEL_' + this.displayedPanel.toUpperCase(), this.collapseEventHandler);
            litui.layoutMngr.provide().off('EXPAND_PANEL_' + this.displayedPanel.toUpperCase(), this.expandEventHandler);
        };

        LituiAppMenuService.prototype.activateNotifications = function () {
            for (var k in this.notifications) {
                var notif = this.notifications[k];
                if (litui.utils.isDefined(notif.pullSettings)) {
                    var ps = litui.utils.isObject(notif.pullSettings) ? litui.lang.merge({
                        delayFirstPull: false
                    }, notif.pullSettings) : {
                        delayFirstPull: false
                    };
                    this.registeredPeriodicalNotifications[k] = litui.Pull.create(function () {
                        notif.callback();
                    }, ps);
                } else {
                    notif.callback();
                }
            }
        };

        LituiAppMenuService.prototype.deactivateNotifications = function () {
            for (var k in this.registeredPeriodicalNotifications) {
                this.registeredPeriodicalNotifications[k].destroy();
                litui.utils.deleteItem(k, this.registeredPeriodicalNotifications);
            }
        };

        LituiAppMenuService.prototype.registerNotification = function (notificationName, callback, pullSettings) {
            this.notifications[notificationName] = {
                callback: callback,
                pullSettings: pullSettings
            };
        };

        LituiAppMenuService.prototype.deregisterNotification = function (notificationName) {
            litui.utils.deleteItem(notificationName, this.notifications);
        };

        LituiAppMenuService.prototype.toggleDrawer = function (e, component) {
            if (this.isDrawerActive)
                return this.hideDrawer(e);
            return this.showDrawer(e, component);
        };

        LituiAppMenuService.prototype.showDrawer = function (e, component) {
            this.trigger('SHOW_DRAWER', component);
            this.isDrawerActive = true;
        };

        LituiAppMenuService.prototype.hideDrawer = function (e) {
            this.trigger('HIDE_DRAWER');
            this.isDrawerActive = false;
        };

        LituiAppMenuService.prototype.setQuickTools = function (component) {
            this.trigger('SET_QUICK_TOOLS', component);
        };

        LituiAppMenuService.prototype.calcBodyHeight = function ($elt) {
            var $body = $elt.find('.litui-app-menu-body');
            var $footer = $elt.find('.litui-app-menu-footer');
            var $header = $elt.find('.litui-app-menu-header');

            var totalH = $elt.innerHeight();
            var headerH = $header.outerHeight();
            var footerH = $footer.outerHeight();

            var calcBodyH = totalH - (footerH + headerH);
            
            TweenMax.to($body, 0.2, {
                height: calcBodyH
            });
        };

        LituiAppMenuService.prototype.onReady = function (cb) {
            var self = this;
            var result = undefined;
            function onreadyhandler() {
                litui.async.delay(function () {
                    result = cb();
                    self.off('NAVIGATION_MENU_READY', onreadyhandler);
                }, 500);
            }

            this.isInitialized = true;
            self.on('NAVIGATION_MENU_READY', onreadyhandler);
            return result;
        };

        return new LituiAppMenuService();
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiDropdownService', lituiDropdownService);

    /** @ngInject */
    function lituiDropdownService($rootScope, $compile, $timeout) {
        function LituiDropdownService() {
            this.defaultHolderEltSelector = '.litui-layout-panel-viewport';
            
            // dropdown states
            this.dropdowns = {};
        }

        LituiDropdownService.ai = 0;

        LituiDropdownService.prototype.generateId = function () {
            LituiDropdownService.ai++;
            return LituiDropdownService.ai;
        };

        LituiDropdownService.prototype.open = function ($holderElt, data) {
            var self = this;
            litui.lang.ensure([
                '$bindingElt', 'appid', 'entityId', 'dropdownItems', 'comId'
            ], data);
            this.createLayer($holderElt);
            var dropdownScope = this.createDropdownScope($holderElt, data);
            var $dropdown = $('<litui-dropdown class="' + (data.styleClass || '') + '" com-id="' + dropdownScope.comId + '" appid="{{appid}}" entity-id="{{entityId}}" binding-elt="$bindingElt" holder-elt="$holderElt" dropdown-items="dropdownItems" from-index="fromIndex" settings="settings"></litui-dropdown>');
            $dropdown.css('display', 'none');
            $dropdown.css('z-index', 11000);
            
            return this.compileDropdown($dropdown, dropdownScope, $holderElt).then(function(){
                $('body').bind('click', dropdownScope.$$dismiss);
                $holderElt.on('scroll', dropdownScope.$$dismiss);

                dropdownScope.$$isOpened = true;
                dropdownScope.$bindingElt.addClass('litui-active');
                dropdownScope.$bindingElt.attr('com-id', dropdownScope.comId);

                self.setDropdownDimensions($dropdown, $holderElt, dropdownScope.$bindingElt);
                self.setDropdownPosition($dropdown, $holderElt, dropdownScope.$bindingElt, dropdownScope.position, dropdownScope.direction);

                self.dropdowns[dropdownScope.comId] = dropdownScope;
                $dropdown.css('display', '');
                return self.$$transitionIn($dropdown);
            }).then(function(){
                return{
                    dropdown: dropdownScope,
                    $dropdown: $dropdown
                };
            });
        };

        LituiDropdownService.prototype.isOpened = function (comId) {
            return litui.utils.isDefined(this.dropdowns[comId]) ? this.dropdowns[comId].$$isOpened : false;
        };

        LituiDropdownService.prototype.destroyAll = function () {
            for (var comId in this.dropdown) {
                var dropdown = this.dropdowns[comId];
                this.close(comId);
                dropdown.$destroy();
                litui.utils.deleteItem(comId, this.dropdowns);
            }

        };

        LituiDropdownService.prototype.destroy = function (comId) {
            var dropdown = this.dropdowns[comId];
            if(litui.utils.isUndefined(dropdown))
                return;
            
            this.close(comId);
            dropdown.$destroy();
            litui.utils.deleteItem(comId, this.dropdowns);
        };

        LituiDropdownService.prototype.close = function (comId) {
            var dropdown = this.dropdowns[comId];
            if(litui.utils.isUndefined(dropdown))
                throw "Dropdown with component ID " + comId + " doesn't exist!";
            dropdown.$$isOpened = false;
            
            if(litui.utils.isFunction(dropdown.onClose))
                dropdown.onClose(dropdown);
            
            dropdown.$bindingElt.focus();
            
            $('body').unbind('click', dropdown.$$dismiss);
            dropdown.$holderElt.off('scroll', dropdown.$$dismiss);
            dropdown.$bindingElt.removeClass('litui-active');
            
            var $elt = dropdown.$holderElt.find('litui-dropdown[com-id=' + dropdown.comId + ']');
            this.$$transitionOut($elt).then(function(){
                dropdown.$holderElt.find('litui-dropdown[com-id=' + dropdown.comId + ']').remove();
            });
            
        };

        LituiDropdownService.prototype.compileDropdown = function ($dropdown, newScope, $holderElt) {
            var self = this;
            var $layer = this.getLayer($holderElt);

            // use existing state or expand it with new state values 
            // (will be undefined if not in self.$$state)
            var dropdownScope = litui.utils.isDefined(newScope)? newScope : (self.dropdowns[newScope.comId] || this.createDropdownScope($holderElt));
            if(litui.utils.isDefined(dropdownScope)){
                this.mergeScopes(dropdownScope, newScope);
            }
            $layer.append($dropdown);
            $compile($dropdown[0])(dropdownScope);
            return litui.async.delay(100);
        };

        LituiDropdownService.prototype.createLayer = function ($holderElt) {
            if ($holderElt.find('.litui-dropdown-layer').length === 0) {
                $holderElt.append('<div class="litui-dropdown-layer"></div>');
                return true;
            }
            return false;
        };

        LituiDropdownService.prototype.getLayer = function ($holderElt) {
            return $holderElt.find('.litui-dropdown-layer');
        };

        LituiDropdownService.prototype.createDropdownScope = function ($holderElt, data) {
            var self = this;
            var $scope = $rootScope.$new();
            $scope.$holderElt = $holderElt;
            var a = litui.lang.merge($scope, data || {});
            a.$$dismiss = function () {
                self.close(a.comId);
            };
            return a;
        };
        
        LituiDropdownService.prototype.setDropdownPosition = function($elt, $holderElt, $bindingElt, position, direction){
            var positionDir = null;
            if($('html').attr('dir') !== 'rtl'){
                positionDir = position;
            }
            else{
                if(position === 'left'){
                    positionDir = 'right';
                }
                else{
                    positionDir = 'left';
                }
            }
            
            var positionLeft = $bindingElt.offset().left - $holderElt.offset().left;
            if(positionDir === 'right')
                positionLeft = $bindingElt.offset().left - $holderElt.offset().left + ($bindingElt.outerWidth() - $elt.outerWidth());

            var positionTop = $bindingElt.offset().top + $holderElt.scrollTop() - $holderElt.offset().top + $bindingElt.outerHeight();
            if(direction === 'up')
                positionTop = $bindingElt.offset().top + $holderElt.scrollTop()  - $holderElt.offset().top - $elt.outerHeight();

            $elt.css('top', positionTop);
            $elt.css('left', positionLeft);
        };
        
        LituiDropdownService.prototype.setDropdownDimensions = function($elt, $holderElt, $bindingElt){
            if($bindingElt.offset().top + $elt.outerHeight() > $holderElt.innerHeight())
                $elt.find('.litui-dropdown-item-slots').height($holderElt.innerHeight() - $bindingElt.offset().top);
            
            if($bindingElt.outerWidth() > $elt.outerWidth())
                $elt.width($bindingElt.innerWidth());
        };
        
        LituiDropdownService.prototype.mergeScopes = function($$state, $$newState){
            var scopeValues = {};
            for(var k in $$newState){
                if(k.indexOf('$') === -1)
                    scopeValues[k] = $$newState[k];
            }
            return litui.lang.merge($$state, scopeValues);
        };
        
        LituiDropdownService.prototype.get = function(comId){
            return this.dropdowns[comId];
        };
        
        
        // ----------------------
        // --- TRANSITION POC ---
        // ----------------------
        LituiDropdownService.prototype.$$transitionIn = function($elt){
            $elt.attr('litui-transition-height', $elt.height());
            var origH = $elt.attr('litui-transition-height');
            $elt.height(0);
            
            return this.$$transition($elt, 0.1, {
                opacity: 1,
                height: origH
            });
        };
        
        LituiDropdownService.prototype.$$transitionOut = function($elt){
            $elt.attr('litui-transition-height', $elt.height());
            return this.$$transition($elt, 0.1, {
                opacity: 0,
                height: 0
            });
        };
        
        LituiDropdownService.prototype.$$transition = function($elt, time, settings){
            var d = litui.async.defer();
            TweenMax.to($elt, time, litui.lang.mergeB({
                onComplete: function(){
                    d.resolve();
                }
            }, settings));
            return d.promise;
        };

        return new LituiDropdownService();
    }
}());
'use strict';

(function () {
    angular.module('litui').directive('lituiDropdownTrigger', LituiDropdownTriggerDirective);

    /** @ngInject */
    function LituiDropdownTriggerDirective(lituiDropdownService) {
        return {
            restrict: 'A',
            scope: {
                appid: '=',
                entityId: '=',
                dropdownItems: '=',
                bindingEltSelector: '=?',
                holderEltSelector: '=?',
                position: '=?',
                direction: '=?',
                fromIndex: '=?',
                isDisabled: '=?',
                tab: '@?',
                settings: '=?'
            },
            link: function ($scope, $elt, attrs) {                    
                var self = this;                
                var $bindingElt = litui.utils.isDefined($scope.bindingEltSelector)? $($scope.bindingEltSelector) : $elt;
                if(prepareDropdownItems().length === 0)
                    return;
                
                if(litui.utils.isUndefined($scope.settings))
                    $scope.settings = {};
                
                litui.lang.mergeB({
                    
                }, $scope.settings);
                
                $elt.attr('tabindex', $scope.tab);
                $elt.attr('aria-haspopup', 'listbox');
                
                $($elt).bind('click', open);
                
                function prepareDropdownItems(){
                    var unauthorizedCount = 0;
                    var dropdownItems = [];
                    for(var i = 0; i < $scope.dropdownItems.length; i++){
                        var item = $scope.dropdownItems[i];
                        if(litui.security.isAuthorized(item.functionalityId))
                            dropdownItems.push(litui.utils.clone(item));
                        else
                            unauthorizedCount++;
                    }
                    if(dropdownItems.length === 0 && $scope.dropdownItems.length === unauthorizedCount){
                        $bindingElt.remove();
                        return [];
                    }
                    return dropdownItems;
                }
                
                function open(){
                    if(self.isDisabled)
                        return;
                    var comId = $elt.attr('com-id');
                    if(litui.utils.isUndefined(comId))
                        comId = lituiDropdownService.generateId();
                    if(!lituiDropdownService.isOpened(comId)){
                        var dropdownItems = prepareDropdownItems();
                        if(dropdownItems.length > 0)
                            return lituiDropdownService.open(litui.utils.isDefined($scope.holderEltSelector)? $($scope.holderEltSelector) : $(lituiDropdownService.defaultHolderEltSelector), {
                                $bindingElt: $bindingElt,
                                appid: $scope.appId,
                                entityId: $scope.entityId,
                                dropdownItems: dropdownItems,
                                comId: comId,
                                position: $scope.position || 'left',
                                direction: $scope.direction || 'down',
                                fromIndex: $scope.fromIndex || 0,
                                settings: {
                                    onItemSelected: $scope.settings.onItemSelected,
                                    isItemActive: $scope.settings.isItemActive
                                },
                                styleClass: $scope.settings.styleClass
                            });
                    }
                    else{
                        return lituiDropdownService.close(comId);
                    }
                }
                
                $scope.$on('$destroy', function(){
                    var comId = $elt.attr('com-id');
                    $($elt).unbind('click');
                    if(litui.utils.isDefined(comId))
                        lituiDropdownService.destroy(comId);
                });
            }
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiDropdown', {
        controller: LituiDropdownCtrl,
        templateUrl: 'litui/com/menu/litui-dropdown/litui-dropdown.html',
        bindings: {
            appid: '@',
            entityId: '@',
            comId: '@',
            bindingElt: '=',
            holderElt: '=',
            dropdownItems: '=',
            fromIndex: '=',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiDropdownCtrl($element, $scope, lituiDropdownService, $timeout){
        var self = this;
        var $elt = $($element);
        $elt.attr('tabindex', 0);
        
        var findex = -1;
        var mousetrap = null;        
        
        this.$onInit = function(){   
            litui.lang.prepareSettings({
                onItemSelected: undefined
            }, this);
            
            var scrollTop = 0;
            for(var i = 0; i < self.dropdownItems.length; i++){
                var item = self.dropdownItems[i];
                if(item.isSelected){
                    scrollTop = i*48;
                    break;
                }
            }
            TweenMax.to($elt.find('.litui-dropdown-item-slots'), 0.3, {
                scrollTop: scrollTop
            });
            
            litui.async.delay(function(){
                registerAccessibilityEvents();
                $elt.focus();
            }, 500);
            
        };
        
        this.$onDestroy = function(){
            mousetrap.unbind('esc', 'down', 'up');
        };
        
        // on selected wrapper
        this.onSelected = function(e, item, index){
            if(litui.utils.isFunction(self.settings.onItemSelected))
                self.settings.onItemSelected(e, item, index);

            var res = null;
            if(litui.utils.isFunction(item.onSelected))
                item.onSelected(e, item, self.entityId);
            lituiDropdownService.close(self.comId);
            return res;
        };
        
        function onEsc(){
            lituiDropdownService.close(self.comId);
        }
        
        function onUp(e){
            e.preventDefault();
            e.stopPropagation();

            if(findex > 0)
                $($elt.find('.litui-dropdown-item button')[findex]).blur();
            else 
                return;

            findex--;
            var $accBtn = $($elt.find('.litui-dropdown-item button')[findex]);
            $accBtn.focus();
        }
        
        function onDown(e){
            e.preventDefault();
            e.stopPropagation();

            if(findex < $elt.find('.litui-dropdown-item').length - 1)
                $($elt.find('.litui-dropdown-item button')[findex]).blur();
            else 
                return;

            findex++;
            var $accBtn = $($elt.find('.litui-dropdown-item button')[findex]);
            $accBtn.focus();
        }
        
        function registerAccessibilityEvents(){
            mousetrap = new Mousetrap($elt[0]);
            mousetrap.bind('up', onUp);
            mousetrap.bind('down', onDown);
            mousetrap.bind('esc', onEsc);
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiInlineMenuService', LituiInlineMenuServiceWrapper);
    
    /** @ngInject */
    function LituiInlineMenuServiceWrapper() {
        function LituiInlineMenuService(){
            
        }
        
        return new LituiInlineMenuService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiInlineMenu', {
        controller: LituiInlineMenu,
        templateUrl: 'litui/com/menu/litui-inline-menu/litui-inline-menu.html',
        bindings: {
            items: '=',
            entity: '=?',
            settings: '=?',
            responsive: '=?'
        }
    });
    
    /** @ngInject */
    function LituiInlineMenu(){
        var self = this;
        var inlineLimit = 3;
        var responsive = null

        this.$onInit = function(){
            litui.lang.prepareSettings({
                showLabel: false,
                defaultLimit: 3,
                onItemSelected: undefined,
                isItemActive: undefined
            }, this);

            this.dropdownSettings = {
                onItemSelected: this.settings.onItemSelected,
                isItemActive: this.settings.isItemActive
            };
            
            responsive = litui.Responsive.create(this, {
                collapse: function(){
                    self.settings.defaultLimit = 0;
                },
                breakpoint: function(breakpoint, breakpointValue){
                    self.settings.defaultLimit = breakpointValue;
                },
                postCalc: function(isTransformed){
                    if(!isTransformed)
                        self.settings.defaultLimit = inlineLimit;
                }
            });
        
            inlineLimit = self.settings.defaultLimit;
            responsive.init();
        };
        
        this.$onDestroy = function(){
            responsive.destroy();
        };
        
        this.onItemSelected = function(e, item, index){
            if(litui.utils.isFunction(item.onSelected))
                item.onSelected(e, item, self.entity, index);
            if(litui.utils.isFunction(self.settings.onItemSelected))
                self.settings.onItemSelected(e, item, self.entity, index);
            deselectAll();
//            item.isActive = true;
        };
        
        this.countAvailableItems = function(){
            var countr = 0;
            for(var i = 0; i < self.items.length; i++){
                var item = self.items[i];
                if(litui.security.isAuthorized(item.functionalityId)){
                    countr++;
                }
            }
            return countr;
        };
        
        function deselectAll(){
            for(var i = 0; i < self.items.length; i++){
                self.items[i].isActive = false;
            }
        }
    }
})();
'use strict';

(function(DebounceHandler){    

    angular.module('litui').component('lituiTogglePanel', {
        controller: LituiTogglePanel,
        templateUrl: 'litui/com/menu/litui-toggle-panel/litui-toggle-panel.html',
        bindings: {
            appid: '@',
            entityId: '=',
            toggleItems: '=',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiTogglePanel(){
        var self = this;
        var allowClick = true;
        var clickDebounce = new DebounceHandler(function(){
            allowClick = true;
        });        
        
        self.$$toggleItems = [];
        
        this.$onInit = function(){
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            litui.lang.mergeB({

            }, this.settings);
            
            self.$$toggleItems = buildStates();
            if(litui.utils.isFunction(self.settings.onInit))
                self.settings.onInit(self);
        };
        
        this.$onDestroy = function(){
            for(var i = 0; i < self.$$toggleItems.length; i++){
                var item = self.$$toggleItems[i];
                if(litui.utils.isFunction(item.onDestroy))
                    item.onDestroy();
            }
            
            if(litui.utils.isFunction(self.settings.onDestroy))
                self.settings.onDestroy(self);
        };
        
        // on selected wrapper
        this.onSelected = function(e, item){
            if(!allowClick)
                return;
            
            if(!litui.utils.isFunction(item.onChange))
                throw "LITUI Toggle panel item must implement onChange callback";
            
            var oldVal = item.value;
            item.value = !item.value;   
            item.onChange(e, item, self.entityId, item.value, oldVal);
            
            if(item.isIconMode){
                self.determineItemState(item);
            }
            allowClick = false;
            clickDebounce.debounce();
        };
        
        this.determineItemState = function(item){
            if(item.value){
                item.activeIcon = item.icons.state1;
            }
            else
                item.activeIcon = item.icons.state0;
        };        
        
        function buildStates(){
            var toggleItems = [];
            // create local copy of toggle items
            for(var i = 0; i < self.toggleItems.length; i++){
                var item = self.toggleItems[i];
                var itemCopy = litui.utils.clone(item);
                
                if(litui.utils.isFunction(itemCopy.onInit))
                    itemCopy.onInit();
                
                toggleItems.push(itemCopy);
                if(itemCopy.isIconMode){
                    self.determineItemState(itemCopy);
                }
            }
            return toggleItems;
        }
    }
})(litui.utility.DebounceHandler);
'use strict';

(function () {
    angular.module('litui').service('lituiDialogService', lituiDialogServiceWrapper);
    /** @ngInject */
    function lituiDialogServiceWrapper(lituiPopComponentService) {
        litui.lang.extend(LituiDialogService, lituiPopComponentService);
        
        function LituiDialogService(){
            lituiPopComponentService.call(this);
        }
        
        
        // -----------------
        // --- OVERRIDEN ---
        // -----------------
        LituiDialogService.prototype.open = function(settings){
            var d = litui.async.defer();
            var dialog = {
                promise: null,
                resolution: d.promise
            };
            var ismodal = litui.utils.isDefined(settings.isModal)? settings.isModal : true;
            settings.type = litui.utils.isDefined(settings.type) && settings.type.indexOf('litui-') === -1? 'litui-' + settings.type : settings.type;
            dialog.promise = lituiPopComponentService.prototype.open.call(this, litui.lang.merge(settings || {}, {
                outletId: 'popup',
                type: 'dialog',
                styleClass: settings.styleClass || '',
                size: settings.type || '',
                position:'center',
                component: settings.content || settings.component,
                isDraggable: false,
                isDismissible: litui.utils.isDefined(settings.isDismissible) && !ismodal? settings.isDismissible : false,
                dragHandle: 'litui-dialog-header',
                isBackdrop: ismodal,
                dialogResolution: d
            }));
            
            return dialog;
        };
        
        return new LituiDialogService();
    }
})();

'use strict';

(function(){
    angular.module('litui').component('lituiDialog', {
        controller: LituiDialogCtrl,
        templateUrl: 'litui/com/pop/litui-dialog/litui-dialog.html',
        bindings: {
            pop: '='
        }
    });
    
    /** @ngInject */
    function LituiDialogCtrl($element, lituiPopupService){
        var self = this;
        var $elt = $($element);
        
        this.header = null;
        
        this.$onInit = function(){
            var predefinedActions = [
                litui.lang.merge({
                    icon: 'icon-clear',
                    label: 'LITUI.DIALOG.ACTIONS.CANCEL',
                    onSelected: function(e){
                        var p = null;
                        if(litui.utils.isFunction(self.pop.settings.onCancel))
                            p = litui.async.when(self.pop.settings.onCancel(e));
                        else
                            p = litui.async.promise();
                        return p.then(function(){
                            self.pop.settings.dialogResolution.reject(self.pop);
                            return lituiPopupService.close(self.pop);
                        });
                    }
                }, this.pop.settings.btnCancel || {}),
                litui.lang.merge({
                    icon: 'icon-publish',
                    label: 'LITUI.DIALOG.ACTIONS.SUBMIT',
                    styleClass:'litui-btn-submit',
                    onSelected: function(e){
                        var p = null;
                        if(litui.utils.isFunction(self.pop.settings.onSubmit))
                            p = self.pop.settings.onSubmit(e);
                        else
                            p = litui.async.promise();
                        return litui.async.when(p).then(function(){
                            self.pop.settings.dialogResolution.resolve(self.pop);
                            return lituiPopupService.close(self.pop);
                        });
                    }
                }, this.pop.settings.btnSubmit || {})
            ];

            this.header = litui.lang.merge({
                $dropdownMenuHolder: $elt.find('.litui-dialog-inner'),
                isCloseBtn: false,
                actions: litui.lang.mergeArr(this.pop.settings.actions || [], predefinedActions)
            }, this.pop.settings.header || {});
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiPopComponentEvent', lituiPopComponentEventWrapper);
    /** @ngInject */
    function lituiPopComponentEventWrapper($compile, $rootScope, $timeout) {        
        function LituiPopComponentEvent(){
            new litui.Subscribe(this);
        }
        
        return new LituiPopComponentEvent();
    }
})();

'use strict';

(function () {
    angular.module('litui').service('lituiPopComponentFactory', lituiPopComponentFactoryWrapper);
    /** @ngInject */
    function lituiPopComponentFactoryWrapper(LituiPopComponentItem) {        
        function LituiPopComponentFactory(){
            this.defaultOutletSelector = '.litui-layout-panel-viewport .litui-active-viewport';
            this.registerEvents();
        }
        
        LituiPopComponentFactory.POP_AI = 0;
        
        LituiPopComponentFactory.prototype.producePop = function(outletId, settings){
            LituiPopComponentFactory.POP_AI++;
            var pop = LituiPopComponentItem.create(LituiPopComponentFactory.POP_AI, outletId, settings);
            return pop;
        };
        
        LituiPopComponentFactory.prototype.registerEvents = function(){

        };
        
        return new LituiPopComponentFactory();
    }
})();

'use strict';

(function () {
    angular.module('litui').service('lituiPopComponentHandler', lituiPopComponentHandlerServiceWrapper);
    /** @ngInject */
    function lituiPopComponentHandlerServiceWrapper(lituiPopComponentFactory, lituiPopComponentEvent, lituiPopComponentPositionMngr, $timeout) {        
        function LituiPopComponentHandlerService(){
            this.$parentHolder = null;
            this.pops = {};
            this.isTransiting = false;
            
            this.registerEvents();
        }
        
        
        
        LituiPopComponentHandlerService.prototype.getPop = function(id){
            return this.pops[id];
        };
        
        LituiPopComponentHandlerService.prototype.popExists = function(id){
            return litui.utils.isDefined(this.get(id));
        };
        
        LituiPopComponentHandlerService.prototype.createPop = function(settings){
            var self = this;
            var d = litui.async.defer();
            var pop = lituiPopComponentFactory.producePop(settings.outletId || 'default', settings);
            self.pops[pop.id] = pop;
            
            lituiPopComponentEvent.trigger('LITUI_POP_COMPONENT_ADD#' + pop.outletId, pop);
            
            var onCompiled = function(){
                d.resolve(pop);
                lituiPopComponentEvent.off('LITUI_POP_COMPONENT_COMPILED', onCompiled);
                pop.$keyHandler = new Mousetrap();
                pop.$keyHandler.bind('esc', function(){
                    self.closePop(pop.id);
                });
            };
            lituiPopComponentEvent.on('LITUI_POP_COMPONENT_COMPILED', onCompiled);
            
            return d.promise;
        };
        
        LituiPopComponentHandlerService.prototype.openPop = function(settings){
            return this.createPop(settings);
        };
        
        LituiPopComponentHandlerService.prototype.closePop = function(id){
            var pop = this.pops[id];
            if(litui.utils.isUndefined(pop)){
                litui.logger.error("Can not close pop component with id %o. Component not found.", id, this.pops);
                return null;
            }
            lituiPopComponentEvent.trigger('LITUI_POP_COMPONENT_REMOVE#' + pop.outletId, pop);
            
            if(litui.utils.isFunction(pop.settings.onClose))
                pop.settings.onClose(pop);
            
            if(litui.utils.isSet(pop.$backdrop))
                pop.$backdrop.remove();
            
            if(litui.utils.isDefined(pop.$keyHandler))
                pop.$keyHandler.unbind('esc');
            
            litui.utils.deleteItem(id, this.pops);
            return null;
        };
        
        LituiPopComponentHandlerService.prototype.togglePop = function(id, settings){
            
        };
        
        LituiPopComponentHandlerService.prototype.showPop = function(id){
            var self = this;
            var d = litui.async.defer();
            var pop = this.getPop(id);
            if(litui.utils.isDefined(pop)){
                this.isTransiting = true;
                var $inner = pop.$elt.find('.litui-pop-component-inner');
                var $contentHolder = pop.$elt.find('.litui-pop-component-content-holder');
                var w = $inner.width();
                var tweenConfig = {
                    height: $inner.outerHeight(),
                    onComplete: function(){
                        $inner.width("");
                        $inner.height("");
                        TweenMax.to($contentHolder, 0.2, {
                            opacity: 1
                        });
                        self.isTransiting = false;
                        d.resolve();
                    }
                   
                };
                $inner.height(0);
                
                if(pop.settings.bindedPosition === 'left' || pop.settings.bindedPosition === 'right'){
                    tweenConfig.width = $inner.width();
                    $inner.width(0);
                }
                
                // backdrop
                if(pop.settings.isBackdrop && litui.utils.isNull(pop.$backdrop)){
                    pop.$backdrop = $('<div class="litui-backdrop"></div>');
                    pop.$parentHolder.append(pop.$backdrop);
                    var opacity = pop.$backdrop.css('opacity');
                    pop.$backdrop.css('opacity', 0);
                    TweenMax.to(pop.$backdrop, 0.5, {
                        opacity: opacity
                    });
                }
                
                TweenMax.to($inner, 0.1, tweenConfig);
                TweenMax.to(pop.$elt, 0.2, {
                    opacity: 1
                });
            }
            else
                d.resolve();
            return d.promise;
        };
        
        LituiPopComponentHandlerService.prototype.hidePop = function(id){
            
        };
        
        
        
        LituiPopComponentHandlerService.prototype.registerEvents = function(){
            var self = this;
            
            lituiPopComponentEvent.on('LITUI_POP_COMPONENT_COMPILED', function(pop){
                return self.onPopCompiled(pop);
            });
            
            lituiPopComponentEvent.on('LITUI_POP_COMPONENT_CLOSE', function(pop){
                self.closePop(pop.id);
            });
        };
        
        LituiPopComponentHandlerService.prototype.setParentHolder = function(pop, $parentHolder){
            pop.$parentHolder = $parentHolder;
        };
        
        LituiPopComponentHandlerService.prototype.getParentHolder = function(pop){
            return pop.$parentHolder;
        };
        
        LituiPopComponentHandlerService.prototype.bindPopPosition = function(pop){
            if(!litui.utils.isSet(pop.settings.binder) || !litui.utils.isSet(pop.settings.bindedPosition))
                return false;
            
            lituiPopComponentPositionMngr.bindPosition(pop);            
            return true;
        };
        
        LituiPopComponentHandlerService.prototype.calcPopMarkerPosition = function(pop){
            if(!pop.settings.showPositionMarker)
                return litui.async.promise();
            
            return lituiPopComponentPositionMngr.calcMarkerPosition(pop);            
        };
        
        LituiPopComponentHandlerService.prototype.calcPopDimensions = function(pop){
            var x = pop.position.left;
            var y = pop.position.top;
            var w = pop.$elt.outerWidth();
            var h = pop.$elt.outerHeight();
            var holderH = pop.$parentHolder.innerHeight();
            
            if(y + h > holderH){
                var d = Math.abs(h - Math.abs(y + h - holderH - pop.$parentHolder.scrollTop()) - 12);
                pop.$elt.css('max-height', d);
            }
            
            var $inner = pop.$elt.find('.litui-pop-component-inner');
            var contentH = $inner.innerHeight() - litui.utils.pxToNum($inner.css('padding-top')) - litui.utils.pxToNum($inner.css('padding-bottom'));
//            pop.$elt.find('.litui-pop-component-content').css('max-height',contentH);
        };
        
        LituiPopComponentHandlerService.prototype.onPopCompiled = function(pop){
            var self = this;
            if(pop.settings.size !== 'default' && pop.settings.size !== ''){
                this.calcPredefinedSize(pop);
            }
            else{
                this.calcPopDimensions(pop);
                if(!this.bindPopPosition(pop)){
                    lituiPopComponentPositionMngr.calcPopPosition(pop);
                }
            }
            self.calcPopMarkerPosition(pop).then(function(){
                lituiPopComponentPositionMngr.xCorrection(pop); 
                return self.showPop(pop.id);
            });
        };
        
        LituiPopComponentHandlerService.prototype.move = function(pop, position){
            if(this.isTransiting)
                return;
            pop.settings.binder.x = position.x || pop.settings.binder.x;
            pop.settings.binder.y = position.y || pop.settings.binder.y;
            lituiPopComponentPositionMngr.bindPosition(pop);
            lituiPopComponentPositionMngr.xCorrection(pop);
        };
        
        LituiPopComponentHandlerService.prototype.popExists = function(popId){
            return litui.utils.isDefined(this.pops[popId]);
        };
        
        LituiPopComponentHandlerService.prototype.calcPredefinedSize = function(pop){
            var x = pop.position.left;
            var y = pop.position.top;
            var w = pop.$elt.outerWidth();
            var h = pop.$elt.outerHeight();
            var holderW = pop.$parentHolder.innerWidth();
            var holderH = pop.$parentHolder.innerHeight();
            var $sizeSetterElt = pop.$elt.find('.litui-pop-component-content');
            switch(pop.settings.size){
                case 'litui-overlay':
                    $sizeSetterElt.width(holderW);
                    $sizeSetterElt.height(holderH);
                    $sizeSetterElt.css({
                        maxHeight: ''
                    });
//                    lituiPopComponentPositionMngr.setPosition(pop, {
//                        x: pop.$parentHolder.offset().left,
//                        y: pop.$parentHolder.offset().top
//                    });
                    break;
                case 'litui-window':
                    $sizeSetterElt.width(holderW - 40);
                    $sizeSetterElt.height(holderH - 40);
                    $sizeSetterElt.css({
                        maxHeight: ''
                    });
                    lituiPopComponentPositionMngr.setPosition(pop, {
                        x: pop.$parentHolder.offset().left + 20,
                        y: pop.$parentHolder.offset().top + 20
                    });
                    break;
                case 'litui-big':
                    $sizeSetterElt.width(holderW * 0.8);
                    $sizeSetterElt.height(holderH * 0.8);
                    $sizeSetterElt.css({
                        maxHeight: ''
                    });
                    pop.settings.position = 'center';
                    lituiPopComponentPositionMngr.calcPopPosition(pop);
                    break;
                case 'litui-small':
                    $sizeSetterElt.width(400);
                    $sizeSetterElt.height(300);
                    $sizeSetterElt.css({
                        maxHeight: ''
                    });
                    pop.settings.position = 'center';
                    lituiPopComponentPositionMngr.calcPopPosition(pop);
                    break;
                case 'litui-medium':
                    $sizeSetterElt.width(holderW * 0.6);
                    $sizeSetterElt.height(holderH * 0.6);
                    $sizeSetterElt.css({
                        maxHeight: ''
                    });
                    pop.settings.position = 'center';
                    lituiPopComponentPositionMngr.calcPopPosition(pop);
                    break;
                default:
                    pop.settings.position = 'center';
                    lituiPopComponentPositionMngr.calcPopPosition(pop);
                    break;
            }

            return;
        };
        
        LituiPopComponentHandlerService.prototype.bootstrapPopComponent = function(pop, $elt, $scope){            
            var bckwrdCompatibility = pop.settings.component || pop.settings.content;
            if(litui.utils.isDefined(bckwrdCompatibility) && litui.utils.isFunction(bckwrdCompatibility.bootstrap))
                bckwrdCompatibility.bootstrap($elt, bckwrdCompatibility.params, bckwrdCompatibility, pop, pop.context, $scope);
        };
        
        
        return new LituiPopComponentHandlerService();
    }
})();

'use strict';

(function () {
    angular.module('litui').factory('LituiPopComponentItem', lituiPopComponentItemWrapper);
    /** @ngInject */
    function lituiPopComponentItemWrapper() {        
        function LituiPopComponentItem(id, outletId, settings){
            this.id = id;
            this.outletId = outletId;
            this.position = {
                left: 0,
                top: 0
            };
            this.settings = litui.lang.merge({
                bindedPosition: 'right', // left, right, top, bottom, custom
                position: 'center',
                binder: null,
                type: 'none',
                showPositionMarker: false,
                size: 'default',
                isDraggable: false,
                dragHandle: undefined,
                isDismissible: true,
                isBackdrop: false,
                showClose: false,
                component: null,
                cssClass: ''
            }, settings || {});
            this.$elt = null;
            this.$parentHolder = null;
            this.context = null;
            this.$backdrop = null;
        }
        
        LituiPopComponentItem.create = function(id, outletId, settings){
            var popComp = new LituiPopComponentItem(id, outletId, settings);
            return popComp;
        };
        
        return LituiPopComponentItem;
    }
})();

'use strict';

(function(){
    angular.module('litui').component('lituiPopComponentOutlet', {
        controller: LituiPopComponentOutletCtrl,
        templateUrl: 'litui/com/pop/litui-pop-component/litui-pop-component-outlet.html',
        bindings: {
            id: '@',
            name: '@'
        }
    });
    
    /** @ngInject */
    function LituiPopComponentOutletCtrl($element, $timeout, lituiPopComponentEvent, lituiPopComponentHandler){
        var self = this;
        this.pops = [];
        
        this.$onInit = function(){
            if(litui.utils.isDefined(this.id))
                litui.logger.warn("LITUI Pop component outlet deprecation: ID binding is obsolete, please use name attribute instead!");
            
            registerServiceEvents();
        };
        
        this.$onDestroy = function(){
            lituiPopComponentEvent.off('LITUI_POP_COMPONENT_ADD#' + (self.id || self.name), addPop);
            lituiPopComponentEvent.off('LITUI_POP_COMPONENT_REMOVE#' + (self.id || self.name), removePop);
        };
        
        function registerServiceEvents(){
            lituiPopComponentEvent.on('LITUI_POP_COMPONENT_ADD#' + (self.id || self.name), addPop);
            lituiPopComponentEvent.on('LITUI_POP_COMPONENT_REMOVE#' + (self.id || self.name), removePop);
        }
        
        function addPop(pop){
            if(!litui.utils.isSet(lituiPopComponentHandler.getParentHolder(pop)))
                lituiPopComponentHandler.setParentHolder(pop, $element.parent());
            self.pops.push(pop);
        }
        
        function removePop(pop){
            $timeout(function(){
                var index = self.pops.indexOf(pop);
                if(index > -1)
                    litui.utils.deleteElement(self.pops, index);
            });
        }
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiPopComponentPositionMngr', lituiPopComponentPositionMngrWrapper);
    /** @ngInject */
    function lituiPopComponentPositionMngrWrapper($timeout) {        
        function LituiPopComponentPositionMngr(){
            
        }
        
        LituiPopComponentPositionMngr.prototype.bindPosition = function(pop){
            var pos = this.calcBinded(pop, pop.settings.bindedPosition);
            this.setPosition(pop, pos);
        };
        
        LituiPopComponentPositionMngr.prototype.calcBinded = function(pop, bindedPosition){
            switch(bindedPosition){
                case 'top':
                    return this.calcTop(pop);
                case 'bottom':
                    return this.calcBottom(pop);
                case 'left':
                    return this.calcLeft(pop);
                case 'right':
                default:
                    return this.calcRight(pop);
            }
        };
        
        LituiPopComponentPositionMngr.prototype.setPosition = function(pop, position){
            pop.position.left = position.x - pop.$parentHolder.offset().left + pop.$parentHolder.scrollLeft();
            pop.position.top = position.y - pop.$parentHolder.offset().top + pop.$parentHolder.scrollTop();
        };
        
        LituiPopComponentPositionMngr.prototype.calcTop = function(pop){
            var pos = {
                x: pop.settings.binder.x + (pop.settings.binder.width / 2 - pop.$elt.outerWidth() / 2),
                y: pop.settings.binder.y - pop.$elt.outerHeight()
            };            
            if(pos.y >= 0){
                return pos;
            }
            pop.settings.bindedPosition = 'bottom';
            return this.calcBottom(pop);
        };
        
        LituiPopComponentPositionMngr.prototype.calcBottom = function(pop){
            var pos = {
                x: pop.settings.binder.x + (pop.settings.binder.width / 2 - pop.$elt.outerWidth() / 2),
                y: pop.settings.binder.y + pop.settings.binder.height
            };
            
            if(pos.x < 0)
                pos.x = pop.$parentHolder.offset().left;
//            if(pos.y){
                return pos;
//            }
//            return this.calcTop(pop);
        };
        
        LituiPopComponentPositionMngr.prototype.calcLeft = function(pop){
            var pos = {
                x: pop.settings.binder.x - pop.$elt.outerWidth(),
                y: pop.settings.binder.y - pop.$elt.outerHeight()/2
            };
            if(pos.y < pop.$parentHolder.offset().top){
                pos.y = pop.$parentHolder.offset().top;
            }
            if(pos.x >= 0){
                return pos;
            }
            pop.settings.bindedPosition = 'right';
            return this.calcRight(pop);
        };
        
        LituiPopComponentPositionMngr.prototype.calcRight = function(pop){
            var pos = {
                x: pop.settings.binder.x + pop.settings.binder.width,
                y: pop.settings.binder.y - pop.$elt.outerHeight()/2 + pop.settings.binder.height/2
            };
            if(pos.y < pop.$parentHolder.offset().top){
                pos.y = pop.$parentHolder.offset().top;
            }
            if(pos.x <= pop.$parentHolder.innerWidth() - pop.$elt.outerWidth()){
                return pos;
            }
            pop.settings.bindedPosition = 'left';
            return this.calcLeft(pop);
        };
        
        LituiPopComponentPositionMngr.prototype.calcMarkerPosition = function(pop){
            var d = litui.async.defer();
            $timeout(function(){
                var $marker = pop.$elt.find('.litui-pop-component-marker');
                if(pop.settings.bindedPosition === 'left' || pop.settings.bindedPosition === 'right'){
                    var eltY = pop.$elt.offset().top;
                    var bindedY = pop.settings.binder.y;
                    var markerY = Math.abs(eltY - bindedY) + pop.settings.binder.height / 2 - $marker.outerHeight() / 2;
                    $marker.css('margin-top', markerY);
                }
                else if(pop.settings.bindedPosition === 'top' || pop.settings.bindedPosition === 'bottom'){
                    $marker.css('margin-left', pop.settings.binder.x - pop.$elt.offset().left + pop.settings.binder.width/2 - $marker.outerWidth()/2);
                }
                d.resolve();
            });
            return d.promise;
        };
        
        LituiPopComponentPositionMngr.prototype.calcPopPosition = function(pop){            
            switch(pop.settings.position){
                case 'center':
                default:
                    this.setPosition(pop, {
                        x: pop.$parentHolder.offset().left + pop.$parentHolder.innerWidth()/2 - pop.$elt.outerWidth()/2,
                        y: pop.$parentHolder.offset().top + pop.$parentHolder.innerHeight()/2 - pop.$elt.outerHeight()/2
                    });
                    break;
            }
        };
        
        LituiPopComponentPositionMngr.prototype.registerDrag = function(pop){            
            var $container = pop.$parentHolder;
            var settings = {
                handle: pop.settings.dragHandle
            };
            pop.$elt.drag("start",function( ev, dd ){
                        dd.limit = $container.offset();
                        dd.limit.bottom = dd.limit.top + $container.outerHeight(true) - $( this ).outerHeight();
                        dd.limit.right = dd.limit.left + $container.outerWidth(true) - $( this ).outerWidth();
                }).drag(function( ev, dd ){
                        $( this ).css({
                                top: Math.min( dd.limit.bottom, Math.max( dd.limit.top, dd.offsetY ) ) - $container.offset().top,
                                left: Math.min( dd.limit.right, Math.max( dd.limit.left, dd.offsetX ) ) - $container.offset().left
                        });   
                }, settings);
        };
        
        LituiPopComponentPositionMngr.prototype.xCorrection = function(pop){
            var $container = pop.$parentHolder;
            var x = pop.position.left;
            if(x < 0){
                pop.$elt.find('.litui-pop-component-inner').css('margin-left', Math.abs(x));
                pop.$elt.find('.litui-pop-component-marker').css('margin-left', pop.$elt.outerWidth()/2 - pop.$elt.find('.litui-pop-component-marker').outerWidth()/2);
            }
            var farX = x + pop.$elt.outerWidth();
            if(farX > $container.innerWidth()){
                var correction = (farX - $container.innerWidth());
                pop.$elt.css('margin-left', correction * -1);
                pop.$elt.find('.litui-pop-component-marker').css('margin-left', correction + pop.$elt.outerWidth()/2 - pop.$elt.find('.litui-pop-component-marker').outerWidth()/2);
            }
            
            return x;
        };
        
        return new LituiPopComponentPositionMngr();
    }
})();

'use strict';

(function () {
    angular.module('litui').factory('lituiPopComponentService', lituiPopComponentServiceWrapper);
    /** @ngInject */
    function lituiPopComponentServiceWrapper(lituiPopComponentHandler, lituiPopComponentPositionMngr) {        
        function LituiPopComponentService(){
            this.registerEvents();
        }
        
        LituiPopComponentService.prototype.open = function(settings){
            return lituiPopComponentHandler.openPop(settings);
        };
        
        LituiPopComponentService.prototype.close = function(popover){
            return lituiPopComponentHandler.closePop(popover.id);
        };
        
        LituiPopComponentService.prototype.setPosition = function(pop, position){
            return lituiPopComponentPositionMngr.setPosition(pop, position);
        };
        
        LituiPopComponentService.prototype.registerEvents = function(){
            
        };
        
        LituiPopComponentService.prototype.exists = function(id){
            return lituiPopComponentHandler.popExists(id);
        };
        
        LituiPopComponentService.prototype.move = function(pop, position){
            return lituiPopComponentHandler.move(pop, position);
        };
        
        return LituiPopComponentService;
    }
})();

'use strict';

(function(){
    angular.module('litui').component('lituiPopComponent', {
        controller: LituiPopComponentCtrl,
        templateUrl: 'litui/com/pop/litui-pop-component/litui-pop-component.html',
        bindings: {
            component: '='
//            popupid: '=',
//            content: '=',
//            header: '=?',
//            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiPopComponentCtrl($element, $timeout, lituiPopComponentEvent, lituiPopComponentHandler, lituiPopComponentPositionMngr, $scope){
        var self = this;     
        
        this.compileComponent = null;
        
        this.$onInit = function(){
            compilePopComponent();
            self.component.context = self;
            
            self.component.$elt.on('mousedown', function(e){
                e.stopPropagation();
            });
            
            if(self.component.settings.isDraggable)
                lituiPopComponentPositionMngr.registerDrag(self.component);
            
            if(self.component.settings.isDismissible)
                $('body').on('mousedown', onDismiss);
            
        };
        
        this.onCompiled = function(e){
            lituiPopComponentHandler.bootstrapPopComponent(self.component, $element, $scope);
            lituiPopComponentEvent.trigger('LITUI_POP_COMPONENT_COMPILED', self.component, self.compileComponent);
        };
        
        function compilePopComponent(){
            var tagName = (self.component.settings.typePrefix || 'litui') + '-' + litui.utils.toKebabCase(self.component.settings.type);
            self.component.$elt = $element;
            self.component.$elt.css('opacity', 0);
            self.compileComponent = {
                template: '<' + tagName + ' pop="pop">No pop component</' + tagName + '>',
                compileTimeout: 100,
                params: {
                    pop: self.component
                }
            };
            
            if(litui.utils.isDefined(self.component.settings.size)){
                var size = self.component.settings.size.indexOf('litui-') === 0? self.component.settings.size : self.component.settings.size;
                self.component.$elt.addClass(size);
            }
        }
        
        function onDismiss(e){
            if(litui.utils.isDefined(e))
                e.stopPropagation();
            if(lituiPopComponentHandler.popExists(self.component.id))
                lituiPopComponentHandler.closePop(self.component.id);
        }
        
        this.onClose = function(e){
            onDismiss(e);
        };
        
        this.$onDestroy = function(){
            self.component.$elt.off();
            
            if(self.component.settings.isDismissible)
                $('body').off('mousedown', onDismiss);
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiPopupHeader', {
        controller: LituiPopupHeaderCtrl,
        templateUrl: 'litui/com/pop/litui-popup/litui-popup-header.html',
        bindings: {
            pop: '=',
            settings: '='
        }
    });
    
    /** @ngInject */
    function LituiPopupHeaderCtrl(lituiPopupService, $element){
        var self = this;
        var $elt = $($element);
        
        this.dropdown = null;
        
        this.$onInit = function(){
            // default settings
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};
            litui.lang.mergeB({
                title: 'Hello World',
                isCloseBtn: true,
                dropdownItems: [],
                $dropdownMenuHolder: $elt.parents('litui-popup').find('.litui-popup-inner'),
                actions: []
            }, this.settings);

            this.dropdown = {
    //            bindingEltSelector: ,
                holderEltSelector: this.settings.$dropdownMenuHolder
            };
        };
        
                
        // ------------------------
        // --- USER INTERACTION ---
        // ------------------------
        this.onActionSelected = function(e, action){
            if(litui.utils.isFunction(action.onSelected))
                return action.onSelected(e, action);
        };
        
        this.onClose = function(){
            lituiPopupService.close(self.pop);
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiPopupService', lituiPopupService);
    /** @ngInject */
    function lituiPopupService(lituiPopComponentService) {
        litui.lang.extend(LituiPopupService, lituiPopComponentService);
        
        function LituiPopupService(){
            lituiPopComponentService.call(this);
        }
        
        
        // -----------------
        // --- OVERRIDEN ---
        // -----------------
        LituiPopupService.prototype.open = function(settings){
            settings.type = litui.utils.isDefined(settings.type) && settings.type.indexOf('litui-') === -1? 'litui-' + settings.type : settings.type;
            return lituiPopComponentService.prototype.open.call(this, litui.lang.merge(settings || {}, {
                outletId: 'popup',
                type: 'popup',
                styleClass: settings.styleClass || '',
                size: settings.type || '',
                position:'center',
                component: settings.content || settings.component,
                isDraggable: (settings.type !== 'litui-overlay' && settings.type !== 'litui-window' && settings.type !== 'litui-big') && settings.isDraggable,
                dragHandle: settings.dragHandle || 'litui-popup-header'
            }));
        };
        
        return new LituiPopupService();
    }
})();

'use strict';

(function(){
    angular.module('litui').component('lituiPopup', {
        controller: LituiPopupCtrl,
        templateUrl: 'litui/com/pop/litui-popup/litui-popup.html',
        bindings: {
            pop: '='
        }
    });
    
    /** @ngInject */
    function LituiPopupCtrl($element, $compile, $scope){
        this.popRef = null;
        
        this.$onInit = function(){
            this.popRef = {
                popup: this.pop
            };
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').service('lituiPopoverService', lituiPopoverServiceWrapper);
    
    /** @ngInject */
    function lituiPopoverServiceWrapper(lituiPopComponentService) {
        litui.lang.extend(LituiPopoverService, lituiPopComponentService);
        
        function LituiPopoverService(){
           lituiPopComponentService.call(this);
        }
        
        
        // -----------------
        // --- OVERRIDEN ---
        // -----------------
        LituiPopoverService.prototype.open = function(binder, settings){
            return lituiPopComponentService.prototype.open.call(this, litui.lang.merge(settings || {}, {
                binder: (settings.customBinder)? binder : {
                    x: binder.offset().left,
                    y: binder.offset().top,
                    width: binder.outerWidth(),
                    height: binder.outerHeight(),
                    target: binder
                },
                type: 'popover',
                showPositionMarker: litui.utils.isDefined(settings.showPositionMarker)? settings.showPositionMarker : true,
                isCloseEnabled: true
            }));
        };
        
        LituiPopoverService.prototype.registerEvents = function(){
            
        };
        
        return new LituiPopoverService();
    }
})();

'use strict';

(function () {
    angular.module('litui').directive('lituiPopoverTrigger', LituiPopoverTrigger);

    /** @ngInject */
    function LituiPopoverTrigger(LituiPopoverTrigger) {
        return {
            restrict: 'A',
            scope: {
                settings: '=lituiPopoverTrigger'
            },
            link: function ($scope, $elt, attrs) {
                LituiPopoverTrigger.register($elt, $scope);                
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').factory('LituiPopoverTrigger', lituiPopoverTriggerFactoryWrapper);
    
    /** @ngInject */
    function lituiPopoverTriggerFactoryWrapper(lituiPopoverService) {
        
        function LituiPopoverTrigger($elt, $scope, debounceHandler){
           this.popover = null;
           this.isOpening = false;
           
           this.$elt = $elt;
           this.$scope = $scope;
           this.debounceHandler = debounceHandler;
        }
        
        
        LituiPopoverTrigger.prototype.init = function(){
            var self = this;
            this.$elt.addClass(this.$scope.settings.styleClass);

            if(this.$scope.settings.triggerType === 'hover'){
                this.$elt.hover(function(e){
                    self.isOpening = true;
                    self.debounceHandler.cancel();
                    self.debounceHandler.debounce();

                }, function(){
                    self.debounceHandler.cancel();
                    self.isOpening = false;
                    if(litui.utils.isSet(self.popover)){
                        lituiPopoverService.close(self.popover);
                        self.popover = null;
                    }
                });
            }
            
            this.$scope.$on('$destroy', function(){
                self.deregister();
            });
        };
        
        LituiPopoverTrigger.register = function($elt, $scope){
            if(litui.utils.isUndefined($scope.settings))
                $scope.settings = {};

            litui.lang.mergeB({
                triggerType: 'hover',
                delay: 1000,
                styleClass: 'litui-popover-trigger-hover'
            }, $scope.settings);

            var debounceHandler = new litui.utility.DebounceHandler(function(){
                trigger.debounce();
            }, {
                timeout: $scope.settings.delay
            });
            if(litui.utils.isUndefined($scope.settings.popover.styleClass))
                $scope.settings.popover.styleClass = '';
            $scope.settings.popover.styleClass += ' litui-help-legend-popover';

            var trigger = new LituiPopoverTrigger($elt, $scope, debounceHandler);
            trigger.init();
            return trigger;
        };
        
        LituiPopoverTrigger.prototype.deregister = function(){
            this.$elt.removeClass(this.$scope.settings.styleClass);

            if(this.$scope.settings.triggerType === 'hover')
                this.$elt.off();
            if(litui.utils.isSet(this.popover)){
                lituiPopoverService.close(this.popover);
                this.popover = null;
            }
            this.debounceHandler.cancel();   
        };
        
        LituiPopoverTrigger.prototype.debounce = function(){
            var self = this;
            if(this.isOpening)
                lituiPopoverService.open(this.$elt, this.$scope.settings.popover).then(function(pop){
                    self.popover = pop;
                    self.isOpening = false;
                });   
        };
        
        
        return LituiPopoverTrigger;
    }
})();

'use strict';

(function(){
    angular.module('litui').component('lituiPopover', {
        controller: LituiPopoverCtrl,
        templateUrl: 'litui/com/pop/litui-popover/litui-popover.html',
        bindings: {
            pop: '='
        }
    });
    
    /** @ngInject */
    function LituiPopoverCtrl($element, $compile, $scope){
        
    }
})();
'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTranslatePreviewNotification', {
        controller: LituiTranslatePreviewNotificationCtrl,
        templateUrl: 'litui/com/translate/litui-translate-preview-notification/litui-translate-preview-notification.html',
        bindings: {
            languageCode: '@'
        }
    });
    
    /** @ngInject */
    function LituiTranslatePreviewNotificationCtrl(lituiTranslateService){
        var self = this;
        
        this.notificationParams = null;
        
        this.$onInit = function(){
            this.notificationParams = {
                languageCode: this.languageCode
            };
        };
        
        this.onDisable = function(){
            return lituiTranslateService.preview(self.languageCode);
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiTranslationImporterService', LituiTranslationImporterServiceWrapper);
    
    /** @ngInject */
    function LituiTranslationImporterServiceWrapper(lituiDialogService) {
        function LituiTranslationImporterService(){
            
        }
        
        LituiTranslationImporterService.prototype.openImporter = function(languageCode, appId){
            var hooks = {};
            return lituiDialogService.open({
                header: {
                    title: 'LITUI.TRANSLATION_IMPORTER.TITLE'
                },
                btnSubmit: {
                    label: 'LITUI.TRANSLATION_IMPORTER.SUBMIT'
                },
                onSubmit: function(e){
                    return hooks.onSubmit(e);
                },
//                type: 'litui-medium',
                styleClass: 'litui-translation-importer-dialog',
                component: {
                    template: '<litui-translation-importer settings="settings"></litui-translation-importer>',
                    params: {
                        settings: {
                            languageCode: languageCode,
                            appId: appId,
                            hooks: hooks
                        }
                    }
                }
            });
        };
        
        return new LituiTranslationImporterService();
    }
})();


'use strict';

(function (request) {


    angular.module('litui').component('lituiTranslationImporter', {
        controller: LituiTranslationImporterCtrl,
        templateUrl: 'litui/com/translate/litui-translation-importer/litui-translation-importer.html',
        bindings: {
            settings: '='
        }
    });

    /** @ngInject */
    function LituiTranslationImporterCtrl(lituiTranslateService) {
        var self = this;
        
        this.uploadData = null;
        this.tabset = null;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                languageCode: 'en',
                appId: 'litui',
                hooks: {}
            }, this);

            this.settings.hooks.onSubmit = function (e) {
                return uploadSettings.hooks.onUpload(e).then(function(){
                    litui.notify.success({
                        title: 'LITUI.TRANSLATION_IMPORTER.IMPORT_SUCCESS.TITLE',
                        message: litui.translator.translate('LITUI.TRANSLATION_IMPORTER.IMPORT_SUCCESS.MESSAGE', {
                            languageCode: self.settings.languageCode,
                            appId: self.settings.appId
                        })
                    });
                });
            };

            var uploadSettings = {
                url: request.restBaseUrl + lituiTranslateService.getPath('importTranslations', this.settings.languageCode, this.settings.appId),
                regex: /.json$/i,
                format: 'JSON',
                text: 'LITUI.TRANSLATION_IMPORTER.UPLOAD_TEXT',
                showUploadBtn: false,
                enableProgressBar: false,
                onSuccess: function (payload) {

                },
                onFail: function () {

                },
                onClear: function () {

                },
                hooks: {}
            };

            this.uploadData = {
                formDef: {
                    fields: {
                        isOverrideExisting: {
                            type: 'boolean',
                            label: 'LITUI.TRANSLATION_IMPORTER.OVERRIDE_EXISTING'
                        },
                        isCleanImport: {
                            type: 'boolean',
                            label: 'LITUI.TRANSLATION_IMPORTER.CLEAN_IMPORT'
                        }
                    }
                },
                model: {
                    isOverrideExisting: false,
                    isCleanImport: false
                }
            };

            this.tabset = {
                tabs: [
                    {
                        label: 'JSON',
                        component: {
                            template: '<div><litui-upload settings="settings" form-data="uploadData"></litui-upload></div>',
                            params: {
                                settings: uploadSettings,
                                uploadData: {
                                    settings: this.uploadData.model
                                }
                            }
                        }

                    }
                ],
                settings: {
                    defaultTabIndex: 0
                }
            };
        };
        
    }
})(litui.request);
"use strict";

(function(){
    angular.module('litui').service('lituiTranslationToolService', LituiTranslationToolServiceWrapper);
    
    /** @ngInject */
    function LituiTranslationToolServiceWrapper() {
        function LituiTranslationToolService(){
            
        }
        
        return new LituiTranslationToolService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiTranslationTool', {
        controller: LituiTranslationToolCtrl,
        templateUrl: 'litui/com/translate/litui-translation-tool/litui-translation-tool.html',
        bindings: {
            settings: '='
        }
    });
    
    /** @ngInject */
    function LituiTranslationToolCtrl($element, lituiTranslateService, lituiCompileService, lituiTranslationImporterService, lituiFunctionalitiesMappingService){
        var self = this;
        
        var $elt = $($element);
        var translatorCom = null;
        var translatorHooks = {};
        
        this.appIds = [];
        this.appId = null;
        this.languages = [];
        this.activeLanguageId = null;
        this.activeAppId = null;
        this.isPreview = false;
        this.localStore = null;
        
        this.$onInit = function(){
            litui.lang.prepareSettings({
                refLangId: 'en',
                defaultAppId: lituiTranslateService.appId,
                enableSave: true,
                disabledAppIds: [],
                hooks: {
                    save: function(){
                        return translatorHooks.push();
                    }
                }
            }, this);

            this.activeLanguageId = litui.storage.get('translationTool.language') || this.settings.defaultLanguage;
            this.activeAppId = litui.storage.get('translationTool.appId') || this.settings.defaultAppId;
            this.isPreview = litui.config.get('translate').isPreview;
            this.appId = lituiTranslateService.appId;


            this.localStore = {
                translations: []
            };

            this.mainTools = [
                {
                    functionalityId: lituiFunctionalitiesMappingService.get('TRANSLATOR.FEATURE.SAVE'),
                    icon: 'icon-save',
                    label: 'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.SAVE',
                    isVisible: function(){
                        return self.settings.enableSave;
                    },
                    isDisabled: function(){
                        return !self.localStore.translations.length > 0
                    },
                    onSelected: onSave
                },
                {
                    functionalityId: lituiFunctionalitiesMappingService.get('TRANSLATOR.FEATURE.PREVIEW'),
                    icon: 'icon-view',
                    label: 'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.ENABLE_PREVIEW',
                    isVisible: function(){
                        if(litui.config.get('translate').isPreview){
                            return self.activeAppId === self.appId && litui.config.get('language') !== self.activeLanguageId;
                        }
                        return self.activeAppId === self.appId;
                    },
                    onSelected: onPreview
                },
                {
                    functionalityId: lituiFunctionalitiesMappingService.get('TRANSLATOR.FEATURE.IMPORT'),
                    icon: 'icon-import',
                    label: 'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.IMPORT',
                    onSelected: onImport
                },
                {
                    functionalityId: lituiFunctionalitiesMappingService.get('TRANSLATOR.FEATURE.EXPORT'),
                    icon: 'icon-export',
                    label: 'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.EXPORT',
                    onSelected: onExport
                },
                {
                    functionalityId: lituiFunctionalitiesMappingService.get('TRANSLATOR.FEATURE.PUBLISH'),
                    icon: 'icon-publish',
                    label: 'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.PUBLISH',
                    styleClass: 'litui-translation-tool-publish',
                    onSelected: onPublish
                }
            ];
            
            return lituiTranslateService.appIds().then(function(appIds){
                litui.utils.foreach(appIds, function(i, appId){
                    if(self.settings.disabledAppIds.indexOf(appId) === -1)
                        self.appIds.push(appId);
                });
                return lituiTranslateService.getLanguages(self.activeAppId);
            }).then(function(languages){
                self.languages = languages;
                
                compileTranslator();
            });
        };
        
        this.onSelectLanguage = function(e, language){
            self.activeLanguageId = language;
            translatorHooks.commit().then(function(){
                compileTranslator();
                litui.storage.set('translationTool.language', language);
            });
        };
        
        this.onSelectAppId = function(e, appId){
            self.activeAppId = appId;
            
            translatorHooks.commit().then(function(){
                compileTranslator();
                litui.storage.set('translationTool.appId', appId);
            });
        };
        
        function onSave(e) {
            translatorHooks.push();
        };

        function onPublish(e) {
            translatorHooks.publish();
        };

        function onImport(e) {
            var dialog = lituiTranslationImporterService.openImporter(self.activeLanguageId, self.activeAppId);
            dialog.resolution.then(function(){
                return compileTranslator();
            });
        };

        function onExport(e) {
            lituiTranslateService.exportTranslations(self.activeLanguageId, self.activeAppId);
        };

        function onPreview(e) {
            translatorHooks.preview();
        };
        
        function compileTranslator(){
            if(litui.utils.isSet(translatorCom))
                translatorCom = translatorCom.destroy();
                
            return lituiCompileService.compile($elt.find('.litui-translation-tool-translator'), {
                component: {
                    template: '<litui-translator language-code="' + self.activeLanguageId + '" app-id="' + self.activeAppId + '" local-store="localStore" hooks="hooks"></litui-translator>',
                    params: {
                        hooks: translatorHooks,
                        localStore: self.localStore
                    }
                }
            }).then(function(com){
                translatorCom = com;
            });
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiTranslatorService', LituiTranslatorServiceWrapper);
    
    /** @ngInject */
    function LituiTranslatorServiceWrapper() {
        function LituiTranslatorService(){
            
        }
        
        return new LituiTranslatorService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiTranslator', {
        controller: LituiTranslatorCtrl,
        templateUrl: 'litui/com/translate/litui-translator/litui-translator.html',
        bindings: {
            languageCode: '@',
            appId: '@',
            localStore: '=',
            hooks: '=?'
        }
    });

    /** @ngInject */
    function LituiTranslatorCtrl(lituiTranslateService, lituiPopoverService, lituiConfirmService, lituiFunctionalitiesMappingService) {
        var self = this;

        var hintPop = null;
        var filterDto = null;
        
        this.refTranslations = null;
        this.translations = null;
        this.searchFields = null;
        this.fmap = null;
        
        this.pagination = {
            totalCount: -1,
            pageCount: -1,
            itemPerPageCount: 200,
            currentPage: 0,
            availablePerPage: [10, 20, 100, 200]
        };
        
        this.paginationSettings = {
            onPrevious: function (pageNo, pagination) {
                self.pagination = pagination;
                return fetch();
            },
            onNext: function (pageNo, pagination) {
                self.pagination = pagination;
                return fetch();
            },
            onPage: function (pageNo, pagination) {
                return fetch();
            },
            onPerPageChanged: function(){
                return fetch().then(function(payload){
                    setPagination(payload.totalCount);
                });
            }
        };

        this.editableField = {
            type: 'plain-text'
        };
        
        this.hintsTrigger = {
            onOpen: function (e, tr) {
                if (litui.utils.isSet(hintPop)) {
                    hintPop = lituiPopoverService.close(hintPop);
                }

                var tpl = '<div>\n\
                    <div ng-repeat="hint in tr.hints" ng-click="onSelect(hint, tr)">\n\
                        <div>{{$index + 1}}. {{hint}}</div>\n\
                    </div>\n\
                </div>';

                lituiPopoverService.open($(e.currentTarget), {
                    outletId: 'litui-translator-hints-outlet',
                    component: {
                        template: tpl,
                        params: {
                            tr: tr,
                            onSelect: function (hint, tr) {
                                tr.value = hint;
                                litui.utils.deleteElement(tr.hints, tr.hints.indexOf(hint));
                                storeLocal(tr.key, tr.value);
                                lituiPopoverService.close(hintPop);
                            }
                        }
                    },
//                            component: 'TEST',
                    bindedPosition: 'left',
                }).then(function (pop) {
                    hintPop = pop;
                }, function (err) {
                    litui.logger.error("???", err);
                });
            }
        };
        
        this.searchValues = {
            key: '',
            reference: '',
            published: '',
            value: ''
        };
        

        this.$onInit = function () {            
            initHooks();

            this.searchFields = {
                key: {
                    type: 'string',
                    placeholder: litui.translator.translate('LITUI.TRANSLATOR.SEARCH.BY_KEY'),
                    enableError: false,
                    onChange: search
                },
                reference: {
                    type: 'string',
                    placeholder: litui.translator.translate('LITUI.TRANSLATOR.SEARCH.BY_REFERENCE_VALUE'),
                    enableError: false,
                    onChange: search
                },
                published: {
                    type: 'string',
                    placeholder: litui.translator.translate('LITUI.TRANSLATOR.SEARCH.BY_PUBLISHED_VALUE'),
                    enableError: false,
                    onChange: search
                },
                value: {
                    type: 'string',
                    placeholder: litui.translator.translate('LITUI.TRANSLATOR.SEARCH.BY_VALUE'),
                    enableError: false,
                    onChange: search
                }
            };

            this.fmap = lituiFunctionalitiesMappingService.getMap();

            filterDto = {
                search: self.searchValues,
                limit: {
                    from: self.pagination.currentPage,
                    numberOf: self.pagination.itemPerPageCount
                }
            };
            return loadRefTranslations().then(function () {
                return fetch().then(function (payload) {
                    setPagination(payload.totalCount);
                });
            });
        };
        
        this.onPublishSinge = function(e, tr){
            return lituiTranslateService.publishSingle(self.languageCode, self.appId, {
                key: tr.key,
                value: tr.value
            }).then(fetch);
        };

        this.onApplyToAllEqual = function (e, tr, refValue) {
            return lituiTranslateService.applyToEqual(self.languageCode, self.appId, {
                id: tr.id,
                key: tr.key,
                value: tr.value,
                languageCode: tr.languageCode,
                refValue: refValue
            }).then(function (payload) {
                litui.notify.success({
                    title: 'LITUI.TRANSLATOR.APPLY_TO_EQUAL.SUCCESS.TITLE',
                    message: litui.translator.translate('LITUI.TRANSLATOR.APPLY_TO_EQUAL.SUCCESS.MESSAGE', {
                        number: payload.updateCount
                    })
                });
            }).then(loadRefTranslations).then(fetch);
        };

        this.onValueChanged = function (e, val, field) {
//            self.hooks.commit(e.ctrl.name, val);
            storeLocal(e.ctrl.name, val);
        };

        function fetch() {
            self.localStore.translations = [];
            filterDto.limit.from = self.pagination.currentPage;
            filterDto.limit.numberOf = self.pagination.itemPerPageCount;

            return lituiTranslateService.fetch(self.appId, self.languageCode, filterDto).then(function (payload) {
                var translations = [];
                for (var i = 0; i < payload.data.length; i++) {
                    var tr = payload.data[i];
                    tr.originValue = tr.value;

                    for (var j = 0; j < self.localStore.translations.length; j++) {
                        var trLoc = self.localStore.translations[j];

                        if (trLoc.key === tr.key && trLoc.languageCode === tr.languageCode && tr.value !== trLoc.value && trLoc.originValue === tr.value) {
                            tr.value = trLoc.value;
                            break;
                        }
                    }

                    translations.push(tr);
                }
                self.translations = translations;
                return payload;
            });
        }
        
        function loadRefTranslations(){
            return lituiTranslateService.loadRef(self.appId).then(function (refTranslations) {
                self.refTranslations = refTranslations;
            });
        }

        function setPagination(totalCount) {
            self.pagination.totalCount = totalCount;
            self.pagination.pageCount = Math.ceil(self.pagination.totalCount / self.pagination.itemPerPageCount);
        }

        function storeLocal(key, value) {
            if (litui.utils.isNull(self.translations))
                return;

            for (var i = 0; i < self.translations.length; i++) {
                var tr = self.translations[i];

                if (tr.key !== key)
                    continue;

                var exists = false;
                for (var j = 0; j < self.localStore.translations.length; j++) {
                    var trLoc = self.localStore.translations[j];
                    if (trLoc.key === tr.key && trLoc.languageCode === tr.languageCode && trLoc.appId === tr.appId && trLoc.value !== value) {
                        if (trLoc.value !== value)
                            trLoc.value = value;
                        exists = true;
                        break;
                    }
                }

                if (!exists && tr.originValue !== value) {
                    self.localStore.translations.push(tr);
                    return;
                }
            }
        }

        var searchDebounce = new litui.utility.DebounceHandler(function () {
            fetch().then(function (payload) {
                setPagination(payload.totalCount);
            });
        }, {
            timeout: 200
        });

        function search() {
            self.pagination.currentPage = 0;
            return searchDebounce.debounce();
        }
        
        function initHooks(){
            litui.lang.prepareSettings({
                hooks: {}
            }, self, 'hooks');
            
            self.hooks.push = function () {
                var list = [];
                for (var i = 0; i < self.localStore.translations.length; i++) {
                    var item = self.localStore.translations[i];
                    list.push({
                        id: item.id,
                        key: item.key,
                        value: item.value,
                        languageCode: item.languageCode,
                        appId: item.appId
                    });
                }

                return lituiTranslateService.saveTranslations(self.languageCode, self.appId, list).then(function () {
                    self.localStore.translations = [];
                    litui.notify.success({
                        title: "LITUI.TRANSLATOR.SAVE.SUCCESS.TITLE",
                        message: "LITUI.TRANSLATOR.SAVE.SUCCESS.MESSAGE"
                    });
                    return lituiTranslateService.loadRef(self.appId).then(function (refTranslations) {
                        self.refTranslations = refTranslations;
                        return fetch();
                    });
                });
            };
            
            self.hooks.commit = function (key, value) {
                storeLocal(key, value);
                return litui.async.promise();
            };
            
            self.hooks.publish = function () {
                return lituiConfirmService.notify({
                    icon: 'icon-publish',
                    label: 'LITUI.TRANSLATOR.PUBLISH.CONFIRM.LABEL',
                    title: 'LITUI.TRANSLATOR.PUBLISH.CONFIRM.TITLE',
                    text: 'LITUI.TRANSLATOR.PUBLISH.CONFIRM.MESSAGE',
                    onSubmit: function(){
                        self.hooks.push().then(function () {
                            return lituiTranslateService.publish(self.languageCode, self.appId);
                        }).then(fetch).then(function (payload) {
                            litui.notify.success({
                                "title": "LITUI.TRANSLATOR.PUBLISH.SUCCESS.TITLE",
                                "message": litui.translator.translate("LITUI.TRANSLATOR.PUBLISH.SUCCESS.MESSAGE", {
                                    languageCode: self.languageCode,
                                    appId: self.appId
                                })
                            });
                            return payload;
                        });
                    }
                }).resolution;
            };
            
            self.hooks.preview = function () {
                return lituiTranslateService.preview(self.languageCode, self.appId);
            };
        }
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiBanner', {
        templateUrl: 'litui/com/info/litui-dashboard/litui-banner/litui-banner.html',
        controller: LituiBanner,
        bindings: {
            imagesrc: '=',
            imageposition: '=',
            tapeTitle: '=',
            enableEditMode: '=?',
            uploadService: '=?',
            options: '=?',
            settings: '=?'
        }
    });
    
    /** @ngInject */
    function LituiBanner($scope, $timeout, $element){  
        var self = this;
        var $elt = $($element);
        
        this.isBannerEditMode = false;
        this.isBannerImgUploadMode = true;
        this.isBannerPositioningMode = false;
        self.isImgPending = false;
        
        this.imageSettings = {
            scale: 'none'
        };    
        
        this.lituiUploadImg = null;
        
        $scope.$on('lituiUploadImgDisable', function(val){
            self.isBannerImgUploadMode = val;
        });
        
        $scope.$on('lituiUploadImgSelected', function(val){
            self.isImgPending = val;
            self.isBannerPositioningMode = val;
        });
        
        this.$onInit = function(){
            if(this.enableEditMode === undefined)
                this.enableEditMode = false;
            if(this.enableEditMode && litui.utils.isUndefined(this.uploadService))
                new litui.Exception("No file upload service defined for banner edit mode!", this, "component");

            litui.lang.prepareSettings({
                imageproperties: {
                    size: 'cover',
                    attachment: 'fixed',
                    repeat: 'none'
                }
            }, this);
            
            this.lituiUploadImg = {
                url: this.uploadService || '__NONE__',
                text: 'Upload new image',
                onSuccess: function(payload){
                    $timeout(function(){
                        if(litui.utils.isUndefined(payload) || litui.utils.isUndefined(payload.src)){
                            litui.logger.error("No banner image source returned or returned payload is not of correct DTO type!");
                        }
                        self.imagesrc = payload.src;
                        self.imageposition.top = payload.position.top;
                        self.imageposition.left = payload.position.left;
                        self.exitBannerEditMode();
                    });
                    litui.notify.success({
                        title: 'LITUI.BANNER.SAVED_TITLE',
                        message: 'LITUI.BANNER.SAVED_TXT'
                    });
                },
                onFail: function(){
                    litui.logger.error("Uploading of image has failed");
                },
                onClear: function(){

                    self.isBannerImgUploadMode = false;
                    self.isImgPending = false;
                }
            };   
        };
        
        this.enterBannerPositioningMode = function(){
            self.isBannerPositioningMode = true;
            self.isBannerImgUploadMode = false;
            
            if(litui.utils.isString(self.imagesrc))
                $scope.$broadcast('lituiUploadImgPreview', {
                    imagesrc: self.imagesrc,
                    position: self.imageposition
                });
        };
        
        this.enterBannerImgUploadMode = function(){
            self.isBannerPositioningMode = false;
            self.isBannerImgUploadMode = true;
            
            $scope.$broadcast('lituiUploadImgPreviewExit');
        };
        
        this.exitBannerEditMode = function(){
            self.isBannerEditMode = false;
            self.isBannerPositioningMode = false;
            self.isBannerImgUploadMode = true;
        };
        
        this.onEdit = function(){
            self.isBannerEditMode = true;
        };
        
        this.onUploadBannerImg = function(e){
            $scope.$broadcast('lituiUploadImgExecute', e);
        };
        
        this.onEnterBannerPositioningMode = function(e){
            self.enterBannerPositioningMode();
        };
        
        this.onEnterBannerImgUploadMode = function(e){
            self.enterBannerImgUploadMode();
        };
        
        this.onExitBannerEditMode = function(e){
            self.exitBannerEditMode();
        };
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiBannerOptions', {
        controller: LituiDashboardOptionsCtrl,
        templateUrl: 'litui/com/info/litui-dashboard/litui-banner-options/litui-banner-options.html',
        bindings: {
            options: '='
        }
    });

    /** @ngInject */
    function LituiDashboardOptionsCtrl(){
        
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiDashboardSectionService', LituiDashboardSectionServiceWrapper);
    
    /** @ngInject */
    function LituiDashboardSectionServiceWrapper() {
        function LituiDashboardSectionService(){
            this.updateLocation = false;
            this.activeSectionId = null;
            this.$headerNavElt = null;
            new litui.Subscribe(this, [
                'ACTIVATE_SECTION',
                'SET_BANNER_OPACITY'
            ]);
        }
        
        LituiDashboardSectionService.prototype.setHeaderNavElt = function($elt){
            this.$headerNavElt = $elt;
        };
        
        LituiDashboardSectionService.prototype.getHeaderNavElt = function(){
            return this.$headerNavElt;
        };
        
        LituiDashboardSectionService.prototype.goto = function(sectionId){
            litui.utils.stateParam('section', sectionId);
        };
        
        LituiDashboardSectionService.prototype.activateSection = function(sectionId){
            if(this.activeSectionId === sectionId)
                return;
            console.log("Activate section", sectionId);
            this.trigger('ACTIVATE_SECTION', sectionId);
            this.trigger('ACTIVATE_SECTION:' + sectionId, sectionId);
            
            this.activeSectionId = sectionId;
        };
        
        return new LituiDashboardSectionService();
    }
})();

'use strict';

(function(){
    
    
    angular.module('litui').component('lituiDashboardSection', {
        controller: LituiDashboardSection,
        templateUrl: 'litui/com/info/litui-dashboard/litui-dashboard-section/litui-dashboard-section.html',
        bindings: {
            section: '='
        }
    });
    
    /** @ngInject */
    function LituiDashboardSection(lituiDashboardSectionService, $element){
        var $elt = $($element);
        
        this.$onInit = function(){
            lituiDashboardSectionService.on('ACTIVATE_SECTION', activateSectionHandler);
            lituiDashboardSectionService.on('ACTIVATE_SECTION:' + this.section.id, activateSpecificSectionHandler);
        };
        
        this.$onDestroy = function(){
            lituiDashboardSectionService.off('ACTIVATE_SECTION', activateSectionHandler);
            lituiDashboardSectionService.off('ACTIVATE_SECTION:' + this.section.id, activateSpecificSectionHandler);
        };
        
        function activateSectionHandler(){
            var $header = $elt.find('.litui-dashboard-section-header-inner');
            TweenMax.to($header, 0.3, {
                top: 0
            });
        }
        
        function activateSpecificSectionHandler(){
            var $header = $elt.find('.litui-dashboard-section-header-inner');
            TweenMax.to($header, 0.5, {
                top: -$header.outerHeight()
            });
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').factory('LituiDashboardSectionsScroll', LituiDashboardSectionsScrollFactoryWrapper);
    
    /** @ngInject */
    function LituiDashboardSectionsScrollFactoryWrapper($rootScope, lituiDashboardSectionService, lituiLayoutMngrService, lituiNotification) {
        function LituiDashboardSectionsScrollFactory($rootElt){
            var self = this;
            
            this.$rootElt = $rootElt;
            this.currentSectionId = null;
            this.isPreventLocationChange = false;
            this.isTransiting = false;
            this.notif = null;
            this.locationChangeEventHandler = null;
            
            this.eventHandlers = {
                viewportScroll: function(){
                    return self.onScroll.apply(self, arguments);
                },
                viewportScrollEnd: function(){
                    return self.onScrollEnd.apply(self, arguments);
                },
                locationChanged: function(){
                    return self.onLocationChange.apply(self, arguments);
                },
                resizeEnd: function(){
                    self.onScroll(lituiLayoutMngrService.getPanelElt('viewport').find('.litui-active-viewport'));
                }
            };
        }
        
        LituiDashboardSectionsScrollFactory.create = function($rootElt){
            var scrollHandler = new LituiDashboardSectionsScrollFactory($rootElt);
            return scrollHandler.init();
        };
        
        LituiDashboardSectionsScrollFactory.prototype.init = function() {       
            var self = this;
            var d = litui.async.defer();
            litui.async.delay(function(){
                self.onLocationChange();
                d.resolve(self);
            }, 100);
            
            this.registerEventsHandlers();
            return d.promise;
        };
        
        LituiDashboardSectionsScrollFactory.prototype.destroy = function() {       
            if(litui.utils.nonNull(this.locationChangeEventHandler))
                this.locationChangeEventHandler();
            
            lituiLayoutMngrService.off('VIEWPORT_SCROLL', this.eventHandlers.viewportScroll);
            lituiLayoutMngrService.off('VIEWPORT_SCROLL_END', this.eventHandlers.viewportScrollEnd);
            lituiLayoutMngrService.off('RESIZE_END', this.eventHandlers.resizeEnd);
        };
        
        LituiDashboardSectionsScrollFactory.prototype.registerEventsHandlers = function() {       
            this.locationChangeEventHandler = $rootScope.$on('$locationChangeSuccess', this.eventHandlers.locationChanged);
            lituiLayoutMngrService.on('VIEWPORT_SCROLL', this.eventHandlers.viewportScroll);
            lituiLayoutMngrService.on('VIEWPORT_SCROLL_END', this.eventHandlers.viewportScrollEnd);
            lituiLayoutMngrService.on('RESIZE_END', this.eventHandlers.resizeEnd);
        };
        
        LituiDashboardSectionsScrollFactory.prototype.onScroll = function($viewport) {
            var scrollTop = $viewport.scrollTop();
            this.setBannerOverlayOpacity(scrollTop);
            
            if (this.isTransiting)
                return;

            var sectionId = this.calcSectionId(scrollTop);

            if (this.currentSectionId === sectionId)
                return;
            
            if(!this.validateAnchorElement(sectionId))
                return;
            
            this.currentSectionId = sectionId;
            lituiDashboardSectionService.activateSection(this.currentSectionId);
        };

        LituiDashboardSectionsScrollFactory.prototype.onScrollEnd = function() {
            var self = this;
            
            this.isPreventLocationChange = true;
            litui.utils.stateParam('section', litui.utils.isNull(this.currentSectionId)? undefined : this.currentSectionId);
            litui.async.delay(function(){
                self.isPreventLocationChange = false;
            });
        };

        LituiDashboardSectionsScrollFactory.prototype.onLocationChange = function() {            
            if(this.isPreventLocationChange){
                return;
            }
            
            this.currentSectionId = litui.utils.stateParam('section');
            
            if(!this.validateAnchorElement(this.currentSectionId))
                return;
            
            lituiDashboardSectionService.activateSection(this.currentSectionId);
            this.scrollTo(this.currentSectionId);
        };

        LituiDashboardSectionsScrollFactory.prototype.scrollTo = function(sectionId) {
            var self = this;
            
            var $viewport = lituiLayoutMngrService.getPanelElt('viewport').find('.litui-active-viewport');
            var $anchor = this.$rootElt.find('[litui-dashboard-section-id=' + sectionId + ']');
            
            var y = 0;
            if (litui.utils.isSet(sectionId))
                y = Math.ceil($anchor.offset().top + $viewport.scrollTop());

            var d = litui.async.defer();
            this.isTransiting = true;
            $viewport.stop().animate({
                scrollTop: y
            }, 500, 'swing', function () {
                self.isTransiting = false;
                d.resolve();
            });
            return d.promise;
        };

        LituiDashboardSectionsScrollFactory.prototype.calcSectionId = function(scrollTop) {
            var length = this.$rootElt.find('litui-dashboard-section').length;
            for (var i = 0; i < length; i++) {
                var $curr = $(this.$rootElt.find('litui-dashboard-section')[i]);
                if (i < length - 1) {
                    var $next = $(this.$rootElt.find('litui-dashboard-section')[i + 1]);
                    if (scrollTop + $next.find('.litui-dashboard-section-header').height() >= $curr.offset().top + scrollTop &&
                            scrollTop + $next.find('.litui-dashboard-section-header').height() < $next.offset().top + scrollTop)
                        return $curr.attr('litui-dashboard-section-id');
                } else if (scrollTop + $curr.find('.litui-dashboard-section-header').height() >= $curr.offset().top + scrollTop)
                    return $curr.attr('litui-dashboard-section-id');
            }
            return null;
        };
        
        LituiDashboardSectionsScrollFactory.prototype.setBannerOverlayOpacity = function(scrollTop){
            var sectionTop = 0;            
            if(this.$rootElt.find('litui-dashboard-section').length > 0)
                sectionTop = $(this.$rootElt.find('litui-dashboard-section')[0]).offset().top;
            var opacity = scrollTop / (sectionTop + scrollTop);            
            if(opacity <= 1)
                lituiDashboardSectionService.trigger('SET_BANNER_OPACITY', opacity);
        };
        
        LituiDashboardSectionsScrollFactory.prototype.validateAnchorElement = function(sectionId){
            if(litui.utils.notSet(sectionId))
                return true;
            
            var $anchor = this.$rootElt.find('[litui-dashboard-section-id=' + sectionId + ']');
            if($anchor.length === 0 && litui.utils.isNull(this.notif)){
                return false;
            }
            else if(litui.utils.nonNull(this.notif)){
                lituiNotification.remove(this.notif);
                this.notif = null;
            }
            return true;
        };
        
        return LituiDashboardSectionsScrollFactory;
    }
})();

'use strict';

(function () {


    angular.module('litui').component('lituiDashboardSections', {
        controller: LituiDashboardSections,
        templateUrl: 'litui/com/info/litui-dashboard/litui-dashboard-section/litui-dashboard-sections.html',
        bindings: {
            sections: '=',
            settings: '=?'
        }
    });

    /** @ngInject */
    function LituiDashboardSections($element, LituiDashboardSectionsScroll) {        
        var scrollHandler = null;        

        this.$onInit = function () {
            if (litui.utils.isUndefined(this.settings))
                this.settings = {};

            litui.lang.mergeB({
                defaultSectionId: undefined,
                noDefaultSection: true
            }, this.settings);
            
            return LituiDashboardSectionsScroll.create($($element)).then(function(scrollHandlerInst){
                scrollHandler = scrollHandlerInst;
            });
        };

        this.$onDestroy = function () {            
            scrollHandler.destroy();
        };

        
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiDashboardHeaderService', LituiDashboardHeaderServiceWrapper);
    
    /** @ngInject */
    function LituiDashboardHeaderServiceWrapper() {
        function LituiDashboardHeaderService(){
            new litui.Subscribe(this, [
                'SELECT_SECTION'
            ]);
        }
        
        return new LituiDashboardHeaderService();
    }
})();


'use strict';

(function () {


    angular.module('litui').component('lituiDashboardHeader', {
        controller: LituiDashboardHeader,
        templateUrl: 'litui/com/info/litui-dashboard/litui-dashboard-header/litui-dashboard-header.html',
        bindings: {
            sections: '=',
            banner: '=',
            settings: '=?'
        }
    });

    /** @ngInject */
    function LituiDashboardHeader(lituiDashboardSectionService, lituiAppMenuService, $element) {
        var self = this;
        var $elt = $($element);
        
        this.activeSection = null;
        this.showAppMenuBtn = true;
        
        // follow scroll position
//        lituiLayoutMngrService.on('VIEWPORT_SCROLL', function ($vp) {
//            $elt.css('top', $vp.scrollTop());
//        });

        lituiDashboardSectionService.on('ACTIVATE_SECTION', activateSectionHandler);
        lituiAppMenuService.on('AUX_APP_MENU_BTN', onAuxAppMenuBtn);
        
        this.$onInit = function(){
            // set header element so it can be accessed by multiple components
            lituiDashboardSectionService.setHeaderNavElt($elt);
            this.showAppMenuBtn = !lituiAppMenuService.isVisible;
            
            if(litui.utils.isUndefined(this.settings))
                this.settings = {};

            this.loadingIndicator = {
                onLoad: function (dto) {
                    if (litui.utils.isDefined(self.settings) &&
                            litui.utils.isFunction(self.settings.onLoad)) {
                        return self.settings.onLoad(dto);
                    }
                }
            };

            this.defaultSection = litui.lang.merge({
                id: undefined,
                icon: 'icon-menu_home',
                title: 'Home'
            }, this.settings.defaultSection || {});

            this.headerMenu = {
                items: [],
                settings: {
                    showLabels: false,
                    defaultLimit: 3,
                    onItemSelected: function(e, item){
                        console.log("GOTO SECTION!!");
                        lituiDashboardSectionService.goto(item.sectionId);
                    },
                    isItemActive: function(item){
                        if(litui.utils.isNull(self.activeSection))
                            return false;
                        return item.sectionId === self.activeSection.id;
                    }
                },
                responsive: {
                    breakpoints: {
                        700: 2,
                        620: 1,
                        550: 0
                    }
                }
            };
            
            buildHeaderMenu();
        };
        
        this.$onDestroy = function () {
            lituiDashboardSectionService.off('ACTIVATE_SECTION', activateSectionHandler);
            lituiDashboardSectionService.off('AUX_APP_MENU_BTN', onAuxAppMenuBtn);
        };

        this.onGoto = function (e, section) {
            lituiDashboardSectionService.goto(section.id);
        };

        function activateSectionHandler(sectionId) {
//            litui.async.delay(function () {
                titleTransitionOut().then(function () {
                    if (!litui.utils.isSet(sectionId)) {
                        self.activeSection = self.defaultSection;
                        $elt.removeClass('litui-dashboard-hassection');
                        return;
                    }

                    for (var i = 0; i < self.sections.length; i++) {
                        var section = self.sections[i];
                        if (section.id === sectionId) {
                            self.activeSection = section;
                            break;
                        }
                    }
                    if (!litui.utils.isNull(self.activeSection) && litui.utils.isSet(self.activeSection.id))
                        $elt.addClass('litui-dashboard-hassection');
                    return titleTransitionIn();
                });


//            });
        }

        function onAuxAppMenuBtn(isShow) {
            litui.async.delay(function () {
                self.showAppMenuBtn = isShow;
            });
        }

        function titleTransitionOut() {
            var d = litui.async.defer();
            var $title = $elt.find('.litui-dashboard-header-title');
            TweenMax.to($title, 0.2, {
                top: -$title.outerHeight(),
                onComplete: function () {
                    d.resolve();
                }
            });
            return d.promise;
        }

        function titleTransitionIn() {
            var d = litui.async.defer();
            var $title = $elt.find('.litui-dashboard-header-title');
            $title.css('top', $title.height());
//            d.resolve();
            TweenMax.to($title, 0.2, {
                top: 0,
                onComplete: function () {
                    d.resolve();
                }
            });
            return d.promise;
        }
        
        function buildHeaderMenu(){
            litui.utils.foreach(self.sections, function(i, section){
                self.headerMenu.items.push({
                    sectionId: section.id,
                    icon: section.icon,
                    label: section.title,
                    tooltip: section.title,
                    functionalityId: section.functionalityId
                });
            });
        }
    }
})();
'use strict';

//(function(){
//    angular.module('litui').component('lituiDashboard', {
//        controller: LituiDashboardCtrl,
//        templateUrl: 'litui/com/litui-dashboard/litui-dashboard.html',
//        bindings: {
//            banner: '='
//        }
//    });
//    
//    /** @ngInject */
//    function LituiDashboardCtrl(){
//        
//    }
//})(lt.$$const);
(function(){
    angular.module('litui').directive('lituiDashboardWidget', LituiDashboardWidgetDirective);
    
    /** @ngInject */
    function LituiDashboardWidgetDirective(){
        return { 
            restrict: 'E', 
            transclude: { 
                
            },
            scope: { 
                title: '=widgetTitle'
            },
            //Let's change the order of elements
            templateUrl: 'litui/com/info/litui-dashboard/litui-dashboard-widget/litui-dashboard-widget.html',
            link: function(){
                
            }
        };
    }
})();
'use strict';

(function () {


    angular.module('litui').component('lituiDatatableCell', {
        controller: LituiDatatableCellCtrl,
        templateUrl: 'litui/com/info/litui-datatable/litui-datatable-cell/litui-datatable-cell.html',
        bindings: {
            entity: '<',
            column: '<'
        }
    });

    /** @ngInject */
    function LituiDatatableCellCtrl() {
        var self = this;
        this.cellArgs = {};
        
        var oldEntity;
        var oldColumn;
        
        this.$onChanges = function(){
            if(!litui.utils.equals(self.entity, oldEntity) ||
                !litui.utils.equals(self.column, oldColumn)){
                
                if(litui.utils.isUndefined(self.column))
                    return;
                
                if(litui.utils.isUndefined(self.column.component) && 
                    litui.utils.isDefined(self.column.cellFilter)){
                    self.cellArgs = {
                        filter: self.column.cellFilter, 
                        entity: self.entity, 
                        col: self.column
                    };
                }
                else if(litui.utils.isDefined(self.column.component)){
                    self.cellArgs = {
                        entity: self.entity,
                        col: { 
                            label: self.column.label 
                        }
                    };
                }
                
                oldEntity = litui.lang.copy(self.entity);
                oldColumn = litui.lang.copy(self.column);
            }
        };
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiChecklistTrigger', LituiChecklistTriggerDirective);

    /** @ngInject */
    function LituiChecklistTriggerDirective(lituiPopoverService) {
        return {
            restrict: 'A',
            scope: {
                items: '=',
                mapping: '=?',
                visibility: "=?"
            },
            link: function ($scope, $elt, attrs) {
                var pop = null;
                $elt.on('click', function(){
                    if(litui.utils.isNull(pop))
                        lituiPopoverService.open($elt, {
                            component: {
                                template: '<litui-checklist items="items" mapping="mapping" visibility="visibility"></litui-checklist>',
                                params: {
                                    items: $scope.items,
                                    mapping: $scope.mapping,
                                    visibility: $scope.visibility
                                }
                            },
                            onClose: function(){
                                $elt.removeClass('litui-active');
                                pop = null;
                            },
                            bindedPosition: 'bottom',
                            showPositionMarker: true,
                            styleClass: 'litui-checklist-dropdown'
                        }).then(function(popover){
                            pop = popover;
                            $elt.addClass('litui-active');
                        });
                    else{
                        pop = lituiPopoverService.close(pop);
                    }
                });
                
                $scope.$on('$destroy', function(){
                    if(litui.utils.nonNull(pop))
                        pop = lituiPopoverService.close(pop);
                    
                    $elt.off();
                });
            }
        };
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiChecklistTriggerService', LituiChecklistTriggerServiceWrapper);
    
    /** @ngInject */
    function LituiChecklistTriggerServiceWrapper() {
        function LituiChecklistTriggerService(){
            
        }
        
        return new LituiChecklistTriggerService();
    }
})();


"use strict";

(function(){
    angular.module('litui').service('lituiViewFooterDrawerService', LituiViewFooterDrawerServiceWrapper);
    
    /** @ngInject */
    function LituiViewFooterDrawerServiceWrapper() {
        function LituiViewFooterDrawerService(){
            this.isVisible = false;
            this.isInitialized = false;
            
            new litui.Subscribe(this, ['SHOW', 'HIDE', 'SET_COMPONENT', 'READY']);
        }
        
        LituiViewFooterDrawerService.prototype.toggle = function(){
            if(this.isVisible)
                return this.hide();
            return this.show();
        };
        
        LituiViewFooterDrawerService.prototype.show = function(){
            var r = this.trigger('SHOW');
            this.isVisible = true;
            return r;
        };
        
        LituiViewFooterDrawerService.prototype.hide = function(){
            var r = this.trigger('HIDE');
            this.isVisible = false;
            return r;
        };
        
        LituiViewFooterDrawerService.prototype.setComponent = function(component){
            return this.trigger('SET_COMPONENT', component);
        };
        
        return new LituiViewFooterDrawerService();
    }
})();


'use strict';

(function(){
    
    
    angular.module('litui').component('lituiViewFooterDrawer', {
        controller: LituiViewFooterDrawerCtrl,
        templateUrl: 'litui/com/layout/litui-view-footer/litui-view-footer-drawer/litui-view-footer-drawer.html',
        bindings: {

        }
    });
    
    /** @ngInject */
    function LituiViewFooterDrawerCtrl($element, lituiViewFooterDrawerService){
        var self = this;
        var $elt = $($element);
        
        this.$onInit = function(){
            lituiViewFooterDrawerService.on('SHOW', show);
            lituiViewFooterDrawerService.on('HIDE', hide);
            lituiViewFooterDrawerService.on('SET_COMPONENT', setComponent);
            
            lituiViewFooterDrawerService.isInitialized = true;
            lituiViewFooterDrawerService.trigger('READY');
        };
        this.$onDestrpy = function(){
            lituiViewFooterDrawerService.off('SHOW', show);
            lituiViewFooterDrawerService.off('HIDE', hide);
            lituiViewFooterDrawerService.off('SET_COMPONENT', setComponent);
        };
        
        this.onHide = function(){
            lituiViewFooterDrawerService.hide();
        };
        
        function show(){
            $elt.css('display', 'block');
            return $animateTop(0);
        }
        
        function hide(){
            return $animateTop($elt.find('.litui-view-footer-drawer-inner').height()).then(function(){
                $elt.css('display', 'none');
            });
        }
        
        function setComponent(component){
            self.component = component;
        }
        
        function $animateTop(val){
            var d = litui.async.defer();
            TweenMax.to($elt.find('.litui-view-footer-drawer-inner .litui-view-footer-drawer-content'), 0.2, {
                top: val,
                onComplete: function(){
                    d.resolve();
                }
            });
            return d.promise;
        }
    }
})();
'use strict';

(function(){
    angular.module('litui').directive('lituiAppMenuBrand', directive);
    
    /** @ngInject */
    function directive(){
        var tpl = '';
        tpl += '<div class="litui-app-menu-brand">';
        tpl += '    <div class="litui-logo-html" ng-if="logoImg.length === 0 && brandname.length === 0"></div>';
//        tpl += '    <div class="litui-brandname"><span ng-if="logoImg.length === 0 && brandname.length > 0">{{brandname}}</span></div>';
        tpl += '    <div class="litui-brandname" ng-if="logoImg.length === 0 && brandname.length > 0">{{brandname}}</div>';
        tpl += '    <div class="litui-logo-img litui-nav-logo" ng-if="logoImg.length > 0" ng-style="{\'background-image\': \'url(\' + logoImg + \')\'}"></div>';
        tpl += '</div>';
        
        return {
            restrict: 'E',
            replace: true,
            controller: LituiAppMenuBrandCtrl,
            template: tpl,
            scope: {
                logoImg: '=?',
                brandname: '=?'
            }
        };
    }
    
    /** @ngInject */
    function LituiAppMenuBrandCtrl($scope){
        if(litui.utils.isUndefined($scope.brandname))
            $scope.brandname = "";
        if(litui.utils.isUndefined($scope.logoImg))
            $scope.logoImg = "";
    }
})();
'use strict';

(function(){
    angular.module('litui').directive('lituiAppMenuBtn', directive);
    
    /** @ngInject */
    function directive(){
        var tpl = '';
        tpl += '<button ng-click="onSelect($event)" litui-ripple-fx aria-label="{{\'LITUI.APP_MENU.ACCESSIBILITY.APP_MENU_BTN\' | lituiTranslate}}">';
        tpl += '    <span class="litui-icon icon-menu"></span>';
        tpl += '</button>';
        
        return {
            restrict: 'E',
            replace: true,
            controller: LituiAppMenuBtnCtrl,
            template: tpl
        };
    }
    
    /** @ngInject */
    function LituiAppMenuBtnCtrl($scope, lituiAppMenuService){        
        $scope.onSelect = function(e){
            lituiAppMenuService.toggle();
        };
    }
})();
'use stric';

(function(){
    angular.module('litui').directive('lituiAppMenuCollapsedSubMenu', directive);
    
    /** @ngInject */
    function directive(){
        var tpl = '';
        tpl += '<div class="litui-app-menu-collapsed-sub-menu" ng-mouseenter="onMouseenter($event)" ng-mouseleave="onMouseleave($event)">';
        tpl += '    <div class="litui-app-menu-collapsed-sub-menu-title">';
        tpl += '        <span litui-translate="title"></span>';
        tpl += '    </div>';
        tpl += '    <div class="litui-app-menu-collapsed-sub-menu-body">';
        tpl += '        <litui-app-menu-list arg-menu-items="list" ng-if="list !== undefined">App menu</litui-app-menu-list>';
        tpl += '    </div>';
        tpl += '</div>';
        
        return {
            restrict: 'E',
            replace: true,
            template: tpl,
            controller: LituiAppMenuCollapsedSubMenuCtrl
        };
    }
    
    /** @ngInject */
    function LituiAppMenuCollapsedSubMenuCtrl($element, $scope, $compile, lituiAppMenuService, $timeout, $window){
        $scope.list = undefined;
        var isDisplayed = false;
        var forceDisplay = false;
        var hideTimeoutHandler = null;
        var $target = null;
        
        // position element just outside of the visible area
        if(!isDisplayed)
            $element.css('left', -$element.outerWidth());
        
        
        $scope.$on('$destroy', function(){
            lituiAppMenuService.off('SHOW_COLLAPSED_SUB', itemSelected);
            lituiAppMenuService.off('HIDE_COLLAPSED_SUB', hideCollapsedSub);
            lituiAppMenuService.off('ITEM_SELECTED');
            lituiAppMenuService.off('ITEM_EXPANDED', itemExpanded);
            lituiAppMenuService.off('ITEM_COLLAPSE', itemCollapse);
        });
        
        
        // -----------------
        // --- FUNCTIONS ---
        // -----------------
        function hide(){
            if(!forceDisplay){
                TweenMax.to($element, 0.3, {
                    left: -$element.outerWidth(),
                    onComplete: function(){
                        $element.css('display', 'none');
                        if(!litui.utils.isNull($target))
                            $target.removeClass('hovered');
                        
                        isDisplayed = false;
                        forceDisplay = false;
                        $scope.list = undefined;
                    }
                });
            }
        }
        
        
        // -----------------
        // --- UI EVENTS ---
        // -----------------
        $scope.onMouseenter = function(){
            $target.addClass('hovered');
            forceDisplay = true;
        };
        
        $scope.onMouseleave = function(){
            forceDisplay = false;
            
            $timeout.cancel(hideTimeoutHandler);
            hideTimeoutHandler = $timeout(hide, 700);
        };
        
        lituiAppMenuService.on('SHOW_COLLAPSED_SUB', function(args){            
            $timeout.cancel(hideTimeoutHandler);
            $timeout(function(){
                $scope.list = args.item.subMenu;
                $scope.title = args.item.title;
                
                if(!litui.utils.isNull($target))
                    $target.removeClass('hovered');
                
                
                $target = $(args.e.currentTarget);
                var $csmBody = $element.find('.litui-app-menu-collapsed-sub-menu-body');
                
                // reset csm body height, move element to target Y, show element
                $csmBody.height('');
                $element.css('top', $target.offset().top);       
                $element.css('display', 'block');
                
                TweenMax.to($element, 0.3, {
                    left: 0,
                    onComplete: function(){
                        isDisplayed = true;
                        
                        // calc if elt height is over the screen
                        if($element.height() + $element.offset().top > $(window).height()){
                            var delta = $(window).height() - $element.offset().top - $element.find('.litui-app-menu-collapsed-sub-menu-title').height() - 8; // -8 is padding
                            $csmBody.height(delta);
                        }
                    }
                });
                
            });
        });
        
        function itemExpanded(){
            var $csmBody = $element.find('.litui-app-menu-collapsed-sub-menu-body');
            
            // calc if elt height is over the screen
            if($element.height() + $element.offset().top > $(window).height()){
                var delta = $(window).height() - $element.offset().top - $element.find('.litui-app-menu-collapsed-sub-menu-title').height() - 8; // -8 is padding
                $csmBody.height(delta);
            }
        }
        
        function itemCollapse(){
            var $csmBody = $element.find('.litui-app-menu-collapsed-sub-menu-body');
            $csmBody.height('');
        }
        
        function hideCollapsedSub(e){                
            hideTimeoutHandler = $timeout(hide, 200);
        }
        
        function itemSelected(){
            forceDisplay = false;
            hide();
        }
        
        // -----------------
        // --- SUBSCRIBE ---
        // -----------------
        lituiAppMenuService.on('ITEM_SELECTED', itemSelected);
        
        lituiAppMenuService.on('HIDE_COLLAPSED_SUB', hideCollapsedSub);
        
        lituiAppMenuService.on('ITEM_EXPANDED', itemExpanded);
        
        lituiAppMenuService.on('ITEM_COLLAPSE', itemCollapse);
        
        
    }
})();
'use strict';

(function () {
    angular.module('litui').directive('lituiAppMenuListItem', directive);

    /** @ngInject */
    function directive() {
        return {
            restrict: 'E',
            replace: false,
            scope: {
                item: '=argItem',
                level: '=argLevel'
            },
            controller: LituiAppMenuListItemCtrl,
            templateUrl: 'litui/com/menu/litui-app-menu/com/litui-app-menu-list-item.html',
        };
    }

    /** @ngInject */
    function LituiAppMenuListItemCtrl($scope, $element, $compile, $state, lituiAppMenuService, $q, $timeout) {
        var holderH = 0;
        
        var isCollapsing = false;
        var isExpanding = false;
        
        $scope.isExpanded = false;
        $scope.isSelected = false;
        $scope.notification = {
            num: 0,
            cssClass: ''
        };
        
        // subscribe to location change event for menu item selection
        // NOTE: this isn't optimal solution; maybe move this one layer up and
        // then emmit specific event; each of the components could register 
        // the same event "class" but with additional unique designation (<item_id>-<event_name>)
        $scope.$on('$stateChangeSuccess', function(){
            select();
        });
        
//        $scope.$on('$destroy', function(){
//            lituiAppMenuService.off();
//        });

        // add sub menu 
        // compiling sub menu's element is the only way to achieve recursion 
        // of directives
        if (litui.utils.isDefined($scope.item.subMenu) && $scope.item.subMenu.length > 0) {
            // create & append child menu list
            var $subMenuList = $('<div class="litui-app-menu-list-holder"><div class="litui-app-menu-list-inner"><litui-app-menu-list arg-menu-items="item.subMenu" arg-level="level + 1"></litui-app-menu-list></div></div>');
            $element.append($subMenuList);

            // calc holder height
            var itemsC = countItems($scope.item.subMenu);
            holderH = itemsC * ($scope.level >= 1? 36 : 47) + itemsC - 1;

            // angular compile element
            $compile($subMenuList)($scope);
        }
        
        // initially select item (will cause auto-selection)
        select();


        // -----------------
        // --- FUNCTIONS ---
        // -----------------
        function toggle(e) {
            if ($scope.isExpanded){
                $scope.collapse(e);
            }
            else
                expand(e);
        }

        function expand(e) {            
            if(isExpanding)
                return;
            
            isExpanding = true;
            
            var d = $q.defer();
            var $holder = $element.children('.litui-app-menu-list-holder');
            
            var $parentHolder = $($element.parents('.litui-app-menu-list-holder')[0]);
            var parentHolderH = $parentHolder.innerHeight();
            
            $holder.removeClass('litui-collapsed-item');
            
            // transition height to holder height
            TweenMax.to($holder, 0.3, {
                height: holderH,
                onUpdate: function(){
                    if(litui.utils.isDefined($scope.item.parent)){
                        $parentHolder.height(parentHolderH + $holder.outerHeight());
                    }
                },
                onComplete: function () {
                    $timeout(function () {
                        $scope.isExpanded = true;
                        lituiAppMenuService.trigger('ITEM_EXPANDED', $scope);
                        isExpanding = false;
                        d.resolve();
                    });
                }
            });
            
//            var $marker = $(e.currentTarget).find('.litui-app-menu-sub-marker');
            var $marker = $element.find('.litui-app-menu-sub-marker');
            
            if($marker.length > 0)
                TweenMax.to($($marker.get(0)), 0.2, {
                    rotation: -270
                });

            return d.promise;
        }
        
        function countItems(items){
            var itemc = 0;
            for(var i = 0; i < items.length; i++){
                if(items[i].isVisible !== false){
                    itemc++;
                }
            }
            return itemc;
        }

        $scope.collapse = function (e) {
            if(isCollapsing)
                return;
            
            isCollapsing = true;
            var d = $q.defer();
            var $holder = $element.children('.litui-app-menu-list-holder');
            var $parentHolder = $($element.parents('.litui-app-menu-list-holder')[0]);
            var parentHolderH = $parentHolder.innerHeight();
            
            $holder.addClass('litui-collapsed-item');
            
            lituiAppMenuService.trigger('ITEM_COLLAPSE', $scope);
            
            // transition height to 0
            TweenMax.to($holder, 0.3, {
                height: 0,
                onUpdate: function(){
                    if(litui.utils.isDefined($scope.item.parent) && !$parentHolder.hasClass('litui-collapsed-item')){
                        var delta = holderH - $holder.outerHeight();
                        $parentHolder.height(parentHolderH - delta);
                    }
                },
                onComplete: function () {
                    $timeout(function () {
                        $scope.isExpanded = false;
                        isCollapsing = false;
                        d.resolve();
                    });
                }
            });
            
//            var $marker = $(e.currentTarget).find('.litui-app-menu-sub-marker');
            var $marker = $element.find('.litui-app-menu-sub-marker');
            if($marker.length > 0)
                TweenMax.to($marker, 0.2, {
                    rotation: 0
                });
            
            return d.promise;
        };
        
        function select(){
            $scope.isSelected = lituiAppMenuService.isAnyOfChild($state.current.name, $scope.item);
        }


        // -----------------
        // --- UI EVENTS ---
        // -----------------
        $scope.onSelect = function (e) {
            // when app menu is NOT collapsed:
            // 1) don't trigger COLLAPSE_EXPANDED_ITEMS
            // 2) don't togle menu item
            // trigger: state change
            if (!$scope.isSelected && litui.utils.isDefined($scope.item.sref)) {  
                // go-to sref
//                lituiAppMenuService.goto($scope.item.sref);
                
                litui.layoutMngr.provide().trigger('COLLAPSE_SPLITTER');
            }

            if (litui.utils.isFunction($scope.item.onSelect))
                $scope.item.onSelect(e);

            if (litui.utils.isArray($scope.item.subMenu) && (!lituiAppMenuService.isCollapsed || litui.utils.isDefined($scope.item.parent)))
                toggle(e);
            
            if(!lituiAppMenuService.isCollapsed){
                // collapse any expanded item
                lituiAppMenuService.trigger('COLLAPSE_EXPANDED_ITEMS', $scope);
            }
        };

        $scope.onMouseenter = function (e) {
            if (litui.utils.isDefined($scope.item.subMenu) && $scope.item.subMenu.length > 0 && lituiAppMenuService.isCollapsed && litui.utils.isUndefined($scope.item.parent))
                lituiAppMenuService.trigger('SHOW_COLLAPSED_SUB', {
                    e: e,
                    item: $scope.item
                });
        };

        $scope.onMouseleave = function (e) {
            if (litui.utils.isDefined($scope.item.subMenu) && $scope.item.subMenu.length > 0 && lituiAppMenuService.isCollapsed && litui.utils.isUndefined($scope.item.parent))
                lituiAppMenuService.trigger('HIDE_COLLAPSED_SUB', e);
        };

        $scope.onLinkFocus = function (e) {
            if(litui.utils.isDefined($scope.item.parent)){
                if(!lituiAppMenuService.isCollapsed){
                    lituiAppMenuService.trigger('EXPAND_ITEM:' + $scope.item.parent.__index);
                }
//                else{
//                    lituiAppMenuService.trigger('SHOW_COLLAPSED_SUB', {
//                        e: e,
//                        item: $scope.item.parent
//                    });
//                }
            }
                    
        };
        
        
        // -----------------
        // --- SUBSCRIBE ---
        // -----------------
        // subscribe to notifications only if notification for item is enabled
        if(litui.utils.isDefined($scope.item.notification)){
            // ON: lituiAppMenuService.ON.UPDATE_ITEM_NOTIFICATION
            lituiAppMenuService.on('UPDATE_ITEM_NOTIFICATION', function(data){
                $timeout(function(){
                    if(data.num >= 0 && data.type === $scope.item.notification){
                        $scope.notification.num = data.num;
                    }
                });
            });
        }
        
        lituiAppMenuService.on('EXPAND_ITEM:' + $scope.item.__index, function(){
            if(!$scope.isExpanded)
                expand();
         });
        
        lituiAppMenuService.trigger('ITEM_CREATED', $scope.item);
    }
})();
'use strict';

(function(){
    angular.module('litui').directive('lituiAppMenuList', directive);
    
    var tpl = '';
    tpl += '<ul class="litui-app-menu-list">';
    tpl += '    <li ng-repeat="item in menuItems" ng-if="item && item.isVisible !== false" ng-class="{\'litui-menu-item-has-children\': item.subMenu && item.subMenu.length > 0, \'litui-menu-item-has-no-children\': !item.subMenu || item.subMenu.length === 0}">';
    tpl += '        <litui-app-menu-list-item arg-item="item" arg-level="level"></litui-app-menu-list-item>';
    tpl += '    </li>';
    tpl += '</ul>';
    
    /** @ngInject */
    function directive(){
        return {
            restrict: 'E',
            replace: true,
            scope: {
                menuItems: '=argMenuItems',
                level: '=?argLevel'
            },
            controller: LituiAppMenuListCtrl,
            template: tpl
        };
    }
    
    /** @ngInject */
    function LituiAppMenuListCtrl($scope){
        if(litui.utils.isUndefined($scope.level)){
            $scope.level = 0;
        }
    }
})();
"use strict";

(function(){
    angular.module('litui').service('lituiAppMenuServerTimeService', LituiAppMenuServerTimeServiceWrapper);
    
    /** @ngInject */
    function LituiAppMenuServerTimeServiceWrapper() {
        function LituiAppMenuServerTimeService(){            
            this.syncService = null;
        }
        
        LituiAppMenuServerTimeService.prototype.setSyncService = function(syncService){
            if(!litui.utils.isFunction(syncService))
                throw "LITUI App menu server time exception: sync service must be a function!";
            
            this.syncService = syncService;
        };
        
        LituiAppMenuServerTimeService.prototype.serverTimeSync = function(){
            if(litui.utils.isNull(this.syncService))
                return litui.async.promise();
            else
                return this.syncService();
        };
        
        return new LituiAppMenuServerTimeService();
    }
})();


'use strict';

(function () {
    angular.module('litui').directive('lituiAppMenuServerTime', directive);

    /** @ngInject */
    function directive() {
        var tpl = '';
        tpl += '<div class="litui-app-menu-server-time">';
        tpl += '    <div class="litui-server-time-tempus"><span>{{server.time| lituiDatetimeFormatter:server.timeFormat }}</span></div>';
        tpl += '    <div class="litui-server-time-date"><span>{{server.time| lituiDatetimeFormatter:server.dateFormat }}</span></div>';
        tpl += '</div>';

        return {
            restrict: 'E',
            replace: true,
            controller: LituiAppMenuServerTimeCtrl,
            template: tpl
        };
    }

    /** @ngInject */
    function LituiAppMenuServerTimeCtrl($scope, lituiAppMenuServerTimeService, lituiAppMenuService, TmsDatetimeFormatEnum) {   
        var timeDiff = 0;
        $scope.server = {
            time: litui.dateTime.now(),
            dateFormat: lituiAppMenuService.isCollapsed ? litui.config.get('dateShortFormat') : litui.config.get('dateFormat'),
            timeFormat: lituiAppMenuService.isCollapsed ? litui.config.get('timeShortFormat') : litui.config.get('timeFormat')
        };
        
        var timeLoop = litui.Pull.create(function(){
            return litui.async.delay(function(){
                syncedTime();
            });
        }, {
            delayFirstPull: false,
            frequency: 1
        });
        
        var serverSyncPull = litui.Pull.create(function(){
            return lituiAppMenuServerTimeService.serverTimeSync().then(function(diff){
                timeDiff = diff || 0;
            });
        }, {
            delayFirstPull: false,
            frequency: 60
        });
        

        // --- subscribe ---
        lituiAppMenuService.on('EXPAND_APP_MENU', function () {
            $scope.server.dateFormat = litui.config.get('dateFormat');
            $scope.server.timeFormat = litui.config.get('timeFormat');
        });

        lituiAppMenuService.on('COLLAPSE_APP_MENU', function () {
            $scope.server.dateFormat = litui.config.get('dateShortFormat');
            $scope.server.timeFormat = litui.config.get('timeShortFormat');
        });


        this.$onInit = function () {

        };

        this.$onDestroy = function () {
//            lituiAppMenuServerTimeService.stopTimers();
            timeLoop.stop();
            serverSyncPull.stop();
        };
        
        function syncedTime(now){
            now = now || litui.dateTime.now();
            now.add(timeDiff, 'milliseconds');
            $scope.server.time = now;
            timeDiff = 0;
        }
    }
})();
'use strict';

(function(){
    var tpl = '';
    tpl += '<div class="litui-app-menu-sys-version">';
    tpl += '    <span ng-if="$ctrl.version.length > 0">v{{$ctrl.version}}</span>';
    tpl += '</div>';
    
    angular.module('litui').component('lituiAppMenuSysVersion', {
        controller: LituiAppMenuSysVersionCtrl,
        template: tpl
    });
    
    function LituiAppMenuSysVersionCtrl(config){
        this.version = config.sysVersion || "";
    }
})();
"use strict";

(function () {
    angular.module('litui').service('lituiAppMenuWeatherService', LituiAppMenuWeatherServiceWrapper);

    /** @ngInject */
    function LituiAppMenuWeatherServiceWrapper() {
        function LituiAppMenuWeatherService() {
            this.weatherService = null;
            this.iconMap = {
                "01d": "wi-day-sunny",
                "02d": "wi-day-sunny-overcast",
                "03d": "wi-day-cloudy",
                "04d": "wi-cloudy",
                "09d": "wi-day-showers",
                "10d": "wi-day-rain",
                "11d": "wi-day-thunderstorm",
                "13d": "wi-day-snow",
                "50d": "wi-fog",
                "01n": "wi-night-clear",
                "02n": "wi-night-cloudy",
                "03n": "wi-night-cloudy",
                "04n": "wi-cloudy",
                "09n": "wi-night-showers",
                "10n": "wi-night-rain",
                "11n": "wi-night-thunderstorm",
                "13n": "wi-night-snow",
                "50n": "wi-fog"
            };
        }

        LituiAppMenuWeatherService.prototype.setWeatherService = function (weatherService) {
            if (!litui.utils.isFunction(weatherService))
                throw "LITUI App menu weather exception: weather service must be a function!";

            this.weatherService = weatherService;
        };

        LituiAppMenuWeatherService.prototype.weatherSync = function () {
            var self = this;
            if (litui.utils.isNull(this.weatherService))
                return litui.async.promise();

            return this.weatherService().then(function (wd) {
                if (litui.utils.isDefined(wd) && wd.cod === 200) {
                    return {
                        temperature: Math.round(wd.main.temp) + (litui.config.get('weather').units === 'metric' ? '°C' : '°F'),
                        icon: self.getIconFont(wd.weather),
                        date: Date.now(),
                        param: {
                            units: litui.config.get('weather').units
                        }
                    };
                }
            });
        };

        LituiAppMenuWeatherService.prototype.getIconFont = function (weatherInfo) {
            if (litui.utils.isArray(weatherInfo) && weatherInfo.length > 0) {
                var icon = weatherInfo[0].icon;
                if (this.iconMap.hasOwnProperty(icon)) {
                    return this.iconMap[icon];
                }
            }
            return 'wi-thermometer';
        }

        return new LituiAppMenuWeatherService();
    }
})();


'use strict';

(function () {
    angular.module('litui').directive('lituiAppMenuWeather', directive);

    /** @ngInject */
    function directive() {
        var tpl = '';
        tpl += '<div class="litui-app-menu-weather">';
        tpl += '    <span class="litui-weather-icon" ng-class="weather.icon"></span>';
        tpl += '    <span class="litui-weather-temperature">{{weather.temperature}}</span>';
        tpl += '</div>';

        return {
            restrict: 'E',
            replace: true,
            controller: LituiAppMenuWeatherCtrl,
            templateUrl: 'litui/com/menu/litui-app-menu/com/litui-app-menu-weather.html'
        };
    }

    /** @ngInject */
    function LituiAppMenuWeatherCtrl($scope, lituiAppMenuService, lituiAppMenuWeatherService) {
        $scope.weather = undefined;
        if(!litui.config.get('weather').isEnabled)
            lituiAppMenuService.trigger('FEATURE', {
                featureId: 'weather',
                isEnabled: false
            });
        
        var serverSync = litui.Pull.create(function () {
            return lituiAppMenuWeatherService.weatherSync().then(function(weather){
                $scope.weather = weather;
            });
        }, {
            delayFirstPull: false,
            frequency: 60
        });

        $scope.$on('$destroy', function () {
            serverSync.stop();
        });
    }
})();
'use strict';

(function(){
    angular.module('litui').component('lituiAppMenuDrawer', {
        templateUrl: 'litui/com/menu/litui-app-menu/com/litui-app-menu-drawer/litui-app-menu-drawer.html',
        controller: LituiAppMenuDrawerCtrl,
        bindings: {

        }
    });
    
    /** @ngInject */
    function LituiAppMenuDrawerCtrl(lituiAppMenuService, $element){  
        var self = this;
//        this.settings = {
//            header: null,
//            component: null
//        };

        this.$onInit = function(){
            lituiAppMenuService.on('SHOW_DRAWER', function(settings){
                self.settings = litui.lang.deepMerge(self.settings, settings || {});

                $element.css('display', 'block');
                var $holder = $element.find('.litui-app-menu-drawer-holder');
                var props = {
                    opacity: 1,
                    onComplete: function(){
                        $('body').on('mousedown', onDismiss);
                    }
                };
                if($('html').attr('dir') === 'rtl'){
                    props.right = 0;
                }
                else{
                    props.left = 0;
                }

                $holder.css('opacity', '0');
                TweenMax.to($holder, 0.2, props);
            });

            lituiAppMenuService.on('HIDE_DRAWER', function(){
                var $holder = $element.find('.litui-app-menu-drawer-holder');    
                var props = {
                    opacity: 0,
                    onComplete: function(){
                        $element.css('display', 'none');
                        $('body').off('mousedown', onDismiss);
                    }
                };
                var move = $holder.outerWidth() * (-1);
                if($('html').attr('dir') === 'rtl'){
                    props.right = move;
                }
                else{
                    props.left = move;
                }
                TweenMax.to($holder, 0.2, props);
            });
        
            $element.on('mousedown', function(e){
                e.stopPropagation();
            });
        };
        
        this.$onDestroy = function(){
            $element.off();
            $('body').off('mousedown', onDismiss);
        };
        
        this.onDismiss = function(e){
            lituiAppMenuService.hideDrawer(e);
        };
        
        function onDismiss(e){
            e.stopPropagation();
            
            lituiAppMenuService.hideDrawer(e);
        }
    }
})();
angular.module("litui").run(function($templateCache){$templateCache.put("litui/com/base/litui-image/litui-image.html","<div class=litui-image-inner ng-class=\"{'litui-image-error': $ctrl.isError && ($ctrl.src !== undefined &&  $ctrl.src.length > 0) }\">    <div class=litui-image-not-found ng-if=\"$ctrl.isError && ($ctrl.src !== undefined && $ctrl.src.length > 0)\"></div></div>");$templateCache.put("litui/com/base/litui-range/litui-range.html","<div class=litui-range-inner>    <div class=litui-range-handle name=handle-a>        <span>{{$ctrl.handleA.label}}</span>    </div>    <div ng-if=$ctrl.handleB.isRange class=litui-range-bar name=handle-bar>        <span>{{$ctrl.handleBar.label}}</span>    </div>    <div ng-if=$ctrl.handleB.isRange class=litui-range-handle name=handle-b>        <span>{{$ctrl.handleB.label}}</span>    </div></div>");$templateCache.put("litui/com/base/litui-wizard/litui-wizard.html","<div class=litui-wizard>    <div class=litui-wizard-inner>        <div class=litui-wizard-header>            <div class=litui-float-left>                <button class=litui-btn-primary ng-click=onPreviousStep() ng-if=!isFirstStep litui-ripple-fx>                    <span>Back</span>                </button>            </div>            <div class=litui-wizard-steps>                <span>                    {{currentStepIndex + 1}} / {{steps.length}}                </span>            </div>            <div class=litui-float-right>                <button class=litui-btn-minimal ng-click=onCancel() litui-ripple-fx>                    <span>Cancel</span>                </button>                <button class=litui-btn-primary ng-click=onNextStep() ng-if=!isLastStep litui-ripple-fx>                    <span>Next</span>                </button>                <button class=litui-btn-primary ng-click=onSubmit() ng-if=isLastStep litui-ripple-fx>                    <span>Done</span>                </button>            </div>        </div>                <div class=litui-wizard-body>            <div class=litui-wizard-title>                <h1>{{currentStep.title}}</h1>            </div>            <div class=litui-wizard-body-inner>                <litui-compile component=currentStep.component is-dynamic=settings.isDynamic></litui-compile>            </div>        </div>    </div></div>");$templateCache.put("litui/com/datetime/litui-date-period-activity/litui-date-period-activity.html","<div class=litui-date-period-activity-inner ng-class=\"{'litui-active': $ctrl.activity === 'active', 'litui-mark-current-activity': $ctrl.activity === 'current', 'litui-mark-obsolete': $ctrl.activity === 'obsolete'}\">    <div ng-if=\"!$ctrl.isInfinityMin($ctrl.datetimeA) && !$ctrl.isInfinityMax($ctrl.datetimeB)\">        <span>{{$ctrl.datetimeA| lituiDatetimeFormatter: 'date' : $ctrl.settings.dateA.tz}}</span>         <span>-</span>        <span>{{$ctrl.datetimeB| lituiDatetimeFormatter: 'date' : $ctrl.settings.dateB.tz}}</span>    </div>    <div ng-if=\"$ctrl.isInfinityMin($ctrl.datetimeA) && !$ctrl.isInfinityMax($ctrl.datetimeB)\">        <span litui-translate=\"'LITUI.DATE_TIME.INFINITY_MIN'\"></span>         <span>-</span>        <span>{{$ctrl.datetimeB| lituiDatetimeFormatter: 'date' : $ctrl.settings.dateB.tz}}</span>    </div>    <div ng-if=\"!$ctrl.isInfinityMin($ctrl.datetimeA) && $ctrl.isInfinityMax($ctrl.datetimeB)\">        <span>{{$ctrl.datetimeA| lituiDatetimeFormatter: 'date' : $ctrl.settings.dateA.tz}}</span>        <span>-</span>        <span litui-translate=\"'LITUI.DATE_TIME.INFINITY_MAX'\"></span>     </div>    <div ng-if=\"$ctrl.isInfinityMin($ctrl.datetimeA) && $ctrl.isInfinityMax($ctrl.datetimeB)\">        <span litui-translate=\"'LITUI.DATE_PERIOD.INFINITY'\"></span>    </div></div>");$templateCache.put("litui/com/datetime/litui-date-period-picker/litui-date-period-picker.html","<div class=\"litui-row litui-holder\">    <div class=litui-col-5>        <litui-date-time-picker-trigger ng-if=!$ctrl.settings.dateA.isInfinity datetime=$ctrl.datetimeA on-change=$ctrl.onDatetimeAChanged is-disabled=$ctrl.isDisabled settings=$ctrl.settings.date.dateA></litui-date-time-picker-trigger>        <div class=litui-date-period-infinity ng-if=$ctrl.settings.enableInfinity>            <litui-input field=$ctrl.foreverMinField value=$ctrl.settings.dateA.isInfinity is-disabled=$ctrl.isDisabled on-change=\"$ctrl.foreverMinField.onChange(e, val, field)\"></litui-input>        </div>    </div>    <div class=\"litui-col-1 litui-align-center litui-date-period-picker-to-sign\">        <span>to</span>    </div>    <div class=litui-col-5>        <litui-date-time-picker-trigger ng-if=!$ctrl.settings.date.dateB.isInfinity datetime=$ctrl.datetimeB on-change=$ctrl.onDatetimeBChanged is-disabled=$ctrl.isDisabled settings=$ctrl.settings.date.dateB></litui-date-time-picker-trigger>        <div class=litui-date-period-infinity ng-if=$ctrl.settings.enableInfinity>            <litui-input field=$ctrl.foreverMaxField value=$ctrl.settings.date.dateB.isInfinity is-disabled=$ctrl.isDisabled on-change=\"$ctrl.foreverMaxField.onChange(e, val, field)\"></litui-input>        </div>    </div></div>");$templateCache.put("litui/com/datetime/litui-date-picker/litui-date-picker.html","<div class=litui-date-picker-inner ng-class=\"{'litui-show-input': $ctrl.settings.showSelected}\">    <div class=litui-date-picker-current ng-if=$ctrl.settings.showSelected>        {{date | lituiDateFormatter}}            </div>    <div class=litui-date-picker-calendar-holder>        <div uib-datepicker ng-model=date datepicker-options=options></div>    </div></div>");$templateCache.put("litui/com/datetime/litui-date-time-picker-trigger/litui-date-time-picker-trigger.html","<button ng-click=$ctrl.onSelected($event) ng-disabled=$ctrl.isDisabled type=button>    <span class=litui-icon ng-class=\"{ 'icon-time': $ctrl.settings.type === 'time', 'icon-date': $ctrl.settings.type === 'date' || $ctrl.settings.type === 'datetime' }\"></span>    <span class=litui-label ng-if=\"$ctrl.settings.type === 'time'\">        {{$ctrl.datetime | lituiDatetimeFormatter: 'time-short' : $ctrl.settings.tz}}    </span>    <span class=litui-label ng-if=\"$ctrl.settings.type === 'date'\">        {{$ctrl.datetime | lituiDatetimeFormatter: 'date' : $ctrl.settings.tz}}    </span>    <span class=litui-label ng-if=\"$ctrl.settings.type === 'datetime'\">        {{$ctrl.datetime | lituiDatetimeFormatter: 'datetime-short' : $ctrl.settings.tz}}    </span></button>");$templateCache.put("litui/com/datetime/litui-date-time-picker/litui-date-time-picker.html","<div class=litui-date-time-picker-datetime ng-if=\"$ctrl.settings.type === 'datetime'\">    <div class=litui-date-time-picker-date-holder>        <div class=litui-date-time-picker-datetime-date-title>            <span litui-translate=\"'LITUI.DATE_TIME_PICKER.DATE'\"></span>        </div>        <litui-date-picker datetime=$ctrl.datetime on-change=$ctrl.onDatetimeChange settings=$ctrl.settings></litui-date-picker>    </div>    <div class=litui-date-time-picker-time-holder>        <div class=litui-date-time-picker-datetime-time-title>            <span litui-translate=\"'LITUI.DATE_TIME_PICKER.TIME'\"></span>        </div>        <litui-time-picker datetime=$ctrl.datetime on-change=$ctrl.onDatetimeChange settings=$ctrl.settings></litui-time-picker>    </div></div><div ng-if=\"$ctrl.settings.type === 'date'\">    <litui-date-picker datetime=$ctrl.datetime on-change=$ctrl.onDatetimeChange settings=$ctrl.settings></litui-date-picker></div><div ng-if=\"$ctrl.settings.type === 'time'\">    <litui-time-picker datetime=$ctrl.datetime on-change=$ctrl.onDatetimeChange settings=$ctrl.settings></litui-time-picker></div>");$templateCache.put("litui/com/datetime/litui-day-of-week-activity/litui-day-of-week-activity.html","<div class=litui-day-of-week-day litui-tooltip={{day.name}} ng-class=\"{'litui-day-of-week-today': day.value === $ctrl.todayValue,                 'litui-active': $ctrl.days.indexOf(day.value) > -1,                 'litui-mark-current-activity': $ctrl.activity === 'current',                 'litui-mark-obsolete': $ctrl.activity === 'obsolete' && $ctrl.days.indexOf(day.value) > -1,                 'litui-day-of-week-activity-weekend-start': day.value === 6}\" ng-repeat=\"day in $ctrl.daysOfWeek track by day.value\">    <span litui-translate=day.nameShort></span></div>");$templateCache.put("litui/com/datetime/litui-day-of-week-indentifier/litui-day-of-week-indentifier.html","<span ng-if=\"$ctrl.state === 0\">    <span ng-if=\"$ctrl.days.indexOf(1) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.MONDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(2) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.TUESDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(3) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.WEDNESDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(4) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.THURSDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(5) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.FRIDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(6) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.SATURDAY'\"></span>    <span ng-if=\"$ctrl.days.indexOf(7) > -1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.SUNDAY'\"></span></span><span ng-if=\"$ctrl.state === 1\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.WEEKDAYS'\"></span><span ng-if=\"$ctrl.state === 2\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.WEEKENDS'\"></span><span ng-if=\"$ctrl.state === 3\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.EVERY_DAY'\"></span><span ng-if=\"$ctrl.state === 4\" litui-translate=\"'LITUI.DAY_OF_WEEK_PICKER.SELECTED_DAYS'\"></span>");$templateCache.put("litui/com/datetime/litui-day-of-week-picker/litui-day-of-week-picker.html","<div class=litui-day-of-week-day litui-ripple-fx litui-tooltip={{day.name}} ng-click=\"$ctrl.onDaySelected($event, day)\" ng-class=\"{'litui-active': $ctrl.days.indexOf(day.value) > -1, 'litui-disabled': $ctrl.isDisabled}\" ng-repeat=\"day in $ctrl.daysOfWeek track by day.value\">    <span litui-translate=day.symbol></span></div>");$templateCache.put("litui/com/datetime/litui-period-activity/litui-period-activity.html","<div class=litui-period-activity-inner>    <litui-date-period-activity datetime-a=$ctrl.datetimeA datetime-b=$ctrl.datetimeB activity=$ctrl.activity.date settings=$ctrl.settings.date></litui-date-period-activity>    <litui-day-of-week-activity days=$ctrl.reccuringDays activity=$ctrl.activity.day></litui-day-of-week-activity>    <litui-time-period-activity time-a=$ctrl.timeA time-b=$ctrl.timeB activity=$ctrl.activity.time settings=$ctrl.settings.time></litui-time-period-activity></div>");$templateCache.put("litui/com/datetime/litui-period-selection/litui-period-selection.html","<div class=litui-period-selection-inner>    <div class=litui-period-selection-period-holder>        <div class=litui-period-selection-period-header>            <span litui-translate=\"'LITUI.PERIOD_SELECTION.PERIOD.TITLE'\"></span>        </div>        <div class=litui-period-selection-period-body>            <div class=litui-period-selection-period-inner>                <div>                    <litui-input field=$ctrl.isPeriodicalField value=$ctrl.isPeriodical on-change=\"$ctrl.settings.onRepeatInPeriod(e, val, field)\" is-disabled=$ctrl.settings.isPeriodicalDisabled></litui-input>                </div>                <div ng-if=$ctrl.isPeriodical>                    <litui-date-period-picker datetime-a=$ctrl.datetimeA datetime-b=$ctrl.datetimeB entity=$ctrl.entity on-datetime-a-change=$ctrl.onDatetimeAChange on-datetime-b-change=$ctrl.onDatetimeBChange is-disabled=$ctrl.settings.isPeriodicalDisabled settings=$ctrl.settings></litui-date-period-picker>                </div>            </div>        </div>    </div>    <div class=litui-period-selection-period-holder>        <div class=litui-period-selection-period-header>            <span litui-translate=\"'LITUI.PERIOD_SELECTION.RECURRANCE.TITLE'\"></span>        </div>        <div class=litui-period-selection-period-body>            <div class=litui-period-selection-period-inner>                <div>                    <litui-input field=$ctrl.reccurancePeriod.field value=$ctrl.isReccuring on-change=\"$ctrl.settings.onRepeatInTimePeriod(e, val, field)\" is-disabled=$ctrl.settings.isReccuringTimeDisabled></litui-input>                </div>                <div ng-if=$ctrl.isReccuring>                    <litui-time-period-picker datetime-a=$ctrl.timeA datetime-b=$ctrl.timeB entity=$ctrl.entity on-datetime-a-change=$ctrl.onTimeAChange on-datetime-b-change=$ctrl.onTimeBChange is-disabled=$ctrl.settings.isReccuringTimeDisabled settings=$ctrl.settings.time></litui-time-period-picker>                </div>            </div>            <div class=litui-period-selection-reccurance-day-of-week ng-if=$ctrl.reccuringDays>                <div class=litui-label>                    <span litui-translate=\"'LITUI.PERIOD_SELECTION.RECURRANCE.REPEAT_ON'\"></span>                    <span ng-if=\"$ctrl.reccuringDays.length > 0\">                        <litui-day-of-week-indentifier days=$ctrl.reccuringDays settings=$ctrl.reccuringDaysSettings></litui-day-of-week-indentifier>                    </span>                </div>                <div>                    <litui-day-of-week-picker days=$ctrl.reccuringDays is-disabled=$ctrl.settings.isDaySelectionDisabled settings=$ctrl.reccuringDaysSettings></litui-day-of-week-picker>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/datetime/litui-time-period-activity/litui-time-period-activity.html","<div class=litui-time-period-activity-inner ng-class=\"{'litui-active': $ctrl.activity === 'active', 'litui-mark-current-activity': $ctrl.activity === 'current', 'litui-mark-obsolete': $ctrl.activity === 'obsolete'}\">        <div ng-if=\"!$ctrl.isInfinityMin($ctrl.timeA) || !$ctrl.isInfinityMax($ctrl.timeB)\">        <span>{{$ctrl.timeA| lituiDatetimeFormatter: 'time-short' : $ctrl.settings.timeA.tz}}</span>         <span>-</span>        <span>{{$ctrl.timeB| lituiDatetimeFormatter: 'time-short' : $ctrl.settings.timeB.tz}}</span>    </div>    <div ng-if=\"$ctrl.isInfinityMin($ctrl.timeA) && $ctrl.isInfinityMax($ctrl.timeB)\">        <span litui-translate=\"'LITUI.TIME_PERIOD.INFINITY'\"></span>    </div></div>");$templateCache.put("litui/com/datetime/litui-time-period-picker/litui-time-period-picker.html","<div class=\"litui-row litui-holder\">    <div class=litui-col-5>        <litui-date-time-picker-trigger datetime=$ctrl.datetimeA on-change=$ctrl.onDatetimeAChange is-disabled=$ctrl.isDisabled settings=$ctrl.settings.timeA></litui-date-time-picker-trigger>    </div>    <div class=\"litui-col-1 litui-align-center litui-time-period-picker-to-sign\">        <span litui-translate=\"'LITUI.TIME_PERIOD_PICKER.TO'\"></span>    </div>    <div class=litui-col-5>        <litui-date-time-picker-trigger datetime=$ctrl.datetimeB on-change=$ctrl.onDatetimeBChange is-disabled=$ctrl.isDisabled settings=$ctrl.settings.timeB></litui-date-time-picker-trigger>    </div></div>");$templateCache.put("litui/com/datetime/litui-time-picker/litui-time-picker.html","<div class=litui-time-picker-inner>    <div class=litui-time-picker-hours>        <button ng-click=$ctrl.onIncrementHours($event) litui-ripple-fx>            <span class=\"litui-icon icon-plus\"></span>        </button>        <input class=form-control type=text ng-model=$ctrl.formatted.hours ng-change=$ctrl.onHourChange($event)>        <button ng-click=$ctrl.onDecrementHours($event) litui-ripple-fx>            <span class=\"litui-icon icon-minus\"></span>        </button>    </div>    <div class=litui-time-picker-delimiter>        <div class=litui-time-picker-delimiter-top></div>        <span>:</span>    </div>    <div class=litui-time-picker-minutes>        <button ng-click=$ctrl.onIncrementMinutes($event) litui-ripple-fx>            <span class=\"litui-icon icon-plus\"></span>        </button>        <input class=form-control type=text ng-model=$ctrl.formatted.minutes ng-change=$ctrl.onMinuteChange($event)>        <button ng-click=$ctrl.onDecrementMinutes($event) litui-ripple-fx>            <span class=\"litui-icon icon-minus\"></span>        </button>    </div></div>");$templateCache.put("litui/com/file/litui-file-explorer/litui-file-explorer.html","<div class=litui-file-explorer-inner ng-click=$ctrl.onFileExplorerSelected($event)>    <div class=litui-file-explorer-location ng-if=$ctrl.settings.isLocationEnabled>        <div class=litui-file-explorer-location-input>            <litui-input-string ng-model=$ctrl.data.location label=\"'LITUI.FILE_EXPLORER.LOCATION'\"></litui-input-string>        </div>        <div>            <button class=litui-btn-primary litui-ripple-fx>                <span class=litui-label>GO</span>            </button>        </div>    </div>    <div class=litui-file-explorer-stage>        <div class=litui-file-group>            <div class=litui-file-group-header>                <div class=litui-file-group-title>                    <span litui-translate=\"'LITUI.FILE_EXPLORER.FOLDER'\"></span>                </div>            </div>            <div class=litui-file-group-body>                <div class=litui-file ng-repeat=\"folder in $ctrl.data.folders\" ng-click=\"$ctrl.onFolderSelected($event, folder)\" ng-class=\"{'litui-selected': $ctrl.selectedFile.name === folder.name}\">                    <div class=\"litui-file-icon litui-file-icon-folder\"></div>                    <div class=litui-file-name>                        <span>                            {{folder.name}}                        </span>                    </div>                </div>            </div>        </div>        <div class=litui-file-group>            <div class=litui-file-group>                <div class=litui-file-group-header>                    <div class=litui-file-group-title>                        <span litui-translate=\"'LITUI.FILE_EXPLORER.FILE'\"></span>                    </div>                </div>                <div class=litui-file-group-body>                    <div class=litui-file ng-repeat=\"file in $ctrl.data.files\" ng-click=\"$ctrl.onFileSelected($event, file)\" ng-class=\"{'litui-selected': $ctrl.selectedFile.name === file.name}\">                        <div class=\"litui-file-icon litui-file-icon-file\"></div>                        <div class=litui-file-name>                            <span>                                {{file.name}}                            </span>                        </div>                    </div>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/file/litui-media-lib/litui-media-lib.html","MEDIA LIB");$templateCache.put("litui/com/info/litui-countdown/litui-countdown.html","<div class=litui-countdown-inner litui-tooltip=\"{{ 'LITUI.COUNTDOWN.LAST_REFRESH_TIME' | lituiTranslate : { dt: $ctrl.lastRefreshTime } }}\" delay=\"{{$ctrl.settings.tooltipDelay || -1}}\">    <refresh-button ng-click=$ctrl.onSelected() options=$ctrl.settings.indicator filter=$ctrl.filter refresh=$ctrl.onLoad()></refresh-button></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-banner-options/litui-banner-options.html","<div class=litui-banner-option-holder ng-repeat=\"option in $ctrl.options\" ng-click=\"option.onSelected($event, option)\">    <div class=litui-banner-option ng-if=\"(option.type === 'item' || option.type === undefined) && (option.isVisible || option.isVisible === undefined)\">        <span class=\"litui-icon {{option.icon}}\"></span>        <span class=litui-label>{{option.label}}</span>    </div>    <div class=litui-banner-option-component ng-if=\"option.type === 'component' && (option.isVisible || option.isVisible === undefined)\">        <litui-compile component=option is-dynamic=option.isDynamic></litui-compile>    </div></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-banner/litui-banner.html","<div class=litui-banner-img-holder>    <litui-image class=litui-cover-width src=$ctrl.imagesrc settings=$ctrl.imageSettings ng-style=\"{'background-position': $ctrl.imageposition.left + 'px ' + $ctrl.imageposition.top + 'px', 'background-attachment': $ctrl.settings.imageproperties.attachment, 'background-size': $ctrl.settings.imageproperties.size, 'background-repeat': $ctrl.settings.imageproperties.repeat}\"></litui-image></div><div class=litui-banner-tape ng-class=\"{ 'litui-banner-options': $ctrl.options }\">    <div class=litui-banner-tape-title-holder>        <div class=litui-banner-tape-title>            <span>{{$ctrl.tapeTitle}}</span>        </div>    </div>    <div class=litui-banner-tape-options-holder ng-if=$ctrl.options>        <litui-compile component=$ctrl.options is-dynamic=$ctrl.options.isDynamic is-deep=$ctrl.options.isDeep></litui-compile>    </div></div><div class=litui-banner-edit-panel ng-if=$ctrl.isBannerEditMode>    <litui-upload-img settings=$ctrl.lituiUploadImg></litui-upload-img>        <div class=litui-banner-edit-panel-instructions ng-if=$ctrl.isBannerPositioningMode>        <span class=\"litui-icon icon-info\"></span><span litui-translate=\"'LITUI.BANNER.POSITION_IMAGE_TXT'\"></span>    </div>    <div class=litui-banner-edit-panel-tools>        <button class=\"litui-banner-edit-panel-tool-btn litui-icon icon-save\" ng-click=$ctrl.onUploadBannerImg() ng-if=\"$ctrl.isBannerPositioningMode && $ctrl.isImgPending\" litui-tooltip=LITUI.BANNER.UPLOAD_TOOLTIP>                    </button>        <button class=\"litui-banner-edit-panel-tool-btn litui-icon icon-close\" ng-click=$ctrl.onExitBannerEditMode() litui-tooltip=LITUI.BANNER.CLOSE_TOOLTIP></button>    </div></div><button class=\"litui-banner-edit-btn litui-icon icon-edit\" ng-if=\"$ctrl.enableEditMode && !$ctrl.isBannerEditMode\" ng-click=$ctrl.onEdit() litui-tooltip=LITUI.BANNER.EDIT_TOOLTIP></button>");$templateCache.put("litui/com/info/litui-dashboard/litui-dashboard-header/litui-dashboard-header.html","<div class=litui-dashboard-header-inner>    <div class=litui-dashboard-header-background ng-if=!$ctrl.settings.noDefaultState>        <litui-banner imagesrc=$ctrl.banner.imagesrc enable-edit-mode=false imageposition=$ctrl.banner.imageposition settings=$ctrl.banner.settings>        </litui-banner>    </div>    <div class=litui-dashboard-header-content>        <div class=litui-dashboard-header-content-inner>            <div class=litui-dashboard-header-content-inner-dynamic>                <div class=litui-dashboard-header-app-menu-btn ng-if=$ctrl.showAppMenuBtn>                    <litui-app-menu-btn class=litui-app-menu-btn-holder></litui-app-menu-btn>                </div>                <div class=litui-dashboard-header-title>                    <span litui-translate=$ctrl.activeSection.title ng-if=\"$ctrl.activeSection && $ctrl.activeSection.id !== undefined\"></span>                </div>                <div class=litui-dashboard-header-component ng-if=\"$ctrl.settings.anchorSectionHeaderComponent === undefined && $ctrl.activeSection && $ctrl.activeSection.id !== undefined && $ctrl.activeSection.header.component\">                    <litui-compile component=$ctrl.activeSection.header.component></litui-compile>                </div>                <div class=litui-dashboard-header-component ng-if=\"$ctrl.settings.anchorSectionHeaderComponent !== undefined && $ctrl.activeSection && $ctrl.activeSection.id !== undefined && $ctrl.sections[$ctrl.settings.anchorSectionHeaderComponent] && $ctrl.sections[$ctrl.settings.anchorSectionHeaderComponent].header.component\">                    <litui-compile component=$ctrl.sections[$ctrl.settings.anchorSectionHeaderComponent].header.component></litui-compile>                </div>            </div>            <div class=litui-dashboard-header-options>                <div class=litui-dashboard-header-menu>                    <button ng-class=\"{ 'litui-active': $ctrl.activeSection === null || $ctrl.activeSection.id === undefined }\" ng-click=\"$ctrl.onGoto($event, $ctrl.defaultSection)\" ng-if=!$ctrl.settings.noDefaultState aria-label=\"{{$ctrl.defaultSection.title | lituiTranslate}}\">                        <span class=\"litui-icon {{$ctrl.defaultSection.icon}}\" ng-if=$ctrl.settings.showLabels></span>                        <span class=\"litui-icon {{$ctrl.defaultSection.icon}}\" litui-tooltip={{$ctrl.defaultSection.title}} ng-if=!$ctrl.settings.showLabels></span>                        <span class=litui-label litui-translate=$ctrl.defaultSection.title ng-if=$ctrl.settings.showLabels></span>                    </button>                    <litui-inline-menu items=$ctrl.headerMenu.items settings=$ctrl.headerMenu.settings responsive=$ctrl.headerMenu.responsive></litui-inline-menu>                </div>                <div class=litui-dashboard-header-loading-indicator>                    <litui-countdown settings=$ctrl.loadingIndicator></litui-countdown>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-dashboard-section/litui-dashboard-section.html","<div class=litui-dashboard-section-inner>    <div class=litui-dashboard-section-header ng-if=$ctrl.section.title>        <div class=litui-dashboard-section-header-inner>            <div class=litui-dashboard-section-title>                <span litui-translate=$ctrl.section.title></span>            </div>            <div class=litui-dashboard-header-component ng-if=$ctrl.section.header>                <litui-compile component=$ctrl.section.header.component></litui-compile>            </div>        </div>    </div>    <div class=litui-dashboard-section-body>        <litui-compile component=$ctrl.section.component></litui-compile>    </div></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-dashboard-section/litui-dashboard-sections.html","<div ng-repeat=\"section in $ctrl.sections\" litui-authorized={{section.functionalityId}}>    <litui-dashboard-section section=section litui-dashboard-section-id={{section.id}}></litui-dashboard-section></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-dashboard-widget/litui-dashboard-widget.html","<div class=litui-dashboard-widget-header>    <span class=litui-dashboard-widget-title litui-translate=title></span></div><div class=litui-dashboard-widget-body ng-transclude></div>");$templateCache.put("litui/com/info/litui-dashboard/litui-dashboard.html","<div class=litui-dashboard-holder ng-class=\"{ 'litui-noheader': settings.noDefaultState }\">    <div class=litui-dashboard-header ng-if=!settings.noDefaultState>        <litui-banner imagesrc=banner.imagesrc tape-title=banner.title options=banner.options enable-edit-mode=banner.enableEditMode upload-service=banner.uploadService imageposition=banner.imageposition settings=banner.settings>        </litui-banner>        <div class=litui-dashboard-banner-overlay></div>    </div>    <div class=litui-dashboard-body ng-class=\"{ 'litui-nocontent': content === undefined || content.length === 0 }\">        <div class=litui-dashboard-widgets-holder>            <div class=litui-dashboard-widgets-content ng-transclude=widgets></div>        </div>        <div class=litui-dashboard-content-holder>            <div class=litui-dashboard-content ng-transclude=content></div>        </div>        <div class=litui-dashboard-content-holder ng-if=\"sections && sections.length > 0\">            <div class=litui-dashboard-content>                <litui-dashboard-sections sections=sections settings=sectionsSettings></litui-dashboard-sections>            </div>        </div>    </div></div>");$templateCache.put("litui/com/info/litui-datatable/litui-datatable-cell/litui-datatable-cell.html","<div class=litui-datatable-cell ng-if=\"$ctrl.column.component === undefined\">    <span ng-if=\"$ctrl.column.cellFilter === undefined\">{{$ctrl.entity[$ctrl.column.field]}}</span>    <span ng-if=$ctrl.column.cellFilter litui-dynamic-filter=$ctrl.cellArgs></span></div><div class=litui-datatable-cell ng-if=$ctrl.column.component>    <litui-compile component=$ctrl.column.component additional-params=$ctrl.cellArgs></litui-compile></div>");$templateCache.put("litui/com/info/litui-datatable/litui-datatable.html","<table>    <thead>        <tr>            <th litui-can-view={{col.gridColumnId}} ng-repeat=\"col in $ctrl.tableDefinition.columns track by $index\" ng-class=col.styleClass>                <span litui-translate=col.label></span>            </th>            <th ng-if=$ctrl.tableDefinition.inlineMenu class=litui-inline-menu-column>                            </th>        </tr>    </thead>    <tbody>        <tr ng-repeat=\"item in $ctrl.items track by (item.id || $index)\" class=litui-datatable-row_{{$index}}>            <td litui-can-view={{col.gridColumnId}} ng-repeat=\"col in $ctrl.tableDefinition.columns track by (col.field || $index)\" ng-class=col.styleClass>                <div class=litui-datatable-cell_{{col.field}}>                    {{item[col.field]}}                </div>            </td>            <td ng-if=$ctrl.tableDefinition.inlineMenu class=litui-inline-menu-column>                <litui-inline-menu items=$ctrl.tableDefinition.inlineMenu entity=item></litui-inline-menu>            </td>        </tr>    </tbody></table><div class=litui-datatable-nodata ng-if=\"$ctrl.items.length === 0\">    <span>No data</span></div>");$templateCache.put("litui/com/info/litui-details/litui-details.html","<div class=litui-details-row ng-if=!$ctrl.isObject($ctrl.detailsData[key]) ng-repeat=\"(key, def) in $ctrl.detailsDefinition\" litui-authorized={{def.functionalityId}}>    <div class=litui-details-label>        <span>            <span litui-translate=def.label></span>        </span>    </div>    <div class=litui-details-value>        <span litui-value=$ctrl.detailsData[key] litui-pipes={{def.pipes}} ng-if=\"$ctrl.detailsData[key] !== undefined && $ctrl.detailsData[key] !== null\"></span>        <span litui-value=\"'/'\" ng-if=\"$ctrl.detailsData[key] === undefined || $ctrl.detailsData[key] === null\"></span>    </div></div><div class=litui-details-row ng-if=$ctrl.isObject($ctrl.detailsData[key]) ng-repeat=\"(key, def) in $ctrl.detailsDefinition\" litui-authorized={{def.functionalityId}}>    <litui-details details-data=$ctrl.detailsData[key] details-definition=def ng-if=\"$ctrl.detailsData[key] !== undefined && $ctrl.detailsData[key] !== null\"></litui-details>    <span litui-value=\"'/'\" ng-if=\"$ctrl.detailsData[key] === undefined || $ctrl.detailsData[key] === null\"></span></div>");$templateCache.put("litui/com/info/litui-help-legend/litui-help-legend.html","<div class=litui-help-legend-header ng-if=\"$ctrl.content.title !== undefined || $ctrl.content.title.length === 0\">    <span class=\"litui-icon icon-help\"></span>    <span litui-translate=$ctrl.content.title></span></div><div class=litui-help-legend-body>    <div class=litui-help-legend-items ng-if=\"$ctrl.content.legend !== undefined\">        <div class=litui-help-legend-item-title>            <span litui-translate=\"'LITUI.HELP_LEGEND.LEGEND_LABEL'\"></span>        </div>        <div class=litui-help-legend-item ng-repeat=\"(key, obj) in $ctrl.content.legend\">            <div class=litui-help-legend-item-symbol>                <div class=litui-help-legend-item-color ng-style=\"{'background': obj.color}\" ng-if=\"obj.color !== undefined\"></div>                <div class=litui-help-legend-item-component ng-if=\"obj.component !== undefined\">                    <litui-compile component=obj.component></litui-compile>                </div>            </div>            <div class=litui-help-legend-item-description>                <span litui-translate=obj.description></span>            </div>        </div>    </div>    <div class=litui-help-legend-description ng-if=\"$ctrl.content.description !== undefined\">        <span litui-translate=$ctrl.content.description></span>    </div></div>");$templateCache.put("litui/com/info/litui-infobox/litui-infobox.html","<div class=litui-infobox-body ng-if=\"$ctrl.settings.display === 'inline'\">    <span class=\"litui-icon icon-info\"></span>    <span litui-translate=$ctrl.message></span></div><div class=litui-infobox-body ng-if=\"$ctrl.settings.display === undefined || $ctrl.settings.display === 'popover'\">    <span class=\"litui-icon icon-info\" litui-popover-trigger=$ctrl.messageTrigger></span></div>");$templateCache.put("litui/com/info/litui-notification/litui-notification.html","<div class=\"notify-container animation\" ng-class=\"{'collapsed': notify.collapsed, 'animated': notify.animations}\">    <div class=notification ng-class=notification.type ng-repeat=\"notification in notify.notifications\">        <div class=notification-inner>            <div class=icon-container ng-click=notify.toggle()>                <span class=litui-icon ng-class=notification.icon></span>                                            </div>            <div class=notification-body>                <div class=content-holder>                    <div class=notify-title>                        <span litui-translate=notification.title></span>                    </div>                                        <div ng-if=notification.isComponent>                        <litui-compile class=notify-message component=notification.component is-dynamic=notification.component.isDynamic is-deep=notification.component.isDeep></litui-compile>                     </div>                                        <div class=notify-message ng-if=!notification.isComponent>                        <span litui-translate=notification.message></span>                    </div>                                        <div class=notify-close ng-if=!notification.disableCloseBtn ng-click=notify.close(notification)>                        <span class=\"litui-icon icon-close\"></span>                    </div>                </div>                <div class=notification-actions ng-if=\"notification.actions.length > 0\">                    <button class=pull-right ng-click=\"notify.onAction($event, action, $parent.notification)\" ng-repeat=\"action in notification.actions track by $index\" litui-tooltip={{action.tooltip}} litui-position=bottom>                        <span class=\"litui-icon {{action.icon}}\" ng-if=action.icon></span>                        <span class=litui-label litui-translate=action.label></span>                    </button>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/info/litui-pagination/litui-pagination.html","<div class=litui-pagination-holder ng-if=\"$ctrl.pagination.totalCount > -1\">    <div class=litui-pagination-section>        <div class=litui-pagination-info-holder>            <span class=litui-pagination-info>                <span class=litui-label litui-translate=\"'LITUI.PAGINATION.TOTAL'\"></span>                <span>                    {{$ctrl.pagination.totalCount}}                </span>            </span>            <span class=litui-pagination-info ng-if=\"$ctrl.pageLinks.length > 1 || $ctrl.pagination.availablePerPage\">                <span class=litui-label litui-translate=\"'LITUI.PAGINATION.PER_PAGE'\"></span>                                <span ng-if=!$ctrl.pagination.availablePerPage>                    {{$ctrl.pagination.itemPerPageCount}}                </span>                <select class=litui-select-options ng-if=$ctrl.pagination.availablePerPage ng-model=$ctrl.pagination.itemPerPageCount ng-options=\"val as val for val in $ctrl.pagination.availablePerPage\" ng-change=$ctrl.onPaginationItemsChanged()>                    <option>{{val}}</option>                </select>            </span>                    </div>    </div>    <div class=litui-pagination-inner>        <div class=litui-pagination-frame ng-if=\"$ctrl.pageLinks.length > 1\">            <button class=\"litui-btn-minimal litui-pagination-action\" litui-ripple-fx ng-click=$ctrl.onFirstPage() ng-disabled=\"$ctrl.pagination.currentPage === 0\">                <span class=\"litui-icon icon-first_page\"></span>            </button>            <button class=\"litui-btn-minimal litui-pagination-action\" litui-ripple-fx ng-click=$ctrl.onPreviousPage() ng-disabled=\"$ctrl.pagination.currentPage === 0\">                <span class=\"litui-icon icon-previous\"></span>            </button>            <div class=litui-pagination-links-holder>                <div class=litui-pagination-links-holder-inner>                    <button class=litui-btn-minimal litui-ripple-fx ng-repeat=\"pageLink in $ctrl.pageLinks\" ng-class=\"{'litui-active': $ctrl.selectedPageLink.linkValue === pageLink.linkValue}\" ng-click=\"$ctrl.onSelectPage($event, pageLink)\">                        <span class=litui-label>{{pageLink.linkValue + 1}}</span>                    </button>                </div>            </div>            <button class=\"litui-btn-minimal litui-pagination-action\" litui-ripple-fx ng-click=$ctrl.onNextPage() ng-disabled=\"$ctrl.pagination.currentPage === $ctrl.pagination.pageCount - 1\">                <span class=\"litui-icon icon-next\"></span>            </button>            <button class=\"litui-btn-minimal litui-pagination-action\" litui-ripple-fx ng-click=$ctrl.onLastPage() ng-disabled=\"$ctrl.pagination.currentPage === $ctrl.pagination.pageCount - 1\">                <span class=\"litui-icon icon-last_page\"></span>            </button>        </div>    </div>    <div class=litui-pagination-section>            </div></div>");$templateCache.put("litui/com/info/litui-user-info/litui-user-info.html","<div class=user-info-signature ng-if=\"$ctrl.infoType === 'signature' && $ctrl.model !== null\">    <span ng-repeat=\"defn in $ctrl.signatureDef\">        {{$ctrl.model[defn]}}    </span></div><div class=user-info-signature ng-if=\"$ctrl.infoType === 'identity' && $ctrl.model !== null\">    <span ng-repeat=\"defn in $ctrl.identityDef\">        {{$ctrl.model[defn]}}    </span></div><div class=user-info-signature ng-if=\"$ctrl.infoType === 'identity-details' && $ctrl.model !== null\" litui-popover-trigger=$ctrl.identityDetailsTrigger>    <span ng-repeat=\"defn in $ctrl.identityDef\">        {{$ctrl.model[defn]}}    </span></div><div class=user-info-signature ng-if=\"$ctrl.model === null\">    <span>/</span></div>");$templateCache.put("litui/com/info/litui-user-profile-info/litui-user-profile-info.html","<div class=litui-user-profile-info-inner>    <div class=litui-user-profile-info-header>    </div>    <div class=litui-user-profile-info-body>        <div class=litui-user-profile-info-body-inner>            <div class=litui-user-profile-info-name>                <span>{{$ctrl.data.fullName}}</span>            </div>            <litui-details details-data=$ctrl.data details-definition=$ctrl.settings.details.detailsDef></litui-details>            <div class=litui-user-profile-info-action-menu>                <div class=litui-user-profile-info-action-item ng-repeat=\"item in $ctrl.settings.actionMenu\">                    <button class=litui-user-profile-info-action ng-if=\"item.component === undefined\" ng-click=\"item.onSelected($event, item)\" litui-authorized={{item.functionalityId}} litui-ripple-fx>                        <span class=\"litui-icon {{item.icon}}\" ng-if=item.icon></span>                        <span litui-translate=item.title></span>                    </button>                    <div class=litui-user-profile-info-action-custom ng-if=\"item.component !== undefined\">                        <litui-compile component=item.component is-dynamic=item.isDynamic is-deep=item.isDeep on-compiled=\"item.onCompiled($element, bindings)\" additional-params=item.additionalParams></litui-compile>                    </div>                </div>            </div>        </div>    </div>    <div class=litui-user-profile-info-footer>        <button ng-click=$ctrl.onLogout($event) litui-ripple-fx>            <span class=litui-label litui-translate=\"'LITUI.USER_PROFILE.LOGOUT_TILE'\"></span>            <span class=\"litui-icon icon-log_out\"></span>        </button>    </div></div>");$templateCache.put("litui/com/input/litui-angle-picker/litui-angle-picker.html","<div class=litui-angle-picker-circle-holder>    <div class=litui-angle-picker-circle></div>    <div class=litui-angle-picker-handle></div></div><div class=litui-angle-picker-input-holder>    <input type=text ng-model=$ctrl.angleDeg ng-change=$ctrl.events.onChange($ctrl.angleDeg) ng-class=\"{ 'litui-invalid': !$ctrl.$$validity }\">    <span>        °&nbsp;    </span>    <span class=litui-angle-picker-label translate=LITUI.ANGLE_PICKER.LABEL></span></div>");$templateCache.put("litui/com/input/litui-button/litui-button.html","<button class=litui-btn-submit ng-click=$ctrl.onSelected($event) ng-disabled=$ctrl.isActionInProgress litui-ripple-fx>    <span class=litui-button-label>        <span class=litui-icon ng-class=\"$ctrl.settings.icon || 'icon-publish'\"></span>        <span class=litui-label litui-translate=$ctrl.settings.label></span>    </span>    <div class=litui-button-loader ng-if=$ctrl.isActionInProgress></div>    <div class=litui-button-confirmation ng-if=$ctrl.isConfirmationInProgress>        <div class=litui-button-confirmation-choice>            YES | NO        </div>    </div></button>");$templateCache.put("litui/com/input/litui-checklist/litui-checklist-trigger/litui-checklist-trigger-directive.html","Checklist trigger");$templateCache.put("litui/com/input/litui-checklist/litui-checklist.html","<ul>        <li ng-if=\"$ctrl.visibility === undefined || $ctrl.visibility(item)\" ng-repeat=\"item in $ctrl.items\" litui-ripple-fx>        <litui-input field=$ctrl.inputField label={{item[$ctrl.mapping.label]}} value=item[$ctrl.mapping.value]></litui-input>    </li></ul>");$templateCache.put("litui/com/input/litui-interval/litui-interval.html","<div class=litui-interval-scale>        <div class=litui-interval-scale-inner>        <div class=litui-interval-scale-numbers-holder>            <div class=litui-interval-scale-number name={{number}} ng-class=\"{'litui-selectable': $ctrl.intervals[0].length === 1}\" ng-click=\"$ctrl.onNumberSelected($event, number)\" ng-repeat=\"number in $ctrl.scaleNumbers\" ng-class=\"{'litui-active': $ctrl.limits.indexOf(number) > -1 }\">                <span>{{number}}</span>            </div>        </div>    </div></div>");$templateCache.put("litui/com/input/litui-list-assignment/litui-list-assignment.html","<div class=litui-list-assignment-inner>    <div class=litui-list-assignment-a>        <litui-select-list list=$ctrl.listA on-item-selected=$ctrl.onListAitemSelected on-item-activated=$ctrl.onListAitemActivated settings=$ctrl.settings.listA></litui-select-list>    </div>    <div class=litui-list-assignment-controls>        <button ng-click=$ctrl.onToListB($event) litui-tooltip=LITUI.LIST_ASSIGNMENT.TO_B>            <span class=\"litui-icon icon-details\"></span>        </button>        <button ng-click=$ctrl.onToListA($event) litui-tooltip=LITUI.LIST_ASSIGNMENT.TO_A position=bottom>            <span class=\"litui-icon icon-previous\"></span>        </button>    </div>    <div class=litui-list-assignment-b>        <litui-select-list list=$ctrl.listB on-item-selected=$ctrl.onListBitemSelected on-item-activated=$ctrl.onListBitemActivated settings=$ctrl.settings.listB></litui-select-list>    </div></div>");$templateCache.put("litui/com/input/litui-number-picker/litui-number-picker.html","<button ng-if=$ctrl.stepControls ng-click=$ctrl.events.onDecrementValue()>    <span>-</span></button><input type=text ng-model=$ctrl.value ng-change=$ctrl.events.onChange()><button ng-if=$ctrl.stepControls ng-click=$ctrl.events.onIncrementValue()>    <span>+</span></button>");$templateCache.put("litui/com/input/litui-search-box/litui-search-box-results/litui-search-box-results.html","<div ng-if=\"$ctrl.results && $ctrl.results.length > 0\">    <div ng-click=\"$ctrl.onSelected($event, result)\" ng-repeat=\"result in $ctrl.results\">        <span>{{result}}</span>    </div></div><div class=litui-search-box-results-none ng-if=\"$ctrl.results === undefined || $ctrl.results.length === 0\">    <span litui-translate=\"'LITUI.SEARCH_BOX.RESULTS.NONE'\"></span></div>");$templateCache.put("litui/com/input/litui-search-box/litui-search-box.html","<litui-input field=$ctrl.searchField value=$ctrl.value></litui-input><button class=litui-btn-minimal ng-click=$ctrl.onSearch($event) litui-ripple-fx>    <span class=\"litui-icon icon-search\"></span></button>");$templateCache.put("litui/com/input/litui-select-list/litui-select-list.html","<div class=litui-select-list-inner>    <div class=litui-select-list-title>        <span litui-translate=$ctrl.settings.title></span>    </div>    <div class=litui-select-list-body>        <div class=litui-select-list-item ng-repeat=\"item in $ctrl.list track by $index\" ng-dblclick=\"$ctrl.onActivateItem($event, item)\" ng-click=\"$ctrl.onSelectItem($event, item)\" ng-class=\"{'litui-selected': item.isSelected}\">            <span>{{item.label}}</span>        </div>    </div></div>");$templateCache.put("litui/com/input/litui-state-switch/litui-state-switch.html","<div class=litui-state-switch-bar ng-click=$ctrl.onSelect($event)>    <div class=litui-state-switch-state-label-a ng-if=$ctrl.settings.showBackgroundStateLabels>        <span litui-translate=$ctrl.settings.labelA></span>    </div>    <div class=litui-state-switch-state-label-b ng-if=$ctrl.settings.showBackgroundStateLabels>        <span litui-translate=$ctrl.settings.labelB></span>    </div>    <button ng-click=$ctrl.onSelect($event)>        <span ng-if=$ctrl.settings.showStateLabel litui-translate=$ctrl.buttonLabel></span>    </button></div>");$templateCache.put("litui/com/input/litui-upload-img/litui-upload-img.html","<litui-image class=litui-upload-img-preview src=$ctrl.previewSrc settings=$ctrl.imageSettings ng-style=\"{top: $ctrl.imgPosition.top, left: $ctrl.imgPosition.left}\" ng-if=$ctrl.previewSrc></litui-image><div ng-file-drop=$ctrl.onFileSelect($files) class=litui-upload-img-droparea ng-file-drag-over-class=litui-active ng-if=\"!$ctrl.isFilePending && !$ctrl.isPreviewMode\">    <div class=litui-upload-img-droparea-txt-holder>        <span class=litui-upload-img-droparea-txt litui-translate>LITUI.UPLOAD_IMG.DROPAREA</span>    </div></div>");$templateCache.put("litui/com/input/litui-upload/litui-upload.html","<div>    </div><div class=litui-upload>        <div>        <uib-progressbar class=progress-striped ng-if=$ctrl.fupload.enableProgressBar value=$ctrl.fupload.uploadProgress type=info>            {{$ctrl.fupload.uploadProgress}}%        </uib-progressbar>    </div>    <div class=litui-clearfix>                <div class=litui-upload-file-drop-holder ng-if=$ctrl.fupload.showHitArea>            <div class=litui-upload-file-drop-overlay ng-if=$ctrl.isFilePending></div>            <div ng-file-drop=$ctrl.onFileSelect($files) class=litui-upload-drop-box ng-file-drag-over-class=litui-active>                <span>                    <span class=litui-upload-img-droparea-txt litui-translate>LITUI.UPLOAD_FILE.DROP_HERE</span>                </span>            </div>        </div>        <div class=litui-upload-inner>                          <div class=litui-upload-text>                <span litui-translate=$ctrl.fupload.text></span>            </div>            <div class=litui-upload-inner-body>                <div class=litui-upload-file-info>                                        <div ng-if=$ctrl.file>                        <span litui-translate=\"'LITUI.UPLOAD_FILE.FILENAME'\"></span>:                         <span>{{$ctrl.file.name}}</span>                    </div>                                        <div ng-if=\"$ctrl.file && $ctrl.fupload.isCalcMd5\">                        <span litui-translate=\"'LITUI.UPLOAD_FILE.MD5_CHECKSUM'\"></span>:                         <span>{{$ctrl.md5hash}}</span>                    </div>                                        <div ng-if=\"$ctrl.error.length > 0\">                        <span class=litui-upload-file-error>{{$ctrl.error}}</span>                    </div>                </div>                                <div class=\"btn-group litui-upload-actions-row\">                    <button class=\"btn btn-primary\" ng-file-select=$ctrl.onFileSelect($files) ng-disabled=$ctrl.isFilePending data-multiple=false>                        <span litui-translate=\"'LITUI.UPLOAD_FILE.BROWSE'\"></span>                    </button>                    <button class=\"btn btn-primary\" ng-click=$ctrl.onClear() ng-disabled=!$ctrl.isFilePending>                        <span litui-translate=\"'LITUI.UPLOAD_FILE.CLEAR'\"></span>                    </button>                    <button class=\"btn btn-primary\" ng-if=$ctrl.fupload.showUploadBtn ng-click=$ctrl.onUpload($event) ng-disabled=!$ctrl.isValid>                        <span litui-translate=\"'LITUI.UPLOAD_FILE.UPLOAD'\"></span>                    </button>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/input/litui-value-list/litui-value-list.html","<div class=litui-clearfix style=\"height: 40px;\" ng-repeat=\"value in $ctrl.values\">    <div style=\"float: left; width: 50%;\">        <litui-input field=$ctrl.inputField value=value.key>    </litui-input></div>    <div style=\"float: left; width: 50%;\">        <litui-input field=$ctrl.inputField value=value.type>    </litui-input></div></div><div>    <button class=litui-btn-minimal ng-click=$ctrl.onAddValue($event) style=\"float: right;\" litui-ripple-fx>        <span class=\"litui-icon icon-add\"></span>        <span class=litui-label>Add</span>    </button></div>");$templateCache.put("litui/com/layout/litui-drawer/litui-drawer-outlet-directive.html","Hello world");$templateCache.put("litui/com/layout/litui-drawer/litui-drawer.html","<div class=litui-drawer-inner></div>");$templateCache.put("litui/com/layout/litui-layout-mngr/litui-layout-mngr.html","<div class=\"litui-layout litui-layout-panel-root\">            <div class=litui-layout-panel-drawer-west></div>            <div class=litui-layout-panel-north ng-transclude=panelNorth>    </div>    <div class=litui-layout-panel-middle>        <button ng-click=onSkipToContent() class=litui-layout-skip-main>Skip to content</button>                <div class=litui-layout-panel-west ng-transclude=panelWest>        </div>        <div class=litui-layout-panel-central>            <div class=litui-layout-panel-view-header ng-transclude=panelViewHeader></div>            <div class=litui-layout-panel-ribbon ng-transclude=panelRibbon></div>            <div class=litui-layout-panel-viewport ng-transclude=panelViewport>                <div class=litui-active-viewport ui-view></div>                <litui-pop-component-outlet id=default></litui-pop-component-outlet>            </div>            <div class=litui-layout-panel-view-footer ng-transclude=panelViewFooter></div>            <div ng-transclude=panelCentral></div>            <div class=litui-layout-panel-wizard>                <litui-wizard-outlet></litui-wizard-outlet>            </div>            <litui-pop-component-outlet id=popup></litui-pop-component-outlet>        </div>        <div class=litui-layout-panel-east ng-transclude=panelEast>        </div>    </div>    <div class=litui-layout-panel-south ng-transclude=panelSouth>    </div></div>");$templateCache.put("litui/com/layout/litui-side-panel/litui-side-panel.html","<div class=litui-side-panel>    <div class=litui-side-panel-header>        <div class=litui-side-panel-header-inner>            <div class=litui-side-panel-header-title>                {{title}}            </div>            <div class=litui-side-panel-header-close>                <button class=\"litui-btn-icon icon-close\" ng-click=onClose()></button>            </div>        </div>    </div>    <div class=litui-side-panel-body>        <litui-compile class=litui-side-panel-body-inner component=component is-dynamic=true></litui-compile>    </div></div>");$templateCache.put("litui/com/layout/litui-view-footer/litui-view-footer-drawer/litui-view-footer-drawer.html","<div class=litui-view-footer-drawer-inner>    <div class=litui-view-footer-drawer-content>        <litui-compile component=$ctrl.component is-dynamic=true></litui-compile>    </div></div>");$templateCache.put("litui/com/layout/litui-view-footer/litui-view-footer.html","<litui-compile component=$ctrl.footer></litui-compile>");$templateCache.put("litui/com/layout/litui-view-options-panel/litui-view-options-panel.html","<div class=litui-view-options-panel-header ng-if=$ctrl.settings.isHeader>    <div class=litui-view-options-header-outlet ng-if=\"$ctrl.settings.mainTools !== undefined\" ng-class=\"{'litui-view-options-notrigger': !$ctrl.settings.isTrigger}\">        <litui-compile component=$ctrl.settings.mainTools is-dynamic=true></litui-compile>    </div>        <div class=litui-view-options-actions>        <button class=\"litui-btn-minimal litui-view-options-trigger\" ng-click=$ctrl.onToggle() ng-if=$ctrl.settings.isTrigger litui-ripple-fx>            <span class=\"litui-icon {{$ctrl.settings.trigger.icon}}\" ng-if=\"$ctrl.settings.trigger !== undefined && $ctrl.settings.trigger.icon !== undefined\"></span>            <span litui-translate=$ctrl.settings.trigger.label ng-if=\"$ctrl.settings.trigger !== undefined && $ctrl.settings.trigger.label !== undefined\"></span>                        <span class=\"litui-icon icon-settings_view\" ng-if=\"$ctrl.settings.trigger === undefined || $ctrl.settings.trigger.icon === undefined\"></span>            <span litui-translate=\"'LITUI.VIEW_OPTIONS_PANEL.TRIGGER_LABEL'\" ng-if=\"$ctrl.settings.trigger === undefined || $ctrl.settings.trigger.label === undefined\"></span>        </button>    </div></div><div class=litui-view-options-panel-body ng-class=\"{'litui-view-options-panel-no-header': !$ctrl.settings.isHeader}\">    <div class=litui-view-options-group-holder litui-eq-width=.litui-view-options-group>        <div class=litui-view-options-group litui-authorized={{group.functionalityId}} ng-repeat=\"(gname, group) in $ctrl.settings.groups\">            <div class=litui-view-options-group-header>                <span litui-translate=group.title></span>            </div>            <div class=litui-view-options-group-body litui-view-options-panel-control-arrangement=group.controls>                <div class=litui-view-option litui-authorized={{field.functionalityId}} ng-repeat=\"(fname, field) in group.controls\">                    <litui-input name=fname field=field value=field.value on-change=\"field.onChange(e, val, fname)\"></litui-input>                </div>            </div>        </div>    </div>    <div class=litui-view-options-controls-holder>        <div>            <div ng-repeat=\"action in $ctrl.settings.actions\">                <button class=litui-btn-minimal ng-click=\"$ctrl.onActionSelected($event, action)\">                    <span class=\"litui-icon {{action.icon}}\"></span>                    <span class=litui-label litui-translate=action.label></span>                </button>            </div>        </div>        <div>            <button class=litui-btn-minimal ng-click=$ctrl.onReset() litui-ripple-fx>                <span class=\"litui-icon icon-reload\"></span>                <span class=litui-label litui-translate=\"'LITUI.VIEW_OPTIONS.CONTROLS.RESET'\"></span>            </button>        </div>    </div></div>");$templateCache.put("litui/com/layout/litui-wizard/litui-wizard.html","<div class=litui-wizard-header>    <div class=litui-wizard-header-left>        <button class=\"litui-btn-submit litui-wizard-btn-previous\" ng-if=\"$ctrl.activeStateIndex > 0 && $ctrl.settings.preventBack !== true && $ctrl.states[$ctrl.activeStateIndex].preventBack !== true\" ng-click=$ctrl.onPrevious($event)>            <span class=\"litui-icon icon-previous\"></span>            <span litui-translate=\"'Previous'\"></span>        </button>    </div>    <div class=litui-wizard-header-center>        <div class=litui-wizard-header-state-info>            <span class=litui-wizard-current-state>{{$ctrl.activeStateIndex + 1}}</span>            <span>/</span>            <span class=litui-wizard-state>{{$ctrl.states.length}}</span>        </div>    </div>    <div class=litui-wizard-header-right>        <button class=litui-btn-minimal ng-click=$ctrl.onCancel($event) ng-if=\"$ctrl.settings.showCloseBtn === true\">            <span litui-translate=\"'Cancel'\"></span>        </button>        <button class=litui-btn-primary ng-repeat=\"action in $ctrl.settings.actions\" ng-click=action.onSelected($event) litui-ripple-fx>            <span class=litui-icon ng-class=action.icon></span>            <span class=litui-label litui-translate=action.label></span>        </button>        <button class=\"litui-btn-submit litui-wizard-btn-next\" ng-repeat=\"stateAction in $ctrl.states[$ctrl.activeStateIndex].actions\" ng-click=\"stateAction.onSelected($event, stateAction)\">            <span class=litui-icon ng-class=stateAction.icon></span>            <span litui-translate=stateAction.label></span>        </button>        <button class=\"litui-btn-submit litui-wizard-btn-next\" ng-if=\"$ctrl.activeStateIndex < $ctrl.states.length - 1\" ng-click=$ctrl.onNext($event)>            <span litui-translate=\"'Next'\"></span>            <span class=\"litui-icon icon-details\"></span>        </button>    </div></div><div class=litui-wizard-body>    <div class=litui-wizard-steps>        <div class=litui-col-3>            <span class=litui-title litui-translate=\"$ctrl.states[$ctrl.activeStateIndex].title || $ctrl.states[$ctrl.activeStateIndex].label\"></span>        </div>        <div class=\"litui-clearfix litui-col-6\">            <div class=litui-steps-holder>                <div class=litui-wizard-step ng-class=\"{'litui-active': $index === $ctrl.activeStateIndex, 'litui-wizard-no-discrete-switch': $ctrl.settings.preventDiscreteSwitch}\" ng-click=\"$ctrl.onGoToState($event, $index)\" ng-repeat=\"state in $ctrl.states track by $index\">                        <span class=litui-arrow>                            <span class=litui-icon ng-class=state.icon></span>                            <span>{{state.label || state.title}}</span>                        </span>                </div>            </div>        </div>    </div>    <div class=litui-wizard-body-state>        <litui-state name=litui-wizard-state active-state-index=$ctrl.activeStateIndex states=$ctrl.states></litui-state>    </div></div>");$templateCache.put("litui/com/litui-state/litui-state.html","<div class=litui-state-body name={{$ctrl.name}}></div>");$templateCache.put("litui/com/litui-tabset/litui-tabset.html","<div class=litui-tabset-inner ng-class=\"{'litui-notab': $ctrl.tabs.length <= 1}\">    <div class=litui-tabset-header ng-if=\"$ctrl.tabs.length > 1\">        <litui-inline-menu items=$ctrl.tabs entity=$ctrl.entity settings=$ctrl.tabMenuSettings></litui-inline-menu>    </div>    <div class=litui-tabset-body>            </div></div>");$templateCache.put("litui/com/menu/litui-app-menu/com/litui-app-menu-drawer/litui-app-menu-drawer.html","<div class=litui-app-menu-drawer-inner>    <div class=litui-app-menu-drawer-holder>        <div class=litui-app-menu-drawer-header>            <div class=litui-app-menu-drawer-header-title>                <span litui-translate=$ctrl.settings.header.title></span>            </div>            <div class=litui-app-menu-drawer-header-options>                <button ng-click=$ctrl.onDismiss($event)>                    <span class=\"litui-icon icon-clear\"></span>                </button>            </div>        </div>        <div class=litui-app-menu-drawer-body>            <litui-compile component=$ctrl.settings.component ng-if=\"$ctrl.settings.component !== null\"></litui-compile>        </div>    </div></div>");$templateCache.put("litui/com/menu/litui-app-menu/com/litui-app-menu-list-item.html","<div class=litui-app-menu-list-item ng-click=onSelect($event) ng-class=\"{'litui-app-menu-list-item-no-icon': item.icon === undefined,                  'litui-app-menu-list-item-no-sub-menu': (item.subMenu === undefined || item.subMenu.length === 0),                  'litui-link': item.sref !== undefined,                  'litui-selected': isSelected,                  'litui-additional-icon': item.additionalIcon,                 'litui-is-expanded': isExpanded}\">    <a type=button ui-sref={{item.sref}} ng-if=\"item.sref && item.sref.length > 0\" ng-focus=onLinkFocus($event)>        <div class=litui-app-menu-list-item-inner litui-ripple-fx ng-mouseenter=onMouseenter($event) ng-mouseleave=onMouseleave($event)>            <div class=litui-app-menu-list-item-p1>                <span class=\"litui-icon {{(isSelected? item.selectedIcon || item.icon : item.icon)}}\"></span>                <div class=\"litui-app-menu-notification litui-app-menu-notification-alert\" ng-if=\"notification.num > 0\">{{notification.num}}</div>            </div>            <div class=litui-app-menu-list-item-p2>                <span litui-translate=item.title></span>            </div>            <div class=\"litui-app-menu-list-item-p3 litui-app-menu-sub-marker icon-details\" ng-if=\"(item.additionalIcon === undefined || !item.additionalIcon) && (item.stateIcons === undefined || !item.stateIcons)\"></div>                    <div class=\"litui-app-menu-list-item-p3 {{item.additionalIcon}}\" ng-if=item.additionalIcon></div>            <div class=\"litui-app-menu-list-item-p3 {{(isExpanded? item.stateIcons.expanded : item.stateIcons.collapsed)}}\" ng-if=item.stateIcons></div>        </div>    </a>        <div class=litui-app-menu-list-item-inner ng-if=\"item.sref === undefined || item.sref.length === 0\" ng-mouseenter=onMouseenter($event) ng-mouseleave=onMouseleave($event)>        <div class=litui-app-menu-list-item-p1>            <span class=\"litui-icon {{(isSelected? item.selectedIcon || item.icon : item.icon)}}\"></span>            <div class=\"litui-app-menu-notification litui-app-menu-notification-alert\" ng-if=\"notification.num > 0\">{{notification.num}}</div>            <div class=\"litui-app-menu-notification litui-app-menu-notification-alert\" ng-if=\"notification.num > 9\">9+</div>        </div>        <div class=litui-app-menu-list-item-p2>            <span litui-translate=item.title></span>        </div>        <div class=\"litui-app-menu-list-item-p3 litui-app-menu-sub-marker icon-details\" ng-if=\"(item.additionalIcon === undefined || !item.additionalIcon) && (item.stateIcons === undefined || !item.stateIcons)\"></div>                <div class=\"litui-app-menu-list-item-p3 {{item.additionalIcon}}\" ng-if=item.additionalIcon></div>                <div class=\"litui-app-menu-list-item-p3 {{(isExpanded? item.stateIcons.expanded : item.stateIcons.collapsed)}}\" ng-if=item.stateIcons></div>                    </div></div>");$templateCache.put("litui/com/menu/litui-app-menu/com/litui-app-menu-weather.html","<div class=litui-app-menu-weather>    <div class=litui-app-menu-weather-inner ng-if=weather>        <span class=litui-weather-icon ng-class=weather.icon></span>        <span class=litui-weather-temperature>{{weather.temperature}}</span>    </div>    <div class=litui-app-menu-weather-inner ng-if=\"weather === undefined\" ng-class=\"{ 'litui-nodata': weather === undefined }\">        <span class=litui-label litui-translate=\"'LITUI.APP_MENU.WEATHER.NO_DATA'\"></span>    </div></div>");$templateCache.put("litui/com/menu/litui-app-menu/litui-app-menu.html","<div class=litui-app-menu ng-class=\"{ 'litui-app-menu-collapsed': isAppMenuCollapsed, 'litui-app-menu-header-collapsed': quickTools === null, 'litui-app-menu-feature-weather': activeFeatures.indexOf('weather') > -1, 'litui-app-menu-feature-time': activeFeatures.indexOf('time') > -1, 'litui-app-menu-feature-version': activeFeatures.indexOf('version') > -1 }\">    <div class=litui-app-menu-header>        <div class=litui-app-menu-top>            <litui-app-menu-btn class=litui-app-menu-btn-holder></litui-app-menu-btn>            <litui-app-menu-brand class=litui-app-menu-brand-holder logo-img=brand.logo brandname=brand.brandname ng-click=onSelectBrand($event)></litui-app-menu-brand>        </div>        <div class=litui-app-menu-quick-tools>            <litui-compile component=quickTools></litui-compile>        </div>    </div>    <div class=litui-app-menu-body>        <litui-app-menu-list arg-menu-items=navItems></litui-app-menu-list>    </div>    <div class=litui-app-menu-footer>        <div class=litui-app-menu-footer-menu-list>            <litui-app-menu-list arg-menu-items=menuItems></litui-app-menu-list>        </div>        <div class=litui-app-menu-features ng-if=\"activeFeatures.length > 0\">            <div class=litui-app-menu-features-inner>                <litui-app-menu-weather class=litui-app-menu-feature-holder ng-if=\"activeFeatures.indexOf('weather') > -1\"></litui-app-menu-weather>                <litui-app-menu-server-time class=litui-app-menu-feature-holder ng-if=\"activeFeatures.indexOf('time') > -1\"></litui-app-menu-server-time>                <litui-app-menu-sys-version class=\"litui-app-menu-feature-holder litui-app-menu-sys-version-holder\" litui-authorized=\"{{fmap['FEATURE.SYS.VERSION']}}\" ng-if=\"activeFeatures.indexOf('version') > -1\"></litui-app-menu-sys-version>            </div>        </div>    </div></div>");$templateCache.put("litui/com/menu/litui-dropdown/litui-dropdown.html","<div class=litui-dropdown-item-slots tabindex=-1 role=listbox aria-labelledby=some_trigger>    <div class=litui-dropdown-item litui-authorized={{item.functionalityId}} ng-click=\"$ctrl.onSelected($event, item, $index)\" ng-repeat=\"item in $ctrl.dropdownItems | limitTo: ($ctrl.fromIndex - $ctrl.dropdownItems.length) track by $index\" ng-class=\"{'litui-selected': item.isSelected, 'litui-active': $ctrl.settings.isItemActive(item) || item.isActive}\">        <div ng-if=\"item.type === 'component'\">            <litui-compile component=item.component></litui-compile>        </div>        <button role=option ng-if=\"item.type === undefined || item.type === 'item'\">            <span ng-if=\"item.icon && item.icon !== 'empty'\" class=\"tms-icon {{item.icon}}\"></span>            <span ng-if=\"item.icon === 'empty'\" class=\"tms-icon litui-empty-icon icon-NO_ICON\"></span>            <span ng-if=item.label class=litui-label litui-translate=item.label></span>        </button>    </div></div>");$templateCache.put("litui/com/menu/litui-inline-menu/litui-inline-menu.html","<div class=litui-inline-menu-inner>    <div class=litui-inline-menu-item litui-authorized={{item.functionalityId}} ng-repeat=\"item in $ctrl.items | limitTo: ($ctrl.settings.defaultLimit !== -1? $ctrl.settings.defaultLimit : $ctrl.items.length)\">        <button id=some_trigger class=\"{{item.styleClass || 'litui-btn-minimal'}}\" aria-label=\"{{item.label | lituiTranslate}}\" ng-disabled=item.isDisabled ng-class=\"{'litui-active': $ctrl.settings.isItemActive(item) || item.isActive}\" ng-click=\"$ctrl.onItemSelected($event, item, $index)\" litui-ripple-fx>            <span class=litui-icon ng-class=item.icon ng-if=\"!$ctrl.settings.showLabel && item.label && item.label.length > 0\" litui-tooltip=\"{{item.tooltip || item.label}}\" position=bottom></span>                        <span class=litui-icon ng-class=item.icon ng-if=$ctrl.settings.showLabel></span>            <span class=litui-label litui-translate=item.label ng-if=$ctrl.settings.showLabel></span>        </button>    </div>    <div class=litui-float-left ng-if=\"$ctrl.settings.defaultLimit !== -1 && $ctrl.countAvailableItems() > $ctrl.settings.defaultLimit\">        <button class=litui-btn-minimal litui-dropdown-trigger dropdown-items=$ctrl.items position=\"'right'\" from-index=$ctrl.settings.defaultLimit entity=$ctrl.entity settings=$ctrl.dropdownSettings litui-ripple-fx>            <span class=\"litui-icon icon-function-menu\"></span>        </button>    </div></div>");$templateCache.put("litui/com/menu/litui-toggle-panel/litui-toggle-panel.html","<div class=\"litui-toggle-item litui-float-left {{item.styleClass}}\" ng-repeat=\"item in $ctrl.$$toggleItems track by $index\" ng-class=\"{ 'litui-icon-mode': $ctrl.settings.isIconMode }\">        <div class=\"litui-toggle-item-control litui-float-left\" litui-authorized={{item.functionalityId}} ng-if=!item.isIconMode ng-click=\"$ctrl.onSelected($event, item)\" ng-class=\"{ 'litui-toggle-off': !item.value, 'litui-toggle-on': item.value }\">        <span class=\"litui-icon litui-float-left icon-radiobutton-bullet\"></span>        <span class=\"litui-label litui-float-left\" litui-translate=item.label></span>    </div>    <div class=\"litui-toggle-item-control litui-float-left\" litui-authorized={{item.functionalityId}} ng-if=item.isIconMode ng-click=\"$ctrl.onSelected($event, item)\">        <span class=\"litui-icon litui-float-left {{item.activeIcon}}\"></span>    </div></div>");$templateCache.put("litui/com/pop/litui-dialog/litui-dialog.html","<div class=litui-dialog-inner ng-class=\"{ 'litui-dialog-no-header': !$ctrl.pop.settings.header }\">    <div class=litui-dialog-header-holder ng-if=$ctrl.pop.settings.header>        <litui-popup-header pop=$ctrl.pop settings=$ctrl.header></litui-popup-header>    </div>    <litui-compile class=litui-dialog-body-holder component=$ctrl.pop.settings.component></litui-compile></div>");$templateCache.put("litui/com/pop/litui-pop-component/litui-pop-component-outlet.html","<div ng-repeat=\"pop in $ctrl.pops track by pop.id\">    <litui-pop-component component=pop ng-class=pop.settings.cssClass ng-style=\"{ left: pop.position.left, top: pop.position.top }\"></litui-pop-component></div>");$templateCache.put("litui/com/pop/litui-pop-component/litui-pop-component.html","<div class=\"litui-pop-component-holder litui-{{$ctrl.component.settings.bindedPosition}} {{$ctrl.component.settings.styleClass}}\">            <div class=litui-pop-component-marker ng-if=\"($ctrl.component.settings.bindedPosition === 'right' || $ctrl.component.settings.bindedPosition === 'bottom') && $ctrl.component.settings.showPositionMarker\"></div>        <div class=litui-pop-component-inner>        <div class=litui-pop-close-holder ng-if=$ctrl.component.settings.showClose>            <button class=litui-btn-minimal ng-click=$ctrl.onClose($event)>                <span class=\"litui-icon icon-close\"></span>            </button>        </div>                <div class=litui-pop-component-content>            <litui-compile component=$ctrl.compileComponent on-compiled=\"$ctrl.onCompiled({$elt, $scopeBindings})\"></litui-compile>        </div>    </div>    <div class=litui-pop-component-marker ng-if=\"($ctrl.component.settings.bindedPosition === 'left' || $ctrl.component.settings.bindedPosition === 'top') && $ctrl.component.settings.showPositionMarker\"></div></div>");$templateCache.put("litui/com/pop/litui-popover/litui-popover.html","<litui-compile class=litui-pop-component-content-holder component=$ctrl.pop.settings.component></litui-compile>");$templateCache.put("litui/com/pop/litui-popup/litui-popup-header.html","<div class=\"litui-holder litui-float-left\">    <span class=litui-popup-header-title translate={{$ctrl.settings.title}}></span></div><div class=litui-popup-header-controls>    <button class=litui-popup-header-btn ng-if=\"$ctrl.settings.dropdownItems.length > 0\" litui-dropdown-trigger appid=$ctrl.appid entity-id=\"$ctrl.popupid + '-dropdown'\" dropdown-items=$ctrl.settings.dropdownItems holder-elt-selector=$ctrl.dropdown.holderEltSelector position=\"'right'\" litui-ripple-fx>        <span class=\"litui-icon icon-function-menu\"></span>    </button>    <div class=litui-popup-header-actions ng-if=$ctrl.settings.actions>        <button ng-class=\"action.styleClass || 'litui-btn-primary'\" ng-repeat=\"action in $ctrl.settings.actions track by $index\" ng-click=\"$ctrl.onActionSelected($event, action)\" litui-ripple-fx>            <span class=litui-icon ng-class=action.icon></span>            <span class=litui-label litui-translate=action.label></span>        </button>    </div>    <button ng-if=$ctrl.settings.isCloseBtn class=\"litui-popup-header-btn litui-popup-close\" ng-click=$ctrl.onClose($event)>        <span class=\"litui-icon icon-close\"></span>    </button></div>");$templateCache.put("litui/com/pop/litui-popup/litui-popup.html","<div class=litui-popup-inner ng-class=\"{ 'litui-popup-no-header': !$ctrl.pop.settings.header }\">    <div class=litui-popup-header-holder ng-if=$ctrl.pop.settings.header>        <litui-popup-header pop=$ctrl.pop settings=$ctrl.pop.settings.header></litui-popup-header>    </div>    <litui-compile class=litui-popup-body-holder component=$ctrl.pop.settings.component additional-params=$ctrl.popRef></litui-compile></div>");$templateCache.put("litui/com/translate/litui-translate-preview-notification/litui-translate-preview-notification.html","<div class=litui-translate-preview-holder>    <span litui-translate=\"'LITUI.TRANSLATE_PREVIEW.NOTIFICATION'\" litui-translate-values=$ctrl.notificationParams></span></div><div class=litui-translate-preview-holder>    <button class=litui-btn-primary ng-click=$ctrl.onDisable($event)>        <span class=litui-label litui-translate=\"'LITUI.TRANSLATE_PREVIEW.DISABLE'\"></span>    </button></div>");$templateCache.put("litui/com/translate/litui-translation-importer/litui-translation-importer.html","<div class=litui-translation-importer-instructions>    <p litui-translate=\"'LITUI.TRANSLATION_IMPORTER.INSTRUCTIONS'\"></p></div><div class=litui-translation-importer-body>    <litui-tabset tabs=$ctrl.tabset.tabs settings=$ctrl.tabset.settings></litui-tabset>    <litui-form form-definition=$ctrl.uploadData.formDef model=$ctrl.uploadData.model></litui-form></div>");$templateCache.put("litui/com/translate/litui-translation-tool/litui-translation-tool.html","<div class=litui-translation-tool-main-tools>    <div class=litui-translation-tool-main-tools-info>        <div class=litui-translation-tool-main-tools-info-item>            <span class=litui-label litui-translate=\"'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.APPLICATION'\"></span>            <span class=litui-value>{{$ctrl.activeAppId}}</span>        </div>        <div class=litui-translation-tool-main-tools-info-item>            <span class=litui-label litui-translate=\"'LITUI.TRANSLATION_TOOL.MAIN_TOOLS.LANGUAGE'\"></span>            <span class=litui-value>{{$ctrl.activeLanguageId}}</span>        </div>    </div>        <div class=litui-translation-tool-main-tools-actions>        <button class=litui-btn-minimal litui-ripple-fx litui-authorized={{tool.functionalityId}} ng-class=tool.styleClass ng-repeat=\"tool in $ctrl.mainTools\" ng-if=\"tool.isVisible === undefined? true : tool.isVisible()\" ng-disabled=\"tool.isDisabled === undefined? false : tool.isDisabled()\" ng-click=\"tool.onSelected($event, tool)\">            <span class=litui-icon ng-class=tool.icon></span>            <span class=litui-label>                <span litui-translate=tool.label></span>            </span>        </button>    </div></div><div class=litui-translation-tool-body>    <div class=litui-translation-tool-translator>    </div>    <div class=litui-translation-tool-menu>        <div class=\"litui-translation-tool-menu-category litui-translation-tool-menu-apps\">            <div class=litui-translation-tool-menu-category-header>                <span litui-translate=\"'LITUI.TRANSLATION_TOOL.MENU.SELECT_APPLICATION'\"></span>            </div>            <div class=litui-translation-tool-menu-category-body>                <div class=litui-translation-tool-menu-item ng-repeat=\"appId in $ctrl.appIds\">                    <button class=litui-btn-minimal litui-ripple-fx ng-click=\"$ctrl.onSelectAppId($event, appId)\" ng-class=\"{'litui-active': appId === $ctrl.activeAppId}\">                        <span class=litui-label>{{appId}}</span>                    </button>                </div>            </div>        </div>        <div class=\"litui-translation-tool-menu-category litui-translation-tool-menu-languages\">            <div class=litui-translation-tool-menu-category-header>                <span litui-translate=\"'LITUI.TRANSLATION_TOOL.MENU.SELECT_LANGUAGE'\"></span>            </div>            <div class=litui-translation-tool-menu-category-body>                <div class=litui-translation-tool-menu-item ng-repeat=\"language in $ctrl.languages\">                    <button class=litui-btn-minimal litui-ripple-fx ng-click=\"$ctrl.onSelectLanguage($event, language)\" ng-class=\"{'litui-active': language === $ctrl.activeLanguageId}\">                        <span class=litui-label>{{language}}</span>                    </button>                </div>            </div>        </div>    </div></div>");$templateCache.put("litui/com/translate/litui-translator/litui-translator.html","<div class=litui-translator-sheet>    <div class=litui-translator-sheet-header>        <div class=litui-translator-sheet-cell>            <div class=litui-translator-sheet-header-cell-label>                <span litui-translate=\"'LITUI.TRANSLATOR.KEY'\"></span>            </div>            <div class=litui-translator-sheet-header-search>                <litui-input field=$ctrl.searchFields.key value=$ctrl.searchValues.key on-change=\"$ctrl.searchFields.key.onChange(e, val, field)\"></litui-input>            </div>        </div>        <div class=litui-translator-sheet-cell>            <div class=litui-translator-sheet-header-cell-label>                <span litui-translate=\"'LITUI.TRANSLATOR.REF'\"></span>            </div>            <div class=litui-translator-sheet-header-search>                <litui-input field=$ctrl.searchFields.reference value=$ctrl.searchValues.reference on-change=\"$ctrl.searchFields.reference.onChange(e, val, field)\"></litui-input>            </div>        </div>        <div class=litui-translator-sheet-cell>            <div class=litui-translator-sheet-header-cell-label>                <span litui-translate=\"'LITUI.TRANSLATOR.PUBLISHED'\"></span>            </div>            <div class=litui-translator-sheet-header-search>                <litui-input field=$ctrl.searchFields.published value=$ctrl.searchValues.published on-change=\"$ctrl.searchFields.published.onChange(e, val, field)\"></litui-input>            </div>        </div>        <div class=litui-translator-sheet-cell>            <div class=litui-translator-sheet-header-cell-label>                <span litui-translate=\"'LITUI.TRANSLATOR.VALUE'\"></span>            </div>            <div class=litui-translator-sheet-header-search>                <litui-input field=$ctrl.searchFields.value value=$ctrl.searchValues.value on-change=\"$ctrl.searchFields.value.onChange(e, val, field)\"></litui-input>            </div>        </div>    </div>    <div class=litui-translator-sheet-body>        <div class=litui-translator-sheet-body-inner ng-if=\"$ctrl.translations.length > 0\">            <div class=litui-translator-sheet-row ng-repeat=\"tr in $ctrl.translations track by tr.key\" ng-class=\"{'litui-translator-sheet-unpublished-value': tr.value !== tr.publishedValue && tr.publishedValue}\">                <div class=\"litui-translator-sheet-cell litrui-translator-key\">                    {{tr.key}}                </div>                <div class=litui-translator-sheet-cell>                    {{$ctrl.refTranslations[tr.key]}}                </div>                <div class=litui-translator-sheet-cell>                    {{tr.publishedValue}}                </div>                <div class=litui-translator-sheet-cell>                    <litui-input tab={{$index}} name={{tr.key}} field=$ctrl.editableField value=tr.value on-change=\"$ctrl.onValueChanged(e, val, field)\"></litui-input>                    <div class=litui-translator-sheet-value-tools>                        <button class=litui-btn-minimal litui-tooltip=LITUI.TRANSLATOR.PUBLISH_SINGLE position=left litui-ripple-fx litui-authorized=\"{{$ctrl.fmap['TRANSLATOR.FEATURE.PUBLISH']}}\" ng-if=\"tr.value !== tr.publishedValue\" ng-click=\"$ctrl.onPublishSinge($event, tr)\">                            <span class=\"litui-icon icon-publish\"></span>                        </button>                        <button class=litui-btn-minimal litui-ripple-fx litui-authorized=\"{{$ctrl.fmap['TRANSLATOR.FEATURE.HINTS']}}\" ng-if=\"tr.hints.length > 0\" ng-click=\"$ctrl.hintsTrigger.onOpen($event, tr)\">                            <span class=\"litui-icon icon-info\"></span>                        </button>                        <button class=litui-btn-minimal litui-tooltip=LITUI.TRANSLATOR.APPLY_EQUAL position=left litui-ripple-fx litui-authorized=\"{{$ctrl.fmap['TRANSLATOR.FEATURE.APPLY_TO_EQUAL']}}\" ng-click=\"$ctrl.onApplyToAllEqual($event, tr,$ctrl.refTranslations[tr.key])\">                            <span class=\"litui-icon icon-apply_to_unit\"></span>                        </button>                    </div>                </div>            </div>            <litui-pop-component-outlet id=litui-translator-hints-outlet></litui-pop-component-outlet>        </div>        <div class=litui-translator-sheet-body-inner ng-if=\"$ctrl.translations.length === 0\">            <div class=litui-translator-sheet-nodata>                <span litui-translate=\"'LITUI.TRANSLATOR.NO_DATA'\"></span>            </div>        </div>    </div></div><div class=litui-translator-footer>    <litui-pagination pagination=$ctrl.pagination settings=$ctrl.paginationSettings></litui-pagination></div>");$templateCache.put("litui/directive/litui-interacted/litui-interacted-directive.html","Hello world");$templateCache.put("litui/screen/litui-datagrid-screen/litui-datagrid-screen.html","<div style=\"height: calc(100% - 10px);\">    <div litui-view-header=$ctrl.headerOptions></div>        <div tms-grid=$ctrl.datagridOptions.options></div></div>");});